import * as m from "react";
import g, { useRef as zr, useState as kn, useEffect as ro, useReducer as pf, useCallback as Or, isValidElement as ff, cloneElement as hf, Component as mf, useMemo as vf } from "react";
import E, { css as v, keyframes as pc, createGlobalStyle as tr } from "styled-components";
import { useSelect as Tn, useMultipleSelection as gf, useCombobox as Ar } from "downshift";
import bf from "react-dom";
const li = v`
  uicl-loading-dots::part(animation) {
    height: 88px;
    width: 88px;
  }

  uicl-loading-dots::part(base) {
    margin-top: 0;
    margin-left: 0;
  }
`, yf = v`
  ${li}

  uicl-loading-dots::part(animation) {
    height: 88px;
    width: 88px;
    top: -19px;
    position: relative;
    left: -19px;
  }

  uicl-loading-dots::part(base) {
    position: static;
    width: 50px;
    left: 50%;
    top: 50%;
    scale: 0.4;
    height: 50px;
  }
`, xf = E.div`
  position: relative;
  height: 20px;
  width: 20px;
  bottom: ${(e) => e.bottom || "0"};
  right: ${(e) => e.right || "0"};
  left: ${(e) => e.left || "unset"};
  padding-right: ${(e) => e.paddingRight || "unset"};
  ${(e) => e.customCSS}

  uicl-loading-dots {
    left: -15px;
    top: -15px;
    position: relative;
  }

  ${yf}
`, wf = ({ ...e }) => {
  const { bottom: t, right: n, left: r, paddingRight: o, color: i, customCSS: a } = e;
  return /* @__PURE__ */ g.createElement(
    xf,
    {
      bottom: t,
      right: n,
      left: r,
      paddingRight: o,
      color: i,
      customCSS: a
    },
    /* @__PURE__ */ g.createElement("uicl-loading-dots", { "x-offset": "0", "y-offset": "0", position: "static" })
  );
}, Ef = E.div`
  margin: ${(e) => e.margin || "55px calc(50% - 25px)"};
  opacity: 0.5;
  bottom: ${(e) => e.bottom || "14px"};
  right: ${(e) => e.right || "2px"};
  left: ${(e) => e.left || "unset"};
  padding-right: ${(e) => e.paddingRight || "unset"};
  display: flex;
  align-items: center;
  justify-content: center;
  ${li}
  ${(e) => e.customCSS};
`, kf = ({ ...e }) => {
  const { bottom: t, right: n, left: r, paddingRight: o, color: i, customCSS: a } = e;
  return /* @__PURE__ */ g.createElement(
    Ef,
    {
      bottom: t,
      right: n,
      left: r,
      paddingRight: o,
      color: i,
      customCSS: a
    },
    /* @__PURE__ */ g.createElement("uicl-loading-dots", { "x-offset": "0", "y-offset": "0", position: "static" })
  );
}, Sf = E.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255, 255, 255, 0.5);
  z-index: 4;
  width: 100%;
  height: 100%;
  ${li}
`, Cf = (e) => {
  const { bottom: t, right: n, left: r, paddingRight: o, color: i, customCSS: a } = e;
  return /* @__PURE__ */ g.createElement(
    Sf,
    {
      bottom: t,
      right: n,
      left: r,
      paddingRight: o,
      color: i,
      customCSS: a
    },
    /* @__PURE__ */ g.createElement("uicl-loading-dots", { "x-offset": "0", "y-offset": "0", position: "static" })
  );
}, qf = E.tr`
  background: transparent;
  position: absolute;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 4;
  height: 160px;
  ${li}
`, _f = () => /* @__PURE__ */ g.createElement(qf, null, /* @__PURE__ */ g.createElement("uicl-loading-dots", { "x-offset": "0", "y-offset": "0", position: "static" })), Df = {
  Normal: wf,
  Large: kf,
  TableInitial: _f,
  Table: Cf
}, Of = v`
  position: relative;
  vertical-align: text-top;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`, Rf = v`
  position: relative;
`, Tf = v`
  display: inline-block;
  position: relative;
`, Af = pc`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`, fc = v`
  user-select: none;
  position: absolute;
  padding: var(--sq-spacing-small);
  border-radius: var(--sq-border-radius-normal);
  width: max-content;
  min-height: 20px;
  color: var(--sq-surface);
  background: var(--iui-coal-black);
  font-family: var(--sq-font-family-sans);
  font-size: var(--sq-font-size-small);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-caption);
  animation: ${Af} 0.2s;

  &::before {
    content: " ";
    border: solid transparent;
    left: 50%;
    height: 0;
    width: 0;
    position: absolute;
    border-width: 5px;
    margin-left: calc(5px * -1);
  }

  &.right {
    right: auto;
    left: calc(100% + 10px);
    top: 50%;
    transform: translateX(0) translateY(-50%);
  }

  &.right::before {
    left: calc(5px * -1);
    top: 50%;
    transform: translateX(0) translateY(-50%);
    border-right-color: rgba(35, 35, 35, 0.9);
  }

  &.left {
    left: auto;
    right: calc(100% + 10px);
    top: 50%;
    transform: translateX(0) translateY(-50%);
  }

  &.left::before {
    left: auto;
    right: calc(5px * -2);
    top: 50%;
    transform: translateX(0%) translateY(-50%);
    border-left-color: rgba(35, 35, 35, 0.9);
  }

  &.top {
    bottom: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
  }

  &.top::before {
    top: 100%;
    transform: translateX(5%);
    border-top-color: rgba(35, 35, 35, 0.9);
  }

  &.bottom {
    top: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
  }

  &.bottom::before {
    bottom: calc(100%);
    left: 50%;
    transform: translateX(5%);
    border-bottom-color: rgba(35, 35, 35, 0.9);
  }
`;
let hc = "";
function lC(e) {
  hc = e;
}
function $f(e = "") {
  return hc.replace(/\/$/, "") + (e ? `/${e.replace(/^\//, "")}` : "");
}
var If = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), o, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      i.push(o.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}, Nf = function(e) {
  var t = e.split(/ ?; ?/);
  return t.reduce(function(n, r) {
    var o = If(r.split(/ ?: ?/), 2), i = o[0], a = o[1];
    return i && a && (n[i.replace(/-(\w)/g, function(s, l) {
      return l.toUpperCase();
    })] = Number.isNaN(Number(a)) ? a : Number(a)), n;
  }, {});
};
function Vf(e) {
  e === void 0 && (e = 6);
  for (var t = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", n = "", r = e; r > 0; --r)
    n += t[Math.round(Math.random() * (t.length - 1))];
  return n;
}
var zf = [
  "br",
  "col",
  "colgroup",
  "dl",
  "hr",
  "iframe",
  "img",
  "input",
  "link",
  "menuitem",
  "meta",
  "ol",
  "param",
  "select",
  "table",
  "tbody",
  "tfoot",
  "thead",
  "tr",
  "ul",
  "wbr"
], Js = {
  // HTML
  "accept-charset": "acceptCharset",
  acceptcharset: "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  enctype: "encType",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  icon: "icon",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  typemustmatch: "typeMustMatch",
  usemap: "useMap",
  // SVG
  accentheight: "accentHeight",
  "accent-height": "accentHeight",
  alignmentbaseline: "alignmentBaseline",
  "alignment-baseline": "alignmentBaseline",
  allowreorder: "allowReorder",
  arabicform: "arabicForm",
  "arabic-form": "arabicForm",
  attributename: "attributeName",
  attributetype: "attributeType",
  autoreverse: "autoReverse",
  basefrequency: "baseFrequency",
  baselineshift: "baselineShift",
  "baseline-shift": "baselineShift",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  capheight: "capHeight",
  "cap-height": "capHeight",
  clippath: "clipPath",
  "clip-path": "clipPath",
  clippathunits: "clipPathUnits",
  cliprule: "clipRule",
  "clip-rule": "clipRule",
  colorinterpolation: "colorInterpolation",
  "color-interpolation": "colorInterpolation",
  colorinterpolationfilters: "colorInterpolationFilters",
  "color-interpolation-filters": "colorInterpolationFilters",
  colorprofile: "colorProfile",
  "color-profile": "colorProfile",
  colorrendering: "colorRendering",
  "color-rendering": "colorRendering",
  contentscripttype: "contentScriptType",
  contentstyletype: "contentStyleType",
  diffuseconstant: "diffuseConstant",
  dominantbaseline: "dominantBaseline",
  "dominant-baseline": "dominantBaseline",
  edgemode: "edgeMode",
  enablebackground: "enableBackground",
  "enable-background": "enableBackground",
  externalresourcesrequired: "externalResourcesRequired",
  fillopacity: "fillOpacity",
  "fill-opacity": "fillOpacity",
  fillrule: "fillRule",
  "fill-rule": "fillRule",
  filterres: "filterRes",
  filterunits: "filterUnits",
  floodopacity: "floodOpacity",
  "flood-opacity": "floodOpacity",
  floodcolor: "floodColor",
  "flood-color": "floodColor",
  fontfamily: "fontFamily",
  "font-family": "fontFamily",
  fontsize: "fontSize",
  "font-size": "fontSize",
  fontsizeadjust: "fontSizeAdjust",
  "font-size-adjust": "fontSizeAdjust",
  fontstretch: "fontStretch",
  "font-stretch": "fontStretch",
  fontstyle: "fontStyle",
  "font-style": "fontStyle",
  fontvariant: "fontVariant",
  "font-variant": "fontVariant",
  fontweight: "fontWeight",
  "font-weight": "fontWeight",
  glyphname: "glyphName",
  "glyph-name": "glyphName",
  glyphorientationhorizontal: "glyphOrientationHorizontal",
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphorientationvertical: "glyphOrientationVertical",
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  horizadvx: "horizAdvX",
  "horiz-adv-x": "horizAdvX",
  horizoriginx: "horizOriginX",
  "horiz-origin-x": "horizOriginX",
  imagerendering: "imageRendering",
  "image-rendering": "imageRendering",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  letterspacing: "letterSpacing",
  "letter-spacing": "letterSpacing",
  lightingcolor: "lightingColor",
  "lighting-color": "lightingColor",
  limitingconeangle: "limitingConeAngle",
  markerend: "markerEnd",
  "marker-end": "markerEnd",
  markerheight: "markerHeight",
  markermid: "markerMid",
  "marker-mid": "markerMid",
  markerstart: "markerStart",
  "marker-start": "markerStart",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  overlineposition: "overlinePosition",
  "overline-position": "overlinePosition",
  overlinethickness: "overlineThickness",
  "overline-thickness": "overlineThickness",
  paintorder: "paintOrder",
  "paint-order": "paintOrder",
  "panose-1": "panose1",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointerevents: "pointerEvents",
  "pointer-events": "pointerEvents",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  renderingintent: "renderingIntent",
  "rendering-intent": "renderingIntent",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  shaperendering: "shapeRendering",
  "shape-rendering": "shapeRendering",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  stopcolor: "stopColor",
  "stop-color": "stopColor",
  stopopacity: "stopOpacity",
  "stop-opacity": "stopOpacity",
  strikethroughposition: "strikethroughPosition",
  "strikethrough-position": "strikethroughPosition",
  strikethroughthickness: "strikethroughThickness",
  "strikethrough-thickness": "strikethroughThickness",
  strokedasharray: "strokeDasharray",
  "stroke-dasharray": "strokeDasharray",
  strokedashoffset: "strokeDashoffset",
  "stroke-dashoffset": "strokeDashoffset",
  strokelinecap: "strokeLinecap",
  "stroke-linecap": "strokeLinecap",
  strokelinejoin: "strokeLinejoin",
  "stroke-linejoin": "strokeLinejoin",
  strokemiterlimit: "strokeMiterlimit",
  "stroke-miterlimit": "strokeMiterlimit",
  strokewidth: "strokeWidth",
  "stroke-width": "strokeWidth",
  strokeopacity: "strokeOpacity",
  "stroke-opacity": "strokeOpacity",
  suppresscontenteditablewarning: "suppressContentEditableWarning",
  suppresshydrationwarning: "suppressHydrationWarning",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textanchor: "textAnchor",
  "text-anchor": "textAnchor",
  textdecoration: "textDecoration",
  "text-decoration": "textDecoration",
  textlength: "textLength",
  textrendering: "textRendering",
  "text-rendering": "textRendering",
  underlineposition: "underlinePosition",
  "underline-position": "underlinePosition",
  underlinethickness: "underlineThickness",
  "underline-thickness": "underlineThickness",
  unicodebidi: "unicodeBidi",
  "unicode-bidi": "unicodeBidi",
  unicoderange: "unicodeRange",
  "unicode-range": "unicodeRange",
  unitsperem: "unitsPerEm",
  "units-per-em": "unitsPerEm",
  unselectable: "unselectable",
  valphabetic: "vAlphabetic",
  "v-alphabetic": "vAlphabetic",
  vectoreffect: "vectorEffect",
  "vector-effect": "vectorEffect",
  vertadvy: "vertAdvY",
  "vert-adv-y": "vertAdvY",
  vertoriginx: "vertOriginX",
  "vert-origin-x": "vertOriginX",
  vertoriginy: "vertOriginY",
  "vert-origin-y": "vertOriginY",
  vhanging: "vHanging",
  "v-hanging": "vHanging",
  videographic: "vIdeographic",
  "v-ideographic": "vIdeographic",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  vmathematical: "vMathematical",
  "v-mathematical": "vMathematical",
  wordspacing: "wordSpacing",
  "word-spacing": "wordSpacing",
  writingmode: "writingMode",
  "writing-mode": "writingMode",
  xchannelselector: "xChannelSelector",
  xheight: "xHeight",
  "x-height": "xHeight",
  xlinkactuate: "xlinkActuate",
  "xlink:actuate": "xlinkActuate",
  xlinkarcrole: "xlinkArcrole",
  "xlink:arcrole": "xlinkArcrole",
  xlinkhref: "xlinkHref",
  "xlink:href": "xlinkHref",
  xlinkrole: "xlinkRole",
  "xlink:role": "xlinkRole",
  xlinkshow: "xlinkShow",
  "xlink:show": "xlinkShow",
  xlinktitle: "xlinkTitle",
  "xlink:title": "xlinkTitle",
  xlinktype: "xlinkType",
  "xlink:type": "xlinkType",
  xmlbase: "xmlBase",
  "xml:base": "xmlBase",
  xmllang: "xmlLang",
  "xml:lang": "xmlLang",
  "xml:space": "xmlSpace",
  xmlnsxlink: "xmlnsXlink",
  "xmlns:xlink": "xmlnsXlink",
  xmlspace: "xmlSpace",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan",
  // event handlers
  onblur: "onBlur",
  onchange: "onChange",
  onclick: "onClick",
  oncontextmenu: "onContextMenu",
  ondoubleclick: "onDoubleClick",
  ondrag: "onDrag",
  ondragend: "onDragEnd",
  ondragenter: "onDragEnter",
  ondragexit: "onDragExit",
  ondragleave: "onDragLeave",
  ondragover: "onDragOver",
  ondragstart: "onDragStart",
  ondrop: "onDrop",
  onerror: "onError",
  onfocus: "onFocus",
  oninput: "onInput",
  oninvalid: "onInvalid",
  onkeydown: "onKeyDown",
  onkeypress: "onKeyPress",
  onkeyup: "onKeyUp",
  onload: "onLoad",
  onmousedown: "onMouseDown",
  onmouseenter: "onMouseEnter",
  onmouseleave: "onMouseLeave",
  onmousemove: "onMouseMove",
  onmouseout: "onMouseOut",
  onmouseover: "onMouseOver",
  onmouseup: "onMouseUp",
  onscroll: "onScroll",
  onsubmit: "onSubmit",
  ontouchcancel: "onTouchCancel",
  ontouchend: "onTouchEnd",
  ontouchmove: "onTouchMove",
  ontouchstart: "onTouchStart",
  onwheel: "onWheel"
}, Jo = globalThis && globalThis.__assign || function() {
  return Jo = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Jo.apply(this, arguments);
}, mc = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), o, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      i.push(o.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}, vc = globalThis && globalThis.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
};
function Pf(e, t) {
  var n = {
    key: t
  };
  if (e instanceof Element) {
    var r = e.getAttribute("class");
    r && (n.className = r), vc([], mc(e.attributes), !1).forEach(function(o) {
      switch (o.name) {
        case "class":
          break;
        case "style":
          n[o.name] = Nf(o.value);
          break;
        case "allowfullscreen":
        case "allowpaymentrequest":
        case "async":
        case "autofocus":
        case "autoplay":
        case "checked":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "formnovalidate":
        case "hidden":
        case "ismap":
        case "itemscope":
        case "loop":
        case "multiple":
        case "muted":
        case "nomodule":
        case "novalidate":
        case "open":
        case "readonly":
        case "required":
        case "reversed":
        case "selected":
        case "typemustmatch":
          n[Js[o.name] || o.name] = !0;
          break;
        default:
          n[Js[o.name] || o.name] = o.value;
      }
    });
  }
  return n;
}
function Ff(e, t, n) {
  var r = vc([], mc(e), !1).map(function(o, i) {
    return qa(o, Jo(Jo({}, n), { index: i, level: t + 1 }));
  }).filter(Boolean);
  return r.length ? r : null;
}
function Lf(e) {
  return /[a-z]+[A-Z]+[a-z]+/.test(e) ? e : e.toLowerCase();
}
function qa(e, t) {
  var n;
  if (t === void 0 && (t = {}), !e || !(e instanceof Node))
    return null;
  var r = t.actions, o = r === void 0 ? [] : r, i = t.index, a = i === void 0 ? 0 : i, s = t.level, l = s === void 0 ? 0 : s, d = t.randomKey, p = e, c = "".concat(l, "-").concat(a), b = [];
  if (d && l === 0 && (c = "".concat(Vf(), "-").concat(c)), Array.isArray(o) && o.forEach(function(C) {
    C.condition(p, c, l) && (typeof C.pre == "function" && (p = C.pre(p, c, l), p instanceof Node || (p = e, process.env.NODE_ENV !== "production" && console.warn("The `pre` method always must return a valid DomNode (instanceof Node) - your modification will be ignored (Hint: if you want to render a React-component, use the `post` method instead)"))), typeof C.post == "function" && b.push(C.post(p, c, l)));
  }), b.length)
    return b;
  switch (p.nodeType) {
    case 1:
      return m.createElement(Lf(p.nodeName), Pf(p, c), Ff(p.childNodes, l, t));
    case 3: {
      var k = ((n = p.nodeValue) === null || n === void 0 ? void 0 : n.toString()) || "";
      if (/^\s+$/.test(k) && !/[\u00A0\u202F]/.test(k))
        return null;
      if (!p.parentNode)
        return k;
      var q = p.parentNode.nodeName.toLowerCase();
      return zf.includes(q) ? (/\S/.test(k) && console.warn("A textNode is not allowed inside '".concat(q, `'. Your text "`).concat(k, '" will be ignored')), null) : k;
    }
    case 8:
      return null;
    default:
      return null;
  }
}
function Mf(e, t) {
  if (t === void 0 && (t = {}), !e || typeof e != "string")
    return null;
  var n = t.nodeOnly, r = n === void 0 ? !1 : n, o = t.selector, i = o === void 0 ? "body > *" : o, a = t.type, s = a === void 0 ? "text/html" : a;
  try {
    var l = new DOMParser(), d = l.parseFromString(e, s), p = d.querySelector(i);
    if (!(p instanceof Node))
      throw new TypeError("Error parsing input");
    return r ? p : qa(p, t);
  } catch (c) {
    process.env.NODE_ENV !== "production" && console.error(c);
  }
  return null;
}
function gc(e, t) {
  return t === void 0 && (t = {}), typeof e == "string" ? Mf(e, t) : e instanceof Node ? qa(e, t) : null;
}
var Ks = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ki = { exports: {} }, Rr = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gs;
function Uf() {
  if (Gs)
    return Rr;
  Gs = 1;
  var e = g, t = 60103;
  if (Rr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    t = n("react.element"), Rr.Fragment = n("react.fragment");
  }
  var r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, d) {
    var p, c = {}, b = null, k = null;
    d !== void 0 && (b = "" + d), l.key !== void 0 && (b = "" + l.key), l.ref !== void 0 && (k = l.ref);
    for (p in l)
      o.call(l, p) && !i.hasOwnProperty(p) && (c[p] = l[p]);
    if (s && s.defaultProps)
      for (p in l = s.defaultProps, l)
        c[p] === void 0 && (c[p] = l[p]);
    return { $$typeof: t, type: s, key: b, ref: k, props: c, _owner: r.current };
  }
  return Rr.jsx = a, Rr.jsxs = a, Rr;
}
var Ai = {};
/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zs;
function jf() {
  return Zs || (Zs = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = g, n = 60103, r = 60106;
      e.Fragment = 60107;
      var o = 60108, i = 60114, a = 60109, s = 60110, l = 60112, d = 60113, p = 60120, c = 60115, b = 60116, k = 60121, q = 60122, C = 60117, w = 60129, T = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var F = Symbol.for;
        n = F("react.element"), r = F("react.portal"), e.Fragment = F("react.fragment"), o = F("react.strict_mode"), i = F("react.profiler"), a = F("react.provider"), s = F("react.context"), l = F("react.forward_ref"), d = F("react.suspense"), p = F("react.suspense_list"), c = F("react.memo"), b = F("react.lazy"), k = F("react.block"), q = F("react.server.block"), C = F("react.fundamental"), F("react.scope"), F("react.opaque.id"), w = F("react.debug_trace_mode"), F("react.offscreen"), T = F("react.legacy_hidden");
      }
      var L = typeof Symbol == "function" && Symbol.iterator, me = "@@iterator";
      function O(_) {
        if (_ === null || typeof _ != "object")
          return null;
        var z = L && _[L] || _[me];
        return typeof z == "function" ? z : null;
      }
      var Pe = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function qe(_) {
        {
          for (var z = arguments.length, W = new Array(z > 1 ? z - 1 : 0), De = 1; De < z; De++)
            W[De - 1] = arguments[De];
          it("error", _, W);
        }
      }
      function it(_, z, W) {
        {
          var De = Pe.ReactDebugCurrentFrame, We = "";
          if (le) {
            var Ce = fe(le.type), _e = le._owner;
            We += rt(Ce, le._source, _e && fe(_e.type));
          }
          We += De.getStackAddendum(), We !== "" && (z += "%s", W = W.concat([We]));
          var Ae = W.map(function(kt) {
            return "" + kt;
          });
          Ae.unshift("Warning: " + z), Function.prototype.apply.call(console[_], console, Ae);
        }
      }
      var Ne = !1;
      function Ke(_) {
        return !!(typeof _ == "string" || typeof _ == "function" || _ === e.Fragment || _ === i || _ === w || _ === o || _ === d || _ === p || _ === T || Ne || typeof _ == "object" && _ !== null && (_.$$typeof === b || _.$$typeof === c || _.$$typeof === a || _.$$typeof === s || _.$$typeof === l || _.$$typeof === C || _.$$typeof === k || _[0] === q));
      }
      var at = /^(.*)[\\\/]/;
      function rt(_, z, W) {
        var De = "";
        if (z) {
          var We = z.fileName, Ce = We.replace(at, "");
          if (/^index\./.test(Ce)) {
            var _e = We.match(at);
            if (_e) {
              var Ae = _e[1];
              if (Ae) {
                var kt = Ae.replace(at, "");
                Ce = kt + "/" + Ce;
              }
            }
          }
          De = " (at " + Ce + ":" + z.lineNumber + ")";
        } else
          W && (De = " (created by " + W + ")");
        return `
    in ` + (_ || "Unknown") + De;
      }
      var _t = 1;
      function Me(_) {
        return _._status === _t ? _._result : null;
      }
      function He(_, z, W) {
        var De = z.displayName || z.name || "";
        return _.displayName || (De !== "" ? W + "(" + De + ")" : W);
      }
      function fe(_) {
        if (_ == null)
          return null;
        if (typeof _.tag == "number" && qe("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof _ == "function")
          return _.displayName || _.name || null;
        if (typeof _ == "string")
          return _;
        switch (_) {
          case e.Fragment:
            return "Fragment";
          case r:
            return "Portal";
          case i:
            return "Profiler";
          case o:
            return "StrictMode";
          case d:
            return "Suspense";
          case p:
            return "SuspenseList";
        }
        if (typeof _ == "object")
          switch (_.$$typeof) {
            case s:
              return "Context.Consumer";
            case a:
              return "Context.Provider";
            case l:
              return He(_, _.render, "ForwardRef");
            case c:
              return fe(_.type);
            case k:
              return fe(_.render);
            case b: {
              var z = _, W = Me(z);
              if (W)
                return fe(W);
              break;
            }
          }
        return null;
      }
      var Ee = {};
      Pe.ReactDebugCurrentFrame;
      var le = null;
      function Ve(_) {
        le = _;
      }
      function M(_, z, W, De, We) {
        {
          var Ce = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var _e in _)
            if (Ce(_, _e)) {
              var Ae = void 0;
              try {
                if (typeof _[_e] != "function") {
                  var kt = Error((De || "React class") + ": " + W + " type `" + _e + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof _[_e] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw kt.name = "Invariant Violation", kt;
                }
                Ae = _[_e](z, _e, De, W, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (jt) {
                Ae = jt;
              }
              Ae && !(Ae instanceof Error) && (Ve(We), qe("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", De || "React class", W, _e, typeof Ae), Ve(null)), Ae instanceof Error && !(Ae.message in Ee) && (Ee[Ae.message] = !0, Ve(We), qe("Failed %s type: %s", W, Ae.message), Ve(null));
            }
        }
      }
      var Z = Pe.ReactCurrentOwner, xe = Object.prototype.hasOwnProperty, ve = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, we, Te, ke;
      ke = {};
      function de(_) {
        if (xe.call(_, "ref")) {
          var z = Object.getOwnPropertyDescriptor(_, "ref").get;
          if (z && z.isReactWarning)
            return !1;
        }
        return _.ref !== void 0;
      }
      function ge(_) {
        if (xe.call(_, "key")) {
          var z = Object.getOwnPropertyDescriptor(_, "key").get;
          if (z && z.isReactWarning)
            return !1;
        }
        return _.key !== void 0;
      }
      function ie(_, z) {
        if (typeof _.ref == "string" && Z.current && z && Z.current.stateNode !== z) {
          var W = fe(Z.current.type);
          ke[W] || (qe('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', fe(Z.current.type), _.ref), ke[W] = !0);
        }
      }
      function Se(_, z) {
        {
          var W = function() {
            we || (we = !0, qe("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", z));
          };
          W.isReactWarning = !0, Object.defineProperty(_, "key", {
            get: W,
            configurable: !0
          });
        }
      }
      function st(_, z) {
        {
          var W = function() {
            Te || (Te = !0, qe("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", z));
          };
          W.isReactWarning = !0, Object.defineProperty(_, "ref", {
            get: W,
            configurable: !0
          });
        }
      }
      var Y = function(_, z, W, De, We, Ce, _e) {
        var Ae = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: _,
          key: z,
          ref: W,
          props: _e,
          // Record the component responsible for creating this element.
          _owner: Ce
        };
        return Ae._store = {}, Object.defineProperty(Ae._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Ae, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: De
        }), Object.defineProperty(Ae, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: We
        }), Object.freeze && (Object.freeze(Ae.props), Object.freeze(Ae)), Ae;
      };
      function h(_, z, W, De, We) {
        {
          var Ce, _e = {}, Ae = null, kt = null;
          W !== void 0 && (Ae = "" + W), ge(z) && (Ae = "" + z.key), de(z) && (kt = z.ref, ie(z, We));
          for (Ce in z)
            xe.call(z, Ce) && !ve.hasOwnProperty(Ce) && (_e[Ce] = z[Ce]);
          if (_ && _.defaultProps) {
            var jt = _.defaultProps;
            for (Ce in jt)
              _e[Ce] === void 0 && (_e[Ce] = jt[Ce]);
          }
          if (Ae || kt) {
            var Jt = typeof _ == "function" ? _.displayName || _.name || "Unknown" : _;
            Ae && Se(_e, Jt), kt && st(_e, Jt);
          }
          return Y(_, Ae, kt, We, De, Z.current, _e);
        }
      }
      var x = Pe.ReactCurrentOwner;
      Pe.ReactDebugCurrentFrame;
      function R(_) {
        le = _;
      }
      var N;
      N = !1;
      function V(_) {
        return typeof _ == "object" && _ !== null && _.$$typeof === n;
      }
      function j() {
        {
          if (x.current) {
            var _ = fe(x.current.type);
            if (_)
              return `

Check the render method of \`` + _ + "`.";
          }
          return "";
        }
      }
      function J(_) {
        {
          if (_ !== void 0) {
            var z = _.fileName.replace(/^.*[\\\/]/, ""), W = _.lineNumber;
            return `

Check your code at ` + z + ":" + W + ".";
          }
          return "";
        }
      }
      var U = {};
      function B(_) {
        {
          var z = j();
          if (!z) {
            var W = typeof _ == "string" ? _ : _.displayName || _.name;
            W && (z = `

Check the top-level render call using <` + W + ">.");
          }
          return z;
        }
      }
      function P(_, z) {
        {
          if (!_._store || _._store.validated || _.key != null)
            return;
          _._store.validated = !0;
          var W = B(z);
          if (U[W])
            return;
          U[W] = !0;
          var De = "";
          _ && _._owner && _._owner !== x.current && (De = " It was passed a child from " + fe(_._owner.type) + "."), R(_), qe('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', W, De), R(null);
        }
      }
      function oe(_, z) {
        {
          if (typeof _ != "object")
            return;
          if (Array.isArray(_))
            for (var W = 0; W < _.length; W++) {
              var De = _[W];
              V(De) && P(De, z);
            }
          else if (V(_))
            _._store && (_._store.validated = !0);
          else if (_) {
            var We = O(_);
            if (typeof We == "function" && We !== _.entries)
              for (var Ce = We.call(_), _e; !(_e = Ce.next()).done; )
                V(_e.value) && P(_e.value, z);
          }
        }
      }
      function ae(_) {
        {
          var z = _.type;
          if (z == null || typeof z == "string")
            return;
          var W;
          if (typeof z == "function")
            W = z.propTypes;
          else if (typeof z == "object" && (z.$$typeof === l || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          z.$$typeof === c))
            W = z.propTypes;
          else
            return;
          if (W) {
            var De = fe(z);
            M(W, _.props, "prop", De, _);
          } else if (z.PropTypes !== void 0 && !N) {
            N = !0;
            var We = fe(z);
            qe("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", We || "Unknown");
          }
          typeof z.getDefaultProps == "function" && !z.getDefaultProps.isReactClassApproved && qe("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function pe(_) {
        {
          for (var z = Object.keys(_.props), W = 0; W < z.length; W++) {
            var De = z[W];
            if (De !== "children" && De !== "key") {
              R(_), qe("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", De), R(null);
              break;
            }
          }
          _.ref !== null && (R(_), qe("Invalid attribute `ref` supplied to `React.Fragment`."), R(null));
        }
      }
      function ye(_, z, W, De, We, Ce) {
        {
          var _e = Ke(_);
          if (!_e) {
            var Ae = "";
            (_ === void 0 || typeof _ == "object" && _ !== null && Object.keys(_).length === 0) && (Ae += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var kt = J(We);
            kt ? Ae += kt : Ae += j();
            var jt;
            _ === null ? jt = "null" : Array.isArray(_) ? jt = "array" : _ !== void 0 && _.$$typeof === n ? (jt = "<" + (fe(_.type) || "Unknown") + " />", Ae = " Did you accidentally export a JSX literal instead of a component?") : jt = typeof _, qe("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", jt, Ae);
          }
          var Jt = h(_, z, W, We, Ce);
          if (Jt == null)
            return Jt;
          if (_e) {
            var vn = z.children;
            if (vn !== void 0)
              if (De)
                if (Array.isArray(vn)) {
                  for (var tn = 0; tn < vn.length; tn++)
                    oe(vn[tn], _);
                  Object.freeze && Object.freeze(vn);
                } else
                  qe("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                oe(vn, _);
          }
          return _ === e.Fragment ? pe(Jt) : ae(Jt), Jt;
        }
      }
      function Re(_, z, W) {
        return ye(_, z, W, !0);
      }
      function je(_, z, W) {
        return ye(_, z, W, !1);
      }
      var Ue = je, lt = Re;
      e.jsx = Ue, e.jsxs = lt;
    }();
  }(Ai)), Ai;
}
process.env.NODE_ENV === "production" ? Ki.exports = Uf() : Ki.exports = jf();
var Bf = Ki.exports, Wf = Object.defineProperty, Hf = (e, t, n) => t in e ? Wf(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ro = (e, t, n) => (Hf(e, typeof t != "symbol" ? t + "" : t, n), n), Qs = "react-inlinesvg", el = 10, Qe = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};
function Mo() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Yf() {
  return Jf() && typeof window < "u" && window !== null;
}
async function bc(e, t) {
  const n = await fetch(e, t), r = n.headers.get("content-type"), [o] = (r ?? "").split(/ ?; ?/);
  if (n.status > 299)
    throw new Error("Not found");
  if (!["image/svg+xml", "text/plain"].some((i) => o.includes(i)))
    throw new Error(`Content type isn't valid: ${o}`);
  return n.text();
}
function Xf(e = 1) {
  return new Promise((t) => {
    setTimeout(t, e * 1e3);
  });
}
function Jf() {
  if (!document)
    return !1;
  const e = document.createElement("div");
  e.innerHTML = "<svg />";
  const t = e.firstChild;
  return !!t && t.namespaceURI === "http://www.w3.org/2000/svg";
}
function Kf(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function Gf(e) {
  const t = "abcdefghijklmnopqrstuvwxyz", n = "1234567890", r = `${t}${t.toUpperCase()}${n}`;
  let o = "";
  for (let i = 0; i < e; i++)
    o += Kf(r);
  return o;
}
function Zf(e, ...t) {
  const n = {};
  for (const r in e)
    ({}).hasOwnProperty.call(e, r) && (t.includes(r) || (n[r] = e[r]));
  return n;
}
var Qf = class {
  constructor() {
    Ro(this, "cacheApi"), Ro(this, "cacheStore"), Ro(this, "subscribers", []), Ro(this, "isReady", !1), this.cacheStore = /* @__PURE__ */ new Map();
    let e = Qs, t = !1;
    Mo() && (e = window.REACT_INLINESVG_CACHE_NAME ?? Qs, t = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window), t ? caches.open(e).then((n) => {
      this.cacheApi = n, this.isReady = !0, this.subscribers.forEach((r) => r());
    }).catch((n) => {
      this.isReady = !0, console.error(`Failed to open cache: ${n.message}`);
    }) : this.isReady = !0;
  }
  onReady(e) {
    this.isReady ? e() : this.subscribers.push(e);
  }
  async get(e, t) {
    var n;
    return await (this.cacheApi ? this.fetchAndAddToPersistentCache(e, t) : this.fetchAndAddToInternalCache(e, t)), ((n = this.cacheStore.get(e)) == null ? void 0 : n.content) ?? "";
  }
  set(e, t) {
    this.cacheStore.set(e, t);
  }
  isCached(e) {
    var t;
    return ((t = this.cacheStore.get(e)) == null ? void 0 : t.status) === Qe.LOADED;
  }
  async fetchAndAddToInternalCache(e, t) {
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === Qe.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: Qe.IDLE }), await this.fetchAndAddToInternalCache(e, t);
      });
      return;
    }
    if (!(n != null && n.content)) {
      this.cacheStore.set(e, { content: "", status: Qe.LOADING });
      try {
        const r = await bc(e, t);
        this.cacheStore.set(e, { content: r, status: Qe.LOADED });
      } catch (r) {
        throw this.cacheStore.set(e, { content: "", status: Qe.FAILED }), r;
      }
    }
  }
  async fetchAndAddToPersistentCache(e, t) {
    var o, i, a;
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === Qe.LOADED)
      return;
    if ((n == null ? void 0 : n.status) === Qe.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: Qe.IDLE }), await this.fetchAndAddToPersistentCache(e, t);
      });
      return;
    }
    this.cacheStore.set(e, { content: "", status: Qe.LOADING });
    const r = await ((o = this.cacheApi) == null ? void 0 : o.match(e));
    if (r) {
      const s = await r.text();
      this.cacheStore.set(e, { content: s, status: Qe.LOADED });
      return;
    }
    try {
      await ((i = this.cacheApi) == null ? void 0 : i.add(new Request(e, t)));
      const s = await ((a = this.cacheApi) == null ? void 0 : a.match(e)), l = await (s == null ? void 0 : s.text()) ?? "";
      this.cacheStore.set(e, { content: l, status: Qe.LOADED });
    } catch (s) {
      throw this.cacheStore.set(e, { content: "", status: Qe.FAILED }), s;
    }
  }
  async handleLoading(e, t) {
    var r;
    let n = 0;
    for (; ((r = this.cacheStore.get(e)) == null ? void 0 : r.status) === Qe.LOADING && n < el; )
      await Xf(0.1), n += 1;
    n >= el && await t();
  }
  keys() {
    return [...this.cacheStore.keys()];
  }
  data() {
    return [...this.cacheStore.entries()].map(([e, t]) => ({ [e]: t }));
  }
  async delete(e) {
    this.cacheApi && await this.cacheApi.delete(e), this.cacheStore.delete(e);
  }
  async clear() {
    if (this.cacheApi) {
      const e = await this.cacheApi.keys();
      for (const t of e)
        await this.cacheApi.delete(t);
    }
    this.cacheStore.clear();
  }
};
function tl(e) {
  const t = zr();
  return ro(() => {
    t.current = e;
  }), t.current;
}
function eh(e) {
  const {
    baseURL: t,
    content: n,
    description: r,
    handleError: o,
    hash: i,
    preProcessor: a,
    title: s,
    uniquifyIDs: l = !1
  } = e;
  try {
    const d = th(n, a), p = gc(d, { nodeOnly: !0 });
    if (!p || !(p instanceof SVGSVGElement))
      throw new Error("Could not convert the src to a DOM Node");
    const c = yc(p, { baseURL: t, hash: i, uniquifyIDs: l });
    if (r) {
      const b = c.querySelector("desc");
      b != null && b.parentNode && b.parentNode.removeChild(b);
      const k = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      k.innerHTML = r, c.prepend(k);
    }
    if (typeof s < "u") {
      const b = c.querySelector("title");
      if (b != null && b.parentNode && b.parentNode.removeChild(b), s) {
        const k = document.createElementNS("http://www.w3.org/2000/svg", "title");
        k.innerHTML = s, c.prepend(k);
      }
    }
    return c;
  } catch (d) {
    return o(d);
  }
}
function th(e, t) {
  return t ? t(e) : e;
}
function yc(e, t) {
  const { baseURL: n = "", hash: r, uniquifyIDs: o } = t, i = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"], a = ["href", "xlink:href"], s = (l, d) => a.includes(l) && (d ? !d.includes("#") : !1);
  return o && [...e.children].forEach((l) => {
    var d;
    if ((d = l.attributes) != null && d.length) {
      const p = Object.values(l.attributes).map((c) => {
        const b = c, k = /url\((.*?)\)/.exec(c.value);
        return k != null && k[1] && (b.value = c.value.replace(k[0], `url(${n}${k[1]}__${r})`)), b;
      });
      i.forEach((c) => {
        const b = p.find((k) => k.name === c);
        b && !s(c, b.value) && (b.value = `${b.value}__${r}`);
      });
    }
    return l.children.length ? yc(l, t) : l;
  }), e;
}
var Nr;
function nh(e) {
  const {
    cacheRequests: t = !0,
    children: n = null,
    description: r,
    fetchOptions: o,
    innerRef: i,
    loader: a = null,
    onError: s,
    onLoad: l,
    src: d,
    title: p,
    uniqueHash: c
  } = e, [b, k] = pf(
    (Me, He) => ({
      ...Me,
      ...He
    }),
    {
      content: "",
      element: null,
      isCached: t && Nr.isCached(e.src),
      status: Qe.IDLE
    }
  ), { content: q, element: C, isCached: w, status: T } = b, F = tl(e), L = tl(b), me = zr(c ?? Gf(8)), O = zr(!1), Pe = zr(!1), qe = Or(
    (Me) => {
      O.current && (k({
        status: Me.message === "Browser does not support SVG" ? Qe.UNSUPPORTED : Qe.FAILED
      }), s == null || s(Me));
    },
    [s]
  ), it = Or((Me, He = !1) => {
    O.current && k({
      content: Me,
      isCached: He,
      status: Qe.LOADED
    });
  }, []), Ne = Or(async () => {
    const Me = await bc(d, o);
    it(Me);
  }, [o, it, d]), Ke = Or(() => {
    try {
      const Me = eh({ ...e, handleError: qe, hash: me.current, content: q }), He = gc(Me);
      if (!He || !ff(He))
        throw new Error("Could not convert the src to a React element");
      k({
        element: He,
        status: Qe.READY
      });
    } catch (Me) {
      qe(new Error(Me.message));
    }
  }, [q, qe, e]), at = Or(async () => {
    const Me = /^data:image\/svg[^,]*?(;base64)?,(.*)/u.exec(d);
    let He;
    if (Me ? He = Me[1] ? window.atob(Me[2]) : decodeURIComponent(Me[2]) : d.includes("<svg") && (He = d), He) {
      it(He);
      return;
    }
    try {
      if (t) {
        const fe = await Nr.get(d, o);
        it(fe, !0);
      } else
        await Ne();
    } catch (fe) {
      qe(fe);
    }
  }, [t, Ne, o, qe, it, d]), rt = Or(async () => {
    O.current && k({
      content: "",
      element: null,
      isCached: !1,
      status: Qe.LOADING
    });
  }, []);
  ro(
    () => {
      if (O.current = !0, !Mo() || Pe.current)
        return () => {
        };
      try {
        if (T === Qe.IDLE) {
          if (!Yf())
            throw new Error("Browser does not support SVG");
          if (!d)
            throw new Error("Missing src");
          rt();
        }
      } catch (Me) {
        qe(Me);
      }
      return Pe.current = !0, () => {
        O.current = !1;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), ro(() => {
    if (Mo() && F)
      if (F.src !== d) {
        if (!d) {
          qe(new Error("Missing src"));
          return;
        }
        rt();
      } else
        (F.title !== p || F.description !== r) && Ke();
  }, [r, Ke, qe, rt, F, d, p]), ro(() => {
    L && (L.status !== Qe.LOADING && T === Qe.LOADING && at(), L.status !== Qe.LOADED && T === Qe.LOADED && Ke(), L.status !== Qe.READY && T === Qe.READY && (l == null || l(d, w)));
  }, [at, Ke, w, l, L, d, T]);
  const _t = Zf(
    e,
    "baseURL",
    "cacheRequests",
    "children",
    "description",
    "fetchOptions",
    "innerRef",
    "loader",
    "onError",
    "onLoad",
    "preProcessor",
    "src",
    "title",
    "uniqueHash",
    "uniquifyIDs"
  );
  return Mo() ? C ? hf(C, { ref: i, ..._t }) : [Qe.UNSUPPORTED, Qe.FAILED].includes(T) ? n : a : a;
}
function rh(e) {
  Nr || (Nr = new Qf());
  const { loader: t } = e, n = zr(!1), [r, o] = kn(Nr.isReady);
  return ro(() => {
    n.current || (Nr.onReady(() => {
      o(!0);
    }), n.current = !0);
  }, []), r ? /* @__PURE__ */ Bf.jsx(nh, { ...e }) : t;
}
const oh = ["small", "medium", "large", "badge"];
function Mn(e) {
  return oh.includes(e);
}
const Un = {
  small: "var(--sq-icon-size-small)",
  medium: "var(--sq-icon-size-medium)",
  large: "var(--sq-icon-size-large)",
  badge: "var(--sq-icon-size-badge)"
}, ih = E.span`
  &,
  uicl-icon::part(icon-base) {
    ${Of}

    color: ${(e) => e.color};
    width: ${(e) => Mn(e.size) ? Un[e.size] : e.size};
    min-width: ${(e) => Mn(e.size) ? Un[e.size] : e.size};
    height: ${(e) => Mn(e.size) ? Un[e.size] : e.size};
    line-height: ${(e) => Mn(e.size) ? Un[e.size] : e.size};

    ${(e) => e.customCSS}

    ${(e) => e.center ? v`
            display: flex !important;
            align-items: center;
            justify-content: center;
          ` : ""}
  }
  /* tooltip function */
  ${(e) => e.tooltip && v`
      ${Rf}
      &:hover ${xc} {
        visibility: visible;
        opacity: 1;
      }
    `}

  & > svg {
    cursor: ${(e) => e.cursor ? e.cursor : "inherit"};
    width: ${(e) => Mn(e.size) ? Un[e.size] : e.size};
    min-width: ${(e) => Mn(e.size) ? Un[e.size] : e.size};
    height: ${(e) => Mn(e.size) ? Un[e.size] : e.size};
    line-height: ${(e) => Mn(e.size) ? Un[e.size] : e.size};
  }
`, xc = E.div`
  ${fc}

  visibility: hidden;
  opacity: 0;
  transition: opacity 150ms ease-in-out 400ms, visibility 600ms;

  max-width: ${(e) => e.tooltipMaxWidth ? e.tooltipMaxWidth : "144px"};

  ${(e) => e.tooltipCustomCSS}
`, Le = m.forwardRef(
  (e, t) => {
    const {
      icon: n,
      iconSet: r = "saasquatch",
      color: o = "inherit",
      size: i = "medium",
      cursor: a = "inherit",
      center: s = !1,
      customCSS: l = {},
      customSVGCSS: d = {},
      tooltip: p = "",
      tooltipDirection: c = "top",
      tooltipMaxWidth: b = "",
      tooltipCustomCSS: k = {},
      ...q
    } = e;
    if (!n)
      return /* @__PURE__ */ m.createElement(m.Fragment, null);
    const C = `icons/${n}.svg`, w = $f(C);
    return /* @__PURE__ */ m.createElement(
      ih,
      {
        ...q,
        iconSet: r,
        size: i,
        color: o,
        ref: t,
        customSVGCSS: d,
        customCSS: l,
        cursor: a,
        center: s,
        tooltip: p
      },
      p && /* @__PURE__ */ m.createElement(
        xc,
        {
          className: c,
          tooltipMaxWidth: b,
          tooltipCustomCSS: k
        },
        p
      ),
      r === "impact" ? /* @__PURE__ */ m.createElement("uicl-icon", { name: n }) : /* @__PURE__ */ m.createElement(rh, { src: w })
    );
  }
), cC = Le, wc = v`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 730px;
  align-items: flex-start;
  padding: 10px;
  border-radius: var(--sq-border-radius-normal);
  box-sizing: border-box;
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  & > :first-child {
    margin-right: var(--sq-spacing-medium);
  }
`, Ec = v`
  font-size: var(--sq-font-size-small);
`, kc = v`
  font-weight: var(--sq-font-weight-semibold);
`, Sc = v`
  background-color: transparent;
  border: none;
  padding: 0;
`, ah = v`
  background-color: var(--sq-surface-critical-subdued);
`, sh = v`
  ${Sc}
`, lh = v`
  background-color: var(--sq-surface-warning-subdued);
`, ch = v`
  ${Sc}
`, uh = v`
  background-color: var(--sq-surface-success-subdued);
`, dh = v`
  background-color: var(--sq-background-subdued);
`, ph = v`
  background-color: var(--sq-backround-subdued);
`, fh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlertDiv: wc,
  ContentDiv: Ec,
  TitleSpan: kc,
  critical: ah,
  default_style: dh,
  info: ph,
  success: uh,
  textCritical: sh,
  textWarning: ch,
  warning: lh
}, Symbol.toStringTag, { value: "Module" })), hh = E.div`
  ${wc}
  ${(e) => fh[e.type]}
  ${(e) => e.customCSS}
`, mh = E.div`
  ${Ec}
`, vh = E.div`
  ${kc}
`, gh = {
  default_style: /* @__PURE__ */ m.createElement(Le, { icon: "alert_alt", color: "var(--sq-action-primary)", size: "23px" }),
  critical: /* @__PURE__ */ m.createElement(
    Le,
    {
      icon: "alert_alt",
      color: "var(--sq-surface-critical)",
      size: "23px"
    }
  ),
  textCritical: /* @__PURE__ */ m.createElement(
    Le,
    {
      icon: "alert_alt",
      color: "var(--sq-surface-critical)",
      size: "23px"
    }
  ),
  warning: /* @__PURE__ */ m.createElement(
    Le,
    {
      icon: "alert_alt",
      color: "var(--sq-surface-warning)",
      size: "23px"
    }
  ),
  textWarning: /* @__PURE__ */ m.createElement(
    Le,
    {
      icon: "alert_alt",
      color: "var(--sq-surface-warning)",
      size: "23px"
    }
  ),
  success: /* @__PURE__ */ m.createElement(
    Le,
    {
      icon: "checkmark_circle_filled",
      color: "var(--sq-surface-success)",
      size: "23px"
    }
  ),
  info: /* @__PURE__ */ m.createElement(Le, { icon: "alert_alt", color: "var(--sq-action-primary)", size: "23px" })
}, _a = m.forwardRef(
  (e, t) => {
    const {
      type: n,
      iconSlot: r,
      title: o,
      children: i,
      customCSS: a = {},
      ...s
    } = e, l = !o && n === "textWarning" || n === "textCritical" || !o;
    return /* @__PURE__ */ m.createElement(
      hh,
      {
        ...s,
        type: n,
        ref: t,
        customCSS: a
      },
      r || gh[n],
      /* @__PURE__ */ m.createElement("div", null, /* @__PURE__ */ m.createElement(vh, null, o), /* @__PURE__ */ m.createElement(
        mh,
        {
          style: {
            paddingTop: l ? "var(--sq-spacing-xxx-small)" : "0px"
          }
        },
        i
      ))
    );
  }
), uC = _a, bh = v`
  background-color: var(--sq-background);
  border-radius: 50%;
  width: var(--sq-icon-size-avatar);
  height: var(--sq-icon-size-avatar);
  text-align: center;
  border: 1px solid var(--sq-border);
  box-sizing: border-box;
  border-radius: 50px;
`, yh = v`
  background-color: var(--sq-background);
  border-radius: 50%;
  width: var(--sq-icon-size-avatar-large);
  height: var(--sq-icon-size-avatar-large);
  text-align: center;
  border-radius: 50px;
`, xh = v`
  position: relative;
  top: 7px;
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-bold);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, wh = v`
  position: relative;
  top: 15px;
  color: var(--sq-surface);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-avatar);
  line-height: var(--sq-line-height-regular);
`, Eh = v`
  display: inline-block;
`, kh = E.div`
  ${Eh}
  ${(e) => e.customCSS}
`, Sh = E.div`
  ${(e) => e.large ? yh : bh};
  ${(e) => e.large ? "background-color: " + e.color : ""};
`, Ch = E.span`
  ${(e) => e.large ? wh : xh};
  ${(e) => e.large ? "" : "color: " + e.color};
`, qh = m.forwardRef((e, t) => {
  const {
    firstName: n = "",
    large: r = !1,
    lastName: o = "",
    customCSS: i = {},
    ...a
  } = e;
  let s = "";
  (n || o) && (s = n.charAt(0) + o.charAt(0));
  const l = [
    "#023B44",
    "#0FA177",
    "#00C75F",
    "#0092AD",
    "#44BFD5",
    "#F5A624"
  ], d = s.charCodeAt(0) % 6;
  return /* @__PURE__ */ m.createElement(kh, { ...a, ref: t, customCSS: i }, n || o ? /* @__PURE__ */ m.createElement(Sh, { large: r, color: l[d] }, /* @__PURE__ */ m.createElement(Ch, { large: r, color: l[d] }, s)) : /* @__PURE__ */ m.createElement(
    Le,
    {
      icon: "avatar",
      size: r ? "var(--sq-icon-size-avatar-large)" : "var(--sq-icon-size-avatar)"
    }
  ));
}), dC = qh, Cc = v`
  padding: var(--sq-spacing-xx-small) var(--sq-spacing-x-small);
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-bold);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--sq-spacing-x-small);
  // max-height: 25px;
`, _h = v`
  border-radius: var(--sq-border-radius-normal);
`, Dh = v`
  border-radius: var(--sq-border-radius-pill);
`, Oh = v`
  background-color: var(--sq-background-subdued);
  border: 1px solid var(--sq-border);
  color: var(--sq-text);
`, Rh = v`
  background-color: var(--sq-surface-success-subdued);
  border: 1px solid var(--sq-surface-success);
  color: var(--sq-badge-text-success);
`, Th = v`
  background-color: var(--sq-surface-critical-subdued);
  border: 1px solid var(--sq-badge-text-critical);
  color: var(--sq-badge-text-critical);
`, Ah = v`
  background-color: var(--sq-warning-background);
  border: 1px solid var(--sq-decorative-orange);
  color: var(--sq-decorative-orange);
`, $h = v`
  background-color: var(--iui-ice-blue);
  border: 1px solid var(--sq-text-interactive);
  color: var(--sq-text-interactive) !important;
`, qc = v`
  padding: var(--sq-spacing-xxx-small) var(--sq-spacing-xx-small);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-small);
  gap: var(--sq-spacing-xx-small);
  line-height: var(--sq-spacing-medium);
`, Ih = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  base: Cc,
  critical: Th,
  default_style: Oh,
  info: $h,
  pill_false: _h,
  pill_true: Dh,
  small: qc,
  success: Rh,
  warning: Ah
}, Symbol.toStringTag, { value: "Module" })), Nh = (e) => e.replace("-", "_"), Be = (e) => e ? "" : null, Vh = E.div`
  ${Cc}
  ${(e) => Ih[Nh(e.status)]}
  border-radius: ${(e) => e.pill ? "var(--sq-spacing-xxx-large);" : "var(--sq-spacing-xx-small);"};
  ${(e) => e.size === "small" && qc}

  ${(e) => e.customCSS}
`, _c = m.forwardRef(
  (e, t) => {
    const {
      status: n,
      pill: r = !1,
      size: o = "medium",
      icon: i,
      children: a,
      customCSS: s = {},
      ...l
    } = e;
    return /* @__PURE__ */ m.createElement(
      Vh,
      {
        ...l,
        status: n,
        pill: r,
        size: o,
        ref: t,
        customCSS: s
      },
      i && /* @__PURE__ */ m.createElement(
        Le,
        {
          icon: i,
          color: "inherit",
          size: o === "small" ? "var(--sq-icon-size-small)" : "var(--sq-icon-size-badge)"
        }
      ),
      a && /* @__PURE__ */ m.createElement("span", null, a)
    );
  }
), pC = _c;
v`
  position: absolute;
  width: 40px;
  height: 20px;
  border: 2px solid var(--sq-border);
  border-radius: var(--sq-border-radius-pill);
  background: var(--sq-surface-input-disabled);
  cursor: pointer;
  transform: translateX(-100%);
  box-sizing: border-box;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin: -2px;
    background: var(--sq-surface);
    border: 2px solid var(--sq-border);
    transition: 0.1s;
    box-sizing: border-box;
  }
`;
v`
  display: flex;
  align-items: center;
  font-family: var(--sq-font-family-sans);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  color: var(--sq-text-dark);
  user-select: none;
`;
v`
  background: var(--sq-border-success);
  transition: 0.15s ease-out;
`;
v`
  background: var(--sq-border-critical);
  transition: 0.15s ease-out;
`;
v`
  opacity: 0;
  z-index: 1;
  border-radius: var(--sq-border-radius-pill);
  width: 40px;
  height: 20px;
  margin: 0;
`;
v`
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin-left: 17px;
    transition: 0.1s ease-out;
  }
`;
const zh = v`
  display: inline-block;
  height: 24px;
`, Ph = /* @__PURE__ */ new Set(["children", "wcType"]);
let Fh = class extends mf {
  /**
   * Gets the web component element reference
   *
   * @readonly
   * @memberof Wc
   */
  get element() {
    return this._element;
  }
  /**
   * Gets the web component tag name from the 'wcType' prop
   *
   * @protected
   * @returns
   * @memberof Wc
   */
  getTag() {
    let t;
    return typeof this.props.wcType == "function" ? t = this.props.wcType.name.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase() : typeof this.props.wcType == "string" && (t = this.props.wcType), t;
  }
  /**
   * Renders the web component
   *
   * @returns
   * @memberof Wc
   */
  render() {
    const t = this.getTag();
    if (!t)
      throw '"wcType" must be set!';
    const n = {};
    for (const r of Object.keys(this.props))
      r && this.props[r] === !0 && (n[r] = !0);
    return g.createElement(
      t,
      {
        ...n,
        ref: (r) => this.setRef(r)
      },
      this.props.children
    );
  }
  /**
   * Sets the web component reference and syncs the props
   *
   * @protected
   * @param {HTMLElement} element
   * @memberof Wc
   */
  setRef(t) {
    t ? (t !== this._element && this.cleanUp(), this._element = t, this.syncProps(this.props)) : this.cleanUp(), this.props.innerRef && (typeof this.props.innerRef == "function" ? this.props.innerRef(t) : this.props.innerRef.current = t);
  }
  /**
   * Removes all event listeners from web component element
   *
   * @protected
   * @returns
   * @memberof Wc
   */
  cleanUp() {
    if (this._element) {
      for (const t in this.props)
        this.props.hasOwnProperty(t) && this.isEventProp(t, this.props[t]) && this.removeEventListener(t, this.props[t]);
      this._element = null;
    }
  }
  /**
   * Updates props on web component
   *
   * @param {*} prevProps
   * @memberof Wc
   */
  componentDidUpdate(t) {
    const n = {};
    for (const r in this.props)
      this.props.hasOwnProperty(r) && (!t[r] || t[r] !== this.props[r]) && (n[r] = this.props[r], t[r] && this.isEventProp(r, t[r]) && this.removeEventListener(r, t[r]));
    for (const r in t)
      t.hasOwnProperty(r) && !this.props[r] && this.isEventProp(r, t[r]) && this.removeEventListener(r, t[r]);
    this.syncProps(n);
  }
  /**
   * Syncs all React component props to web component
   *
   * @protected
   * @param {*} props
   * @memberof Wc
   */
  syncProps(t) {
    if (this._element)
      for (const n in t)
        Ph.has(n) || (this.isEventProp(n, t[n]) && this.addEventListener(n, t[n]), this._element[n] = t[n]);
  }
  /**
   * Returns true if prop should be treated as event
   *
   * @protected
   * @param {string} prop
   * @param {*} value
   * @returns
   * @memberof Wc
   */
  isEventProp(t, n) {
    return t && typeof n == "function";
  }
  /**
   * Adds event listener on web component
   *
   * @protected
   * @param {string} propName
   * @param {EventListenerOrEventListenerObject} handler
   * @memberof Wc
   */
  addEventListener(t, n) {
    let r = t;
    r.match(/^on[A-Z]/gm) && (r = r.substring(2).toLowerCase()), this._element.addEventListener(r, n);
  }
  /**
   * Removes event listener from web component
   *
   * @protected
   * @param {string} propName
   * @param {EventListenerOrEventListenerObject} handler
   * @memberof Wc
   */
  removeEventListener(t, n) {
    let r = t;
    r.match(/^on[A-Z]/gm) && (r = r.substring(2).toLowerCase()), this._element.removeEventListener(r, n);
  }
};
const qn = (e) => g.forwardRef(
  (n, r) => g.createElement(Fh, { wcType: e, innerRef: r, ...n })
), Lh = E.div`
  ${zh}
  ${(e) => e.customCSS}
`, Mh = E(qn("uicl-checkbox"))`
  ${(e) => e.lock && "pointer-events: none; cursor:pointer;"}
`, Dc = m.forwardRef((e, t) => {
  const {
    id: n,
    color: r = "success",
    value: o,
    checked: i,
    customCSS: a = {},
    lock: s = !1,
    readonly: l = !1,
    disabled: d = !1,
    onChange: p,
    className: c,
    ...b
  } = e;
  function k(q) {
    const C = q.composedPath()[0];
    Object.defineProperty(q, "target", {
      value: C
    }), p && p(q);
  }
  return /* @__PURE__ */ m.createElement(Lh, { customCSS: a }, /* @__PURE__ */ m.createElement(
    Mh,
    {
      ...b,
      color: r,
      type: "checkbox",
      lock: s,
      isReadOnly: Be(l),
      isDisabled: Be(d),
      modelValue: o || i ? "true" : null,
      isToggleDisplay: Be(!0),
      onInput: k,
      className: `${c} switch`,
      id: n,
      ref: t
    }
  ));
}), hC = Dc;
function mC(e) {
  const t = e.options;
  return /* @__PURE__ */ g.createElement(
    Dc,
    {
      id: e.id,
      ...t,
      checked: e.value,
      disabled: e.disabled,
      readOnly: e.readonly,
      onChange: (n) => {
        e.readonly || e.onChange(n.target.checked);
      }
    }
  );
}
const Uh = v`
  display: flex;
  flex-direction: row;
  background: var(--sq-background-subdued);
  box-sizing: border-box;
  align-items: center;
  width: max-content;
  border-radius: var(--sq-border-radius-normal);
  color: var(--sq-text);
  padding: var(--sq-spacing-xx-small) var(--sq-spacing-x-small);
  gap: 10px;
`, jh = v`
  box-sizing: border-box;
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  font-family: var(--sq-font-family-sans);
`, Bh = v`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 28px;
  height: 26px;
  &:hover {
    color: var(--sq-text-dark);
    cursor: pointer;
  }
  & svg {
    &:hover {
      cursor: pointer;
    }
  }
`, Wh = E.div`
  ${Uh}
  ${(e) => e.customCSS}
`, Hh = E.div`
  ${Bh}
`, Yh = E.div`
  ${jh}
`, Oc = m.forwardRef(
  (e, t) => {
    const {
      onClickClose: n,
      children: r,
      canClose: o = !0,
      customCSS: i = {},
      ...a
    } = e;
    return /* @__PURE__ */ m.createElement(Wh, { ...a, ref: t, customCSS: i }, /* @__PURE__ */ m.createElement(Yh, null, r), o && /* @__PURE__ */ m.createElement(Hh, { onClick: n }, /* @__PURE__ */ m.createElement(Le, { size: "14px", icon: "close" })));
  }
), vC = Oc, Xh = E.div`
  ${Tf}
`, Jh = E.div`
  ${fc};

  max-width: ${(e) => e.maxWidth ? e.maxWidth : "144px"};

  ${(e) => e.customCSS}
`, Kh = g.forwardRef((e, t) => {
  const {
    text: n = "",
    direction: r = "top",
    showTooltip: o = !1,
    children: i,
    maxWidth: a = "",
    customCSS: s = {},
    ...l
  } = e;
  return /* @__PURE__ */ g.createElement(Xh, { ...l, ref: t }, i, o && /* @__PURE__ */ g.createElement(
    Jh,
    {
      maxWidth: a,
      customCSS: s,
      className: r
    },
    n
  ));
}), gC = Kh, Gh = tr`
:root {
  /* font-size: 16px; */

  /* ~~~ Colors ~~~ */

  /* Impact colors */
  --iui-almost-black: #29394A;
  --iui-darker-black: #23313F;
  --iui-coal-black: #2D3E50;
  --iui-strata-blue: #14B1F7;
  --iui-shaded-blue: #12A7EA;
  --iui-sky-blue: #A4E0FB;
  --iui-ice-blue: #F3FBFF;
  --iui-serenity-gray: #CACFD3;
  --iui-pale-gray: #F2F3F4;
  --iui-storm-gray: #6C7784;
  --iui-flash-gray: #EAEBED;
  --iui-bleakest-gray: #969EA7;
  --iui-error-red: #C00800;
  --iui-impact-red: #E41B49;
  --iui-light-pink: #FFEFEE;
  --iui-rose-pink: #EFC1BF;
  --iui-light-orange: #F9ECD9;
  --iui-leaf-green: #008917;

  /* Surface */
  --sq-surface: #ffffff;
  --sq-surface-subdued: #f6f6f6;
  --sq-background: #f9f9f9;
  --sq-background-subdued: var(--iui-pale-gray);
  --sq-surface-overlay: rgba(0, 0, 0, 0.7);
  --sq-surface-dark: #232323;

  /* On Surface */
  --sq-text: var(--iui-coal-black);
  --sq-text-dark: var(--iui-darker-black);
  --sq-text-subdued: var(--iui-storm-gray);
  --sq-border: var(--iui-serenity-gray);
  --sq-border-hover: var(--iui-coal-black);
  --sq-border-subdued: var(--iui-flash-gray);

  /* Loading */
  --sq-loading: var(--iui-strata-blue);


  /* Top Nav Bar */
  --sq-nav-surface-primary: var(--iui-coal-black);
  --sq-nav-surface-primary-subdued: rgba(255, 255, 255, 0.12);
  --sq-nav-text-on-primary: #ffffff;
  --sq-nav-text-on-primary-subdued: var(--iui-bleakest-gray);
  --sq-nav-surface-secondary: #ffffff;
  --sq-nav-text-on-secondary: var(--iui-coal-black);
  --sq-nav-text-on-secondary-subdued: var(--iui-bleakest-gray);

  /* Primary */
  --sq-action-primary: var(--iui-strata-blue);
  --sq-action-primary-hovered: var(--iui-strata-blue);
  --sq-action-primary-disabled: var(--iui-pale-gray);
  --sq-text-on-primary: #ffffff;
  --sq-text-on-primary-disabled: var(--iui-bleakest-gray);

  /* Secondary */
  --sq-action-secondary: var(--iui-pale-gray);
  --sq-action-secondary-hovered: var(--iui-pale-gray);
  --sq-action-secondary-border: #a6b9bd;
  --sq-text-on-secondary: var(--iui-coal-black);
  --sq-text-on-secondary-hovered: var(--iui-bleakest-gray);
  --sq-placeholder-text-on-secondary: var(--iui-bleakest-gray);

  /* Success */
  --sq-surface-success: var(--iui-leaf-green);
  --sq-surface-success-hovered: var(--iui-leaf-green);
  --sq-surface-success-subdued: #D9FBDF;
  --sq-border-success: var(--iui-leaf-green);
  --sq-badge-surface-success: #D9FBDF;
  --sq-badge-text-success: #146352;

  /* Warning */
  --sq-surface-warning: #f1c359;
  --sq-icon-warning: #EEBA00;
  --sq-surface-warning-subdued: #fcf8e3;
  --sq-border-warning: #f1c359;
  --sq-badge-surface-warning: #ffe3a1;
  --sq-badge-text-warning: #92400E;
  --sq-decorative-orange: #EF8626;
  --sq-warning-background: var(--iui-light-orange);

  /* Info */
  --sq-border-info: #95beff;
  --sq-surface-info: #e0ecff;
  --sq-on-surface-info: #1260d9;

  /* Critical */
  --sq-surface-critical: var(--iui-error-red);
  --sq-surface-critical-hovered: var(--iui-error-red);
  --sq-surface-critical-subdued: var(--iui-light-pink);
  --sq-border-critical: var(--iui-error-red);
  --sq-badge-text-critical: #C12F2F;
  /* Deprecated */
  --sq-on-surface-critical: #D14040;

  /* Interactive */
  --sq-text-interactive: #0077DB;
  --sq-text-interactive-hovered: #0077DB;
  --sq-text-interactive-visited: #681DA8;
  --sq-focused: #0077DB;
  --sq-icon-interactive: #0088cc;
  --sq-surface-hover: var(--iui-pale-gray);

  /* Docs site */
  --sq-docs-interactive: #007A5B;
  --sq-docs-interactive-hovered: #00654C;
  --sq-docs-surface-hovered: #E7EDEE;
  --sq-docs-card-border-hovered: #B5CDC7;
  --sq-docs-badge-surface: #EBF9EA;

  /* Editor */
  --sq-editor-canvas-background: #eaeaea;
  --sq-editor-nav-button-disabled: #366168;
  --sq-editor-nav-button-selected: #2E5B65;
  --sq-editor-nav-border: #424c51;
  --sq-editor-interactive-selected: #439b76;
  --sq-editor-selector-intereactive-hovered: #A3CABA;
  --sq-editor-button-interactive-hovered: #388363;
  

  /* Modal */
  --sq-surface-modal-banner: #12c8d7;

  /* Input */
  --sq-surface-input-disabled: var(--iui-pale-gray);
  --sq-text-input-disabled: #bdbdbd;

  /* Typography */
  --sq-font-family-sans: "Muli", "Helvetica Neue", Helvetica, sans-serif;
  --sq-font-family-monospace: monospace;

  --sq-font-weight-regular: 400;
  --sq-font-weight-semibold: 600;
  --sq-font-weight-bold: 700;

  --sq-font-size-header-one: 26px;
  --sq-font-size-header-two: 22px;
  --sq-font-size-header-three: 20px;
  --sq-font-size-header-four: 18px;
  --sq-font-size-regular: 14px;
  --sq-font-size-small: 12px;
  --sq-font-size-caption: 16px;

  --sq-line-height-header-one: 32px;
  --sq-line-height-header-two: 28px;
  --sq-line-height-header-three: 24px;
  --sq-line-height-regular: 20px;
  --sq-line-height-caption: 16px;

  /* Button */
  --sq-font-size-button-small: 12px;
  --sq-font-size-button-medium: 14px;
  --sq-font-size-button-large: 16px;
  --sq-line-height-button-small: 16px;
  --sq-line-height-button-medium: 20px;
  --sq-line-height-button-large: 24px;

  /* Icon Sizes */
  --sq-icon-size-small: 12px;
  --sq-icon-size-medium: 20px;
  --sq-icon-size-large: 36px;
  --sq-icon-size-badge: 18px;

  /* Avatar Sizes */
  --sq-icon-size-avatar: 36px;
  --sq-icon-size-avatar-large: 50px;
  --sq-font-size-avatar: 24px;

  /* Spacing */
  --sq-spacing-xxx-small: 2px;
  --sq-spacing-xx-small: 4px;
  --sq-spacing-x-small: 8px;
  --sq-spacing-small: 12px;
  --sq-spacing-medium: 16px;
  --sq-spacing-large: 20px;
  --sq-spacing-x-large: 24px;
  --sq-spacing-xx-large: 32px;
  --sq-spacing-xxx-large: 48px;
  --sq-spacing-xxxx-large: 64px;

  /* Border Radii */
  --sq-border-radius-small: 2px;
  --sq-border-radius-normal: 8px;
  --sq-border-radius-pill: 9999px;

  /* Shadows */
  --iui-box-shadow-default: 0 1px 4px 0 var(--iui-bleakest-gray);
} 
`, Zh = tr`

a{
  color: var(--iui-strata-blue);
  text-decoration: none;
  font-weight: var(--sq-font-weight-semibold);
  
  &:visited{
    color: var(--iui-strata-blue);
  }

  &:hover{
    color: var(--iui-strata-blue);
    text-decoration: underline;
  }
}`, Qh = tr`
*, *::before, *::after {
  box-sizing: border-box;
}

body{
  line-height: var(--sq-line-height-regular);
  font-family: var(--sq-font-family-sans);
  color: var(--sq-text);
  margin: 0;
}

h1{
  font-size: var(--sq-font-size-header-one);
  line-height: var(--sq-line-height-header-one);
  font-weight: var(--sq-font-weight-bold);
  font-family: var(--sq-font-family-sans);
  color: var(--sq-text);
}

h2{
  font-size: var(--sq-font-size-header-two);
  line-height: var(--sq-line-height-header-two);
  font-weight: var(--sq-font-weight-bold);
  font-family: var(--sq-font-family-sans);
  color: var(--sq-text);
}

h3{
  font-size: var(--sq-font-size-header-three);
  line-height: var(--sq-line-height-header-three);
  font-weight: var(--sq-font-weight-bold);
  font-family: var(--sq-font-family-sans);
  color: var(--sq-text);
}

p{
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  font-weight: var(--sq-font-weight-regular);
  font-family: var(--sq-font-family-sans);
  color: var(--sq-text);
}

pre{
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  font-weight: var(--sq-font-weight-regular);
  font-family: var(--sq-font-family-monospace);
  color: var(--sq-text);
}

a{
  
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  font-weight: var(--sq-font-weight-regular);
  font-family: var(--sq-font-family-sans);
}

`, em = () => /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(tm, null), /* @__PURE__ */ g.createElement(Zh, null), /* @__PURE__ */ g.createElement(Qh, null)), tm = tr`
/* fonts */
/* vietnamese */
@font-face {
  font-family: "Muli";
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/muli/v28/7Auwp_0qiz-afT3GLQjUwkQ1OQ.woff2)
    format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1,
    U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329,
    U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Muli";
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/muli/v28/7Auwp_0qiz-afTzGLQjUwkQ1OQ.woff2)
    format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF,
    U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Muli";
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/muli/v28/7Auwp_0qiz-afTLGLQjUwkQ.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191,
    U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* vietnamese */
@font-face {
  font-family: "Muli";
  font-style: normal;
  font-weight: 600;
  src: url(https://fonts.gstatic.com/s/muli/v28/7Auwp_0qiz-afT3GLQjUwkQ1OQ.woff2)
    format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1,
    U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329,
    U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Muli";
  font-style: normal;
  font-weight: 600;
  src: url(https://fonts.gstatic.com/s/muli/v28/7Auwp_0qiz-afTzGLQjUwkQ1OQ.woff2)
    format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF,
    U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Muli";
  font-style: normal;
  font-weight: 600;
  src: url(https://fonts.gstatic.com/s/muli/v28/7Auwp_0qiz-afTLGLQjUwkQ.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191,
    U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* vietnamese */
@font-face {
  font-family: "Muli";
  font-style: normal;
  font-weight: 700;
  src: url(https://fonts.gstatic.com/s/muli/v28/7Auwp_0qiz-afT3GLQjUwkQ1OQ.woff2)
    format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1,
    U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329,
    U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Muli";
  font-style: normal;
  font-weight: 700;
  src: url(https://fonts.gstatic.com/s/muli/v28/7Auwp_0qiz-afTzGLQjUwkQ1OQ.woff2)
    format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF,
    U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Muli";
  font-style: normal;
  font-weight: 700;
  src: url(https://fonts.gstatic.com/s/muli/v28/7Auwp_0qiz-afTLGLQjUwkQ.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191,
    U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}`, nm = tr`
  hr{
    border: none;
    border-top: 1px solid var(--sq-border);
    margin: var(--sq-spacing-xx-large) 0;
  }
`, rm = tr`
  ul, li {
    color: var(--sq-text);
    font-family: var(--sq-font-family-sans);
    font-weight: var(--sq-font-weight-regular);
    font-size: var(--sq-font-size-regular);
    line-height: var(--sq-line-height-regular);
  }
`, om = tr`
  table {
    color: var(--sq-text);
    font-family: var(--sq-font-family-sans);
    font-weight: var(--sq-font-weight-regular);
    font-size: var(--sq-font-size-regular);
    line-height: var(--sq-line-height-regular);
  }
`, bC = () => /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(Gh, null), /* @__PURE__ */ g.createElement(em, null), /* @__PURE__ */ g.createElement(rm, null), /* @__PURE__ */ g.createElement(im, null), /* @__PURE__ */ g.createElement(nm, null), /* @__PURE__ */ g.createElement(om, null)), im = tr`
  uicl-form-section, uicl-field-label-pair::part(base) {
      width: 100%;
  }

  uicl-form-section::part(heading){
    font-size: var(--sq-font-size-header-four);
    font-weight: var(--sq-font-weight-semibold);
    color: var(--sq-text);
    margin: 0;
  }

  uicl-field-label-pair::part(mainLabel){
    font-size: var(--sq-font-size-regular);
    font-weight: var(--sq-font-weight-bold);
    color: var(--sq-text);
    margin: 0;
  }

  .no-gutter uicl-field-label-pair::part(base){
    --form-gutter : 0
  }

  uicl-form-section.side-heading::part(base){
    padding-left: 0 !important;
  }
`;
E.div`
  text-align: center;
  padding: 6px 0;
`;
const am = E.svg`
  overflow: unset;
  display: inline-block;
  position: relative;
  //   top: 1px;
  //   left: 2px;
  width: ${(e) => e.size};
  height: ${(e) => e.size};
  margin: -2px;
  margin-left: 0.5px;
  margin-right: 0.5px;
  //   margin-right: 0px;

  .path {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
    &.circle {
      -webkit-animation: dash 0.9s ease-in-out;
      animation: dash 0.9s ease-in-out;
    }
    &.line {
      stroke-dashoffset: 1000;
      -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
      animation: dash 0.9s 0.35s ease-in-out forwards;
    }
    &.check {
      stroke-dashoffset: -100;
      -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
      animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }
  }

  p {
    text-align: center;
    margin: 20px 0 60px;
    font-size: 1.25em;
    &.success {
      color: #73af55;
    }
    &.error {
      color: #d06079;
    }
  }

  @-webkit-keyframes dash {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  @keyframes dash {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  @-webkit-keyframes dash-check {
    0% {
      stroke-dashoffset: -100;
    }
    100% {
      stroke-dashoffset: 900;
    }
  }

  @keyframes dash-check {
    0% {
      stroke-dashoffset: -100;
    }
    100% {
      stroke-dashoffset: 900;
    }
  }
`, sm = pc`
   from {      
     transform: rotate(0deg);    
    }    
    to {      
      transform: rotate(360deg);    
    }
`, lm = E.div`
  display: inline-block;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    border-radius: 50%;
    animation: ${sm} 1.7s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  }

  div:nth-child(1) {
    animation-delay: -0.45s;
  }

  div:nth-child(2) {
    animation-delay: -0.3s;
  }

  div:nth-child(3) {
    animation-delay: -0.15s;
  }
`, cm = E(lm)`
  position: relative;

  top: 2px;

  ${(e) => e.size == "12px" ? "margin-right: 12px;" : ""}
  ${(e) => e.size == "12px" ? "margin-right: 12px;" : ""}
  ${(e) => e.size == "15px" ? "margin-right: 15px;" : ""}

  div {
    width: ${(e) => e.size};
    height: ${(e) => e.size};
    bottom: 50%;
    border: 2px solid ${(e) => e.color};
    border-color: ${(e) => e.color} transparent transparent transparent;
  }
`, um = (e, t) => /* @__PURE__ */ g.createElement(cm, { size: e, color: t }, /* @__PURE__ */ g.createElement("div", null), /* @__PURE__ */ g.createElement("div", null), /* @__PURE__ */ g.createElement("div", null), /* @__PURE__ */ g.createElement("div", null)), dm = (e) => /* @__PURE__ */ g.createElement(
  am,
  {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.2 130.2",
    size: e
  },
  /* @__PURE__ */ g.createElement(
    "circle",
    {
      className: "path circle",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "14",
      "stroke-miterlimit": "10",
      cx: "65.1",
      cy: "65.1",
      r: "62.1"
    }
  ),
  /* @__PURE__ */ g.createElement(
    "polyline",
    {
      className: "path check",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "14",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      points: "100.2,40.2 51.5,88.8 29.8,67.5 "
    }
  )
), Gi = {
  mini: "5px",
  small: "16px",
  medium: "16px",
  large: "20px"
}, Rc = {
  impact: {
    small: "calc(var(--sq-icon-size-small) - 4px)",
    medium: "calc(var(--sq-icon-size-medium) - 4px)",
    large: "calc(var(--sq-icon-size-large) - 4px)",
    mini: "calc(var(--sq-icon-size-badge) - 4px)"
  },
  saasquatch: {
    small: "calc(var(--sq-icon-size-badge) - 4px)",
    medium: "calc(var(--sq-icon-size-medium) - 4px)",
    large: "calc(var(--sq-icon-size-large) - 4px)",
    mini: "calc(var(--sq-icon-size-small) - 4px)"
  }
}, Tc = {
  small: "12px",
  medium: "12px",
  large: "15px"
}, Ac = {
  small: "12px",
  medium: "12px",
  large: "15px"
}, Zi = {
  small: "6px",
  medium: "6px",
  large: "6px"
}, $c = v`
  border: none !important;
  box-sizing: border-box;
  font-weight: var(--sq-font-weight-semibold);
  font-family: var(--sq-font-family-sans);
`, Ic = v`
  padding: 6px var(--sq-spacing-x-small);
  font-size: var(--sq-font-size-button-small);
  line-height: var(--sq-line-height-button-small);
  // height: var(--sq-line-height-button-small);
`, pm = v`
  padding: var(--sq-spacing-x-small);
  font-size: var(--sq-font-size-button-medium);
  line-height: var(--sq-line-height-button-medium);
  // height: var(--sq-line-height-button-medium);
`, Nc = v`
  padding: var(--sq-spacing-small);
  font-size: var(--sq-font-size-button-large);
  line-height: var(--sq-line-height-button-large);
  // height: var(--sq-line-height-button-large);
`, fm = {
  critical: v`
    background: var(--sq-surface-critical);
    &:hover {
      background: var(--sq-surface-critical-hovered);
    }
  `,
  success: v`
    background: var(--sq-surface-success);
    &:hover {
      background: var(--sq-surface-success-hovered);
    }
  `,
  loading: v`
    cursor: wait;
    background: var(--sq-action-primary-disabled);
    color: var(--sq-text-on-primary-disabled);
    &:hover {
      background: var(--sq-action-primary-disabled);
    }
  `
}, hm = {
  critical: v`
    color: var(--sq-surface-critical);
    &:hover {
      background: var(--sq-action-secondary-hovered);
    }
  `,
  success: v`
    color: var(--sq-surface-success);
    &:hover {
      background: var(--sq-action-secondary-hovered);
    }
  `,
  loading: v`
    cursor: wait;
    color: var(--sq-text-on-primary-disabled);
    &:hover {
      background: var(--sq-action-secondary);
    }
  `
}, mm = {
  critical: v`
    color: var(--sq-surface-critical-hovered);
  `,
  success: v`
    color: var(--sq-surface-success-hovered);
  `
}, Dn = {
  base: v`
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  primary: v``,
  secondary: v``,
  text: v``,
  outline: v`
    border: 1px solid var(--sq-border);
    &:hover {
      background: transparent;
      border: 1px solid var(--sq-border-hover);
    }
  `,
  disabledBackground: v`
    background: var(--sq-background-subdued) !important;
    border-color: var(--sq-text-on-primary-disabled) !important;
    color: var(--sq-text-on-primary-disabled) !important;
  `,
  uicl_base: v`
    min-width: unset;
  `,
  mini: v`
    width: 20px;
    height: 20px;
    padding: var(--sq-spacing-xxx-small) !important;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  small: v`
    width: 28px;
    height: 28px;
    padding: var(--sq-spacing-xx-small) !important;
  `,
  medium: v`
    width: 36px;
    height: 36px;
    padding: var(--sq-spacing-x-small) !important;
  `,
  large: v`
    width: 62px;
    height: 62px;
    padding: var(--sq-spacing-small) !important;
  `,
  circle: v`
    border-radius: var(--sq-border-radius-pill);
  `,
  borderless: v`
    background: transparent;
  `,
  backgroundless: v`
    background: transparent;
  `
}, $i = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  anim_padding: Zi,
  checkmark_anim: Tc,
  icon: Dn,
  icon_only_size: Rc,
  icon_size: Gi,
  large: Nc,
  loading_anim: Ac,
  medium: pm,
  primary: fm,
  secondary: hm,
  small: Ic,
  text: mm,
  universal_base: $c
}, Symbol.toStringTag, { value: "Module" })), vm = E.div`
  display: block;
  uicl-btn::part(base) {
    ${$c}
    ${(e) => e.size == "small" && Ic}
    ${(e) => e.size == "large" && Nc}
    ${(e) => e.critical && $i[e.buttonType].critical}
    ${(e) => e.success && $i[e.buttonType].success}
    ${(e) => e.isLoading && e.buttonType != "text" && $i[e.buttonType].loading}
    margin-right: 0 !important;
    ${(e) => e.customCSS}
  }
`, gm = qn("uicl-btn"), Vc = m.forwardRef((e, t) => {
  const {
    buttonType: n = "primary",
    loading: r = !1,
    critical: o = !1,
    success: i = !1,
    icon: a,
    iconLocation: s = "left",
    size: l = "medium",
    children: d,
    customCSS: p = {},
    disabled: c = !1,
    style: b,
    onClick: k,
    ...q
  } = e, C = n === "text" ? "tertiary" : n;
  return /* @__PURE__ */ m.createElement(
    vm,
    {
      buttonType: n,
      customCSS: p,
      isLoading: r,
      critical: o && !c,
      success: i && !c,
      size: l,
      style: b
    },
    /* @__PURE__ */ m.createElement(
      gm,
      {
        ...q,
        onClick: (w) => {
          if (!(w != null && w.isTrusted)) {
            w.stopPropagation();
            return;
          }
          k && k(w);
        },
        disabled: c || r,
        isDisabled: Be(c || r),
        className: C,
        isMultiClickable: Be(!0),
        ref: t
      },
      s == "left" && a && /* @__PURE__ */ m.createElement(
        Le,
        {
          cursor: "inherit",
          icon: a,
          size: Gi[l]
        }
      ),
      /* @__PURE__ */ m.createElement("span", null, " ", d, " "),
      s == "right" && a && /* @__PURE__ */ m.createElement(
        Le,
        {
          cursor: "inherit",
          icon: a,
          size: Gi[l]
        }
      ),
      r && e.buttonType != "text" && /* @__PURE__ */ m.createElement(m.Fragment, null, d && /* @__PURE__ */ m.createElement("span", { style: { padding: Zi[l] } }), um(
        Ac[l],
        n == "primary" ? "var(--sq-action-primary)" : "var(--sq-action-secondary-border)"
      )),
      n == "primary" && i && /* @__PURE__ */ m.createElement(m.Fragment, null, d && /* @__PURE__ */ m.createElement("span", { style: { padding: Zi[l] } }), dm(Tc[l]))
    )
  );
}), Mr = Vc, bm = E.div`
  display: contents;
  uicl-btn::part(base) {
    ${Dn.base}
    ${(e) => Dn[e.buttonType]}
    ${(e) => e.buttonType === "outline" && e.disabled && Dn.disabledBackground}
    ${(e) => e.borderless && Dn.borderless}
    ${(e) => e.backgroundless && Dn.backgroundless}
    ${(e) => e.circle && Dn.circle}
    ${(e) => Dn[e.size]}
    ${(e) => e.customCSS}
  }

  uicl-btn::part(base) {
    ${Dn.uicl_base}
  }
`, ym = qn("uicl-btn"), Jn = m.forwardRef((e, t) => {
  const {
    icon: n,
    buttonType: r = "secondary",
    borderless: o = !1,
    backgroundless: i = !1,
    primary: a = !1,
    circle: s = !1,
    size: l = "medium",
    iconSet: d = "saasquatch",
    icon_css: p = {},
    customCSS: c = {},
    disabled: b = !1,
    onClick: k,
    ...q
  } = e, C = a ? "primary" : o ? "text" : r, w = C === "text" || C === "outline" ? "tertiary" : C;
  return /* @__PURE__ */ m.createElement(
    bm,
    {
      buttonType: C,
      circle: s,
      primary: a,
      borderless: o,
      backgroundless: i,
      disabled: b,
      size: l,
      tabIndex: 0,
      customCSS: c
    },
    /* @__PURE__ */ m.createElement(
      ym,
      {
        ...q,
        onClick: (T) => {
          if (!(T != null && T.isTrusted)) {
            T.stopPropagation();
            return;
          }
          k && k(T);
        },
        disabled: b,
        isDisabled: Be(b),
        isMultiClickable: Be(!0),
        ref: t,
        style: { display: "block" },
        className: w
      },
      /* @__PURE__ */ m.createElement(
        Le,
        {
          icon: n,
          size: Rc[d][l],
          iconSet: d,
          style: { display: "flex" },
          customCSS: p,
          cursor: "inherit"
        }
      )
    )
  );
}), fn = Jn, xm = v`
  user-select: none;
  cursor: not-allowed;
  pointer-events: none;
  color: var(--sq-text-subdued);
`;
v`
  user-select: none;
  cursor: not-allowed;
  pointer-events: none;
  background: var(--sq-surface-input-disabled);
  box-shadow: 0 0 0 1px var(--sq-border);
`;
const wm = v`
  user-select: none;
  display: inline-flex;
  cursor: pointer;
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-regular);
  /* width: max-content; */
`;
v`
  position: absolute;
  color: inherit;
  width: 20px;
  height: 20px;
  transition: transform 0.1s;
  transform: scale(0);
`;
v`
  display: none;

  &:checked + div > span {
    transform: scale(1);
  }
`;
const Em = v`
  margin-right: var(--sq-spacing-small);
`;
v`
  &:checked + div {
    box-shadow: 0 0 0 2px var(--sq-text);
  }
`;
v`
  &:checked + div {
    box-shadow: 0 0 0 2px var(--sq-text-subdued);
  }
`;
const km = E.div`
  display: inline;
  ${(e) => e.customContainerCSS}
`, Sm = E.label`
  ${wm}
  ${(e) => e.isDisabled && xm}

  ${(e) => e.hasLabel && `uicl-checkbox {
      line-height: 16px;
      margin-top: var(--sq-spacing-xxx-small);
  }`}
`, Cm = E(qn("uicl-checkbox"))`
  ${(e) => e.lock && "pointer-events: none; cursor:pointer;"}
  ${Em}
`, zc = m.forwardRef(
  (e, t) => {
    const {
      id: n,
      value: r,
      label: o = "",
      disabled: i,
      readonly: a = !1,
      lock: s = !1,
      customContainerCSS: l = {},
      onChange: d,
      ...p
    } = e;
    function c(b) {
      const k = b.composedPath()[0];
      Object.defineProperty(b, "target", {
        value: k
      }), d && d(b);
    }
    return /* @__PURE__ */ m.createElement(km, { customContainerCSS: l }, /* @__PURE__ */ m.createElement(
      Sm,
      {
        htmlFor: n,
        isDisabled: i,
        hasLabel: o !== void 0,
        onClick: () => d && d({ target: { checked: !r } })
      },
      /* @__PURE__ */ m.createElement(
        Cm,
        {
          ...p,
          id: n,
          lock: s,
          isReadOnly: Be(a),
          isDisabled: Be(i),
          ref: t,
          modelValue: r ? "true" : null,
          onInput: c
        }
      ),
      /* @__PURE__ */ m.createElement("div", null, o || "")
    ));
  }
), yC = zc, qm = E.p`
  margin: 0 0 var(--sq-spacing-x-small);
  color: var(--sq-text);
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-bold);
`;
function xC(e) {
  const t = e.options;
  return /* @__PURE__ */ g.createElement("div", null, (t == null ? void 0 : t.description) && /* @__PURE__ */ g.createElement(qm, null, t.description), /* @__PURE__ */ g.createElement(
    zc,
    {
      id: e.id,
      ...t,
      value: e.value,
      required: e.required,
      onChange: (n) => {
        e.readonly || e.onChange(n.target.checked);
      },
      disabled: e.disabled,
      readOnly: e.readonly,
      label: t.title || e.label
    }
  ));
}
var Qi = {}, ea = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ii, nl;
function Da() {
  if (nl)
    return Ii;
  nl = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(p) {
        return a[p];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        d[p] = p;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ii = o() ? Object.assign : function(i, a) {
    for (var s, l = r(i), d, p = 1; p < arguments.length; p++) {
      s = Object(arguments[p]);
      for (var c in s)
        t.call(s, c) && (l[c] = s[c]);
      if (e) {
        d = e(s);
        for (var b = 0; b < d.length; b++)
          n.call(s, d[b]) && (l[d[b]] = s[d[b]]);
      }
    }
    return l;
  }, Ii;
}
/** @license React v16.14.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ni, rl;
function _m() {
  if (rl)
    return Ni;
  rl = 1;
  var e = Da(), t = g;
  function n(y) {
    for (var A = "https://reactjs.org/docs/error-decoder.html?invariant=" + y, D = 1; D < arguments.length; D++)
      A += "&args[]=" + encodeURIComponent(arguments[D]);
    return "Minified React error #" + y + "; visit " + A + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = typeof Symbol == "function" && Symbol.for, o = r ? Symbol.for("react.portal") : 60106, i = r ? Symbol.for("react.fragment") : 60107, a = r ? Symbol.for("react.strict_mode") : 60108, s = r ? Symbol.for("react.profiler") : 60114, l = r ? Symbol.for("react.provider") : 60109, d = r ? Symbol.for("react.context") : 60110, p = r ? Symbol.for("react.concurrent_mode") : 60111, c = r ? Symbol.for("react.forward_ref") : 60112, b = r ? Symbol.for("react.suspense") : 60113, k = r ? Symbol.for("react.suspense_list") : 60120, q = r ? Symbol.for("react.memo") : 60115, C = r ? Symbol.for("react.lazy") : 60116, w = r ? Symbol.for("react.block") : 60121, T = r ? Symbol.for("react.fundamental") : 60117, F = r ? Symbol.for("react.scope") : 60119;
  function L(y) {
    if (y._status === -1) {
      y._status = 0;
      var A = y._ctor;
      A = A(), y._result = A, A.then(function(D) {
        y._status === 0 && (D = D.default, y._status = 1, y._result = D);
      }, function(D) {
        y._status === 0 && (y._status = 2, y._result = D);
      });
    }
  }
  function me(y) {
    if (y == null)
      return null;
    if (typeof y == "function")
      return y.displayName || y.name || null;
    if (typeof y == "string")
      return y;
    switch (y) {
      case i:
        return "Fragment";
      case o:
        return "Portal";
      case s:
        return "Profiler";
      case a:
        return "StrictMode";
      case b:
        return "Suspense";
      case k:
        return "SuspenseList";
    }
    if (typeof y == "object")
      switch (y.$$typeof) {
        case d:
          return "Context.Consumer";
        case l:
          return "Context.Provider";
        case c:
          var A = y.render;
          return A = A.displayName || A.name || "", y.displayName || (A !== "" ? "ForwardRef(" + A + ")" : "ForwardRef");
        case q:
          return me(y.type);
        case w:
          return me(y.render);
        case C:
          if (y = y._status === 1 ? y._result : null)
            return me(y);
      }
    return null;
  }
  var O = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  O.hasOwnProperty("ReactCurrentDispatcher") || (O.ReactCurrentDispatcher = { current: null }), O.hasOwnProperty("ReactCurrentBatchConfig") || (O.ReactCurrentBatchConfig = { suspense: null });
  var Pe = {};
  function qe(y, A) {
    for (var D = y._threadCount | 0; D <= A; D++)
      y[D] = y._currentValue2, y._threadCount = D + 1;
  }
  function it(y, A, D, te) {
    if (te && (te = y.contextType, typeof te == "object" && te !== null))
      return qe(te, D), te[D];
    if (y = y.contextTypes) {
      D = {};
      for (var ce in y)
        D[ce] = A[ce];
      A = D;
    } else
      A = Pe;
    return A;
  }
  for (var Ne = new Uint16Array(16), Ke = 0; 15 > Ke; Ke++)
    Ne[Ke] = Ke + 1;
  Ne[15] = 0;
  var at = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, rt = Object.prototype.hasOwnProperty, _t = {}, Me = {};
  function He(y) {
    return rt.call(Me, y) ? !0 : rt.call(_t, y) ? !1 : at.test(y) ? Me[y] = !0 : (_t[y] = !0, !1);
  }
  function fe(y, A, D, te) {
    if (D !== null && D.type === 0)
      return !1;
    switch (typeof A) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return te ? !1 : D !== null ? !D.acceptsBooleans : (y = y.toLowerCase().slice(0, 5), y !== "data-" && y !== "aria-");
      default:
        return !1;
    }
  }
  function Ee(y, A, D, te) {
    if (A === null || typeof A > "u" || fe(y, A, D, te))
      return !0;
    if (te)
      return !1;
    if (D !== null)
      switch (D.type) {
        case 3:
          return !A;
        case 4:
          return A === !1;
        case 5:
          return isNaN(A);
        case 6:
          return isNaN(A) || 1 > A;
      }
    return !1;
  }
  function le(y, A, D, te, ce, ne) {
    this.acceptsBooleans = A === 2 || A === 3 || A === 4, this.attributeName = te, this.attributeNamespace = ce, this.mustUseProperty = D, this.propertyName = y, this.type = A, this.sanitizeURL = ne;
  }
  var Ve = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(y) {
    Ve[y] = new le(y, 0, !1, y, null, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(y) {
    var A = y[0];
    Ve[A] = new le(A, 1, !1, y[1], null, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(y) {
    Ve[y] = new le(y, 2, !1, y.toLowerCase(), null, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(y) {
    Ve[y] = new le(y, 2, !1, y, null, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(y) {
    Ve[y] = new le(y, 3, !1, y.toLowerCase(), null, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(y) {
    Ve[y] = new le(y, 3, !0, y, null, !1);
  }), ["capture", "download"].forEach(function(y) {
    Ve[y] = new le(y, 4, !1, y, null, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(y) {
    Ve[y] = new le(y, 6, !1, y, null, !1);
  }), ["rowSpan", "start"].forEach(function(y) {
    Ve[y] = new le(y, 5, !1, y.toLowerCase(), null, !1);
  });
  var M = /[\-:]([a-z])/g;
  function Z(y) {
    return y[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(y) {
    var A = y.replace(
      M,
      Z
    );
    Ve[A] = new le(A, 1, !1, y, null, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(y) {
    var A = y.replace(M, Z);
    Ve[A] = new le(A, 1, !1, y, "http://www.w3.org/1999/xlink", !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(y) {
    var A = y.replace(M, Z);
    Ve[A] = new le(A, 1, !1, y, "http://www.w3.org/XML/1998/namespace", !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(y) {
    Ve[y] = new le(y, 1, !1, y.toLowerCase(), null, !1);
  }), Ve.xlinkHref = new le("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function(y) {
    Ve[y] = new le(y, 1, !1, y.toLowerCase(), null, !0);
  });
  var xe = /["'&<>]/;
  function ve(y) {
    if (typeof y == "boolean" || typeof y == "number")
      return "" + y;
    y = "" + y;
    var A = xe.exec(y);
    if (A) {
      var D = "", te, ce = 0;
      for (te = A.index; te < y.length; te++) {
        switch (y.charCodeAt(te)) {
          case 34:
            A = "&quot;";
            break;
          case 38:
            A = "&amp;";
            break;
          case 39:
            A = "&#x27;";
            break;
          case 60:
            A = "&lt;";
            break;
          case 62:
            A = "&gt;";
            break;
          default:
            continue;
        }
        ce !== te && (D += y.substring(ce, te)), ce = te + 1, D += A;
      }
      y = ce !== te ? D + y.substring(ce, te) : D;
    }
    return y;
  }
  function we(y, A) {
    var D = Ve.hasOwnProperty(y) ? Ve[y] : null, te;
    return (te = y !== "style") && (te = D !== null ? D.type === 0 : !(!(2 < y.length) || y[0] !== "o" && y[0] !== "O" || y[1] !== "n" && y[1] !== "N")), te || Ee(y, A, D, !1) ? "" : D !== null ? (y = D.attributeName, te = D.type, te === 3 || te === 4 && A === !0 ? y + '=""' : (D.sanitizeURL && (A = "" + A), y + '="' + (ve(A) + '"'))) : He(y) ? y + '="' + (ve(A) + '"') : "";
  }
  function Te(y, A) {
    return y === A && (y !== 0 || 1 / y === 1 / A) || y !== y && A !== A;
  }
  var ke = typeof Object.is == "function" ? Object.is : Te, de = null, ge = null, ie = null, Se = !1, st = !1, Y = null, h = 0;
  function x() {
    if (de === null)
      throw Error(n(321));
    return de;
  }
  function R() {
    if (0 < h)
      throw Error(n(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function N() {
    return ie === null ? ge === null ? (Se = !1, ge = ie = R()) : (Se = !0, ie = ge) : ie.next === null ? (Se = !1, ie = ie.next = R()) : (Se = !0, ie = ie.next), ie;
  }
  function V(y, A, D, te) {
    for (; st; )
      st = !1, h += 1, ie = null, D = y(A, te);
    return ge = de = null, h = 0, ie = Y = null, D;
  }
  function j(y, A) {
    return typeof A == "function" ? A(y) : A;
  }
  function J(y, A, D) {
    if (de = x(), ie = N(), Se) {
      var te = ie.queue;
      if (A = te.dispatch, Y !== null && (D = Y.get(te), D !== void 0)) {
        Y.delete(te), te = ie.memoizedState;
        do
          te = y(te, D.action), D = D.next;
        while (D !== null);
        return ie.memoizedState = te, [te, A];
      }
      return [ie.memoizedState, A];
    }
    return y = y === j ? typeof A == "function" ? A() : A : D !== void 0 ? D(A) : A, ie.memoizedState = y, y = ie.queue = { last: null, dispatch: null }, y = y.dispatch = U.bind(null, de, y), [ie.memoizedState, y];
  }
  function U(y, A, D) {
    if (!(25 > h))
      throw Error(n(301));
    if (y === de)
      if (st = !0, y = { action: D, next: null }, Y === null && (Y = /* @__PURE__ */ new Map()), D = Y.get(A), D === void 0)
        Y.set(A, y);
      else {
        for (A = D; A.next !== null; )
          A = A.next;
        A.next = y;
      }
  }
  function B() {
  }
  var P = 0, oe = { readContext: function(y) {
    var A = P;
    return qe(y, A), y[A];
  }, useContext: function(y) {
    x();
    var A = P;
    return qe(y, A), y[A];
  }, useMemo: function(y, A) {
    if (de = x(), ie = N(), A = A === void 0 ? null : A, ie !== null) {
      var D = ie.memoizedState;
      if (D !== null && A !== null) {
        e: {
          var te = D[1];
          if (te === null)
            te = !1;
          else {
            for (var ce = 0; ce < te.length && ce < A.length; ce++)
              if (!ke(A[ce], te[ce])) {
                te = !1;
                break e;
              }
            te = !0;
          }
        }
        if (te)
          return D[0];
      }
    }
    return y = y(), ie.memoizedState = [y, A], y;
  }, useReducer: J, useRef: function(y) {
    de = x(), ie = N();
    var A = ie.memoizedState;
    return A === null ? (y = { current: y }, ie.memoizedState = y) : A;
  }, useState: function(y) {
    return J(j, y);
  }, useLayoutEffect: function() {
  }, useCallback: function(y) {
    return y;
  }, useImperativeHandle: B, useEffect: B, useDebugValue: B, useResponder: function(y, A) {
    return { props: A, responder: y };
  }, useDeferredValue: function(y) {
    return x(), y;
  }, useTransition: function() {
    return x(), [function(y) {
      y();
    }, !1];
  } }, ae = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
  function pe(y) {
    switch (y) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  var ye = { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }, Re = e({ menuitem: !0 }, ye), je = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Ue = ["Webkit", "ms", "Moz", "O"];
  Object.keys(je).forEach(function(y) {
    Ue.forEach(function(A) {
      A = A + y.charAt(0).toUpperCase() + y.substring(1), je[A] = je[y];
    });
  });
  var lt = /([A-Z])/g, _ = /^ms-/, z = t.Children.toArray, W = O.ReactCurrentDispatcher, De = { listing: !0, pre: !0, textarea: !0 }, We = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ce = {}, _e = {};
  function Ae(y) {
    if (y == null)
      return y;
    var A = "";
    return t.Children.forEach(y, function(D) {
      D != null && (A += D);
    }), A;
  }
  var kt = Object.prototype.hasOwnProperty, jt = { children: null, dangerouslySetInnerHTML: null, suppressContentEditableWarning: null, suppressHydrationWarning: null };
  function Jt(y, A) {
    if (y === void 0)
      throw Error(n(152, me(A) || "Component"));
  }
  function vn(y, A, D) {
    function te(se, ee) {
      var Q = ee.prototype && ee.prototype.isReactComponent, Dt = it(ee, A, D, Q), ct = [], Ye = !1, dt = { isMounted: function() {
        return !1;
      }, enqueueForceUpdate: function() {
        if (ct === null)
          return null;
      }, enqueueReplaceState: function(Ot, Sr) {
        Ye = !0, ct = [Sr];
      }, enqueueSetState: function(Ot, Sr) {
        if (ct === null)
          return null;
        ct.push(Sr);
      } };
      if (Q) {
        if (Q = new ee(se.props, Dt, dt), typeof ee.getDerivedStateFromProps == "function") {
          var ut = ee.getDerivedStateFromProps.call(null, se.props, Q.state);
          ut != null && (Q.state = e({}, Q.state, ut));
        }
      } else if (de = {}, Q = ee(
        se.props,
        Dt,
        dt
      ), Q = V(ee, se.props, Q, Dt), Q == null || Q.render == null) {
        y = Q, Jt(y, ee);
        return;
      }
      if (Q.props = se.props, Q.context = Dt, Q.updater = dt, dt = Q.state, dt === void 0 && (Q.state = dt = null), typeof Q.UNSAFE_componentWillMount == "function" || typeof Q.componentWillMount == "function")
        if (typeof Q.componentWillMount == "function" && typeof ee.getDerivedStateFromProps != "function" && Q.componentWillMount(), typeof Q.UNSAFE_componentWillMount == "function" && typeof ee.getDerivedStateFromProps != "function" && Q.UNSAFE_componentWillMount(), ct.length) {
          dt = ct;
          var ft = Ye;
          if (ct = null, Ye = !1, ft && dt.length === 1)
            Q.state = dt[0];
          else {
            ut = ft ? dt[0] : Q.state;
            var yt = !0;
            for (ft = ft ? 1 : 0; ft < dt.length; ft++) {
              var wt = dt[ft];
              wt = typeof wt == "function" ? wt.call(Q, ut, se.props, Dt) : wt, wt != null && (yt ? (yt = !1, ut = e({}, ut, wt)) : e(ut, wt));
            }
            Q.state = ut;
          }
        } else
          ct = null;
      if (y = Q.render(), Jt(y, ee), typeof Q.getChildContext == "function" && (se = ee.childContextTypes, typeof se == "object")) {
        var Vt = Q.getChildContext();
        for (var Vn in Vt)
          if (!(Vn in se))
            throw Error(n(108, me(ee) || "Unknown", Vn));
      }
      Vt && (A = e({}, A, Vt));
    }
    for (; t.isValidElement(y); ) {
      var ce = y, ne = ce.type;
      if (typeof ne != "function")
        break;
      te(ce, ne);
    }
    return { child: y, context: A };
  }
  var tn = function() {
    function y(D, te) {
      t.isValidElement(D) ? D.type !== i ? D = [D] : (D = D.props.children, D = t.isValidElement(D) ? [D] : z(D)) : D = z(D), D = { type: null, domNamespace: ae.html, children: D, childIndex: 0, context: Pe, footer: "" };
      var ce = Ne[0];
      if (ce === 0) {
        var ne = Ne;
        ce = ne.length;
        var se = 2 * ce;
        if (!(65536 >= se))
          throw Error(n(304));
        var ee = new Uint16Array(se);
        for (ee.set(ne), Ne = ee, Ne[0] = ce + 1, ne = ce; ne < se - 1; ne++)
          Ne[ne] = ne + 1;
        Ne[se - 1] = 0;
      } else
        Ne[0] = Ne[ce];
      this.threadID = ce, this.stack = [D], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = te, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [];
    }
    var A = y.prototype;
    return A.destroy = function() {
      if (!this.exhausted) {
        this.exhausted = !0, this.clearProviders();
        var D = this.threadID;
        Ne[D] = Ne[0], Ne[0] = D;
      }
    }, A.pushProvider = function(D) {
      var te = ++this.contextIndex, ce = D.type._context, ne = this.threadID;
      qe(ce, ne);
      var se = ce[ne];
      this.contextStack[te] = ce, this.contextValueStack[te] = se, ce[ne] = D.props.value;
    }, A.popProvider = function() {
      var D = this.contextIndex, te = this.contextStack[D], ce = this.contextValueStack[D];
      this.contextStack[D] = null, this.contextValueStack[D] = null, this.contextIndex--, te[this.threadID] = ce;
    }, A.clearProviders = function() {
      for (var D = this.contextIndex; 0 <= D; D--)
        this.contextStack[D][this.threadID] = this.contextValueStack[D];
    }, A.read = function(D) {
      if (this.exhausted)
        return null;
      var te = P;
      P = this.threadID;
      var ce = W.current;
      W.current = oe;
      try {
        for (var ne = [""], se = !1; ne[0].length < D; ) {
          if (this.stack.length === 0) {
            this.exhausted = !0;
            var ee = this.threadID;
            Ne[ee] = Ne[0], Ne[0] = ee;
            break;
          }
          var Q = this.stack[this.stack.length - 1];
          if (se || Q.childIndex >= Q.children.length) {
            var Dt = Q.footer;
            if (Dt !== "" && (this.previousWasTextNode = !1), this.stack.pop(), Q.type === "select")
              this.currentSelectValue = null;
            else if (Q.type != null && Q.type.type != null && Q.type.type.$$typeof === l)
              this.popProvider(Q.type);
            else if (Q.type === b) {
              this.suspenseDepth--;
              var ct = ne.pop();
              if (se) {
                se = !1;
                var Ye = Q.fallbackFrame;
                if (!Ye)
                  throw Error(n(303));
                this.stack.push(Ye), ne[this.suspenseDepth] += "<!--$!-->";
                continue;
              } else
                ne[this.suspenseDepth] += ct;
            }
            ne[this.suspenseDepth] += Dt;
          } else {
            var dt = Q.children[Q.childIndex++], ut = "";
            try {
              ut += this.render(dt, Q.context, Q.domNamespace);
            } catch (ft) {
              throw ft != null && typeof ft.then == "function" ? Error(n(294)) : ft;
            } finally {
            }
            ne.length <= this.suspenseDepth && ne.push(""), ne[this.suspenseDepth] += ut;
          }
        }
        return ne[0];
      } finally {
        W.current = ce, P = te;
      }
    }, A.render = function(D, te, ce) {
      if (typeof D == "string" || typeof D == "number")
        return ce = "" + D, ce === "" ? "" : this.makeStaticMarkup ? ve(ce) : this.previousWasTextNode ? "<!-- -->" + ve(ce) : (this.previousWasTextNode = !0, ve(ce));
      if (te = vn(D, te, this.threadID), D = te.child, te = te.context, D === null || D === !1)
        return "";
      if (!t.isValidElement(D)) {
        if (D != null && D.$$typeof != null)
          throw ce = D.$$typeof, Error(ce === o ? n(257) : n(258, ce.toString()));
        return D = z(D), this.stack.push({ type: null, domNamespace: ce, children: D, childIndex: 0, context: te, footer: "" }), "";
      }
      var ne = D.type;
      if (typeof ne == "string")
        return this.renderDOM(D, te, ce);
      switch (ne) {
        case a:
        case p:
        case s:
        case k:
        case i:
          return D = z(D.props.children), this.stack.push({ type: null, domNamespace: ce, children: D, childIndex: 0, context: te, footer: "" }), "";
        case b:
          throw Error(n(294));
      }
      if (typeof ne == "object" && ne !== null)
        switch (ne.$$typeof) {
          case c:
            de = {};
            var se = ne.render(D.props, D.ref);
            return se = V(ne.render, D.props, se, D.ref), se = z(se), this.stack.push({ type: null, domNamespace: ce, children: se, childIndex: 0, context: te, footer: "" }), "";
          case q:
            return D = [t.createElement(ne.type, e({ ref: D.ref }, D.props))], this.stack.push({ type: null, domNamespace: ce, children: D, childIndex: 0, context: te, footer: "" }), "";
          case l:
            return ne = z(D.props.children), ce = {
              type: D,
              domNamespace: ce,
              children: ne,
              childIndex: 0,
              context: te,
              footer: ""
            }, this.pushProvider(D), this.stack.push(ce), "";
          case d:
            ne = D.type, se = D.props;
            var ee = this.threadID;
            return qe(ne, ee), ne = z(se.children(ne[ee])), this.stack.push({ type: D, domNamespace: ce, children: ne, childIndex: 0, context: te, footer: "" }), "";
          case T:
            throw Error(n(338));
          case C:
            switch (ne = D.type, L(ne), ne._status) {
              case 1:
                return D = [t.createElement(ne._result, e({ ref: D.ref }, D.props))], this.stack.push({ type: null, domNamespace: ce, children: D, childIndex: 0, context: te, footer: "" }), "";
              case 2:
                throw ne._result;
              default:
                throw Error(n(295));
            }
          case F:
            throw Error(n(343));
        }
      throw Error(n(130, ne == null ? ne : typeof ne, ""));
    }, A.renderDOM = function(D, te, ce) {
      var ne = D.type.toLowerCase();
      if (!Ce.hasOwnProperty(ne)) {
        if (!We.test(ne))
          throw Error(n(65, ne));
        Ce[ne] = !0;
      }
      var se = D.props;
      if (ne === "input")
        se = e({ type: void 0 }, se, { defaultChecked: void 0, defaultValue: void 0, value: se.value != null ? se.value : se.defaultValue, checked: se.checked != null ? se.checked : se.defaultChecked });
      else if (ne === "textarea") {
        var ee = se.value;
        if (ee == null) {
          ee = se.defaultValue;
          var Q = se.children;
          if (Q != null) {
            if (ee != null)
              throw Error(n(92));
            if (Array.isArray(Q)) {
              if (!(1 >= Q.length))
                throw Error(n(93));
              Q = Q[0];
            }
            ee = "" + Q;
          }
          ee == null && (ee = "");
        }
        se = e({}, se, { value: void 0, children: "" + ee });
      } else if (ne === "select")
        this.currentSelectValue = se.value != null ? se.value : se.defaultValue, se = e({}, se, { value: void 0 });
      else if (ne === "option") {
        Q = this.currentSelectValue;
        var Dt = Ae(se.children);
        if (Q != null) {
          var ct = se.value != null ? se.value + "" : Dt;
          if (ee = !1, Array.isArray(Q)) {
            for (var Ye = 0; Ye < Q.length; Ye++)
              if ("" + Q[Ye] === ct) {
                ee = !0;
                break;
              }
          } else
            ee = "" + Q === ct;
          se = e(
            { selected: void 0, children: void 0 },
            se,
            { selected: ee, children: Dt }
          );
        }
      }
      if (ee = se) {
        if (Re[ne] && (ee.children != null || ee.dangerouslySetInnerHTML != null))
          throw Error(n(137, ne, ""));
        if (ee.dangerouslySetInnerHTML != null) {
          if (ee.children != null)
            throw Error(n(60));
          if (!(typeof ee.dangerouslySetInnerHTML == "object" && "__html" in ee.dangerouslySetInnerHTML))
            throw Error(n(61));
        }
        if (ee.style != null && typeof ee.style != "object")
          throw Error(n(62, ""));
      }
      ee = se, Q = this.makeStaticMarkup, Dt = this.stack.length === 1, ct = "<" + D.type;
      for (Ot in ee)
        if (kt.call(ee, Ot)) {
          var dt = ee[Ot];
          if (dt != null) {
            if (Ot === "style") {
              Ye = void 0;
              var ut = "", ft = "";
              for (Ye in dt)
                if (dt.hasOwnProperty(Ye)) {
                  var yt = Ye.indexOf("--") === 0, wt = dt[Ye];
                  if (wt != null) {
                    if (yt)
                      var Vt = Ye;
                    else if (Vt = Ye, _e.hasOwnProperty(Vt))
                      Vt = _e[Vt];
                    else {
                      var Vn = Vt.replace(lt, "-$1").toLowerCase().replace(_, "-ms-");
                      Vt = _e[Vt] = Vn;
                    }
                    ut += ft + Vt + ":", ft = Ye, yt = wt == null || typeof wt == "boolean" || wt === "" ? "" : yt || typeof wt != "number" || wt === 0 || je.hasOwnProperty(ft) && je[ft] ? ("" + wt).trim() : wt + "px", ut += yt, ft = ";";
                  }
                }
              dt = ut || null;
            }
            Ye = null;
            e:
              if (yt = ne, wt = ee, yt.indexOf("-") === -1)
                yt = typeof wt.is == "string";
              else
                switch (yt) {
                  case "annotation-xml":
                  case "color-profile":
                  case "font-face":
                  case "font-face-src":
                  case "font-face-uri":
                  case "font-face-format":
                  case "font-face-name":
                  case "missing-glyph":
                    yt = !1;
                    break e;
                  default:
                    yt = !0;
                }
            yt ? jt.hasOwnProperty(Ot) || (Ye = Ot, Ye = He(Ye) && dt != null ? Ye + '="' + (ve(dt) + '"') : "") : Ye = we(Ot, dt), Ye && (ct += " " + Ye);
          }
        }
      Q || Dt && (ct += ' data-reactroot=""');
      var Ot = ct;
      ee = "", ye.hasOwnProperty(ne) ? Ot += "/>" : (Ot += ">", ee = "</" + D.type + ">");
      e: {
        if (Q = se.dangerouslySetInnerHTML, Q != null) {
          if (Q.__html != null) {
            Q = Q.__html;
            break e;
          }
        } else if (Q = se.children, typeof Q == "string" || typeof Q == "number") {
          Q = ve(Q);
          break e;
        }
        Q = null;
      }
      return Q != null ? (se = [], De.hasOwnProperty(ne) && Q.charAt(0) === `
` && (Ot += `
`), Ot += Q) : se = z(se.children), D = D.type, ce = ce == null || ce === "http://www.w3.org/1999/xhtml" ? pe(D) : ce === "http://www.w3.org/2000/svg" && D === "foreignObject" ? "http://www.w3.org/1999/xhtml" : ce, this.stack.push({ domNamespace: ce, type: ne, children: se, childIndex: 0, context: te, footer: ee }), this.previousWasTextNode = !1, Ot;
    }, y;
  }(), kr = { renderToString: function(y) {
    y = new tn(y, !1);
    try {
      return y.read(1 / 0);
    } finally {
      y.destroy();
    }
  }, renderToStaticMarkup: function(y) {
    y = new tn(y, !0);
    try {
      return y.read(1 / 0);
    } finally {
      y.destroy();
    }
  }, renderToNodeStream: function() {
    throw Error(n(207));
  }, renderToStaticNodeStream: function() {
    throw Error(n(208));
  }, version: "16.14.0" };
  return Ni = kr.default || kr, Ni;
}
var Vi = { exports: {} }, zi, ol;
function Oa() {
  if (ol)
    return zi;
  ol = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return zi = e, zi;
}
var Pi, il;
function Pc() {
  return il || (il = 1, Pi = Function.call.bind(Object.prototype.hasOwnProperty)), Pi;
}
var Fi, al;
function Fc() {
  if (al)
    return Fi;
  al = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Oa(), n = {}, r = Pc();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, s, l, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in i)
        if (r(i, p)) {
          var c;
          try {
            if (typeof i[p] != "function") {
              var b = Error(
                (l || "React class") + ": " + s + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw b.name = "Invariant Violation", b;
            }
            c = i[p](a, p, l, s, null, t);
          } catch (q) {
            c = q;
          }
          if (c && !(c instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), c instanceof Error && !(c.message in n)) {
            n[c.message] = !0;
            var k = d ? d() : "";
            e(
              "Failed " + s + " type: " + c.message + (k ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Fi = o, Fi;
}
/** @license React v16.14.0
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sl;
function Dm() {
  return sl || (sl = 1, process.env.NODE_ENV !== "production" && function() {
    var e = g, t = Da(), n = Fc();
    function r(u) {
      for (var f = "https://reactjs.org/docs/error-decoder.html?invariant=" + u, S = 1; S < arguments.length; S++)
        f += "&args[]=" + encodeURIComponent(arguments[S]);
      return "Minified React error #" + u + "; visit " + f + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var o = "16.14.0", i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    i.hasOwnProperty("ReactCurrentDispatcher") || (i.ReactCurrentDispatcher = {
      current: null
    }), i.hasOwnProperty("ReactCurrentBatchConfig") || (i.ReactCurrentBatchConfig = {
      suspense: null
    });
    function a(u) {
      {
        for (var f = arguments.length, S = new Array(f > 1 ? f - 1 : 0), $ = 1; $ < f; $++)
          S[$ - 1] = arguments[$];
        l("warn", u, S);
      }
    }
    function s(u) {
      {
        for (var f = arguments.length, S = new Array(f > 1 ? f - 1 : 0), $ = 1; $ < f; $++)
          S[$ - 1] = arguments[$];
        l("error", u, S);
      }
    }
    function l(u, f, S) {
      {
        var $ = S.length > 0 && typeof S[S.length - 1] == "string" && S[S.length - 1].indexOf(`
    in`) === 0;
        if (!$) {
          var I = i.ReactDebugCurrentFrame, K = I.getStackAddendum();
          K !== "" && (f += "%s", S = S.concat([K]));
        }
        var G = S.map(function(ot) {
          return "" + ot;
        });
        G.unshift("Warning: " + f), Function.prototype.apply.call(console[u], console, G);
        try {
          var re = 0, X = "Warning: " + f.replace(/%s/g, function() {
            return S[re++];
          });
          throw new Error(X);
        } catch {
        }
      }
    }
    var d = typeof Symbol == "function" && Symbol.for, p = d ? Symbol.for("react.portal") : 60106, c = d ? Symbol.for("react.fragment") : 60107, b = d ? Symbol.for("react.strict_mode") : 60108, k = d ? Symbol.for("react.profiler") : 60114, q = d ? Symbol.for("react.provider") : 60109, C = d ? Symbol.for("react.context") : 60110, w = d ? Symbol.for("react.concurrent_mode") : 60111, T = d ? Symbol.for("react.forward_ref") : 60112, F = d ? Symbol.for("react.suspense") : 60113, L = d ? Symbol.for("react.suspense_list") : 60120, me = d ? Symbol.for("react.memo") : 60115, O = d ? Symbol.for("react.lazy") : 60116, Pe = d ? Symbol.for("react.block") : 60121, qe = d ? Symbol.for("react.fundamental") : 60117, it = d ? Symbol.for("react.scope") : 60119, Ne = -1, Ke = 0, at = 1, rt = 2;
    function _t(u) {
      return u._status === at ? u._result : null;
    }
    function Me(u) {
      if (u._status === Ne) {
        u._status = Ke;
        var f = u._ctor, S = f();
        u._result = S, S.then(function($) {
          if (u._status === Ke) {
            var I = $.default;
            I === void 0 && s(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, $), u._status = at, u._result = I;
          }
        }, function($) {
          u._status === Ke && (u._status = rt, u._result = $);
        });
      }
    }
    function He(u, f, S) {
      var $ = f.displayName || f.name || "";
      return u.displayName || ($ !== "" ? S + "(" + $ + ")" : S);
    }
    function fe(u) {
      if (u == null)
        return null;
      if (typeof u.tag == "number" && s("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof u == "function")
        return u.displayName || u.name || null;
      if (typeof u == "string")
        return u;
      switch (u) {
        case c:
          return "Fragment";
        case p:
          return "Portal";
        case k:
          return "Profiler";
        case b:
          return "StrictMode";
        case F:
          return "Suspense";
        case L:
          return "SuspenseList";
      }
      if (typeof u == "object")
        switch (u.$$typeof) {
          case C:
            return "Context.Consumer";
          case q:
            return "Context.Provider";
          case T:
            return He(u, u.render, "ForwardRef");
          case me:
            return fe(u.type);
          case Pe:
            return fe(u.render);
          case O: {
            var f = u, S = _t(f);
            if (S)
              return fe(S);
            break;
          }
        }
      return null;
    }
    var Ee = /^(.*)[\\\/]/;
    function le(u, f, S) {
      var $ = "";
      if (f) {
        var I = f.fileName, K = I.replace(Ee, "");
        if (/^index\./.test(K)) {
          var G = I.match(Ee);
          if (G) {
            var re = G[1];
            if (re) {
              var X = re.replace(Ee, "");
              K = X + "/" + K;
            }
          }
        }
        $ = " (at " + K + ":" + f.lineNumber + ")";
      } else
        S && ($ = " (created by " + S + ")");
      return `
    in ` + (u || "Unknown") + $;
    }
    var Ve = !1, M = !1, Z, xe;
    Z = i.ReactDebugCurrentFrame, xe = /* @__PURE__ */ new Set();
    var ve = {};
    Object.freeze(ve);
    function we(u, f) {
      var S = u.contextTypes;
      if (!S)
        return ve;
      var $ = {};
      for (var I in S)
        $[I] = f[I];
      return $;
    }
    function Te(u, f, S) {
      n(u, f, S, "Component", Z.getCurrentStack);
    }
    function ke(u, f) {
      for (var S = u._threadCount | 0; S <= f; S++)
        u[S] = u._currentValue2, u._threadCount = S + 1;
    }
    function de(u, f, S, $) {
      if ($) {
        var I = u.contextType;
        if ("contextType" in u) {
          var K = (
            // Allow null for conditional declaration
            I === null || I !== void 0 && I.$$typeof === C && I._context === void 0
          );
          if (!K && !xe.has(u)) {
            xe.add(u);
            var G = "";
            I === void 0 ? G = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof I != "object" ? G = " However, it is set to a " + typeof I + "." : I.$$typeof === q ? G = " Did you accidentally pass the Context.Provider instead?" : I._context !== void 0 ? G = " Did you accidentally pass the Context.Consumer instead?" : G = " However, it is set to an object with keys {" + Object.keys(I).join(", ") + "}.", s("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", fe(u) || "Component", G);
          }
        }
        if (typeof I == "object" && I !== null)
          return ke(I, S), I[S];
        {
          var re = we(u, f);
          return u.contextTypes && Te(u.contextTypes, re, "context"), re;
        }
      } else {
        var X = we(u, f);
        return u.contextTypes && Te(u.contextTypes, X, "context"), X;
      }
    }
    for (var ge = new Uint16Array(16), ie = 0; ie < 15; ie++)
      ge[ie] = ie + 1;
    ge[15] = 0;
    function Se() {
      var u = ge, f = u.length, S = f * 2;
      if (!(S <= 65536))
        throw Error("Maximum number of concurrent React renderers exceeded. This can happen if you are not properly destroying the Readable provided by React. Ensure that you call .destroy() on it if you no longer want to read from it, and did not read to the end. If you use .pipe() this should be automatic.");
      var $ = new Uint16Array(S);
      $.set(u), ge = $, ge[0] = f + 1;
      for (var I = f; I < S - 1; I++)
        ge[I] = I + 1;
      return ge[S - 1] = 0, f;
    }
    function st() {
      var u = ge[0];
      return u === 0 ? Se() : (ge[0] = ge[u], u);
    }
    function Y(u) {
      ge[u] = ge[0], ge[0] = u;
    }
    var h = 0, x = 1, R = 2, N = 3, V = 4, j = 5, J = 6, U = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", B = U + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", P = "data-reactroot", oe = new RegExp("^[" + U + "][" + B + "]*$"), ae = Object.prototype.hasOwnProperty, pe = {}, ye = {};
    function Re(u) {
      return ae.call(ye, u) ? !0 : ae.call(pe, u) ? !1 : oe.test(u) ? (ye[u] = !0, !0) : (pe[u] = !0, s("Invalid attribute name: `%s`", u), !1);
    }
    function je(u, f, S) {
      return f !== null ? f.type === h : S ? !1 : u.length > 2 && (u[0] === "o" || u[0] === "O") && (u[1] === "n" || u[1] === "N");
    }
    function Ue(u, f, S, $) {
      if (S !== null && S.type === h)
        return !1;
      switch (typeof f) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if ($)
            return !1;
          if (S !== null)
            return !S.acceptsBooleans;
          var I = u.toLowerCase().slice(0, 5);
          return I !== "data-" && I !== "aria-";
        }
        default:
          return !1;
      }
    }
    function lt(u, f, S, $) {
      if (f === null || typeof f > "u" || Ue(u, f, S, $))
        return !0;
      if ($)
        return !1;
      if (S !== null)
        switch (S.type) {
          case N:
            return !f;
          case V:
            return f === !1;
          case j:
            return isNaN(f);
          case J:
            return isNaN(f) || f < 1;
        }
      return !1;
    }
    function _(u) {
      return W.hasOwnProperty(u) ? W[u] : null;
    }
    function z(u, f, S, $, I, K) {
      this.acceptsBooleans = f === R || f === N || f === V, this.attributeName = $, this.attributeNamespace = I, this.mustUseProperty = S, this.propertyName = u, this.type = f, this.sanitizeURL = K;
    }
    var W = {}, De = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    De.forEach(function(u) {
      W[u] = new z(
        u,
        h,
        !1,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(u) {
      var f = u[0], S = u[1];
      W[f] = new z(
        f,
        x,
        !1,
        // mustUseProperty
        S,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(u) {
      W[u] = new z(
        u,
        R,
        !1,
        // mustUseProperty
        u.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(u) {
      W[u] = new z(
        u,
        R,
        !1,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(u) {
      W[u] = new z(
        u,
        N,
        !1,
        // mustUseProperty
        u.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(u) {
      W[u] = new z(
        u,
        N,
        !0,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(u) {
      W[u] = new z(
        u,
        V,
        !1,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(u) {
      W[u] = new z(
        u,
        J,
        !1,
        // mustUseProperty
        u,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), ["rowSpan", "start"].forEach(function(u) {
      W[u] = new z(
        u,
        j,
        !1,
        // mustUseProperty
        u.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    });
    var We = /[\-\:]([a-z])/g, Ce = function(u) {
      return u[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(u) {
      var f = u.replace(We, Ce);
      W[f] = new z(
        f,
        x,
        !1,
        // mustUseProperty
        u,
        null,
        // attributeNamespace
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(u) {
      var f = u.replace(We, Ce);
      W[f] = new z(
        f,
        x,
        !1,
        // mustUseProperty
        u,
        "http://www.w3.org/1999/xlink",
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(u) {
      var f = u.replace(We, Ce);
      W[f] = new z(
        f,
        x,
        !1,
        // mustUseProperty
        u,
        "http://www.w3.org/XML/1998/namespace",
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(u) {
      W[u] = new z(
        u,
        x,
        !1,
        // mustUseProperty
        u.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    });
    var _e = "xlinkHref";
    W[_e] = new z(
      "xlinkHref",
      x,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0
    ), ["src", "href", "action", "formAction"].forEach(function(u) {
      W[u] = new z(
        u,
        x,
        !1,
        // mustUseProperty
        u.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0
      );
    }), i.ReactDebugCurrentFrame;
    var Ae = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, kt = !1;
    function jt(u) {
      !kt && Ae.test(u) && (kt = !0, s("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(u)));
    }
    var Jt = /["'&<>]/;
    function vn(u) {
      var f = "" + u, S = Jt.exec(f);
      if (!S)
        return f;
      var $, I = "", K, G = 0;
      for (K = S.index; K < f.length; K++) {
        switch (f.charCodeAt(K)) {
          case 34:
            $ = "&quot;";
            break;
          case 38:
            $ = "&amp;";
            break;
          case 39:
            $ = "&#x27;";
            break;
          case 60:
            $ = "&lt;";
            break;
          case 62:
            $ = "&gt;";
            break;
          default:
            continue;
        }
        G !== K && (I += f.substring(G, K)), G = K + 1, I += $;
      }
      return G !== K ? I + f.substring(G, K) : I;
    }
    function tn(u) {
      return typeof u == "boolean" || typeof u == "number" ? "" + u : vn(u);
    }
    function kr(u) {
      return '"' + tn(u) + '"';
    }
    function y() {
      return P + '=""';
    }
    function A(u, f) {
      var S = _(u);
      if (u !== "style" && je(u, S, !1) || lt(u, f, S, !1))
        return "";
      if (S !== null) {
        var $ = S.attributeName, I = S.type;
        return I === N || I === V && f === !0 ? $ + '=""' : (S.sanitizeURL && (f = "" + f, jt(f)), $ + "=" + kr(f));
      } else if (Re(u))
        return u + "=" + kr(f);
      return "";
    }
    function D(u, f) {
      return !Re(u) || f == null ? "" : u + "=" + kr(f);
    }
    function te(u, f) {
      return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
    }
    var ce = typeof Object.is == "function" ? Object.is : te, ne = null, se = null, ee = null, Q = !1, Dt = !1, ct = null, Ye = 0, dt = 25, ut = !1, ft;
    function yt() {
      if (ne === null)
        throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.`);
      return ut && s("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://fb.me/rules-of-hooks"), ne;
    }
    function wt(u, f) {
      if (f === null)
        return s("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", ft), !1;
      u.length !== f.length && s(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, ft, "[" + u.join(", ") + "]", "[" + f.join(", ") + "]");
      for (var S = 0; S < f.length && S < u.length; S++)
        if (!ce(u[S], f[S]))
          return !1;
      return !0;
    }
    function Vt() {
      if (Ye > 0)
        throw Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Vn() {
      return ee === null ? se === null ? (Q = !1, se = ee = Vt()) : (Q = !0, ee = se) : ee.next === null ? (Q = !1, ee = ee.next = Vt()) : (Q = !0, ee = ee.next), ee;
    }
    function Ot(u) {
      ne = u, ut = !1;
    }
    function Sr(u, f, S, $) {
      for (; Dt; )
        Dt = !1, Ye += 1, ee = null, S = u(f, $);
      return ne = null, se = null, Ye = 0, ct = null, ee = null, ut = !1, S;
    }
    function Gd(u, f) {
      var S = Eo;
      return ke(u, S), ut && s("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), u[S];
    }
    function Zd(u, f) {
      ft = "useContext", yt();
      var S = Eo;
      return ke(u, S), u[S];
    }
    function wi(u, f) {
      return typeof f == "function" ? f(u) : f;
    }
    function Qd(u) {
      return ft = "useState", as(
        wi,
        // useReducer has a special case to support lazy useState initializers
        u
      );
    }
    function as(u, f, S) {
      if (u !== wi && (ft = "useReducer"), ne = yt(), ee = Vn(), Q) {
        var $ = ee.queue, I = $.dispatch;
        if (ct !== null) {
          var K = ct.get($);
          if (K !== void 0) {
            ct.delete($);
            var G = ee.memoizedState, re = K;
            do {
              var X = re.action;
              ut = !0, G = u(G, X), ut = !1, re = re.next;
            } while (re !== null);
            return ee.memoizedState = G, [G, I];
          }
        }
        return [ee.memoizedState, I];
      } else {
        ut = !0;
        var ot;
        u === wi ? ot = typeof f == "function" ? f() : f : ot = S !== void 0 ? S(f) : f, ut = !1, ee.memoizedState = ot;
        var xt = ee.queue = {
          last: null,
          dispatch: null
        }, Rt = xt.dispatch = rp.bind(null, ne, xt);
        return [ee.memoizedState, Rt];
      }
    }
    function ep(u, f) {
      ne = yt(), ee = Vn();
      var S = f === void 0 ? null : f;
      if (ee !== null) {
        var $ = ee.memoizedState;
        if ($ !== null && S !== null) {
          var I = $[1];
          if (wt(S, I))
            return $[0];
        }
      }
      ut = !0;
      var K = u();
      return ut = !1, ee.memoizedState = [K, S], K;
    }
    function tp(u) {
      ne = yt(), ee = Vn();
      var f = ee.memoizedState;
      if (f === null) {
        var S = {
          current: u
        };
        return Object.seal(S), ee.memoizedState = S, S;
      } else
        return f;
    }
    function np(u, f) {
      ft = "useLayoutEffect", s("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://fb.me/react-uselayouteffect-ssr for common fixes.");
    }
    function rp(u, f, S) {
      if (!(Ye < dt))
        throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (u === ne) {
        Dt = !0;
        var $ = {
          action: S,
          next: null
        };
        ct === null && (ct = /* @__PURE__ */ new Map());
        var I = ct.get(f);
        if (I === void 0)
          ct.set(f, $);
        else {
          for (var K = I; K.next !== null; )
            K = K.next;
          K.next = $;
        }
      }
    }
    function op(u, f) {
      return u;
    }
    function ip(u, f) {
      return {
        props: f,
        responder: u
      };
    }
    function ap(u, f) {
      return yt(), u;
    }
    function sp(u) {
      yt();
      var f = function(S) {
        S();
      };
      return [f, !1];
    }
    function Ei() {
    }
    var Eo = 0;
    function ss(u) {
      Eo = u;
    }
    var lp = {
      readContext: Gd,
      useContext: Zd,
      useMemo: ep,
      useReducer: as,
      useRef: tp,
      useState: Qd,
      useLayoutEffect: np,
      useCallback: op,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: Ei,
      // Effects are not run in the server environment.
      useEffect: Ei,
      // Debugging effect
      useDebugValue: Ei,
      useResponder: ip,
      useDeferredValue: ap,
      useTransition: sp
    }, ko = "http://www.w3.org/1999/xhtml", ls = "http://www.w3.org/1998/Math/MathML", ki = "http://www.w3.org/2000/svg", Si = {
      html: ko,
      mathml: ls,
      svg: ki
    };
    function cs(u) {
      switch (u) {
        case "svg":
          return ki;
        case "math":
          return ls;
        default:
          return ko;
      }
    }
    function cp(u, f) {
      return u == null || u === ko ? cs(f) : u === ki && f === "foreignObject" ? ko : u;
    }
    var us = null, So = {
      checkPropTypes: null
    };
    {
      us = i.ReactDebugCurrentFrame;
      var up = {
        button: !0,
        checkbox: !0,
        image: !0,
        hidden: !0,
        radio: !0,
        reset: !0,
        submit: !0
      }, dp = {
        value: function(u, f, S) {
          return up[u.type] || u.onChange || u.readOnly || u.disabled || u[f] == null || M ? null : new Error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        },
        checked: function(u, f, S) {
          return u.onChange || u.readOnly || u.disabled || u[f] == null || M ? null : new Error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
        }
      };
      So.checkPropTypes = function(u, f) {
        n(dp, f, "prop", u, us.getStackAddendum);
      };
    }
    var ds = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, pp = t({
      menuitem: !0
    }, ds), fp = "__html", Ci = null;
    Ci = i.ReactDebugCurrentFrame;
    function hp(u, f) {
      if (f) {
        if (pp[u] && !(f.children == null && f.dangerouslySetInnerHTML == null))
          throw Error(u + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." + Ci.getStackAddendum());
        if (f.dangerouslySetInnerHTML != null) {
          if (f.children != null)
            throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (!(typeof f.dangerouslySetInnerHTML == "object" && fp in f.dangerouslySetInnerHTML))
            throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.");
        }
        if (!f.suppressContentEditableWarning && f.contentEditable && f.children != null && s("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), !(f.style == null || typeof f.style == "object"))
          throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." + Ci.getStackAddendum());
      }
    }
    var Yr = {
      animationIterationCount: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function mp(u, f) {
      return u + f.charAt(0).toUpperCase() + f.substring(1);
    }
    var vp = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Yr).forEach(function(u) {
      vp.forEach(function(f) {
        Yr[mp(f, u)] = Yr[u];
      });
    });
    function gp(u, f, S) {
      var $ = f == null || typeof f == "boolean" || f === "";
      return $ ? "" : !S && typeof f == "number" && f !== 0 && !(Yr.hasOwnProperty(u) && Yr[u]) ? f + "px" : ("" + f).trim();
    }
    var bp = /([A-Z])/g, yp = /^ms-/;
    function xp(u) {
      return u.replace(bp, "-$1").toLowerCase().replace(yp, "-ms-");
    }
    function qi(u, f) {
      if (u.indexOf("-") === -1)
        return typeof f.is == "string";
      switch (u) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var ps = function() {
    };
    {
      var wp = /^(?:webkit|moz|o)[A-Z]/, Ep = /^-ms-/, kp = /-(.)/g, fs = /;\s*$/, Cr = {}, _i = {}, hs = !1, ms = !1, Sp = function(u) {
        return u.replace(kp, function(f, S) {
          return S.toUpperCase();
        });
      }, Cp = function(u) {
        Cr.hasOwnProperty(u) && Cr[u] || (Cr[u] = !0, s(
          "Unsupported style property %s. Did you mean %s?",
          u,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Sp(u.replace(Ep, "ms-"))
        ));
      }, qp = function(u) {
        Cr.hasOwnProperty(u) && Cr[u] || (Cr[u] = !0, s("Unsupported vendor-prefixed style property %s. Did you mean %s?", u, u.charAt(0).toUpperCase() + u.slice(1)));
      }, _p = function(u, f) {
        _i.hasOwnProperty(f) && _i[f] || (_i[f] = !0, s(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, u, f.replace(fs, "")));
      }, Dp = function(u, f) {
        hs || (hs = !0, s("`NaN` is an invalid value for the `%s` css style property.", u));
      }, Op = function(u, f) {
        ms || (ms = !0, s("`Infinity` is an invalid value for the `%s` css style property.", u));
      };
      ps = function(u, f) {
        u.indexOf("-") > -1 ? Cp(u) : wp.test(u) ? qp(u) : fs.test(f) && _p(u, f), typeof f == "number" && (isNaN(f) ? Dp(u, f) : isFinite(f) || Op(u, f));
      };
    }
    var Rp = ps, vs = {
      "aria-current": 0,
      // state
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, qr = {}, Tp = new RegExp("^(aria)-[" + B + "]*$"), Ap = new RegExp("^(aria)[A-Z][" + B + "]*$"), $p = Object.prototype.hasOwnProperty;
    function Ip(u, f) {
      {
        if ($p.call(qr, f) && qr[f])
          return !0;
        if (Ap.test(f)) {
          var S = "aria-" + f.slice(4).toLowerCase(), $ = vs.hasOwnProperty(S) ? S : null;
          if ($ == null)
            return s("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", f), qr[f] = !0, !0;
          if (f !== $)
            return s("Invalid ARIA attribute `%s`. Did you mean `%s`?", f, $), qr[f] = !0, !0;
        }
        if (Tp.test(f)) {
          var I = f.toLowerCase(), K = vs.hasOwnProperty(I) ? I : null;
          if (K == null)
            return qr[f] = !0, !1;
          if (f !== K)
            return s("Unknown ARIA attribute `%s`. Did you mean `%s`?", f, K), qr[f] = !0, !0;
        }
      }
      return !0;
    }
    function Np(u, f) {
      {
        var S = [];
        for (var $ in f) {
          var I = Ip(u, $);
          I || S.push($);
        }
        var K = S.map(function(G) {
          return "`" + G + "`";
        }).join(", ");
        S.length === 1 ? s("Invalid aria prop %s on <%s> tag. For details, see https://fb.me/invalid-aria-prop", K, u) : S.length > 1 && s("Invalid aria props %s on <%s> tag. For details, see https://fb.me/invalid-aria-prop", K, u);
      }
    }
    function Vp(u, f) {
      qi(u, f) || Np(u, f);
    }
    var gs = !1;
    function zp(u, f) {
      {
        if (u !== "input" && u !== "textarea" && u !== "select")
          return;
        f != null && f.value === null && !gs && (gs = !0, u === "select" && f.multiple ? s("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", u) : s("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", u));
      }
    }
    var Pp = {}, bs = {}, ys = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, xs = function() {
    };
    {
      var zt = {}, Fp = Object.prototype.hasOwnProperty, ws = /^on./, Lp = /^on[^A-Z]/, Mp = new RegExp("^(aria)-[" + B + "]*$"), Up = new RegExp("^(aria)[A-Z][" + B + "]*$");
      xs = function(u, f, S, $) {
        if (Fp.call(zt, f) && zt[f])
          return !0;
        var I = f.toLowerCase();
        if (I === "onfocusin" || I === "onfocusout")
          return s("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), zt[f] = !0, !0;
        if ($) {
          if (Pp.hasOwnProperty(f))
            return !0;
          var K = bs.hasOwnProperty(I) ? bs[I] : null;
          if (K != null)
            return s("Invalid event handler property `%s`. Did you mean `%s`?", f, K), zt[f] = !0, !0;
          if (ws.test(f))
            return s("Unknown event handler property `%s`. It will be ignored.", f), zt[f] = !0, !0;
        } else if (ws.test(f))
          return Lp.test(f) && s("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", f), zt[f] = !0, !0;
        if (Mp.test(f) || Up.test(f))
          return !0;
        if (I === "innerhtml")
          return s("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), zt[f] = !0, !0;
        if (I === "aria")
          return s("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), zt[f] = !0, !0;
        if (I === "is" && S !== null && S !== void 0 && typeof S != "string")
          return s("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof S), zt[f] = !0, !0;
        if (typeof S == "number" && isNaN(S))
          return s("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", f), zt[f] = !0, !0;
        var G = _(f), re = G !== null && G.type === h;
        if (ys.hasOwnProperty(I)) {
          var X = ys[I];
          if (X !== f)
            return s("Invalid DOM property `%s`. Did you mean `%s`?", f, X), zt[f] = !0, !0;
        } else if (!re && f !== I)
          return s("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", f, I), zt[f] = !0, !0;
        return typeof S == "boolean" && Ue(f, S, G, !1) ? (S ? s('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', S, f, f, S, f) : s('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', S, f, f, S, f, f, f), zt[f] = !0, !0) : re ? !0 : Ue(f, S, G, !1) ? (zt[f] = !0, !1) : ((S === "false" || S === "true") && G !== null && G.type === N && (s("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", S, f, S === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', f, S), zt[f] = !0), !0);
      };
    }
    var jp = function(u, f, S) {
      {
        var $ = [];
        for (var I in f) {
          var K = xs(u, I, f[I], S);
          K || $.push(I);
        }
        var G = $.map(function(re) {
          return "`" + re + "`";
        }).join(", ");
        $.length === 1 ? s("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://fb.me/react-attribute-behavior", G, u) : $.length > 1 && s("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://fb.me/react-attribute-behavior", G, u);
      }
    };
    function Bp(u, f, S) {
      qi(u, f) || jp(u, f, S);
    }
    var zn = e.Children.toArray, _n = [], Di = i.ReactCurrentDispatcher, Co, Oi = null, Es = function() {
      return "";
    }, ks = function(u) {
      return "";
    }, Ss = function(u, f) {
    }, Cs = function(u) {
    }, qs = function(u) {
    }, _s = function() {
    }, Ds = !1;
    Co = i.ReactDebugCurrentFrame, Ss = function(u, f) {
      Vp(u, f), zp(u, f), Bp(
        u,
        f,
        /* canUseEventSystem */
        !1
      );
    }, ks = function(u) {
      var f = u._source, S = u.type, $ = fe(S), I = null;
      return le($, f, I);
    }, Cs = function(u) {
      _n.push(u), _n.length === 1 && (Oi = Co.getCurrentStack, Co.getCurrentStack = Es);
    }, qs = function(u) {
      var f = _n[_n.length - 1], S = f[f.length - 1];
      S.debugElementStack.push(u);
    }, _s = function() {
      _n.pop(), _n.length === 0 && (Co.getCurrentStack = Oi, Oi = null);
    }, Es = function() {
      if (_n.length === 0)
        return "";
      for (var u = _n[_n.length - 1], f = "", S = u.length - 1; S >= 0; S--)
        for (var $ = u[S], I = $.debugElementStack, K = I.length - 1; K >= 0; K--)
          f += ks(I[K]);
      return f;
    };
    var Os = !1, Rs = !1, Ts = !1, As = !1, $s = !1, Is = {}, Ns = {}, Vs = {}, zs = {}, Ps = {}, Fs = {}, Ls = ["value", "defaultValue"], Wp = {
      listing: !0,
      pre: !0,
      textarea: !0
    }, Hp = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ms = {};
    function Yp(u) {
      if (!Ms.hasOwnProperty(u)) {
        if (!Hp.test(u))
          throw Error("Invalid tag: " + u);
        Ms[u] = !0;
      }
    }
    var Ri = {}, Xp = function(u) {
      if (Ri.hasOwnProperty(u))
        return Ri[u];
      var f = xp(u);
      return Ri[u] = f, f;
    };
    function Jp(u) {
      var f = "", S = "";
      for (var $ in u)
        if (u.hasOwnProperty($)) {
          var I = $.indexOf("--") === 0, K = u[$];
          I || Rp($, K), K != null && (f += S + (I ? $ : Xp($)) + ":", f += gp($, K, I), S = ";");
        }
      return f || null;
    }
    function Us(u, f) {
      {
        var S = u.constructor, $ = S && fe(S) || "ReactClass", I = $ + "." + f;
        if (Is[I])
          return;
        s(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, f, f, $), Is[I] = !0;
      }
    }
    function Kp(u) {
      return u.prototype && u.prototype.isReactComponent;
    }
    function Gp(u) {
      var f = u.dangerouslySetInnerHTML;
      if (f != null) {
        if (f.__html != null)
          return f.__html;
      } else {
        var S = u.children;
        if (typeof S == "string" || typeof S == "number")
          return tn(S);
      }
      return null;
    }
    function Zp(u) {
      if (!e.isValidElement(u))
        return zn(u);
      var f = u;
      if (f.type !== c)
        return [f];
      var S = f.props.children;
      if (!e.isValidElement(S))
        return zn(S);
      var $ = S;
      return [$];
    }
    function Qp(u) {
      if (u == null)
        return u;
      var f = "";
      return e.Children.forEach(u, function(S) {
        S != null && (f += S, !$s && typeof S != "string" && typeof S != "number" && ($s = !0, s("Only strings and numbers are supported as <option> children.")));
      }), f;
    }
    var ef = Object.prototype.hasOwnProperty, tf = "style", nf = {
      children: null,
      dangerouslySetInnerHTML: null,
      suppressContentEditableWarning: null,
      suppressHydrationWarning: null
    };
    function rf(u, f, S, $, I, K) {
      var G = "<" + u;
      for (var re in S)
        if (ef.call(S, re)) {
          var X = S[re];
          if (X != null) {
            re === tf && (X = Jp(X));
            var ot = null;
            qi(f, S) ? nf.hasOwnProperty(re) || (ot = D(re, X)) : ot = A(re, X), ot && (G += " " + ot);
          }
        }
      return I || K && (G += " " + y()), G;
    }
    function js(u, f) {
      if (u === void 0)
        throw Error((fe(f) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
    }
    function of(u, f, S) {
      for (; e.isValidElement(u); ) {
        var $ = u, I = $.type;
        if (qs($), typeof I != "function")
          break;
        K($, I);
      }
      function K(G, re) {
        var X = Kp(re), ot = de(re, f, S, X), xt = [], Rt = !1, Bt = {
          isMounted: function(Ln) {
            return !1;
          },
          enqueueForceUpdate: function(Ln) {
            if (xt === null)
              return Us(Ln, "forceUpdate"), null;
          },
          enqueueReplaceState: function(Ln, Dr) {
            Rt = !0, xt = [Dr];
          },
          enqueueSetState: function(Ln, Dr) {
            if (xt === null)
              return Us(Ln, "setState"), null;
            xt.push(Dr);
          }
        }, be;
        if (X) {
          if (be = new re(G.props, ot, Bt), typeof re.getDerivedStateFromProps == "function") {
            if (be.state === null || be.state === void 0) {
              var nn = fe(re) || "Unknown";
              Fs[nn] || (s("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", nn, be.state === null ? "null" : "undefined", nn), Fs[nn] = !0);
            }
            var Pt = re.getDerivedStateFromProps.call(null, G.props, be.state);
            if (Pt === void 0) {
              var Wt = fe(re) || "Unknown";
              Ps[Wt] || (s("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", Wt), Ps[Wt] = !0);
            }
            Pt != null && (be.state = t({}, be.state, Pt));
          }
        } else {
          if (re.prototype && typeof re.prototype.render == "function") {
            var Ht = fe(re) || "Unknown";
            Ns[Ht] || (s("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", Ht, Ht), Ns[Ht] = !0);
          }
          var Pn = {};
          if (Ot(Pn), be = re(G.props, ot, Bt), be = Sr(re, G.props, be, ot), be == null || be.render == null) {
            u = be, js(u, re);
            return;
          }
          {
            var rn = fe(re) || "Unknown";
            Vs[rn] || (s("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", rn, rn, rn), Vs[rn] = !0);
          }
        }
        be.props = G.props, be.context = ot, be.updater = Bt;
        var an = be.state;
        if (an === void 0 && (be.state = an = null), typeof be.UNSAFE_componentWillMount == "function" || typeof be.componentWillMount == "function") {
          if (typeof be.componentWillMount == "function") {
            if (be.componentWillMount.__suppressDeprecationWarning !== !0) {
              var Fn = fe(re) || "Unknown";
              zs[Fn] || (a(
                // keep this warning in sync with ReactStrictModeWarning.js
                `componentWillMount has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
                Fn
              ), zs[Fn] = !0);
            }
            typeof re.getDerivedStateFromProps != "function" && be.componentWillMount();
          }
          if (typeof be.UNSAFE_componentWillMount == "function" && typeof re.getDerivedStateFromProps != "function" && be.UNSAFE_componentWillMount(), xt.length) {
            var on = xt, sn = Rt;
            if (xt = null, Rt = !1, sn && on.length === 1)
              be.state = on[0];
            else {
              for (var gn = sn ? on[0] : be.state, qo = !0, _r = sn ? 1 : 0; _r < on.length; _r++) {
                var ln = on[_r], Xr = typeof ln == "function" ? ln.call(be, gn, G.props, ot) : ln;
                Xr != null && (qo ? (qo = !1, gn = t({}, gn, Xr)) : t(gn, Xr));
              }
              be.state = gn;
            }
          } else
            xt = null;
        }
        u = be.render(), u === void 0 && be.render._isMockFunction && (u = null), js(u, re);
        var nr;
        {
          if (typeof be.getChildContext == "function") {
            var _o = re.childContextTypes;
            if (typeof _o == "object") {
              nr = be.getChildContext();
              for (var Do in nr)
                if (!(Do in _o))
                  throw Error((fe(re) || "Unknown") + '.getChildContext(): key "' + Do + '" is not defined in childContextTypes.');
            } else
              s("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", fe(re) || "Unknown");
          }
          nr && (f = t({}, f, nr));
        }
      }
      return {
        child: u,
        context: f
      };
    }
    var Bs = /* @__PURE__ */ function() {
      function u(S, $) {
        var I = Zp(S), K = {
          type: null,
          // Assume all trees start in the HTML namespace (not totally true, but
          // this is what we did historically)
          domNamespace: Si.html,
          children: I,
          childIndex: 0,
          context: ve,
          footer: ""
        };
        K.debugElementStack = [], this.threadID = st(), this.stack = [K], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = $, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [], this.contextProviderStack = [];
      }
      var f = u.prototype;
      return f.destroy = function() {
        this.exhausted || (this.exhausted = !0, this.clearProviders(), Y(this.threadID));
      }, f.pushProvider = function($) {
        var I = ++this.contextIndex, K = $.type._context, G = this.threadID;
        ke(K, G);
        var re = K[G];
        this.contextStack[I] = K, this.contextValueStack[I] = re, this.contextProviderStack[I] = $, K[G] = $.props.value;
      }, f.popProvider = function($) {
        var I = this.contextIndex;
        (I < 0 || $ !== this.contextProviderStack[I]) && s("Unexpected pop.");
        var K = this.contextStack[I], G = this.contextValueStack[I];
        this.contextStack[I] = null, this.contextValueStack[I] = null, this.contextProviderStack[I] = null, this.contextIndex--, K[this.threadID] = G;
      }, f.clearProviders = function() {
        for (var $ = this.contextIndex; $ >= 0; $--) {
          var I = this.contextStack[$], K = this.contextValueStack[$];
          I[this.threadID] = K;
        }
      }, f.read = function($) {
        if (this.exhausted)
          return null;
        var I = Eo;
        ss(this.threadID);
        var K = Di.current;
        Di.current = lp;
        try {
          for (var G = [""], re = !1; G[0].length < $; ) {
            if (this.stack.length === 0) {
              this.exhausted = !0, Y(this.threadID);
              break;
            }
            var X = this.stack[this.stack.length - 1];
            if (re || X.childIndex >= X.children.length) {
              var ot = X.footer;
              if (ot !== "" && (this.previousWasTextNode = !1), this.stack.pop(), X.type === "select")
                this.currentSelectValue = null;
              else if (X.type != null && X.type.type != null && X.type.type.$$typeof === q) {
                var xt = X.type;
                this.popProvider(xt);
              } else if (X.type === F) {
                this.suspenseDepth--;
                var Rt = G.pop();
                if (re) {
                  re = !1;
                  var Bt = X.fallbackFrame;
                  if (!Bt)
                    throw Error("ReactDOMServer did not find an internal fallback frame for Suspense. This is a bug in React. Please file an issue.");
                  this.stack.push(Bt), G[this.suspenseDepth] += "<!--$!-->";
                  continue;
                } else
                  G[this.suspenseDepth] += Rt;
              }
              G[this.suspenseDepth] += ot;
              continue;
            }
            var be = X.children[X.childIndex++], nn = "";
            Cs(this.stack), X.debugElementStack.length = 0;
            try {
              nn += this.render(be, X.context, X.domNamespace);
            } catch (Pt) {
              if (Pt != null && typeof Pt.then == "function") {
                if (!Ve)
                  throw Error("ReactDOMServer does not yet support Suspense.");
              } else
                throw Pt;
            } finally {
              _s();
            }
            G.length <= this.suspenseDepth && G.push(""), G[this.suspenseDepth] += nn;
          }
          return G[0];
        } finally {
          Di.current = K, ss(I);
        }
      }, f.render = function($, I, K) {
        if (typeof $ == "string" || typeof $ == "number") {
          var G = "" + $;
          return G === "" ? "" : this.makeStaticMarkup ? tn(G) : this.previousWasTextNode ? "<!-- -->" + tn(G) : (this.previousWasTextNode = !0, tn(G));
        } else {
          var re, X = of($, I, this.threadID);
          if (re = X.child, I = X.context, re === null || re === !1)
            return "";
          if (!e.isValidElement(re)) {
            if (re != null && re.$$typeof != null) {
              var ot = re.$$typeof;
              throw Error(ot === p ? "Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render." : "Unknown element-like object type: " + ot.toString() + ". This is likely a bug in React. Please file an issue.");
            }
            var xt = zn(re), Rt = {
              type: null,
              domNamespace: K,
              children: xt,
              childIndex: 0,
              context: I,
              footer: ""
            };
            return Rt.debugElementStack = [], this.stack.push(Rt), "";
          }
          var Bt = re, be = Bt.type;
          if (typeof be == "string")
            return this.renderDOM(Bt, I, K);
          switch (be) {
            case b:
            case w:
            case k:
            case L:
            case c: {
              var nn = zn(re.props.children), Pt = {
                type: null,
                domNamespace: K,
                children: nn,
                childIndex: 0,
                context: I,
                footer: ""
              };
              return Pt.debugElementStack = [], this.stack.push(Pt), "";
            }
            case F:
              throw Error("ReactDOMServer does not yet support Suspense.");
          }
          if (typeof be == "object" && be !== null)
            switch (be.$$typeof) {
              case T: {
                var Wt = re, Ht, Pn = {};
                Ot(Pn), Ht = be.render(Wt.props, Wt.ref), Ht = Sr(be.render, Wt.props, Ht, Wt.ref), Ht = zn(Ht);
                var rn = {
                  type: null,
                  domNamespace: K,
                  children: Ht,
                  childIndex: 0,
                  context: I,
                  footer: ""
                };
                return rn.debugElementStack = [], this.stack.push(rn), "";
              }
              case me: {
                var an = re, Fn = [e.createElement(be.type, t({
                  ref: an.ref
                }, an.props))], on = {
                  type: null,
                  domNamespace: K,
                  children: Fn,
                  childIndex: 0,
                  context: I,
                  footer: ""
                };
                return on.debugElementStack = [], this.stack.push(on), "";
              }
              case q: {
                var sn = re, gn = sn.props, qo = zn(gn.children), _r = {
                  type: sn,
                  domNamespace: K,
                  children: qo,
                  childIndex: 0,
                  context: I,
                  footer: ""
                };
                return _r.debugElementStack = [], this.pushProvider(sn), this.stack.push(_r), "";
              }
              case C: {
                var ln = re.type;
                ln._context === void 0 ? ln !== ln.Consumer && (Ds || (Ds = !0, s("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : ln = ln._context;
                var Xr = re.props, nr = this.threadID;
                ke(ln, nr);
                var _o = ln[nr], Do = zn(Xr.children(_o)), Ln = {
                  type: re,
                  domNamespace: K,
                  children: Do,
                  childIndex: 0,
                  context: I,
                  footer: ""
                };
                return Ln.debugElementStack = [], this.stack.push(Ln), "";
              }
              case qe:
                throw Error("ReactDOMServer does not yet support the fundamental API.");
              case O: {
                var Dr = re, Oo = re.type;
                switch (Me(Oo), Oo._status) {
                  case at: {
                    var df = [e.createElement(Oo._result, t({
                      ref: Dr.ref
                    }, Dr.props))], Hs = {
                      type: null,
                      domNamespace: K,
                      children: df,
                      childIndex: 0,
                      context: I,
                      footer: ""
                    };
                    return Hs.debugElementStack = [], this.stack.push(Hs), "";
                  }
                  case rt:
                    throw Oo._result;
                  case Ke:
                  default:
                    throw Error("ReactDOMServer does not yet support lazy-loaded components.");
                }
              }
              case it:
                throw Error("ReactDOMServer does not yet support scope components.");
            }
          var Ti = "";
          {
            var Ys = Bt._owner;
            (be === void 0 || typeof be == "object" && be !== null && Object.keys(be).length === 0) && (Ti += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Xs = Ys ? fe(Ys) : null;
            Xs && (Ti += `

Check the render method of \`` + Xs + "`.");
          }
          throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (be == null ? be : typeof be) + "." + Ti);
        }
      }, f.renderDOM = function($, I, K) {
        var G = $.type.toLowerCase(), re = K;
        K === Si.html && (re = cs(G)), re === Si.html && G !== $.type && s("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", $.type), Yp(G);
        var X = $.props;
        if (G === "input")
          So.checkPropTypes("input", X), X.checked !== void 0 && X.defaultChecked !== void 0 && !Rs && (s("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components", "A component", X.type), Rs = !0), X.value !== void 0 && X.defaultValue !== void 0 && !Os && (s("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components", "A component", X.type), Os = !0), X = t({
            type: void 0
          }, X, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: X.value != null ? X.value : X.defaultValue,
            checked: X.checked != null ? X.checked : X.defaultChecked
          });
        else if (G === "textarea") {
          So.checkPropTypes("textarea", X), X.value !== void 0 && X.defaultValue !== void 0 && !As && (s("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://fb.me/react-controlled-components"), As = !0);
          var ot = X.value;
          if (ot == null) {
            var xt = X.defaultValue, Rt = X.children;
            if (Rt != null) {
              if (s("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), xt != null)
                throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
              if (Array.isArray(Rt)) {
                if (!(Rt.length <= 1))
                  throw Error("<textarea> can only have at most one child.");
                Rt = Rt[0];
              }
              xt = "" + Rt;
            }
            xt == null && (xt = ""), ot = xt;
          }
          X = t({}, X, {
            value: void 0,
            children: "" + ot
          });
        } else if (G === "select") {
          {
            So.checkPropTypes("select", X);
            for (var Bt = 0; Bt < Ls.length; Bt++) {
              var be = Ls[Bt];
              if (X[be] != null) {
                var nn = Array.isArray(X[be]);
                X.multiple && !nn ? s("The `%s` prop supplied to <select> must be an array if `multiple` is true.", be) : !X.multiple && nn && s("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", be);
              }
            }
            X.value !== void 0 && X.defaultValue !== void 0 && !Ts && (s("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://fb.me/react-controlled-components"), Ts = !0);
          }
          this.currentSelectValue = X.value != null ? X.value : X.defaultValue, X = t({}, X, {
            value: void 0
          });
        } else if (G === "option") {
          var Pt = null, Wt = this.currentSelectValue, Ht = Qp(X.children);
          if (Wt != null) {
            var Pn;
            if (X.value != null ? Pn = X.value + "" : Pn = Ht, Pt = !1, Array.isArray(Wt)) {
              for (var rn = 0; rn < Wt.length; rn++)
                if ("" + Wt[rn] === Pn) {
                  Pt = !0;
                  break;
                }
            } else
              Pt = "" + Wt === Pn;
            X = t({
              selected: void 0,
              children: void 0
            }, X, {
              selected: Pt,
              children: Ht
            });
          }
        }
        Ss(G, X), hp(G, X);
        var an = rf($.type, G, X, re, this.makeStaticMarkup, this.stack.length === 1), Fn = "";
        ds.hasOwnProperty(G) ? an += "/>" : (an += ">", Fn = "</" + $.type + ">");
        var on, sn = Gp(X);
        sn != null ? (on = [], Wp.hasOwnProperty(G) && sn.charAt(0) === `
` && (an += `
`), an += sn) : on = zn(X.children);
        var gn = {
          domNamespace: cp(K, $.type),
          type: G,
          children: on,
          childIndex: 0,
          context: I,
          footer: Fn
        };
        return gn.debugElementStack = [], this.stack.push(gn), this.previousWasTextNode = !1, an;
      }, u;
    }();
    function af(u) {
      var f = new Bs(u, !1);
      try {
        var S = f.read(1 / 0);
        return S;
      } finally {
        f.destroy();
      }
    }
    function sf(u) {
      var f = new Bs(u, !0);
      try {
        var S = f.read(1 / 0);
        return S;
      } finally {
        f.destroy();
      }
    }
    function lf() {
      throw Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function cf() {
      throw Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    var Ws = {
      renderToString: af,
      renderToStaticMarkup: sf,
      renderToNodeStream: lf,
      renderToStaticNodeStream: cf,
      version: o
    }, uf = Ws.default || Ws;
    Vi.exports = uf;
  }()), Vi.exports;
}
process.env.NODE_ENV === "production" ? ea.exports = _m() : ea.exports = Dm();
var Om = ea.exports, ta = { exports: {} }, To = { exports: {} }, Ge = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ll;
function Rm() {
  if (ll)
    return Ge;
  ll = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, q = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, T = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
  function L(O) {
    if (typeof O == "object" && O !== null) {
      var Pe = O.$$typeof;
      switch (Pe) {
        case t:
          switch (O = O.type, O) {
            case l:
            case d:
            case r:
            case i:
            case o:
            case c:
              return O;
            default:
              switch (O = O && O.$$typeof, O) {
                case s:
                case p:
                case q:
                case k:
                case a:
                  return O;
                default:
                  return Pe;
              }
          }
        case n:
          return Pe;
      }
    }
  }
  function me(O) {
    return L(O) === d;
  }
  return Ge.AsyncMode = l, Ge.ConcurrentMode = d, Ge.ContextConsumer = s, Ge.ContextProvider = a, Ge.Element = t, Ge.ForwardRef = p, Ge.Fragment = r, Ge.Lazy = q, Ge.Memo = k, Ge.Portal = n, Ge.Profiler = i, Ge.StrictMode = o, Ge.Suspense = c, Ge.isAsyncMode = function(O) {
    return me(O) || L(O) === l;
  }, Ge.isConcurrentMode = me, Ge.isContextConsumer = function(O) {
    return L(O) === s;
  }, Ge.isContextProvider = function(O) {
    return L(O) === a;
  }, Ge.isElement = function(O) {
    return typeof O == "object" && O !== null && O.$$typeof === t;
  }, Ge.isForwardRef = function(O) {
    return L(O) === p;
  }, Ge.isFragment = function(O) {
    return L(O) === r;
  }, Ge.isLazy = function(O) {
    return L(O) === q;
  }, Ge.isMemo = function(O) {
    return L(O) === k;
  }, Ge.isPortal = function(O) {
    return L(O) === n;
  }, Ge.isProfiler = function(O) {
    return L(O) === i;
  }, Ge.isStrictMode = function(O) {
    return L(O) === o;
  }, Ge.isSuspense = function(O) {
    return L(O) === c;
  }, Ge.isValidElementType = function(O) {
    return typeof O == "string" || typeof O == "function" || O === r || O === d || O === i || O === o || O === c || O === b || typeof O == "object" && O !== null && (O.$$typeof === q || O.$$typeof === k || O.$$typeof === a || O.$$typeof === s || O.$$typeof === p || O.$$typeof === w || O.$$typeof === T || O.$$typeof === F || O.$$typeof === C);
  }, Ge.typeOf = L, Ge;
}
var Ze = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cl;
function Tm() {
  return cl || (cl = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, b = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, q = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, T = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
    function L(Y) {
      return typeof Y == "string" || typeof Y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Y === r || Y === d || Y === i || Y === o || Y === c || Y === b || typeof Y == "object" && Y !== null && (Y.$$typeof === q || Y.$$typeof === k || Y.$$typeof === a || Y.$$typeof === s || Y.$$typeof === p || Y.$$typeof === w || Y.$$typeof === T || Y.$$typeof === F || Y.$$typeof === C);
    }
    function me(Y) {
      if (typeof Y == "object" && Y !== null) {
        var h = Y.$$typeof;
        switch (h) {
          case t:
            var x = Y.type;
            switch (x) {
              case l:
              case d:
              case r:
              case i:
              case o:
              case c:
                return x;
              default:
                var R = x && x.$$typeof;
                switch (R) {
                  case s:
                  case p:
                  case q:
                  case k:
                  case a:
                    return R;
                  default:
                    return h;
                }
            }
          case n:
            return h;
        }
      }
    }
    var O = l, Pe = d, qe = s, it = a, Ne = t, Ke = p, at = r, rt = q, _t = k, Me = n, He = i, fe = o, Ee = c, le = !1;
    function Ve(Y) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(Y) || me(Y) === l;
    }
    function M(Y) {
      return me(Y) === d;
    }
    function Z(Y) {
      return me(Y) === s;
    }
    function xe(Y) {
      return me(Y) === a;
    }
    function ve(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === t;
    }
    function we(Y) {
      return me(Y) === p;
    }
    function Te(Y) {
      return me(Y) === r;
    }
    function ke(Y) {
      return me(Y) === q;
    }
    function de(Y) {
      return me(Y) === k;
    }
    function ge(Y) {
      return me(Y) === n;
    }
    function ie(Y) {
      return me(Y) === i;
    }
    function Se(Y) {
      return me(Y) === o;
    }
    function st(Y) {
      return me(Y) === c;
    }
    Ze.AsyncMode = O, Ze.ConcurrentMode = Pe, Ze.ContextConsumer = qe, Ze.ContextProvider = it, Ze.Element = Ne, Ze.ForwardRef = Ke, Ze.Fragment = at, Ze.Lazy = rt, Ze.Memo = _t, Ze.Portal = Me, Ze.Profiler = He, Ze.StrictMode = fe, Ze.Suspense = Ee, Ze.isAsyncMode = Ve, Ze.isConcurrentMode = M, Ze.isContextConsumer = Z, Ze.isContextProvider = xe, Ze.isElement = ve, Ze.isForwardRef = we, Ze.isFragment = Te, Ze.isLazy = ke, Ze.isMemo = de, Ze.isPortal = ge, Ze.isProfiler = ie, Ze.isStrictMode = Se, Ze.isSuspense = st, Ze.isValidElementType = L, Ze.typeOf = me;
  }()), Ze;
}
var ul;
function Lc() {
  return ul || (ul = 1, process.env.NODE_ENV === "production" ? To.exports = Rm() : To.exports = Tm()), To.exports;
}
var Li, dl;
function Am() {
  if (dl)
    return Li;
  dl = 1;
  var e = Lc(), t = Da(), n = Oa(), r = Pc(), o = Fc(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Li = function(s, l) {
    var d = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function c(M) {
      var Z = M && (d && M[d] || M[p]);
      if (typeof Z == "function")
        return Z;
    }
    var b = "<<anonymous>>", k = {
      array: T("array"),
      bigint: T("bigint"),
      bool: T("boolean"),
      func: T("function"),
      number: T("number"),
      object: T("object"),
      string: T("string"),
      symbol: T("symbol"),
      any: F(),
      arrayOf: L,
      element: me(),
      elementType: O(),
      instanceOf: Pe,
      node: Ke(),
      objectOf: it,
      oneOf: qe,
      oneOfType: Ne,
      shape: rt,
      exact: _t
    };
    function q(M, Z) {
      return M === Z ? M !== 0 || 1 / M === 1 / Z : M !== M && Z !== Z;
    }
    function C(M, Z) {
      this.message = M, this.data = Z && typeof Z == "object" ? Z : {}, this.stack = "";
    }
    C.prototype = Error.prototype;
    function w(M) {
      if (process.env.NODE_ENV !== "production")
        var Z = {}, xe = 0;
      function ve(Te, ke, de, ge, ie, Se, st) {
        if (ge = ge || b, Se = Se || de, st !== n) {
          if (l) {
            var Y = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Y.name = "Invariant Violation", Y;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var h = ge + ":" + de;
            !Z[h] && // Avoid spamming the console because they are often not actionable except for lib authors
            xe < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Se + "` prop on `" + ge + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Z[h] = !0, xe++);
          }
        }
        return ke[de] == null ? Te ? ke[de] === null ? new C("The " + ie + " `" + Se + "` is marked as required " + ("in `" + ge + "`, but its value is `null`.")) : new C("The " + ie + " `" + Se + "` is marked as required in " + ("`" + ge + "`, but its value is `undefined`.")) : null : M(ke, de, ge, ie, Se);
      }
      var we = ve.bind(null, !1);
      return we.isRequired = ve.bind(null, !0), we;
    }
    function T(M) {
      function Z(xe, ve, we, Te, ke, de) {
        var ge = xe[ve], ie = fe(ge);
        if (ie !== M) {
          var Se = Ee(ge);
          return new C(
            "Invalid " + Te + " `" + ke + "` of type " + ("`" + Se + "` supplied to `" + we + "`, expected ") + ("`" + M + "`."),
            { expectedType: M }
          );
        }
        return null;
      }
      return w(Z);
    }
    function F() {
      return w(a);
    }
    function L(M) {
      function Z(xe, ve, we, Te, ke) {
        if (typeof M != "function")
          return new C("Property `" + ke + "` of component `" + we + "` has invalid PropType notation inside arrayOf.");
        var de = xe[ve];
        if (!Array.isArray(de)) {
          var ge = fe(de);
          return new C("Invalid " + Te + " `" + ke + "` of type " + ("`" + ge + "` supplied to `" + we + "`, expected an array."));
        }
        for (var ie = 0; ie < de.length; ie++) {
          var Se = M(de, ie, we, Te, ke + "[" + ie + "]", n);
          if (Se instanceof Error)
            return Se;
        }
        return null;
      }
      return w(Z);
    }
    function me() {
      function M(Z, xe, ve, we, Te) {
        var ke = Z[xe];
        if (!s(ke)) {
          var de = fe(ke);
          return new C("Invalid " + we + " `" + Te + "` of type " + ("`" + de + "` supplied to `" + ve + "`, expected a single ReactElement."));
        }
        return null;
      }
      return w(M);
    }
    function O() {
      function M(Z, xe, ve, we, Te) {
        var ke = Z[xe];
        if (!e.isValidElementType(ke)) {
          var de = fe(ke);
          return new C("Invalid " + we + " `" + Te + "` of type " + ("`" + de + "` supplied to `" + ve + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return w(M);
    }
    function Pe(M) {
      function Z(xe, ve, we, Te, ke) {
        if (!(xe[ve] instanceof M)) {
          var de = M.name || b, ge = Ve(xe[ve]);
          return new C("Invalid " + Te + " `" + ke + "` of type " + ("`" + ge + "` supplied to `" + we + "`, expected ") + ("instance of `" + de + "`."));
        }
        return null;
      }
      return w(Z);
    }
    function qe(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function Z(xe, ve, we, Te, ke) {
        for (var de = xe[ve], ge = 0; ge < M.length; ge++)
          if (q(de, M[ge]))
            return null;
        var ie = JSON.stringify(M, function(st, Y) {
          var h = Ee(Y);
          return h === "symbol" ? String(Y) : Y;
        });
        return new C("Invalid " + Te + " `" + ke + "` of value `" + String(de) + "` " + ("supplied to `" + we + "`, expected one of " + ie + "."));
      }
      return w(Z);
    }
    function it(M) {
      function Z(xe, ve, we, Te, ke) {
        if (typeof M != "function")
          return new C("Property `" + ke + "` of component `" + we + "` has invalid PropType notation inside objectOf.");
        var de = xe[ve], ge = fe(de);
        if (ge !== "object")
          return new C("Invalid " + Te + " `" + ke + "` of type " + ("`" + ge + "` supplied to `" + we + "`, expected an object."));
        for (var ie in de)
          if (r(de, ie)) {
            var Se = M(de, ie, we, Te, ke + "." + ie, n);
            if (Se instanceof Error)
              return Se;
          }
        return null;
      }
      return w(Z);
    }
    function Ne(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var Z = 0; Z < M.length; Z++) {
        var xe = M[Z];
        if (typeof xe != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + le(xe) + " at index " + Z + "."
          ), a;
      }
      function ve(we, Te, ke, de, ge) {
        for (var ie = [], Se = 0; Se < M.length; Se++) {
          var st = M[Se], Y = st(we, Te, ke, de, ge, n);
          if (Y == null)
            return null;
          Y.data && r(Y.data, "expectedType") && ie.push(Y.data.expectedType);
        }
        var h = ie.length > 0 ? ", expected one of type [" + ie.join(", ") + "]" : "";
        return new C("Invalid " + de + " `" + ge + "` supplied to " + ("`" + ke + "`" + h + "."));
      }
      return w(ve);
    }
    function Ke() {
      function M(Z, xe, ve, we, Te) {
        return Me(Z[xe]) ? null : new C("Invalid " + we + " `" + Te + "` supplied to " + ("`" + ve + "`, expected a ReactNode."));
      }
      return w(M);
    }
    function at(M, Z, xe, ve, we) {
      return new C(
        (M || "React class") + ": " + Z + " type `" + xe + "." + ve + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + we + "`."
      );
    }
    function rt(M) {
      function Z(xe, ve, we, Te, ke) {
        var de = xe[ve], ge = fe(de);
        if (ge !== "object")
          return new C("Invalid " + Te + " `" + ke + "` of type `" + ge + "` " + ("supplied to `" + we + "`, expected `object`."));
        for (var ie in M) {
          var Se = M[ie];
          if (typeof Se != "function")
            return at(we, Te, ke, ie, Ee(Se));
          var st = Se(de, ie, we, Te, ke + "." + ie, n);
          if (st)
            return st;
        }
        return null;
      }
      return w(Z);
    }
    function _t(M) {
      function Z(xe, ve, we, Te, ke) {
        var de = xe[ve], ge = fe(de);
        if (ge !== "object")
          return new C("Invalid " + Te + " `" + ke + "` of type `" + ge + "` " + ("supplied to `" + we + "`, expected `object`."));
        var ie = t({}, xe[ve], M);
        for (var Se in ie) {
          var st = M[Se];
          if (r(M, Se) && typeof st != "function")
            return at(we, Te, ke, Se, Ee(st));
          if (!st)
            return new C(
              "Invalid " + Te + " `" + ke + "` key `" + Se + "` supplied to `" + we + "`.\nBad object: " + JSON.stringify(xe[ve], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(M), null, "  ")
            );
          var Y = st(de, Se, we, Te, ke + "." + Se, n);
          if (Y)
            return Y;
        }
        return null;
      }
      return w(Z);
    }
    function Me(M) {
      switch (typeof M) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !M;
        case "object":
          if (Array.isArray(M))
            return M.every(Me);
          if (M === null || s(M))
            return !0;
          var Z = c(M);
          if (Z) {
            var xe = Z.call(M), ve;
            if (Z !== M.entries) {
              for (; !(ve = xe.next()).done; )
                if (!Me(ve.value))
                  return !1;
            } else
              for (; !(ve = xe.next()).done; ) {
                var we = ve.value;
                if (we && !Me(we[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function He(M, Z) {
      return M === "symbol" ? !0 : Z ? Z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Z instanceof Symbol : !1;
    }
    function fe(M) {
      var Z = typeof M;
      return Array.isArray(M) ? "array" : M instanceof RegExp ? "object" : He(Z, M) ? "symbol" : Z;
    }
    function Ee(M) {
      if (typeof M > "u" || M === null)
        return "" + M;
      var Z = fe(M);
      if (Z === "object") {
        if (M instanceof Date)
          return "date";
        if (M instanceof RegExp)
          return "regexp";
      }
      return Z;
    }
    function le(M) {
      var Z = Ee(M);
      switch (Z) {
        case "array":
        case "object":
          return "an " + Z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Z;
        default:
          return Z;
      }
    }
    function Ve(M) {
      return !M.constructor || !M.constructor.name ? b : M.constructor.name;
    }
    return k.checkPropTypes = o, k.resetWarningCache = o.resetWarningCache, k.PropTypes = k, k;
  }, Li;
}
var Mi, pl;
function $m() {
  if (pl)
    return Mi;
  pl = 1;
  var e = Oa();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Mi = function() {
    function r(a, s, l, d, p, c) {
      if (c !== e) {
        var b = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw b.name = "Invariant Violation", b;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Mi;
}
if (process.env.NODE_ENV !== "production") {
  var Im = Lc(), Nm = !0;
  ta.exports = Am()(Im.isElement, Nm);
} else
  ta.exports = $m()();
var Vm = ta.exports, Ra;
Object.defineProperty(Qi, "__esModule", { value: !0 });
var ar = g, Mc = Om, na = E, zm = bf, Pm = Vm;
function Uc(e) {
  return e && typeof e == "object" && "default" in e ? e : { default: e };
}
var Lt = Uc(ar), un = Uc(Pm), Fm = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof Ks < "u" ? Ks : typeof self < "u" ? self : {};
function jc(e, t) {
  return e(t = { exports: {} }, t.exports), t.exports;
}
var Lm = jc(function(e) {
  (function(t) {
    var n = function(w, T, F) {
      if (!l(T) || p(T) || c(T) || b(T) || s(T))
        return T;
      var L, me = 0, O = 0;
      if (d(T))
        for (L = [], O = T.length; me < O; me++)
          L.push(n(w, T[me], F));
      else
        for (var Pe in L = {}, T)
          Object.prototype.hasOwnProperty.call(T, Pe) && (L[w(Pe, F)] = n(w, T[Pe], F));
      return L;
    }, r = function(w) {
      return k(w) ? w : (w = w.replace(/[\-_\s]+(.)?/g, function(T, F) {
        return F ? F.toUpperCase() : "";
      })).substr(0, 1).toLowerCase() + w.substr(1);
    }, o = function(w) {
      var T = r(w);
      return T.substr(0, 1).toUpperCase() + T.substr(1);
    }, i = function(w, T) {
      return function(F, L) {
        var me = (L = L || {}).separator || "_", O = L.split || /(?=[A-Z])/;
        return F.split(O).join(me);
      }(w, T).toLowerCase();
    }, a = Object.prototype.toString, s = function(w) {
      return typeof w == "function";
    }, l = function(w) {
      return w === Object(w);
    }, d = function(w) {
      return a.call(w) == "[object Array]";
    }, p = function(w) {
      return a.call(w) == "[object Date]";
    }, c = function(w) {
      return a.call(w) == "[object RegExp]";
    }, b = function(w) {
      return a.call(w) == "[object Boolean]";
    }, k = function(w) {
      return (w -= 0) == w;
    }, q = function(w, T) {
      var F = T && "process" in T ? T.process : T;
      return typeof F != "function" ? w : function(L, me) {
        return F(L, w, me);
      };
    }, C = { camelize: r, decamelize: i, pascalize: o, depascalize: i, camelizeKeys: function(w, T) {
      return n(q(r, T), w);
    }, decamelizeKeys: function(w, T) {
      return n(q(i, T), w, T);
    }, pascalizeKeys: function(w, T) {
      return n(q(o, T), w);
    }, depascalizeKeys: function() {
      return this.decamelizeKeys.apply(this, arguments);
    } };
    e.exports ? e.exports = C : t.humps = C;
  })(Fm);
}).decamelize, Mm = function(e) {
  if (Array.isArray(e))
    return e;
}, Um = function(e, t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) {
    var n = [], r = !0, o = !1, i = void 0;
    try {
      for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0)
        ;
    } catch (l) {
      o = !0, i = l;
    } finally {
      try {
        r || s.return == null || s.return();
      } finally {
        if (o)
          throw i;
      }
    }
    return n;
  }
}, fl = function(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}, jm = function(e, t) {
  if (e) {
    if (typeof e == "string")
      return fl(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? fl(e, t) : void 0;
  }
}, Bm = function() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}, Wm = function(e, t) {
  return Mm(e) || Um(e, t) || jm(e, t) || Bm();
}, Bc = jc(function(e) {
  function t() {
    return e.exports = t = Object.assign || function(n) {
      for (var r = 1; r < arguments.length; r++) {
        var o = arguments[r];
        for (var i in o)
          Object.prototype.hasOwnProperty.call(o, i) && (n[i] = o[i]);
      }
      return n;
    }, t.apply(this, arguments);
  }
  e.exports = t;
}), Hm = function(e, t) {
  if (e == null)
    return {};
  var n, r, o = {}, i = Object.keys(e);
  for (r = 0; r < i.length; r++)
    n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
  return o;
}, Wc = function(e, t) {
  if (e == null)
    return {};
  var n, r, o = Hm(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}, Ym = ar.createContext(null);
function ra(e) {
  var t = e.children, n = Wc(e, ["children"]);
  return typeof t != "string" && (t = Mc.renderToString(t)), Lt.default.createElement("template", Bc({}, n, { dangerouslySetInnerHTML: { __html: t } }));
}
function oa(e) {
  var t = e.root, n = e.children;
  return zm.createPortal(n, t);
}
function Xm(e) {
  var t = ar.forwardRef(function(n, r) {
    var o, i, a = n.mode, s = n.delegatesFocus, l = n.styleSheets, d = n.ssr, p = n.children, c = Wc(n, ["mode", "delegatesFocus", "styleSheets", "ssr", "children"]), b = (o = r, i = ar.useRef(o && o.current), ar.useEffect(function() {
      o && (o.current = i.current);
    }, [o]), i), k = ar.useState(null), q = Wm(k, 2), C = q[0], w = q[1], T = "node_".concat(a).concat(s);
    return ar.useLayoutEffect(function() {
      if (b.current)
        try {
          if (typeof r == "function" && r(b.current), d) {
            var F = b.current.shadowRoot;
            return void w(F);
          }
          var L = b.current.attachShadow({ mode: a, delegatesFocus: s });
          l.length > 0 && (L.adoptedStyleSheets = l), w(L);
        } catch (me) {
          (function(O) {
            var Pe = O.error, qe = O.styleSheets, it = O.root;
            switch (Pe.name) {
              case "NotSupportedError":
                qe.length > 0 && (it.adoptedStyleSheets = qe);
                break;
              default:
                throw Pe;
            }
          })({ error: me, styleSheets: l, root: C });
        }
    }, [r, b, l]), Lt.default.createElement(Lt.default.Fragment, null, Lt.default.createElement(e.tag, Bc({ key: T, ref: b }, c), (C || d) && Lt.default.createElement(Ym.Provider, { value: C }, d ? Lt.default.createElement(ra, { shadowroot: a, shadowrootmode: a }, e.render({ root: C, ssr: d, children: p })) : Lt.default.createElement(oa, { root: C }, e.render({ root: C, ssr: d, children: p })))));
  });
  return t.propTypes = { mode: un.default.oneOf(["open", "closed"]), delegatesFocus: un.default.bool, styleSheets: un.default.arrayOf(un.default.instanceOf(globalThis.CSSStyleSheet)), ssr: un.default.bool, children: un.default.node }, t.defaultProps = { mode: "open", delegatesFocus: !1, styleSheets: [], ssr: !1, children: null }, t;
}
ra.propTypes = { children: un.default.oneOfType([un.default.string, un.default.node]) }, ra.defaultProps = { children: "" }, oa.propTypes = { root: un.default.object.isRequired, children: un.default.node }, oa.defaultProps = { children: null };
var Ui = /* @__PURE__ */ new Map();
function Hc() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "core", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(r) {
    return r.children;
  };
  return new Proxy(e, { get: function(r, o) {
    var i = Lm(o, { separator: "-" }), a = "".concat(t, "-").concat(i);
    return Ui.has(a) || Ui.set(a, Xm({ tag: i, render: n })), Ui.get(a);
  } });
}
function Yc(e) {
  var t = new na.ServerStyleSheet();
  return Mc.renderToString(Lt.default.createElement(na.StyleSheetManager, { sheet: t.instance }, Lt.default.createElement(Lt.default.Fragment, null, e))), t.getStyleElement();
}
Hc();
var Jm = Hc({}, "styled-components", function(e) {
  var t = e.root, n = e.ssr, r = e.children;
  return n ? Lt.default.createElement(Lt.default.Fragment, null, Yc(r), r) : Lt.default.createElement(na.StyleSheetManager, { target: t }, Lt.default.createElement(Lt.default.Fragment, null, r));
});
Ra = Qi.default = Jm, Qi.getStyleSheets = Yc;
const Km = v`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, Gm = v`
  display: none;

  &:checked + div {
    border-color: var(--sq-action-primary);
  }

  &:checked + div::after {
    transform: scale(1) translate(-50%, -50%);
  }
`, Zm = v`
  margin-top: 2px;
  width: 14px;
  height: 14px;
  border: 1.5px solid var(--sq-text);
  border-radius: 50%;
  margin-right: 20px;
  box-sizing: border-box;
  flex-shrink: 0;
  position: relative;

  &::after {
    transform-origin: top left;
    position: relative;
    content: "";
    width: 8px;
    height: 8px;
    display: block;
    background: var(--sq-action-primary);
    border-radius: 100%;
    left: 50%;
    top: 50%;
    transform: scale(0) translate(-50%, -50%);
    transition: transform 0.15s;
  }
`, Qm = E(Ra.div)`
  display: contents;
`, ev = E.label`
  ${Km}
  ${(e) => e.readonly && "pointer-events: none; cursor: pointer;"}
  ${(e) => e.customLabelCSS}
`, tv = E.input`
  ${Gm}
`, nv = E.div`
  ${Zm}
`, Xc = m.forwardRef((e, t) => {
  const {
    value: n,
    onChange: r,
    label: o,
    readOnly: i = !1,
    customLabelCSS: a = {},
    ...s
  } = e;
  return /* @__PURE__ */ m.createElement(
    ev,
    {
      customLabelCSS: a,
      htmlFor: s.id,
      readonly: i
    },
    /* @__PURE__ */ m.createElement(
      tv,
      {
        ...s,
        type: "radio",
        checked: n,
        onChange: r,
        ref: t
      }
    ),
    /* @__PURE__ */ m.createElement(nv, null),
    o || ""
  );
}), rv = (e) => {
  const { children: t } = e;
  return /* @__PURE__ */ m.createElement(Qm, null, t);
}, wC = Xc, EC = rv;
function ov(e) {
  return typeof e == "object" && e !== null && e.hasOwnProperty("label") && e.hasOwnProperty("value");
}
function iv(e) {
  return Array.isArray(e);
}
const kC = (e) => {
  var r;
  const t = (r = e == null ? void 0 : e.options) == null ? void 0 : r.enumOptions, n = zr(null);
  return iv(t) ? /* @__PURE__ */ g.createElement("div", { id: e.id }, t == null ? void 0 : t.map((o) => ov(o) ? /* @__PURE__ */ g.createElement(
    Xc,
    {
      ref: n,
      key: e.id + o.value,
      label: o.label,
      name: e.id,
      required: e.required,
      value: e.value == o.value,
      readOnly: e.readonly,
      disabled: e.disabled,
      onChange: () => {
        e.readonly || e.onChange(o.value);
      }
    }
  ) : /* @__PURE__ */ g.createElement(g.Fragment, null))) : /* @__PURE__ */ g.createElement(g.Fragment, null);
};
v`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  height: 36px;
  text-indent: var(--sq-spacing-x-small);
  color: var(--sq-text);
  background: var(--sq-surface);
  font-family: var(--sq-font-family-sans);
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-regular);

  border: 1px solid var(--sq-border);
  border-radius: var(--sq-border-radius-normal);

  &[type="date"] {
    text-indent: 6px;
    padding-right: var(--sq-spacing-small);
  }

  &::placeholder {
    color: var(--sq-text-input-disabled);
  }

  &:focus {
    outline: none;
    border-color: var(--sq-focused);
  }

  &:disabled {
    user-select: none;
    color: var(--sq-text-input-disabled);
    background-color: var(--sq-surface-input-disabled);
  }

  &::-webkit-inner-spin-button {
    opacity: 1;
    margin-right: 10px;
    padding: 10px 1px 10px 1px;
  }
`;
const av = v`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
`;
v`
  border: 1px solid var(--sq-border-critical);
  border-radius: var(--sq-border-radius-normal);

  &:focus {
    outline: none;
    border-color: var(--sq-border-critical);
  }
`;
const sv = v`
  display: inline-block;
  width: 100%;
  position: relative;
  height: auto;
`, hl = E.div`
  ${av}
  ${(e) => e.position == "left" ? "left: 12px;" : "right: 18px;"}
`, lv = E.div`
  ${sv}
  ${(e) => e.limitWidth ? typeof e.limitWidth == "string" ? `max-width: ${e.limitWidth};` : "max-width: 426px;" : "max-width: 100%;"}
  ${(e) => e.customContainerCSS}

  uicl-text-input, uicl-text-input::part(base) {
    width: 100%;
    box-sizing: border-box;
  }

  uicl-text-input::part(base) {
    width: 100%;
    box-sizing: border-box;
    ${(e) => e.customLabelCSS}
  }

  uicl-text-input::part(input) {
    color: var(--sq-text);
    ${(e) => e.hasIcon && `padding-${e.position}: var(--sq-spacing-xx-large);`}
    ${(e) => e.customCSS}
  }
`, cv = qn("uicl-text-input"), In = g.forwardRef(
  (e, t) => {
    const {
      icon: n,
      position: r = "right",
      type: o = "text",
      buttons: i = !1,
      readonly: a = !1,
      errors: s,
      customCSS: l = {},
      customContainerCSS: d = {},
      customLabelCSS: p = {},
      limitWidth: c = !0,
      disabled: b = !1,
      innerTextLeft: k = null,
      innerTextRight: q = null,
      iconSet: C = "saasquatch",
      onChange: w,
      value: T,
      inputMode: F = "text",
      ...L
    } = e;
    function me(O) {
      if (w === void 0)
        return;
      const Pe = O.composedPath()[0];
      Object.defineProperty(O, "target", {
        value: Pe
      }), w(O);
    }
    return /* @__PURE__ */ g.createElement(
      lv,
      {
        customContainerCSS: d,
        customLabelCSS: p,
        customCSS: l,
        hasIcon: !!(n || i),
        position: r,
        limitWidth: c
      },
      /* @__PURE__ */ g.createElement(
        cv,
        {
          ...L,
          ref: t,
          onInput: me,
          isAutoWidth: Be(!1),
          isDisabled: Be(b || !1),
          isReadOnly: Be(b || a || !1),
          innerTextLeft: k,
          innerTextRight: q,
          validationFail: s ? "" : null,
          maxLength: 1e3,
          modelValue: T,
          size: "20",
          type: o
        }
      ),
      n && /* @__PURE__ */ g.createElement(hl, { position: r }, /* @__PURE__ */ g.createElement(
        Le,
        {
          iconSet: C,
          icon: n,
          size: "22px",
          color: "var(--sq-text)"
        }
      )),
      /* @__PURE__ */ g.createElement(hl, { position: r }, i)
    );
  }
), SC = In;
function CC(e) {
  const t = e.options;
  return /* @__PURE__ */ g.createElement(
    In,
    {
      id: e.id,
      ...t,
      value: e.value,
      onChange: (n) => {
        e.readonly || e.onChange(n.target.value);
      },
      disabled: e.disabled,
      errors: e.rawErrors && !!e.rawErrors.length,
      required: e.required,
      placeholder: e.placeholder
    }
  );
}
function qC(e) {
  const t = e.options;
  return /* @__PURE__ */ g.createElement(
    In,
    {
      id: e.id,
      ...t,
      value: e.value,
      type: "number",
      onChange: (n) => {
        e.readonly || e.onChange(n.target.value);
      },
      readOnly: e.readonly,
      disabled: e.disabled,
      errors: e.rawErrors && !!e.rawErrors.length,
      required: e.required,
      placeholder: e.placeholder
    }
  );
}
function _C(e) {
  const [t, n] = kn("password"), r = e.options;
  return /* @__PURE__ */ g.createElement(
    In,
    {
      id: e.id,
      ...r,
      type: t,
      value: e.value,
      onChange: (o) => {
        e.readonly || e.onChange(o.target.value);
      },
      errors: e.rawErrors && !!e.rawErrors.length,
      disabled: e.disabled,
      required: e.required,
      placeholder: e.placeholder,
      buttons: /* @__PURE__ */ g.createElement(
        fn,
        {
          icon: "visibility",
          size: "mini",
          icon_css: "height: 20px; width: 20px",
          borderless: !0,
          onClick: () => {
            n(t == "text" ? "password" : "text");
          }
        }
      )
    }
  );
}
function DC(e) {
  const [t, n] = kn(e.disabled), r = e.options;
  return /* @__PURE__ */ g.createElement(
    In,
    {
      id: e.id,
      ...r,
      value: e.value,
      onChange: (o) => {
        e.readonly || e.onChange(o.target.value);
      },
      disabled: t,
      errors: e.rawErrors && !!e.rawErrors.length,
      required: e.required,
      placeholder: e.placeholder,
      buttons: /* @__PURE__ */ g.createElement(
        fn,
        {
          icon: "edit",
          size: "mini",
          icon_css: "height: 20px; width: 20px",
          borderless: !0,
          onClick: () => {
            n(!t);
          }
        }
      )
    }
  );
}
function OC(e) {
  const t = e.options;
  return /* @__PURE__ */ g.createElement(
    In,
    {
      id: e.id,
      ...t,
      value: e.value,
      onChange: (n) => {
        e.readonly || e.onChange(n.target.value);
      },
      disabled: e.disabled,
      errors: e.rawErrors && !!e.rawErrors.length,
      required: e.required,
      buttons: /* @__PURE__ */ g.createElement(
        fn,
        {
          disabled: e.disabled,
          icon: "close",
          size: "mini",
          icon_css: "height: 20px; width: 20px",
          borderless: !0,
          onClick: () => {
            e.onChange("");
          }
        }
      )
    }
  );
}
function RC(e) {
  const [t, n] = kn(e.value), [r, o] = kn(e.disabled), i = e.options;
  return /* @__PURE__ */ g.createElement(
    In,
    {
      id: e.id,
      ...i,
      value: e.value,
      onChange: (a) => {
        e.readonly || e.onChange(a.target.value);
      },
      disabled: r,
      errors: e.rawErrors && !!e.rawErrors.length,
      required: e.required,
      placeholder: e.placeholder,
      buttons: r == !0 ? /* @__PURE__ */ g.createElement(
        fn,
        {
          icon: "edit",
          size: "mini",
          primary: !0,
          onClick: () => {
            o(!1);
          }
        }
      ) : /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(
        fn,
        {
          icon: "checkmark",
          size: "mini",
          customCSS: "margin-right: 4px;",
          primary: !0,
          onClick: () => {
            n(e.value), o(!0);
          }
        }
      ), /* @__PURE__ */ g.createElement(
        fn,
        {
          icon: "close",
          size: "mini",
          icon_css: "color: #858585;",
          onClick: () => {
            e.onChange(t), o(!0);
          }
        }
      ))
    }
  );
}
const Jc = v`
  padding: var(--sq-spacing-x-small);
  cursor: pointer;
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-regular);
  border-radius: inherit;
  border-radius: var(--sq-border-radius-normal);
  &:hover {
    background: var(--sq-surface-hover);
  }
`, uv = v`
  ${Jc}
  cursor: default;
  background: var(--sq-surface-subdued);
  color: var(--sq-placeholder-text-on-secondary);

  &:hover {
    background: var(--sq-surface-subdued);
  }
`, dv = v`
  position: absolute;
  z-index: 9;
  box-sizing: border-box;
  list-style-type: none;
  width: 100%;
  padding: var(--sq-spacing-xx-small);
  margin: 0;
  background: var(--sq-surface);
  border-radius: var(--sq-border-radius-normal);
  border-top: none;
  outline: none;
  overflow-y: auto;
  box-shadow: var(--iui-box-shadow-default);

  &:empty {
    border: none;
  }
`, pv = v`
  position: absolute;
  display: flex;
  align-items: center;
  text-indent: 0px;
  padding-right: var(--sq-spacing-xx-small);
  right: 0px;
  top: 5px;
  & > :not(:last-child) {
    margin-right: var(--sq-spacing-x-small);
  }
`, fv = v`
  color: var(--sq-text-subdued);
  font-size: var(--sq-font-size-small);
  line-height: var(--sq-line-height-regular);
`, hv = v`
  display: inline-block;
  width: 100%;
  position: relative;
`, mv = v`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 42px;
  max-height: 100%;
  box-sizing: border-box;
  text-indent: 6px;
  color: var(--sq-text);
  background: var(--sq-surface);
  font-family: var(--sq-font-family-sans);
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-regular);
  border: 1px solid var(--sq-border);
  border-radius: var(--sq-border-radius-normal);
  padding: var(--sq-spacing-xx-small) var(--sq-spacing-x-small);
  padding-right: 0;

  &:focus,
  &:hover {
    outline: none;
    border-color: var(--sq-border-hover);
  }
`, vv = v`
  padding-top: var(--sq-spacing-xxx-small);
  margin: 4px 0 auto;
  text-indent: 0px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, gv = v`
  display: flex;
  align-items: center;
  text-indent: 0px;
  padding: 2px 4px 0px;

  & svg {
    &:hover {
      cursor: pointer;
    }
  }

  & > :not(:last-child) {
    margin-right: var(--sq-spacing-xx-small);
  }
`, bv = v`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: auto;
  gap: var(--sq-spacing-xx-small);
  max-width: 100%;
`, yv = v`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--sq-spacing-xx-small);
  flex-direction: column;
  min-height: 50px;
`, xv = v`
  font-weight: var(--sq-font-weight-bold);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  text-align: center;
`, wv = v`
  display: flex;
  border: 1px solid var(--sq-border);
  border-radius: var(--sq-border-radius-normal);
  flex-wrap: wrap;
  &:focus,
  &:hover {
    outline: none;
    border-color: var(--sq-border-hover);
  }
`, Ev = v`
  flex-grow: 1;
`, kv = v`
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  border-radius: var(--sq-border-radius-normal);

  &:hover:not(:disabled) {
    background: var(--sq-action-secondary);
  }
`;
v`
  background-color: var(--sq-background);
  width: 34px;
  height: 34px;
  text-align: center;
  border: 1px solid var(--sq-border);
  box-sizing: border-box;
  border-radius: 50px;
`;
v`
  position: relative;
  top: 6px;
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`;
const Kc = v`
  display: flex;
  min-height: 60px;
  padding: var(--sq-spacing-xx-small) 20px;
  justify-content: space-between;
  align-items: center;
  font-family: var(--sq-font-family-sans);
  font-style: normal;
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  color: var(--sq-text-dark);

  & .actions-container {
    opacity: 0;
    position: absolute;
    right: 0;
    background: linear-gradient(270deg, white 0%, transparent 45%);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    transition: opacity 0.4s;
    pointer-events: none;

    &:first-child {
      max-width: fit-content;
      right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto 0; 
      margin-right: 10px;
    }
}
  }

  &:hover {
    .actions-container {
      opacity: 1;
    }
  }
`, Sv = v`
  & > :first-child {
    border-radius: 6px 6px 0px 0px;
  }
  & > :last-child {
    border-radius: 0px 0px 6px 6px;
  }
`, Gc = {
  row: v`
    background: var(--sq-surface);
    border-bottom: 1px solid var(--sq-border-subdued);
    border-top: 0px;
    box-sizing: border-box;
    position: relative;
  `,
  header: v`
    font-weight: var(--sq-font-weight-semibold);
    background: var(--sq-surface);
    border-bottom: 1px solid var(--sq-border);
    box-sizing: border-box;
    min-height: 40px;
    font-size: var(--sq-font-size-regular) !important;
  `,
  extra: v`
    background: var(--sq-background);
    border: 1px solid var(--sq-border);
    box-sizing: border-box;
  `
}, Cv = v`
  display: flex;
  align-items: center;
  padding: 0 var(--sq-spacing-large);
  height: 74px;
  color: var(--sq-surface);
  background: var(--sq-nav-surface-primary);
  box-sizing: border-box;
`, qv = v`
  width: 100%;
  text-align: center;
`, _v = v`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  /* Body/Body Regular (14) */

  font-family: var(--sq-font-family-sans);
  // font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-small);
  line-height: var(--sq-line-height-regular);
  /* identical to box height, or 143% */

  /* On Surface/Text Dark */

  color: var(--sq-text-dark);
`, Dv = v`
  float: left;
  margin-right: var(--sq-spacing-x-small);
  border-radius: var(--sq-border-radius-pill);
`, Ov = v`
  /* using https://stackoverflow.com/questions/68216941/make-css-shimmer-effect-work-an-already-loaded-image */
  mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right / 300% 100%;
  background-repeat: no-repeat;
  animation: shimmer 2s infinite;
  @keyframes shimmer {
    100% {
      mask-position: left;
    }
  }
`;
v`
  background: var(--sq-surface);
  border: 1px solid var(--sq-border);
  box-sizing: border-box;
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.08);
  // border-radius: 10px;
  div + div.action {
    margin-top: var(--sq-spacing-small);
  }
`;
v`
  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
  font-family: var(--sq-font-family-sans);
  font-style: normal;
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  color: var(--sq-text);
`;
v`
  height: 1px;
  margin: var(--sq-spacing-medium) -36px;
  background: var(--sq-border);
`;
const Rv = v`
  display: flex;
  padding: var(--sq-spacing-large) 0px;
  align-items: center;
  background: var(--sq-surface);
  // border: 1px solid var(--sq-border);
  border-top: 0px;
  box-sizing: border-box;
  min-height: 42px;
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, Tv = v`
  padding: 6px;
  color: var(--sq-text);
  cursor: pointer;
  font-family: var(--sq-font-family-sans);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, Av = v`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: var(--sq-spacing-medium);
`, $v = v`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: var(--sq-spacing-xx-small);
`, Iv = E.div`
  ${Cv}

  ${(e) => e.customCSS}
`, Zc = g.forwardRef((e, t) => {
  const { children: n, customCSS: r = "", ...o } = e;
  return /* @__PURE__ */ g.createElement(Iv, { ...o, ref: t, customCSS: r }, n);
}), Nv = E.div`
  div + div {
    margin-left: var(--sq-spacing-x-small);
  }
  margin-bottom: var(--sq-spacing-large);

  ${(e) => e.customCSS}
`, Qc = g.forwardRef((e, t) => {
  const { children: n, customCSS: r = "", ...o } = e;
  return /* @__PURE__ */ g.createElement(Nv, { ...o, ref: t, customCSS: r }, n);
}), Vv = v`
  position: relative;
  min-width: 191px;
  display: inline-block;
`, zv = v`
  border-radius: inherit;
`, Pv = v`
  text-indent: var(--sq-spacing-x-large);
  border-radius: inherit;
`, Fv = v`
  padding: var(--sq-spacing-x-small) var(--sq-spacing-small);
  border-radius: inherit;
  user-select: none;
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-bold);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, Lv = v`
  margin-left: auto;
  svg {
    width: 12px;
    height: auto;
  }
`, Mv = v`
  display: flex;
  user-select: none;
  padding: 7px 12px;
  border: 1px solid var(--sq-border);
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  cursor: pointer;
`, Uv = v`
  position: absolute;
  width: max-content;
  min-width: inherit;
  z-index: 100;
  background: #ffffff;
  border: 1px solid var(--sq-text-interactive);
  box-sizing: border-box;
  &:empty {
    border: none;
  }
`, jv = v`
  padding: var(--sq-spacing-x-small) var(--sq-spacing-small);
  cursor: pointer;
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  border-radius: inherit;
  &:hover {
    background: var(--sq-surface-hover);
  }
`, Bv = v`
  display: flex;
  align-items: center;
  & > *:not(last-child) {
    margin-right: var(--sq-spacing-xx-small);
  }
`, Wv = v`
  font-size: var(--sq-font-size-regular);
  color: var(--sq-placeholder-text-on-secondary);
  margin-left: auto;
`, Hv = v`
  margin: 0;
  font-size: var(--sq-font-size-small);
  line-height: var(--sq-line-height-regular);
  color: var(--sq-text-subdued);
`, Yv = v`
  color: var(--sq-text-subdued);
  font-size: var(--sq-font-size-regular);
`, Xv = v`
  color: var(--sq-text-subdued);
  font-size: var(--sq-font-size-regular);
  font-style: italic;
`, Jv = E("div")`
  ${Vv}
  ${(e) => e.customCSS}
`, Kv = E("div")`
  ${Mv}
  border-radius: ${(e) => e.pill ? "var(--sq-border-radius-pill)" : "var(--sq-border-radius-normal)"};
  text-align: ${(e) => e.center ? "center" : "left"};
  line-height: ${(e) => e.narrow ? "10px" : "16px"};
  color: ${(e) => e.disabled ? "var(--sq-text-subdued)" : "var(--sq-text-on-secondary)"};
  background: ${(e) => e.disabled ? "#e5e5e5" : "var(--sq-surface)"};
  ${(e) => !e.disabled && e.showMenu && "border-color: var(--sq-text-interactive);"}
  ${(e) => e.showMenu && !e.pill && (e.popUpwards ? "border-top: 2px solid var(--sq-surface);" : "border-bottom: none;")}
  ${(e) => `border-radius: ${e.borderRadius};`}
  &:hover {
    ${(e) => e.disabled && "cursor: not-allowed;"};
  }
`, Gv = E("div")`
  ${Uv}
  border-radius: ${(e) => e.borderRadius};

  ${(e) => e.popUpwards && "top: 2px; transform: translateY(calc(-100% + -1*var(--sq-spacing-x-small)));"}

  ${(e) => e.popUpwards && !e.pill && "top: 2px; transform: translateY(calc(-100%));"}

  ${(e) => !e.pill && (e.popUpwards ? "border-bottom: none;" : "border-top: none; transform: translateY(-1px);")}

  ${(e) => e.pill && !e.popUpwards && "margin-top: var(--sq-spacing-x-small);"}
`, Zv = E("div")`
  ${jv}
  ${(e) => e.customCSS}
`, Qv = E("div")`
  ${zv}
  ${(e) => e.customCSS}
`, eg = E("div")`
  ${Pv}
`, tg = E("div")`
  ${Fv}
`, ng = E("span")`
  ${Lv}
`, rg = E("div")`
  ${Bv}
`, og = E("span")`
  ${Wv}
`, ig = E("p")`
  ${Hv}
`, ag = E("span")`
  ${Yv}
`, sg = E("span")`
  ${Xv}
`, ml = {
  pill: {
    top: {
      open: "var(--sq-border-radius-pill)",
      closed: "var(--sq-border-radius-pill)",
      content: "var(--sq-border-radius-normal)"
    },
    bottom: {
      open: "var(--sq-border-radius-pill)",
      closed: "var(--sq-border-radius-pill)",
      content: "var(--sq-border-radius-normal)"
    }
  },
  normal: {
    top: {
      open: "var(--sq-border-radius-normal) var(--sq-border-radius-normal) 0 0",
      closed: "var(--sq-border-radius-normal)",
      content: "var(--sq-border-radius-normal) var(--sq-border-radius-normal) 0 0"
    },
    bottom: {
      open: "0 0 var(--sq-border-radius-normal) var(--sq-border-radius-normal)",
      closed: "var(--sq-border-radius-normal)",
      content: "0 0 var(--sq-border-radius-normal) var(--sq-border-radius-normal)"
    }
  }
}, eu = m.forwardRef(
  (e, t) => {
    const {
      text: n = "",
      showMenu: r = !1,
      pill: o = !1,
      center: i = !1,
      narrow: a = !1,
      disabled: s = !1,
      popUpwards: l = !1,
      icon: d,
      onClickDropdown: p,
      children: c,
      placeholder: b,
      emptyText: k,
      customCSS: q = {},
      ...C
    } = e;
    return /* @__PURE__ */ m.createElement(Jv, { ...C, ref: t, customCSS: q }, /* @__PURE__ */ m.createElement(
      Kv,
      {
        pill: o,
        center: i,
        narrow: a,
        disabled: s,
        onClick: p,
        showMenu: !s && r,
        popUpwards: l,
        borderRadius: ml[o ? "pill" : "normal"][l ? "bottom" : "top"][r ? "open" : "closed"]
      },
      d && /* @__PURE__ */ m.createElement(
        Le,
        {
          color: "inherit",
          size: "16px",
          icon: d,
          style: {
            margin: -3,
            top: 2.5,
            marginRight: "var(--sq-spacing-x-small)"
          }
        }
      ),
      n || /* @__PURE__ */ m.createElement(ag, null, b),
      /* @__PURE__ */ m.createElement(ng, null, r ? /* @__PURE__ */ m.createElement(Le, { size: "16px", icon: "chevron_up" }) : /* @__PURE__ */ m.createElement(Le, { size: "16px", icon: "chevron_down" }))
    ), r && /* @__PURE__ */ m.createElement(
      Gv,
      {
        popUpwards: l,
        pill: o,
        borderRadius: ml[o ? "pill" : "normal"][l ? "top" : "bottom"].content
      },
      c || k && /* @__PURE__ */ m.createElement(Ta, null, /* @__PURE__ */ m.createElement(sg, null, k))
    ));
  }
), Ta = m.forwardRef(
  (e, t) => {
    const {
      onClick: n,
      children: r,
      checked: o,
      description: i,
      sideDescription: a,
      customCSS: s = {},
      ...l
    } = e;
    return /* @__PURE__ */ m.createElement(
      Zv,
      {
        onClick: n,
        ...l,
        ref: t,
        customCSS: s
      },
      /* @__PURE__ */ m.createElement(rg, null, o && /* @__PURE__ */ m.createElement(Le, { icon: "checkmark", size: "18px" }), r, a && /* @__PURE__ */ m.createElement(og, null, a)),
      i && /* @__PURE__ */ m.createElement(ig, null, i)
    );
  }
), tu = m.forwardRef((e, t) => {
  const { name: n, children: r, customCSS: o = {}, ...i } = e;
  return /* @__PURE__ */ m.createElement(Qv, { ...i, ref: t, customCSS: o }, /* @__PURE__ */ m.createElement(tg, null, n), /* @__PURE__ */ m.createElement(eg, null, r));
}), Ao = Object.assign(eu, {
  SublistView: tu,
  ItemView: Ta
}), TC = Object.assign(eu, {
  Sublist: tu,
  Item: Ta
}), lg = E.div`
  ${Dv}
  background-color: ${(e) => e.color ? e.color : "var(--sq-border)"};

  height: ${(e) => e.circle && e.size ? e.size : "15px"};
  width: ${(e) => e.circle ? e.size ? e.size : "15px" : e.size ? e.size : "100%"};

  ${(e) => !e.hideShimmer && Ov}

  ${(e) => e.customCSS};
`, Aa = m.forwardRef((e, t) => {
  const {
    circle: n = !1,
    size: r,
    color: o,
    children: i,
    customCSS: a = {},
    hideShimmer: s = !1,
    ...l
  } = e;
  return /* @__PURE__ */ m.createElement(
    lg,
    {
      ...l,
      circle: n,
      size: r,
      color: o,
      hideShimmer: s,
      ref: t,
      customCSS: a
    },
    i
  );
}), cg = E.div`
  ${Rv}

  ${(e) => e.customCSS}
`, vl = E.div`
  ${Tv}
  ${(e) => e.selected ? "font-weight: var(--sq-font-weight-bold);" : "font-weight: var(--sq-font-weight-regular);"}
`, ug = E.div`
  ${Av}
`, dg = E.div`
  ${$v}
`, nu = m.forwardRef((e, t) => {
  const {
    offset: n,
    limit: r,
    updatePagination: o,
    hidePerPage: i = !1,
    total: a = null,
    hasNext: s = !1,
    loading: l = !1,
    customCSS: d = {},
    perPageSlot: p,
    ...c
  } = e, b = Math.floor((n + 1) / r), k = a ? Array.from(Array(Math.ceil(a / r)).keys()) : [b], q = k[k.length - 1], C = k.filter(
    (F) => Math.abs(F - b) < 3 || Math.abs(F - q) < 3 || Math.abs(F) < 3
  ), [w, T] = m.useState(!1);
  return /* @__PURE__ */ m.createElement(cg, { ...c, ref: t, customCSS: d }, l ? /* @__PURE__ */ m.createElement(Aa, { customCSS: { marginLeft: "auto" }, size: "160px" }) : /* @__PURE__ */ m.createElement(m.Fragment, null, a !== null && (a === 0 ? "Displaying 0" : `Displaying ${a === 0 ? 0 : n + 1} - ${Math.min(
    n + r,
    a
  )} of ${a}`), /* @__PURE__ */ m.createElement(ug, null, !i && (p || /* @__PURE__ */ m.createElement(
    Ao,
    {
      onClickDropdown: () => T(!w),
      showMenu: w,
      center: !0,
      popUpwards: !0,
      text: `${r} Per Page`,
      customCSS: "min-width: 125px; width: 100%; display: inline-block; border-radius: var(--sq-border-radius-normal);"
    },
    /* @__PURE__ */ m.createElement(
      Ao.ItemView,
      {
        onClick: () => {
          o(10, 0), T(!1);
        }
      },
      "10 Per Page"
    ),
    /* @__PURE__ */ m.createElement(
      Ao.ItemView,
      {
        onClick: () => {
          o(25, 0), T(!1);
        }
      },
      "25 Per Page"
    ),
    /* @__PURE__ */ m.createElement(
      Ao.ItemView,
      {
        onClick: () => {
          o(50, 0), T(!1);
        }
      },
      "50 Per Page"
    )
  )), /* @__PURE__ */ m.createElement(dg, null, /* @__PURE__ */ m.createElement(
    Jn,
    {
      buttonType: "outline",
      size: "mini",
      icon: "chevron_left",
      circle: !0,
      customCSS: "margin: -3px; display: flex; align-items: center; justify-content: center;border-radius: 50px; width: 30px; height: 30px;",
      disabled: n == 0,
      onClick: () => {
        o(r, Math.max(n - r, 0));
      }
    }
  ), C.map((F, L) => /* @__PURE__ */ m.createElement(m.Fragment, { key: `page-${L}` }, L != 0 && C[L - 1] + 1 != F && /* @__PURE__ */ m.createElement(vl, { style: { cursor: "default" } }, "..."), /* @__PURE__ */ m.createElement(
    vl,
    {
      selected: b === F,
      onClick: () => {
        o(r, Math.max(r * F, 0));
      }
    },
    F + 1
  ))), /* @__PURE__ */ m.createElement(
    Jn,
    {
      buttonType: "outline",
      size: "mini",
      icon: "chevron_right",
      customCSS: "margin: -3px;display: flex; align-items: center; justify-content: center;border-radius: 50px; width: 30px; height: 30px;",
      disabled: a != null ? n + r >= a : !s,
      onClick: () => {
        o(r, n + r);
      }
    }
  )))));
}), ru = E.div`
  ${Kc}

  ${(e) => Gc[e.variant]}

  ${(e) => e.customCSS}


${(e) => e.hoverStyle && "&:hover {box-shadow: 0px 4px 2px -4px var(--iui-bleakest-gray);cursor: pointer; z-index: 20;}"}
`, pg = E.div`
  ${_v}
  ${(e) => e.center ? "text-align: center;" : ""}
  flex-grow: ${(e) => e.flex};
  width: ${(e) => e.width};
`, ou = m.forwardRef(
  (e, t) => {
    const {
      variant: n = "row",
      children: r,
      customCSS: o = {},
      actionsSlot: i,
      ...a
    } = e;
    return /* @__PURE__ */ m.createElement(
      ru,
      {
        hoverStyle: !!i,
        variant: n,
        ...a,
        ref: t,
        customCSS: o
      },
      r && r.map((s, l) => /* @__PURE__ */ m.createElement(
        pg,
        {
          flex: s.flex ? s.flex : "1",
          center: s.center,
          width: s.width ? s.width : "100px",
          key: l
        },
        s.text
      )),
      i && /* @__PURE__ */ m.createElement("div", { className: "actions-container" }, i)
    );
  }
), gl = /* @__PURE__ */ g.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "126",
    height: "91",
    fill: "none",
    viewBox: "0 0 126 91"
  },
  /* @__PURE__ */ g.createElement("path", { fill: "url(#sq-visual-dev-data-graphic)", d: "M0 0H126V91H0z" }),
  /* @__PURE__ */ g.createElement("defs", null, /* @__PURE__ */ g.createElement(
    "pattern",
    {
      id: "sq-visual-dev-data-graphic",
      width: "1",
      height: "1",
      patternContentUnits: "objectBoundingBox"
    },
    /* @__PURE__ */ g.createElement(
      "use",
      {
        transform: "matrix(.00401 0 0 .00556 -.002 0)",
        xlinkHref: "#image0_120:653"
      }
    )
  ), /* @__PURE__ */ g.createElement(
    "image",
    {
      id: "image0_120:653",
      width: "250",
      height: "180",
      xlinkHref: "data:image/png;base64,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"
    }
  ))
), fg = E.div`
  ${qv}
`, bl = E.div`
  ${Kc}
  ${Gc.row}
`, hg = E.div`
  ${Sv}
  width: ${(e) => e.width};
  ${(e) => e.customCSS}
`, yl = E(fg)`
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`, iu = m.forwardRef((e, t) => {
  const {
    width: n = "100%",
    children: r,
    customCSS: o = {},
    empty: i = !1,
    loading: a = !1,
    emptyFilter: s = !1,
    emptyGraphic: l = gl,
    emptyFilterGraphic: d = gl,
    emptyContent: p = "No submission found",
    emptyFilterContent: c = "No submissions that meet your filter criteria",
    headerSlot: b = /* @__PURE__ */ m.createElement(m.Fragment, null),
    footerSlot: k = /* @__PURE__ */ m.createElement(m.Fragment, null),
    ...q
  } = e;
  return /* @__PURE__ */ m.createElement(
    hg,
    {
      ...q,
      width: n,
      ref: t,
      customCSS: o
    },
    b,
    a && /* @__PURE__ */ m.createElement(Df.Table, null),
    !a && i && /* @__PURE__ */ m.createElement(bl, null, /* @__PURE__ */ m.createElement(yl, null, l, p)),
    !a && !i && s && /* @__PURE__ */ m.createElement(bl, null, /* @__PURE__ */ m.createElement(yl, null, d, c)),
    !a && !i && !s && r,
    !a && k
  );
}), au = g.forwardRef((e, t) => {
  const {
    variant: n = "row",
    children: r,
    customCSS: o = {},
    actionsSlot: i,
    ...a
  } = e;
  return /* @__PURE__ */ g.createElement(
    ru,
    {
      hoverStyle: !!i,
      variant: n,
      ...a,
      ref: t,
      customCSS: o
    },
    r,
    i && /* @__PURE__ */ g.createElement("div", { className: "actions-container" }, i)
  );
}), ji = Object.assign(iu, {
  RowView: ou,
  PaginationView: nu,
  BannerView: Zc,
  FilterView: Qc,
  SkeletonView: Aa,
  TableRowView: au
}), AC = Object.assign(iu, {
  Row: ou,
  Pagination: nu,
  Banner: Zc,
  Filter: Qc,
  Skeleton: Aa,
  TableRow: au
}), mg = E.ul`
  ${dv}
  ${(e) => e.errors && "border-color: var(--sq-border-critical); background-color: var(--sq-surface-critical-subdued);"}
  ${(e) => e.limitWidth ? typeof e.limitWidth == "string" ? `max-width: ${e.limitWidth};` : "max-width: 300px;" : "max-width: 100%;"}
  ${(e) => e.limitHeight ? typeof e.limitHeight == "string" ? `max-height: ${e.limitHeight};` : "max-height: 200px;" : "max-height: auto;"}
      ${(e) => e.empty && "& li:hover {background: white; cursor: default;}"}
    ${(e) => e.customCSS}
    ${(e) => !e.isOpen && "visibility: hidden; padding: 0;"}
`, Zr = E.li`
  ${Jc}
  ${(e) => e.isHighlighted ? "background-color: var(--sq-surface-hover);" : ""}
    ${(e) => e.customCSS}
`, vg = E.li`
  ${uv}

  ${(e) => e.customCSS}
`, gg = E.div`
  ${pv}
`, bg = E("span")`
  ${fv}
`, yg = E("div")`
  ${hv}
  ${(e) => e.readonly && "pointer-events: none; cursor: pointer;"}
  ${(e) => e.limitWidth ? typeof e.limitWidth == "string" ? `max-width: ${e.limitWidth};` : "max-width: 300px;" : "max-width: 100%;"}
  ${(e) => e.customContainerCSS}
`, xl = E.div`
  ${bv}
`, xg = E.button`
  ${mv}
  ${(e) => e.disabled && "background: var(--sq-surface-input-disabled); cursor: default;"}
  ${(e) => !e.disabled && `&:hover{
    border-color: ${e.errors ? "var(--sq-surface-critical-hovered)" : "var(--sq-border-hover)"} ;
  }`}

  ${(e) => !e.disabled && `&:focus {
    border-color: var(--sq-border-hover);
  }`}

  ${(e) => e.errors && "border-color: var(--sq-border-critical); background: var(--sq-surface-critical-subdued);"}

  ${(e) => e.customCSS}
`, wg = E.span`
  ${vv}
  ${(e) => e.subdued && "color: var(--sq-text-subdued)"}
`, Eg = E.div`
  ${gv}
`, kg = E.div`
  ${yv}
`, Sg = E.span`
  ${xv}
`, Cg = E.div`
  ${Ev}
`, qg = E.button`
  ${kv}
`, _g = E.div`
  ${wv}
  ${(e) => e.errors ? "border-color: var(--sq-border-critical); background-color: var(--sq-surface-critical-subdued);" : ""}
  ${(e) => e.disabled ? "background: var(--sq-surface-input-disabled);" : ""}
`, Dg = (e) => {
  const {
    item: t,
    index: n,
    disabled: r = !1,
    itemToString: o = $a,
    functional: i,
    customCSS: a = {},
    ...s
  } = e, l = o(t), d = e.itemToNode ? e.itemToNode(t) : lu(t, l);
  return r ? (
    //@ts-ignore
    /* @__PURE__ */ g.createElement(
      vg,
      {
        customCSS: a,
        key: `${l}-${n}`,
        ...i.getItemProps({ item: t, index: n, isItemDisabled: !0 }),
        ...s,
        onMouseMove: () => {
        },
        onClick: () => {
        }
      },
      d
    )
  ) : (
    // @ts-ignore
    /* @__PURE__ */ g.createElement(
      Zr,
      {
        customCSS: a,
        isHighlighted: i.highlightedIndex === n,
        key: `${o(t)}-${n}`,
        ...i.getItemProps({ item: t, index: n }),
        ...s,
        onMouseMove: () => {
        }
      },
      d
    )
  );
}, Og = (e) => {
  const {
    readonly: t = !1,
    limitWidth: n = !0,
    customContainerCSS: r = "",
    children: o
  } = e;
  return /* @__PURE__ */ g.createElement(
    yg,
    {
      customContainerCSS: r,
      limitWidth: n,
      readonly: t
    },
    o
  );
}, Rg = E(Jn)`
  &:hover {
    background: transparent;
  }
`, Tg = (e, t) => {
  const {
    customCSS: n = "",
    disabled: r = !1,
    readonly: o = !1,
    errors: i = !1,
    clearable: a = !1,
    placeholder: s = "",
    limitWidth: l = !0,
    customIcon: d,
    functional: p,
    tagsSlot: c,
    itemToString: b = $a,
    ...k
  } = e, q = a ? "inline-flex" : "none";
  function C(O) {
    return O.getInputProps !== void 0;
  }
  const w = o || r ? !1 : p.isOpen, T = p.selectedItem !== void 0 && p.selectedItem !== null, F = p.getToggleButtonProps(), { onSelectedItemChange: L, ...me } = F;
  return C(p) ? /* @__PURE__ */ g.createElement(
    _g,
    {
      ...p.getMenuProps({}, { suppressRefError: !0 }),
      isOpen: w,
      errors: i,
      disabled: r,
      style: {
        paddingRight: `${a ? " var(--sq-spacing-xxxx-large)" : "var(--sq-spacing-xxx-large)"}`
      }
    },
    c && /* @__PURE__ */ g.createElement(
      xl,
      {
        style: {
          padding: "var(--sq-spacing-xx-small) var(--sq-spacing-x-small)"
        }
      },
      c
    ),
    /* @__PURE__ */ g.createElement(Cg, null, /* @__PURE__ */ g.createElement(
      In,
      {
        ...p.getInputProps({}, { suppressRefError: !0 }),
        placeholder: s,
        type: "text",
        ref: t,
        errors: i,
        limitWidth: l,
        customLabelCSS: `
              background-color: transparent;
              border: none !important;
              ${n};
            `,
        disabled: r,
        autoComplete: "off",
        autoCorrect: "off"
      }
    )),
    /* @__PURE__ */ g.createElement(gg, null, /* @__PURE__ */ g.createElement(
      Rg,
      {
        disabled: r,
        icon: "close",
        borderless: !0,
        size: "mini",
        customCSS: {
          color: "var(--sq-text-subdued)",
          display: q
        },
        icon_css: { marginTop: "var(--sq-spacing-xxx-small)" },
        onClick: (O) => {
          O.stopPropagation(), p.selectItem(null);
        }
      }
    ), /* @__PURE__ */ g.createElement(qg, { ...p.getToggleButtonProps() }, /* @__PURE__ */ g.createElement(
      Le,
      {
        icon: d || (w ? "chevron_up" : "chevron_down"),
        size: "small",
        customCSS: "padding: var(--sq-spacing-x-small); box-sizing: content-box;",
        color: "var(--sq-text-subdued)"
      }
    )))
  ) : /* @__PURE__ */ g.createElement(
    xg,
    {
      ...k,
      type: "button",
      role: "button",
      isOpen: p.isOpen,
      ref: t,
      ...me,
      disabled: r,
      errors: i,
      customCSS: n
    },
    c && /* @__PURE__ */ g.createElement(xl, null, c),
    /* @__PURE__ */ g.createElement(wg, { subdued: !T }, T ? b(p.selectedItem) : s),
    /* @__PURE__ */ g.createElement(Eg, null, /* @__PURE__ */ g.createElement(
      Jn,
      {
        disabled: r,
        icon: "close",
        borderless: !0,
        size: "mini",
        customCSS: {
          display: q,
          color: "var(--sq-text-subdued)"
        },
        icon_css: {
          margin: "auto",
          height: "16px",
          width: "16px"
        },
        color: "var(--sq-text-subdued)",
        onClick: (O) => {
          O.stopPropagation(), p.selectItem(null);
        }
      }
    ), d ? /* @__PURE__ */ g.createElement(
      Le,
      {
        icon: d,
        size: "small",
        customCSS: "padding: var(--sq-spacing-x-small); box-sizing: content-box;",
        color: "var(--sq-text-subdued)"
      }
    ) : /* @__PURE__ */ g.createElement(
      Le,
      {
        icon: w ? "chevron_up" : "chevron_down",
        size: "small",
        customCSS: "padding: var(--sq-spacing-x-small); box-sizing: content-box;",
        color: "var(--sq-text-subdued)"
      }
    ))
  );
}, Ag = (e) => {
  const { items: t, functional: n, itemToString: r, itemToNode: o } = e;
  return t.map((i, a) => /* @__PURE__ */ g.createElement(
    Kt.ItemView,
    {
      functional: n,
      index: a,
      item: i,
      itemToNode: o,
      itemToString: r
    }
  ));
}, su = (e, t) => {
  const {
    errors: n = !1,
    limitWidth: r = !0,
    limitHeight: o = !1,
    disabled: i = !1,
    readonly: a = !1,
    loading: s = !1,
    functional: l,
    items: d,
    children: p,
    loadingSlot: c = /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(Zr, { style: { height: "32px" }, key: "1" }, /* @__PURE__ */ g.createElement(ji.SkeletonView, { size: "120px" })), /* @__PURE__ */ g.createElement(Zr, { style: { height: "32px" }, key: "2" }, /* @__PURE__ */ g.createElement(ji.SkeletonView, { size: "120px" })), /* @__PURE__ */ g.createElement(Zr, { style: { height: "32px" }, key: "3" }, /* @__PURE__ */ g.createElement(ji.SkeletonView, { size: "120px" }))),
    empty: b = !d.length,
    emptySlot: k = /* @__PURE__ */ g.createElement(kg, null, /* @__PURE__ */ g.createElement(Sg, null, "No results found")),
    customCSS: q = {}
  } = e, C = !a && !i && l.isOpen;
  return /* @__PURE__ */ g.createElement(
    mg,
    {
      ref: t,
      ...l.getMenuProps({}, { suppressRefError: !0 }),
      limitWidth: r,
      limitHeight: o,
      errors: n,
      empty: b,
      isOpen: C,
      customCSS: q
    },
    C ? s ? c : b ? /* @__PURE__ */ g.createElement(Zr, { key: "empty" }, k) : p : /* @__PURE__ */ g.createElement(g.Fragment, null)
  );
};
function $a(e) {
  return `${e}`;
}
function $g(e) {
  return typeof e == "object" && e.hasOwnProperty("description");
}
function lu(e, t) {
  if (e == null)
    return /* @__PURE__ */ g.createElement(g.Fragment, null);
  const n = e && $g(e) && e.description;
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement("span", null, t), n && /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement("br", null), /* @__PURE__ */ g.createElement(bg, null, n)));
}
const Ig = (e, t) => {
  const { itemToString: n, itemToNode: r, ...o } = e;
  return /* @__PURE__ */ g.createElement(su, { ...o, ref: t }, Ag({
    items: e.items,
    functional: e.functional,
    itemToString: n,
    itemToNode: r
  }));
}, Kt = {
  HandleView: g.forwardRef(Tg),
  ListView: g.forwardRef(Ig),
  FrameView: g.forwardRef(su),
  ContainerView: Og,
  ItemView: Dg,
  ItemToNode: lu,
  ItemToString: $a
}, Ng = (e, t) => /* @__PURE__ */ g.createElement(Kt.ContainerView, { ...e }, /* @__PURE__ */ g.createElement(Kt.HandleView, { ...e, ref: t }), /* @__PURE__ */ g.createElement(Kt.ListView, { ...e, ref: t })), Vg = g.forwardRef(Ng), zg = v`
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-button-medium);
  font-family: var(--sq-font-family-sans);
`, Pg = v`
  font-weight: var(--sq-font-weight-semibold);
  display: block;
  color: var(--sq-text);
  margin: 0 0 var(--sq-spacing-small);
`, Fg = v`
  display: contents;
  & > p {
    color: var(--sq-text-subdued) !important;
    margin: var(--sq-spacing-xx-small) 0 0;
    font-size: var(--sq-font-size-small);
  }
`, Lg = v`
  color: var(--sq-placeholder-text-on-secondary);
`, Mg = v`
  display: contents;
  & > p {
    color: var(--sq-text-subdued) !important;
    margin: var(--sq-spacing-small) 0 0;
  }
`, Ug = v`
  margin: var(--sq-spacing-small) 0;
  padding-left: 0;
  list-style-type: none;
  & > * {
    color: var(--sq-on-surface-critical);
    margin: var(--sq-spacing-small) 0 0 !important;
  }
`, jg = v`
  & > span {
    margin-left: var(--sq-spacing-x-small);
  }
`, cu = E.label`
  ${Pg}
`, uu = E.div`
  ${Fg}
`, du = E.div`
  ${Mg}
`, pu = E.ul`
  ${Ug}
`, fu = E.span`
  ${Lg}
`, hu = E.div`
  ${zg}
  ${(e) => e.customCSS}
`, mu = E.li`
  ${jg}
`, xr = (e) => {
  var b, k;
  const {
    id: t,
    classNames: n,
    label: r,
    help: o,
    required: i,
    description: a,
    children: s,
    schema: l,
    rawErrors: d,
    uiSchema: p
  } = e, c = l.type === "object" || l.type === "array";
  return /* @__PURE__ */ g.createElement(
    hu,
    {
      customCSS: (b = p["ui:options"]) == null ? void 0 : b.customCSS,
      className: n,
      id: t
    },
    !c && r && !((k = p["ui:options"]) != null && k.hideLabel) && /* @__PURE__ */ g.createElement(cu, { htmlFor: t, id: `${t}-title` }, r, i && /* @__PURE__ */ g.createElement(fu, null, " (required)")),
    s,
    !c && /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(uu, { id: `${t}-description` }, a), /* @__PURE__ */ g.createElement(du, { id: `${t}-help` }, o), (d == null ? void 0 : d.length) > 0 && /* @__PURE__ */ g.createElement(pu, { id: `${t}-errors` }, d.map((q) => /* @__PURE__ */ g.createElement(mu, { key: q }, /* @__PURE__ */ g.createElement(Le, { icon: "info", size: "15px" }), /* @__PURE__ */ g.createElement("span", null, q)))))
  );
};
xr.Label = cu;
xr.Description = uu;
xr.HelpText = du;
xr.Errors = pu;
xr.Container = hu;
xr.ErrorItem = mu;
xr.RequiredLabel = fu;
const Bg = v``, Wg = v`
  margin: 0 0 var(--sq-spacing-xx-large);
`, Hg = v`
  margin: 0 0 var(--sq-spacing-xx-large);
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-button-medium);
  font-family: var(--sq-font-family-sans);
`, Yg = v`
  color: var(--sq-text);
  font-weight: var(--sq-font-weight-semibold);
  font-size: var(--sq-font-size-caption);
`, Xg = v`
  color: var(--sq-text-subdued) !important;
  margin: var(--sq-spacing-small) 0 0;
`, Jg = v`
  color: var(--sq-placeholder-text-on-secondary);
`, Kg = E.div`
  ${Bg}
`, Gg = E.div`
  ${Wg}
`, Zg = E.div`
  display: contents;
  ${(e) => e.customCSS}
`, Qg = E.label`
  ${Yg}
`, eb = E.p`
  ${Xg}
`, tb = E.div`
  ${Hg}
`, nb = E.span`
  ${Jg}
`, $C = (e) => {
  var s;
  const {
    idSchema: t,
    title: n,
    description: r,
    properties: o,
    required: i,
    uiSchema: a
  } = e;
  return /* @__PURE__ */ g.createElement(Kg, null, (n || r) && /* @__PURE__ */ g.createElement(tb, null, n && /* @__PURE__ */ g.createElement(Qg, { id: `${t.$id}-title` }, n, i && /* @__PURE__ */ g.createElement(nb, null, " (required)")), r && /* @__PURE__ */ g.createElement(eb, { id: `${t.$id}-description` }, r)), /* @__PURE__ */ g.createElement(Zg, { customCSS: (s = a["ui:options"]) == null ? void 0 : s.customCSS }, o.map((l, d) => /* @__PURE__ */ g.createElement(Gg, { className: "property-wrapper", key: d }, l.content))));
}, rb = v``, ob = v`
  margin: 0 0 var(--sq-spacing-xx-large);
`, ib = v`
  margin: 0 0 var(--sq-spacing-xx-large);
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-button-medium);
  font-family: var(--sq-font-family-sans);
`, ab = v`
  color: var(--sq-text);
  font-weight: var(--sq-font-weight-semibold);
  font-size: var(--sq-font-size-caption);
`, sb = v`
  color: var(--sq-text-subdued);
  margin: var(--sq-spacing-small) 0 0;
`, lb = v`
  color: var(--sq-placeholder-text-on-secondary);
`, cb = v`
  display: flex;
  justify-content: space-between;
  margin: var(--sq-spacing-large) 0;
`, ub = v`
  flex: 1;
`, db = v`
  height: 36px;
  display: flex;
  align-items: center;
  & > * {
    margin-left: var(--sq-spacing-medium);
  }
`, pb = v`
  display: flex;
  flex-direction: column;
`, fb = E.div`
  ${rb}
`;
E.div`
  ${ob}
`;
const hb = E.label`
  ${ab}
`, mb = E.p`
  ${sb}
`, vb = E.div`
  ${ib}
`, gb = E.span`
  ${lb}
`, bb = E.div`
  ${cb}
`, yb = E.div`
  ${ub}
`, xb = E.div`
  ${db}
`, wb = E.div`
  ${pb}
`, Eb = (e) => {
  const {
    key: t,
    children: n,
    hasToolbar: r,
    hasMoveDown: o,
    hasMoveUp: i,
    hasRemove: a,
    disabled: s,
    readonly: l,
    index: d,
    onReorderClick: p,
    onDropIndexClick: c
  } = e;
  return /* @__PURE__ */ g.createElement(bb, { key: t }, /* @__PURE__ */ g.createElement(yb, null, n), /* @__PURE__ */ g.createElement(xb, null, r && /* @__PURE__ */ g.createElement(g.Fragment, null, (i || o) && /* @__PURE__ */ g.createElement(
    fn,
    {
      size: "mini",
      borderless: !0,
      icon: "chevron_up",
      disabled: s || l || !i,
      onClick: p(d, d - 1)
    }
  ), (i || o) && /* @__PURE__ */ g.createElement(
    fn,
    {
      size: "mini",
      borderless: !0,
      icon: "chevron_down",
      disabled: s || l || !o,
      onClick: p(d, d + 1)
    }
  ), a && /* @__PURE__ */ g.createElement(
    fn,
    {
      size: "mini",
      borderless: !0,
      icon: "trash",
      icon_css: { color: "var(--sq-on-surface-critical)" },
      disabled: s || l,
      onClick: c(d)
    }
  ))));
}, IC = (e) => {
  const {
    title: t,
    required: n,
    idSchema: r,
    items: o,
    canAdd: i,
    disabled: a,
    readonly: s,
    onAddClick: l,
    uiSchema: d,
    schema: p
  } = e;
  return /* @__PURE__ */ g.createElement(fb, null, (t || d["ui:description"] || p.description) && /* @__PURE__ */ g.createElement(vb, null, t && /* @__PURE__ */ g.createElement(hb, { key: `array-field-title-${r.$id}` }, t, n && /* @__PURE__ */ g.createElement(gb, null, " (required)")), (d["ui:description"] || p.description) && /* @__PURE__ */ g.createElement(mb, { key: `array-field-description-${r.$id}` }, d["ui:description"] || p.description)), /* @__PURE__ */ g.createElement(wb, { key: `array-item-list-${r.$id}` }, o && o.map((c) => Eb(c)), i && /* @__PURE__ */ g.createElement(
    fn,
    {
      icon: "add",
      size: "mini",
      borderless: !0,
      onClick: l,
      disabled: a || s,
      customCSS: "align-self: end;"
    }
  )));
}, kb = v`
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-button-medium);
  font-family: var(--sq-font-family-sans);
  margin: 0 0 var(--sq-spacing-xx-large);
`, Sb = v`
  margin: var(--sq-spacing-small) 0;
  padding-left: var(--sq-spacing-medium);
  & > * {
    margin: var(--sq-spacing-small) 0 0 !important;
  }
`, Cb = v``, vu = E.ul`
  ${Sb}
`, gu = E.div`
  ${kb}
`, bu = E.li`
  ${Cb}
`, Ia = (e) => {
  const { errors: t } = e;
  return /* @__PURE__ */ g.createElement(gu, null, /* @__PURE__ */ g.createElement(_a, { type: "critical", title: "Error List" }, /* @__PURE__ */ g.createElement(vu, null, t.map((n) => /* @__PURE__ */ g.createElement(bu, { key: n.stack }, n.stack)))));
};
Ia.Container = gu;
Ia.List = vu;
Ia.Item = bu;
const qb = v`
  user-select: none;
  cursor: pointer;
  max-width: 255px;
`, _b = v`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 255px));
  gap: var(--sq-spacing-x-large);
`, Db = v`
  display: none;

  &:checked + div::after {
    transform: scale(1);
  }
`, Ob = E.label`
  ${qb}
  ${(e) => e.readonly && "pointer-events: none; cursor: pointer;"}

  ${(e) => e.customCSS}
`, Rb = E.input`
  ${Db}
  ${(e) => e.disabled && "border-color: unset;"}
`, Tb = E.div`
  ${_b}
`, Ab = qn("uicl-card-radio-button"), yu = m.forwardRef(
  (e, t) => {
    const {
      value: n,
      optionValue: r,
      title: o,
      description: i,
      icon: a = "",
      customCSS: s = {},
      disabled: l = !1,
      readonly: d = !1,
      ...p
    } = e, c = n === r;
    return /* @__PURE__ */ m.createElement(Ob, { htmlFor: p.id, customCSS: s, readonly: d }, /* @__PURE__ */ m.createElement(
      Rb,
      {
        ...p,
        type: "radio",
        checked: c,
        disabled: l,
        readOnly: !0,
        ref: t
      }
    ), /* @__PURE__ */ m.createElement(
      Ab,
      {
        isReadOnly: Be(d),
        isDisabled: Be(l),
        optionName: o,
        checked: Be(c),
        iconName: a ? "no-data" : ""
      },
      a ? /* @__PURE__ */ m.createElement(
        Le,
        {
          color: "var(--sq-text)",
          icon: a,
          size: "26px",
          slot: "icon",
          customCSS: "position: relative; top: -6px;"
        }
      ) : /* @__PURE__ */ m.createElement("span", { slot: "icon" }),
      i
    ));
  }
), xu = (e) => {
  const { children: t } = e;
  return /* @__PURE__ */ m.createElement(Tb, null, t);
}, wl = Object.assign(yu, {
  GroupView: xu
}), NC = Object.assign(yu, {
  Group: xu
});
function wu(e) {
  return typeof e == "object" && e !== null && e.hasOwnProperty("label") && e.hasOwnProperty("value");
}
function $b(e) {
  return typeof e == "object" && e !== null && (e.hasOwnProperty("value") || e.hasOwnProperty("key")) && e.hasOwnProperty("icon") && e.hasOwnProperty("title") && e.hasOwnProperty("description");
}
function so(e) {
  return Array.isArray(e);
}
function VC(e) {
  var r, o, i, a, s, l, d, p, c, b;
  if (!so((r = e == null ? void 0 : e.options) == null ? void 0 : r.enumOptions) || !so((o = e == null ? void 0 : e.options) == null ? void 0 : o.ruleOptions))
    return /* @__PURE__ */ g.createElement(g.Fragment, null);
  const t = (i = e == null ? void 0 : e.options) != null && i.reverse ? (s = (a = e == null ? void 0 : e.options) == null ? void 0 : a.enumOptions) == null ? void 0 : s.reverse() : (l = e == null ? void 0 : e.options) == null ? void 0 : l.enumOptions, n = (d = e == null ? void 0 : e.options) != null && d.reverse ? (c = (p = e == null ? void 0 : e.options) == null ? void 0 : p.ruleOptions) == null ? void 0 : c.reverse() : (b = e == null ? void 0 : e.options) == null ? void 0 : b.ruleOptions;
  return /* @__PURE__ */ g.createElement(wl.GroupView, { id: e.id }, t == null ? void 0 : t.map((k) => {
    if (!wu(k))
      return /* @__PURE__ */ g.createElement(g.Fragment, null);
    const q = n.filter(
      (C) => (C == null ? void 0 : C.value) === (k == null ? void 0 : k.value) || (C == null ? void 0 : C.key) === (k == null ? void 0 : k.value)
    )[0];
    return !q || !$b(q) ? /* @__PURE__ */ g.createElement(g.Fragment, null) : /* @__PURE__ */ g.createElement(
      wl,
      {
        required: e.required,
        readonly: e.readonly,
        disabled: e.disabled,
        id: e.id + k.value.toString(),
        name: e.id + k.value.toString(),
        key: k.value,
        title: q.title,
        description: q.description,
        icon: q.icon,
        optionValue: k.value,
        value: e.value,
        onClick: (C) => {
          C.preventDefault(), !e.readonly && e.onChange(k.value);
        }
      }
    );
  }));
}
const Ib = v`
  display: inline-block;
  width: 100%;
  position: relative;
  height: 100%;
`, Nb = E.div`
  ${Ib}
  ${(e) => `height: ${e.initialHeight};`}
  ${(e) => e.limitWidth ? typeof e.limitWidth == "string" ? `max-width: ${e.limitWidth};` : "max-width: 300px;" : "max-width: 100%;"}

  uicl-text-area {
    height: 100%;
  }

  uicl-text-area::part(base) {
    height: 100%;
  }

  uicl-text-area::part(input) {
    ${(e) => e.customCSS}
  }
`, Vb = qn("uicl-text-area"), Eu = g.forwardRef((e, t) => {
  const {
    errors: n,
    customCSS: r = {},
    limitWidth: o = !0,
    height: i = "180px",
    disabled: a = !1,
    readonly: s = !1,
    placeholder: l,
    value: d,
    onChange: p,
    ...c
  } = e;
  function b(k) {
    const q = k.composedPath()[0];
    q.nodeName === "TEXTAREA" && (Object.defineProperty(k, "target", {
      value: q
    }), p(k));
  }
  return /* @__PURE__ */ g.createElement(
    Nb,
    {
      customCSS: r,
      initialHeight: i,
      limitWidth: o
    },
    /* @__PURE__ */ g.createElement(
      Vb,
      {
        ...c,
        ref: t,
        isDisabled: Be(a),
        isReadOnly: Be(s || a || !1),
        placeholder: l,
        modelValue: d,
        onInput: b,
        validationFail: n ? "" : null
      }
    )
  );
}), zC = Eu;
function PC(e) {
  const t = e.options;
  return /* @__PURE__ */ g.createElement(
    Eu,
    {
      id: e.id,
      ...t,
      limitWidth: "426px",
      value: e.value,
      readonly: e.readonly,
      onChange: (n) => {
        e.readonly || e.onChange(n.target.value);
      },
      disabled: e.disabled,
      errors: e.rawErrors && !!e.rawErrors.length,
      required: e.required
    }
  );
}
function zb(e) {
  var l, d;
  const t = (l = e == null ? void 0 : e.options) == null ? void 0 : l.enumOptions, n = e == null ? void 0 : e.readonly, r = !!((d = e == null ? void 0 : e.options) != null && d.enumDisabled);
  if (!so(t))
    return null;
  const o = t.find((p) => p.value === e.value) || null, i = (p) => p != null && p.label ? p.label : "", s = Tn({
    items: t,
    itemToString: i,
    selectedItem: o,
    onSelectedItemChange: ({ selectedItem: p }) => {
      e.onChange((p == null ? void 0 : p.value) || "");
    }
  });
  return {
    disabled: r,
    readonly: n,
    items: t,
    functional: s,
    itemToString: i
  };
}
function FC(e) {
  const t = zb(e);
  if (t === null)
    return /* @__PURE__ */ g.createElement(g.Fragment, null);
  const n = { ...e.options, ...t };
  return /* @__PURE__ */ g.createElement(Vg, { id: e.id, ...n });
}
const Pb = v`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: var(--sq-spacing-large);
  user-select: none;
  cursor: pointer;
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, Fb = v`
  display: none;

  &:checked + div {
    border-color: var(--sq-action-primary);
  }

  &:checked + div::after {
    transform: scale(1);
  }
`, Lb = v`
  margin-top: 2px;
  width: 14px;
  height: 14px;
  border: 1px solid var(--sq-text);
  border-radius: 50%;
  margin-right: var(--sq-spacing-large);
  box-sizing: border-box;
  padding: 2px;
  flex-shrink: 0;

  &::after {
    content: "";
    width: 8px;
    height: 8px;
    display: block;
    background: var(--sq-action-primary);
    border-radius: 100%;
    transform: scale(0);
    transition: transform 0.15s;
  }
`, Mb = v`
  flex-direction: column;
`, Ub = v`
  display: grid;
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: var(--sq-spacing-small);
`, jb = E(Ra.div)`
  display: contents;
`, Bb = E.div`
  display: contents;
  ${(e) => e.twoColumns && Ub}
`, Wb = E.label`
  ${Pb}
  ${(e) => e.isChecked ? "background: var(--sq-background);" : ""}
`, Hb = E.input`
  ${Fb}
`, Yb = E.div`
  ${Lb}
`, Xb = E.div`
  ${Mb}
`, ku = m.forwardRef((e, t) => {
  const { value: n, optionValue: r, onChange: o, title: i, description: a, ...s } = e, l = n === r;
  return /* @__PURE__ */ m.createElement(Wb, { htmlFor: s.id, isChecked: l }, /* @__PURE__ */ m.createElement(
    Hb,
    {
      ...s,
      type: "radio",
      checked: l,
      readOnly: !0,
      ref: t
    }
  ), /* @__PURE__ */ m.createElement(Yb, null), /* @__PURE__ */ m.createElement(Xb, null, i ? /* @__PURE__ */ m.createElement("div", null, " ", i, " ") : "", a ? /* @__PURE__ */ m.createElement("div", { style: { color: "var(--sq-text-subdued)", marginTop: 4 } }, " ", a, " ") : ""));
}), Su = (e) => {
  const { twoColumns: t = !1, children: n } = e;
  return /* @__PURE__ */ m.createElement(jb, null, /* @__PURE__ */ m.createElement(Bb, { twoColumns: t }, n));
}, LC = ku, MC = Su;
function Jb(e) {
  return typeof e == "object" && e !== null && e.hasOwnProperty("value") && e.hasOwnProperty("title") && e.hasOwnProperty("description");
}
function UC(e) {
  var o, i, a;
  const t = (o = e == null ? void 0 : e.options) == null ? void 0 : o.enumOptions, n = (i = e == null ? void 0 : e.options) == null ? void 0 : i.ruleOptions, r = !!((a = e == null ? void 0 : e.uiSchema["ui:options"]) != null && a.twoColumns);
  return !so(t) || !so(n) ? /* @__PURE__ */ g.createElement(g.Fragment, null) : /* @__PURE__ */ g.createElement(Su, { id: e.id, twoColumns: r }, t == null ? void 0 : t.map((s) => {
    if (!wu(s))
      return /* @__PURE__ */ g.createElement(g.Fragment, null);
    const l = n.filter(
      (d) => d.value === (s == null ? void 0 : s.value)
    )[0];
    return !l || !Jb(l) ? /* @__PURE__ */ g.createElement(g.Fragment, null) : /* @__PURE__ */ g.createElement(
      ku,
      {
        required: e.required,
        id: e.id + l.value.toString(),
        name: e.id + l.value.toString(),
        key: l.value,
        title: l.title,
        description: l.description,
        optionValue: s.value,
        value: e.value,
        onClick: () => {
          e.onChange(s.value);
        }
      }
    );
  }));
}
const Kb = v`
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, Cu = E.li``, Gb = E.ul`
  ${Kb}
  ${(e) => e.customCSS}
`, qu = ({
  customCSS: e = {},
  children: t,
  type: n = "bullet"
}) => {
  const r = n == "bullet" ? "ul" : "ol";
  return /* @__PURE__ */ m.createElement(Gb, { customCSS: e, as: r }, t);
}, jC = Object.assign(qu, { ItemView: Cu }), BC = Object.assign(qu, { Item: Cu }), Zb = v`
  margin-top: var(--sq-spacing-xx-large);
`, Qb = v`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`, ey = v``, ty = v`
  font-size: var(--sq-font-size-caption);
  flex: 1;
  margin: 0;
`, ny = v`
  color: var(--sq-text-subdued);
  margin: var(--sq-spacing-xx-small) 0 0;
`, ry = v`
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
`, oy = v`
  & svg {
    cursor: pointer;
  }
`, iy = E.div`
  ${ey}
  ${(e) => e.customCSS}
`, ay = E.div`
  ${Qb}
`, sy = E.div`
  ${Zb}
`, ly = E.div`
  ${ry}

  ${(e) => e.expanded && "max-height: fit-content; min-height: fit-content; transition: max-height 1s ease-in-out;"}
`, cy = E.h2`
  ${ty}
`, uy = E.p`
  ${ny}
`, dy = E.div`
  ${oy}
`, py = m.forwardRef((e, t) => {
  const {
    heading: n,
    description: r = "",
    children: o,
    customCSS: i = {},
    ...a
  } = e, [s, l] = kn(!1);
  return /* @__PURE__ */ m.createElement(iy, { ...a, ref: t, customCSS: i }, /* @__PURE__ */ m.createElement(
    ay,
    {
      onClick: () => {
        l(!s);
      }
    },
    /* @__PURE__ */ m.createElement(cy, null, n),
    /* @__PURE__ */ m.createElement(dy, null, /* @__PURE__ */ m.createElement(
      Le,
      {
        size: "small",
        icon: s ? "minus" : "add",
        color: "var(--sq-text-subdued)"
      }
    ))
  ), /* @__PURE__ */ m.createElement(ly, { expanded: s }, /* @__PURE__ */ m.createElement(uy, null, r), /* @__PURE__ */ m.createElement(sy, null, o)));
}), WC = py, fy = v`
  box-sizing: border-box;
  padding: 12px 24px;
  overflow-wrap: break-word;
  word-wrap: break-word;

  &:not(:last-child) {
    border-bottom: 1px solid var(--sq-border);
  }
`, hy = v`
  padding: 0px;
  box-sizing: border-box;
  font-size: var(--sq-font-size-small);
  text-decoration: none;
  color: var(--sq-action-primary);
  overflow-wrap: break-word;
  word-wrap: break-word;
  max-width: 100%;
`, my = v`
  position: absolute;
  z-index: 999;
  background: var(--sq-surface);
  width: fit-content;
  box-sizing: border-box;
  border-radius: var(--sq-border-radius-normal);
  color: var(--sq-text);
  font-size: var(--sq-font-size-small);
  line-height: var(--sq-line-height-regular);
  font-family: var(--sq-font-family-sans);
  box-shadow: var(--iui-box-shadow-default);
`, _u = E.div`
  ${fy}
`, Du = ({ children: e }) => /* @__PURE__ */ m.createElement(_u, null, e), vy = E(Mr)`
  border: 1px solid black;
  background: purple;
  ${hy}
`, Ou = ({ children: e, ...t }) => /* @__PURE__ */ m.createElement(vy, { buttonType: "text", ...t }, e), El = E.div`
  display: ${({ show: e }) => e ? "block" : "none"};

  transform: translate(
    ${({ relativeX: e }) => e},
    ${({ relativeY: e }) => e}
  );

  ${my}
  ${(e) => e.maxWidth && `max-width: ${e.maxWidth};`}
  ${(e) => e.customCSS}
`, Ru = ({
  show: e = !0,
  relativeY: t = "0px",
  relativeX: n = "0px",
  children: r,
  padding: o = "8px 16px",
  maxWidth: i = "300px",
  customCSS: a = {}
}) => m.Children.count(r) > 1 ? /* @__PURE__ */ m.createElement(
  El,
  {
    show: e,
    relativeX: n,
    relativeY: t,
    customCSS: a,
    maxWidth: i
  },
  r
) : /* @__PURE__ */ m.createElement(
  El,
  {
    show: e,
    relativeX: n,
    relativeY: t,
    customCSS: a,
    maxWidth: i
  },
  /* @__PURE__ */ m.createElement(_u, { style: { padding: o } }, r)
), HC = Object.assign(Ru, {
  SectionView: Du,
  ActionView: Ou
}), YC = Object.assign(Ru, {
  Section: Du,
  Action: Ou
}), XC = ({
  handle: e,
  children: t
}) => {
  const [n, r] = kn(!1);
  return /* @__PURE__ */ g.createElement(
    "span",
    {
      onMouseOver: () => {
        r(!0);
      },
      onMouseLeave: () => {
        r(!1);
      },
      style: { position: "relative", display: "contents" }
    },
    e,
    n && t
  );
}, gy = E.div`
  display: contents;
`, by = g.forwardRef((e, t) => {
  const { copyContent: n, copyCallback: r, children: o, ...i } = e, a = () => {
    navigator.clipboard.writeText(n).then(
      function() {
        r(!0);
      },
      function() {
        r(!0);
      }
    );
  };
  return /* @__PURE__ */ g.createElement(gy, { onClick: a, ...i, ref: t }, o);
}), JC = by, KC = E.div`
  border: 1px solid var(--sq-border);
  border-radius: 10px;
  padding: var(--sq-spacing-large);
`, yy = v`
  width: 277px;
  background: var(--sq-surface);
  border: 1px solid var(--sq-border);
  box-sizing: border-box;
  border-radius: var(--sq-border-radius-normal);
  color: var(--sq-text);
  padding: var(--sq-spacing-medium) var(--sq-spacing-x-small);
`, xy = v`
display: flex;
height: 40px;
vertical-align: middle
flex-direction: column;
align-items: center;
padding: var(--sq-spacing-x-small);`, wy = v`
  float: left;
  margin-right: 16px;
`, Ey = v`
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-bold);
  font-size: var(--sq-font-size-header-three);
  line-height: var(--sq-line-height-header-three);
  float: left;
`, ky = v`
  height: 94px;
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  padding: var(--sq-spacing-x-small);
`, Sy = v`
  position: relative;
  bottom: 0px;
`, Cy = v`
  width: 450px;
  height: 211px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  background: var(--sq-surface);
  border: 1px solid var(--sq-border);
  box-sizing: border-box;
  border-radius: var(--sq-border-radius-normal);
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, qy = v`
  flex-direction: column;
  align-items: center;
  vertical-align: middle
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
  font-weight: var(--sq-font-weight-bold);
  font-size: var(--sq-font-size-header-three);
  line-height: var(--sq-line-height-header-three);
  padding: var(--sq-spacing-large);
  padding-bottom: 0;
`, _y = v`
  height: 61px;
  font-size: var(--sq-font-size-regular);
  padding: var(--sq-spacing-large);
`, Dy = v`
  position: relative;
  bottom: 0px;
  background: var(--sq-background);
  padding: var(--sq-spacing-large);
  margin-top: auto;
`, Oy = v`
  width: 850px;
  height: 74px;
  background: var(--sq-surface);
  border: 1px solid var(--sq-border);
  box-sizing: border-box;
  border-radius: var(--sq-border-radius-normal);
  color: var(--sq-text);
  padding: var(--sq-spacing-medium);
`, Ry = v`
  display: flex;	
  height: 40px;
  vertical-align: middle
  flex-direction: column;
  align-items: center;
`, Ty = v`
  float: left;
  margin-right: var(--sq-spacing-medium);
`, Ay = v`
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-bold);
  font-size: var(--sq-font-size-header-three);
  line-height: var(--sq-line-height-header-three);
  float: left;
`, $y = v`
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-bold);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, Iy = v`
  color: var(--sq-text-subdued);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, Ny = E.div`
  ${yy}
  ${(e) => e.customCSS}
`, Vy = E.div`
  ${xy}
`, zy = E.div`
  ${wy}
`, Py = E.div`
  ${Ey}
`, Fy = E.div`
  ${ky}
`, Ly = E.div`
  ${Sy}
`, My = m.forwardRef(
  (e, t) => {
    const { title: n, children: r, customCSS: o = {}, ...i } = e;
    return /* @__PURE__ */ m.createElement(Ny, { ...i, ref: t, customCSS: o }, /* @__PURE__ */ m.createElement(Vy, null, /* @__PURE__ */ m.createElement(zy, null, /* @__PURE__ */ m.createElement(
      Le,
      {
        icon: "calendar",
        size: "large",
        customCSS: "",
        color: "var(--sq-text-subdued)"
      }
    )), /* @__PURE__ */ m.createElement(Py, null, n)), /* @__PURE__ */ m.createElement(Fy, null, " ", r), /* @__PURE__ */ m.createElement(Ly, null, /* @__PURE__ */ m.createElement(
      Mr,
      {
        buttonType: "secondary",
        size: "small",
        pill: !0,
        customCSS: "width: 124px; margin-right: 8px;"
      },
      "Learn More"
    ), /* @__PURE__ */ m.createElement(
      Mr,
      {
        buttonType: "primary",
        size: "small",
        pill: !0,
        customCSS: "width: 124px;"
      },
      "Create"
    )));
  }
), GC = My, Uy = E.div`
  ${Cy}
  ${(e) => e.customCSS}
`, jy = E.div`
  ${qy}
`, By = E.div`
  ${_y}
`, Wy = E.div`
  ${Dy}
`, Hy = m.forwardRef((e, t) => {
  const { title: n, footer: r, children: o, customCSS: i = {}, ...a } = e;
  return /* @__PURE__ */ m.createElement(Uy, { ...a, ref: t, customCSS: i }, /* @__PURE__ */ m.createElement(jy, null, n), /* @__PURE__ */ m.createElement(By, null, o), /* @__PURE__ */ m.createElement(Wy, null, r));
}), ZC = Hy, Yy = E.div`
  ${Oy}
  ${(e) => e.customCSS}
`, Xy = E.div`
  ${Ry}
`, Jy = E.div`
  ${Ty}
`, Ky = E.div`
  ${Ay}
`, Gy = E.div`
  ${$y}
`, Zy = E.div`
  ${Iy}
`, Qy = m.forwardRef((e, t) => {
  const { title: n, edit: r = !1, children: o, customCSS: i = {}, ...a } = e, [s, l] = kn(!1);
  return /* @__PURE__ */ m.createElement(Yy, { ...a, ref: t, customCSS: i }, /* @__PURE__ */ m.createElement(Xy, null, /* @__PURE__ */ m.createElement(Jy, null, /* @__PURE__ */ m.createElement(
    Le,
    {
      icon: "calendar",
      size: "large",
      customCSS: "",
      color: "var(--sq-text-subdued)"
    }
  )), r && /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(
    In,
    {
      placeholder: "Edit Program Name",
      disabled: s,
      buttons: s == !0 ? /* @__PURE__ */ m.createElement(
        fn,
        {
          icon: "edit",
          size: "mini",
          customCSS: "position: relative; left: -30px;",
          primary: !0,
          onClick: () => {
            l(!1);
          }
        }
      ) : /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(
        Jn,
        {
          icon: "checkmark",
          size: "mini",
          primary: !0,
          customCSS: "margin-right: 4px;",
          onClick: () => {
            l(!0);
          }
        }
      ), /* @__PURE__ */ m.createElement(
        Jn,
        {
          icon: "close",
          size: "mini",
          icon_css: "color: #858585;",
          onClick: () => {
            l(!0);
          }
        }
      ))
    }
  )), !r && /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(Ky, null, /* @__PURE__ */ m.createElement(Gy, null, n, /* @__PURE__ */ m.createElement(
    Le,
    {
      size: "25px",
      icon: "edit",
      customCSS: "margin: -5px; margin-left: 0; :hover{color: #0275FB	;}"
    }
  ), /* @__PURE__ */ m.createElement(
    _c,
    {
      status: "success",
      customCSS: "display: inline; margin-left: 16px; font-size: 12px; padding: 1px 15px; "
    },
    "Live"
  )), /* @__PURE__ */ m.createElement(Zy, null, o))), /* @__PURE__ */ m.createElement(
    Mr,
    {
      buttonType: "secondary",
      pill: !0,
      customCSS: "margin-left: auto; float: right;"
    },
    "Edit"
  )));
}), QC = Qy, ex = v`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  width: 100%;
  background: var(--sq-action-secondary);
  border-radius: 100px;
  padding: var(--sq-spacing-xx-small);
`, tx = v`
  cursor: pointer;
`, nx = v`
  padding: 6px 32px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sq-text);
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-bold);

  &.active {
    background: var(--sq-surface);
    border-radius: 100px;
    transition: all 0.3s ease-in;
    box-shadow: 0px 2px 2px 0px #00000014;
  }

  &.disabled {
    color: var(--sq-text-subdued);
    cursor: default;
  }
`, Tu = m.createContext([
  void 0,
  void 0
]), Au = ({ id: e, disabled: t, children: n }) => {
  const [r, o] = rx();
  return /* @__PURE__ */ m.createElement(
    "div",
    {
      className: `tab${r == e ? " active" : ""} ${t ? "disabled" : ""}`,
      onClick: () => !t && o(e)
    },
    n
  );
};
function rx() {
  const e = m.useContext(Tu);
  if (!e)
    throw new Error("Tab must be within Tabs component");
  return e;
}
const ox = E.div`
  ${ex}
  & > .tab {
    ${tx}
    ${({ customStyle: e }) => e || nx}
  }
`, $u = ({
  selected: e,
  onTabClick: t,
  customTabStyle: n,
  children: r
}) => /* @__PURE__ */ m.createElement(Tu.Provider, { value: [e, t] }, /* @__PURE__ */ m.createElement(ox, { customStyle: n }, r)), eq = Object.assign($u, {
  TabView: Au
}), tq = Object.assign($u, {
  Tab: Au
});
v`
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--sq-spacing-x-large);
  box-sizing: border-box;
  height: 100vh;
`;
const ix = v`
  margin-top: 10px;
  height: 100%;
  box-sizing: border-box;
  border-radius: 0 0 8px 8px;
  gap: var(--sq-spacing-small);
  display: flex;
  align-items: center;
  justify-content: start;
`;
v`
  position: absolute;
  bottom: 0;
  width: calc(100%);
  box-sizing: border-box;
  background-color: white;
  padding: var(--sq-spacing-large) 0;
`;
const ax = v`
  max-height: 650px;
  overflow: hidden;
  overflow-y: overlay;
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
  }

  ::-webkit-scrollbar-thumb {
    background: var(--sq-border);
    border-radius: 50px;
  }

  ::-webkit-scrollbar-thumb:hover {
  }
  padding: var(--sq-spacing-large);
`, sx = v`
  max-width: fit-content;
  margin-top: 10px;
  margin-bottom: 10px;
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-regular);
`, lx = v`
  display: flex;
  align-items: center;
  padding: var(--sq-spacing-large);
  color: var(--sq-text);
  background: var(--sq-background);
  border: 1px solid var(--sq-border);
  box-sizing: border-box;
  border-radius: var(--sq-border-radius-normal);
  font-family: monospace;
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  line-height: var(--sq-line-height-regular);
`, cx = v``, ux = v`
  user-select: none;
  display: flex;
  padding: var(--sq-spacing-large);
  margin: calc(-1 * var(--sq-spacing-large));
  margin-bottom: var(--sq-spacing-large);
  align-items: center;
  text-indent: var(--sq-spacing-large);
  background: var(--sq-surface-modal-banner);
  color: var(--sq-surface);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-bold);
  font-size: var(--sq-font-size-header-three);
  line-height: var(--sq-line-height-regular);
`, dx = v`
  user-select: none;
  display: flex;
  height: 20px;
  align-items: center;
  background: var(--sq-surface-modal-banner);
  text-indent: 15px;
  font-family: Helvetica;
  font-style: normal;
  font-weight: normal;
  font-size: var(--sq-font-size-header-three);
  line-height: var(--sq-line-height-header-three);
  color: var(--sq-text-subdued);
  background: var(--sq-surface);
  border-bottom: 1px solid var(--sq-border);
  padding: var(--sq-spacing-large);
  margin: calc(-1 * var(--sq-spacing-large));
  margin-bottom: var(--sq-spacing-large);
`, Iu = E.div`
  ${ix}
  ${(e) => e.isConfirmation && "width: 100%; position: statis; box-shadow: none; justify-content: center; padding: 0 10px 0 0;"}
  ${(e) => !e.isConfirmation && `box-shadow: var(--iui-box-shadow-default);
    position: relative;
    left: -20px;
    width: calc(100% + var(--sq-spacing-large)); padding: 0 10px;`}
  ${(e) => e.customCSS}
`, px = m.forwardRef((e, t) => {
  const {
    primaryAction: n,
    secondaryAction: r,
    isConfirmation: o = !1,
    customCSS: i = {},
    ...a
  } = e, {
    onAction: s,
    text: l,
    danger: d,
    ...p
  } = n || {}, {
    onAction: c,
    text: b,
    danger: k,
    ...q
  } = r || {}, C = o ? "100%" : "auto";
  return /* @__PURE__ */ m.createElement(
    Iu,
    {
      ...a,
      isConfirmation: o,
      ref: t,
      customCSS: i,
      slot: "footer"
    },
    n && /* @__PURE__ */ m.createElement(
      Mr,
      {
        buttonType: "primary",
        onClick: s,
        critical: d,
        style: { width: C },
        customCSS: { width: C },
        ...p
      },
      l
    ),
    r && /* @__PURE__ */ m.createElement(
      Mr,
      {
        buttonType: "text",
        critical: k,
        onClick: c,
        style: { width: C },
        customCSS: { width: C },
        ...q
      },
      b
    )
  );
}), fx = E.div`
  ${ax}
  ${(e) => !e.isConfirmation && "rgba(0, 0, 0, 0.75) 0px -10px 10px -17px inset;"}
  ${(e) => e.maxHeight && `max-height: ${e.maxHeight};`}
  ${(e) => e.isConfirmation && "padding: 0 var(--sq-spacing-large);"}
  ${(e) => e.isConfirmation && "text-align: center;"}
    

  ${(e) => e.customCSS}
  ${(e) => e.stickyFooter && v`
      padding-bottom: 0;

      & ${Nu} {
        position: sticky;
        bottom: 0;
        background-color: var(--sq-surface);
      }
      & ${Iu} {
        padding-bottom: var(--sq-spacing-large);
        box-sizing: border-box;
      }
    `}
`, hx = m.forwardRef((e, t) => {
  const {
    children: n,
    customCSS: r = {},
    maxHeight: o = "",
    stickyFooter: i = !1,
    isConfirmation: a = !1,
    ...s
  } = e;
  return /* @__PURE__ */ m.createElement(
    fx,
    {
      ...s,
      ref: t,
      customCSS: r,
      stickyFooter: i,
      maxHeight: o,
      isConfirmation: a
    },
    n
  );
}), mx = E.div`
  ${sx}
  ${(e) => e.customCSS}
`, vx = m.forwardRef((e, t) => {
  const { children: n, customCSS: r = {}, ...o } = e;
  return /* @__PURE__ */ m.createElement(mx, { ...o, ref: t, customCSS: r }, n);
}), gx = E.div`
  ${lx}
  ${(e) => e.customCSS}
`, bx = m.forwardRef((e, t) => {
  const { children: n, customCSS: r = {}, ...o } = e;
  return /* @__PURE__ */ m.createElement(gx, { ...o, ref: t, customCSS: r }, n);
}), yx = E.div`
  ${cx}
  ${(e) => e.customCSS}
`, xx = m.forwardRef((e, t) => {
  const { customCSS: n = {}, ...r } = e;
  return /* @__PURE__ */ m.createElement(yx, { ...r, ref: t, customCSS: n });
}), wx = E.div`
  ${ux}
`, Ex = m.forwardRef((e, t) => {
  const { banner: n, customCSS: r = {}, ...o } = e;
  return /* @__PURE__ */ m.createElement(wx, { ...o, ref: t, customCSS: r }, n ? n.icon : "", n ? n.text : "");
}), kx = E.div`
  ${dx}
`, Sx = m.forwardRef((e, t) => {
  const { action: n, customCSS: r = {}, ...o } = e;
  return /* @__PURE__ */ m.createElement(
    kx,
    {
      onClick: n,
      ...o,
      ref: t,
      customCSS: r
    },
    n ? n.icon : "",
    n ? n.text : ""
  );
}), Nu = E.div`
  ${(e) => e.customCSS}
`, Cx = m.forwardRef((e, t) => {
  const { children: n, customCSS: r = {}, ...o } = e;
  return /* @__PURE__ */ m.createElement(
    Nu,
    {
      ...o,
      ref: t,
      slot: "footer",
      customCSS: r
    },
    n
  );
}), qx = E.div`
  display: contents;
  font-family: var(--sq-font-family-sans);
  ${(e) => e.zIndex ? `z-index: ${e.zIndex};` : "z-index: 1;"}
  uicl-modal-view::part(title) {
    line-height: 35px;
    ${(e) => e.isConfirmation && "font-size: var(--sq-font-size-header-four);"}
    ${(e) => e.isConfirmation && "font-weight: var(--sq-font-weight-semibold);"}
    ${(e) => e.customTitleCSS}
  }
  uicl-modal-view::part(modal-base) {
    ${(e) => e.maxWidth && `max-width: ${e.maxWidth};`}
    ${(e) => e.width && `width: ${e.width};`}
    ${(e) => e.customCSS}
  }

  // ZH: Might want to update this on UICL side eventually
  uicl-btn::part(base) {
    box-sizing: border-box;
  }
`, _x = qn("uicl-modal-view"), Dx = m.forwardRef(
  (e, t) => {
    const {
      title: n,
      subTitle: r,
      open: o = !1,
      onClose: i,
      zIndex: a,
      children: s,
      width: l,
      isConfirmation: d = !1,
      customCSS: p = {},
      customTitleCSS: c = {},
      maxWidth: b,
      ...k
    } = e, q = d ? "350px" : b || "650px", C = d ? "350px" : l || "650px";
    return /* @__PURE__ */ m.createElement(
      qx,
      {
        isConfirmation: d,
        customTitleCSS: c,
        customCSS: p,
        maxWidth: q,
        width: C,
        zIndex: a
      },
      o && /* @__PURE__ */ m.createElement(
        _x,
        {
          ...k,
          ref: t,
          show: o,
          title: n,
          subTitle: r,
          hasIframe: Be(!1),
          hasContentSlot: Be(!0),
          hasFooterSlot: Be(!0),
          close: () => i(),
          isConfirmation: Be(d)
        },
        s
      )
    );
  }
), nq = Object.assign(Dx, {
  ModalContentView: hx,
  ModalContentDividerView: xx,
  ModalContentActionView: px,
  ModalContentTextView: vx,
  ModalContentBannerView: Ex,
  ModalContentTopActionView: Sx,
  ModalContentCodeView: bx,
  ModalContentFooter: Cx
}), Ox = v`
  &[type="range"] {
    -webkit-appearance: none;
    background: transparent;
    width: 100%;
    border-color: transparent;
    border-width: 6px 0;
    height: 4px;
    color: transparent;
  }
  &[type="range"]::-webkit-slider-runnable-track {
    height: 10px;
    -webkit-appearance: none;
    margin-top: -1px;
  }
  &[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
  }
  &[type="range"]:focus {
    outline: none;
  }

  &[type="range"]::-ms-track {
    width: 100%;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  &[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: var(--sq-text);
    cursor: pointer;
    margin-top: -5px;
  }
  &[type="range"]::-moz-range-thumb {
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: var(--sq-text);
    cursor: pointer;
    margin-top: -5px;
  }
  &[type="range"]::-ms-thumb {
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: var(--sq-text);
    cursor: pointer;
    margin-top: -5px;
  }

  &[type="range"]::-webkit-slider-runnable-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: var(--sq-border);
    border-radius: 4px;
  }
  &[type="range"]::-moz-range-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: var(--sq-border);
    border-radius: 4px;
  }
  &[type="range"]::-ms-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: var(--sq-border);
    border-radius: 4px;
  }
`, Rx = E.input`
  ${Ox}
  ${(e) => e.customCSS}
`, rq = m.forwardRef((e, t) => {
  const {
    customCSS: n = {},
    limitWidth: r = !1,
    required: o = !1,
    ...i
  } = e;
  return /* @__PURE__ */ m.createElement(
    Rx,
    {
      ...i,
      ref: t,
      customCSS: n,
      type: "range"
    }
  );
}), Tx = v`
  width: 100%;
  border: 1px solid var(--sq-border);
  padding: var(--sq-spacing-xx-small) var(--sq-spacing-x-small);
  display: flex;
  flex-wrap: wrap;
  gap: var(--sq-spacing-xx-small);
  border-radius: var(--sq-border-radius-normal);
`, Ax = v`
  display: inline-block;
  padding: var(--sq-spacing-xxx-small);
  border: none;
  outline-width: 0;
  font-size: 14px;
  line-height: var(--sq-line-height-regular);
  flex: 1 1 100px;
  max-width: 100%;
`, $x = v`
  background: var(--sq-surface-subdued);
  border-radius: var(--sq-border-radius-normal);
  border: 1px solid var(--sq-border);
  display: grid;
  grid-template-columns: auto min-content;
  grid-gap: var(--sq-spacing-xx-small);
  align-items: center;
  padding: var(--sq-spacing-xxx-small) var(--sq-spacing-x-small);
  font-size: 14px;
  line-height: var(--sq-line-height-regular);
  margin: -1px 0px;

  & svg {
    cursor: pointer;
  }
`, Ix = v`
  &:hover {
    background: none;
    color: var(--sq-text-dark);
  }
`, Nx = E.div`
  ${Tx}

  ${(e) => e.limitWidth ? typeof e.limitWidth == "string" ? `max-width: ${e.limitWidth};` : "max-width: 300px;" : "max-width: 100%;"}

  ${(e) => e.customCSS}
`, Vx = E.span`
  ${Ax}
`, zx = E.div`
  ${$x}
`, Px = (e) => {
  const { children: t, readonly: n = !1 } = e;
  return /* @__PURE__ */ g.createElement(zx, { key: e.id }, t, /* @__PURE__ */ g.createElement(
    Jn,
    {
      size: "small",
      buttonType: "text",
      borderless: !0,
      icon: "close",
      style: { marginTop: "-4px" },
      onClick: () => {
        n || e.onDelete(e.id);
      },
      customCSS: Ix
    }
  ));
}, Fx = g.forwardRef((e, t) => {
  const {
    tagSlot: n,
    limitWidth: r = !0,
    readonly: o = !1,
    customCSS: i = {},
    ...a
  } = e;
  return /* @__PURE__ */ g.createElement(Nx, { limitWidth: r, customCSS: i }, n, /* @__PURE__ */ g.createElement(
    Vx,
    {
      ...a,
      ref: t,
      role: "textbox",
      contentEditable: !o
    }
  ));
}), oq = Object.assign(Fx, {
  TagView: Px
}), Lx = v`
  position: relative;
  width: min-content;
  cursor: pointer;
`, Mx = v`
  color: var(--sq-text);
  font-size: var(--sq-font-size-regular);
  width: max-content;
  display: flex;
  align-items: center;
  gap: var(--sq-spacing-x-small);
`, Ux = v`
  position: absolute;
  background-color: var(--sq-surface);
  border: 1px solid var(--sq-border);
  border-radius: var(--sq-border-radius-normal);
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.08);
  min-width: 80px;
  transform: translate(-16%,-45%);;
`, jx = v`
  font-size: var(--sq-font-size-regular);
  padding: var(--sq-spacing-x-small) var(--sq-spacing-small);
  box-sizing: border-box;
  cursor: pointer;
  min-width: 200px;
  width: 100%;
  max-width: 300px;
  display: flex;
  align-items: center;
  word-wrap: break-word;
  overflow: hidden;
  &:hover {
    background: #fafafa;
  }
`, Bx = E.div`
  ${Lx}
  ${(e) => e.customCSS}
`, Wx = E.div`
  ${Mx}
  ${(e) => e.customCSS}
`, Hx = E.div`
  ${Ux}
  ${(e) => e.customCSS}
  ${(e) => e.isOpen ? "display: block" : "display: none"}
`, Yx = E.div`
  ${jx}
  ${(e) => e.customCSS}
`, Xx = g.forwardRef((e, t) => {
  const { children: n, customCSS: r } = e;
  return /* @__PURE__ */ g.createElement(Bx, { ref: t, customCSS: r }, n);
}), Jx = g.forwardRef((e, t) => {
  const { currentValue: n, onClickHandle: r, customCSS: o } = e;
  return /* @__PURE__ */ g.createElement(
    Wx,
    {
      onClick: r,
      ref: t,
      customCSS: o
    },
    /* @__PURE__ */ g.createElement("span", null, n),
    /* @__PURE__ */ g.createElement(Le, { size: "small", icon: "arrow_dropdown", cursor: "pointer" })
  );
}), Kx = g.forwardRef((e, t) => {
  const { children: n, customCSS: r, isOpen: o } = e;
  return /* @__PURE__ */ g.createElement(Hx, { ref: t, customCSS: r, isOpen: o }, n);
}), Gx = g.forwardRef((e, t) => {
  const { onClickItem: n, children: r, isSelected: o, customCSS: i } = e;
  return /* @__PURE__ */ g.createElement(Yx, { onClick: n, ref: t, customCSS: i }, /* @__PURE__ */ g.createElement(
    Le,
    {
      style: { visibility: o ? "visible" : "hidden" },
      icon: "checkmark"
    }
  ), r);
}), iq = {
  MenuView: Kx,
  HandleView: Jx,
  ItemView: Gx,
  ContainerView: Xx
};
v`
  width: 100%;
  min-width: 110px;
`;
const Zx = v`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--sq-spacing-x-small);
  list-style-position: inside;
  padding: var(--sq-spacing-medium) 0;
  background: var(--sq-background-subdued);

  li {
    color: var(--sq-nav-text-on-primary-subdued);
  }
`, Qx = E.ol`
  ${Zx}
  ${(e) => e.customCSS}
`, aq = m.forwardRef((e, t) => {
  const { customCSS: n = {}, currentStep: r, steps: o, ...i } = e;
  return /* @__PURE__ */ m.createElement(Qx, { ...i, ref: t, customCSS: n }, o.map((a, s) => /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(
    "li",
    {
      style: {
        fontWeight: s === r ? "bold" : "normal",
        color: s === r ? "var(--sq-text)" : "var(--sq-nav-text-on-primary-subdued)"
      }
    },
    a
  ), s < o.length - 1 && /* @__PURE__ */ m.createElement(
    Le,
    {
      color: "var(--sq-nav-text-on-primary-subdued)",
      icon: "chevron_right"
    }
  ))));
}), e0 = v`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: var(--sq-spacing-small);
`, t0 = v`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(--sq-spacing-x-small);
  cursor: pointer;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: -moz-none;
  -o-user-select: none;
  user-select: none;
  width: max-content;
`, n0 = v`
  margin: 0;
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-regular);
  color: var(--sq-text);
`, r0 = E.div`
  ${e0}
  ${(e) => e.customCSS}
`, kl = E.div`
  transition: opacity 0.3s ease, display 0.3s ease;
  // opacity: ${(e) => e.open ? "1" : "0"};
  display: ${(e) => e.open ? "block" : "none"};
`, o0 = E.div`
  ${t0}
`, i0 = E.p`
  ${n0}
`, sq = m.forwardRef((e, t) => {
  const {
    customCSS: n = {},
    summary: r,
    iconSlot: o = /* @__PURE__ */ m.createElement(Le, { icon: "chevron_down", size: "small" }),
    iconPosition: i = "left",
    childrenPosition: a = "bottom",
    children: s,
    open: l,
    setOpen: d,
    ...p
  } = e, c = typeof r == "string" ? /* @__PURE__ */ m.createElement(i0, null, r) : r;
  return /* @__PURE__ */ m.createElement(r0, { ...p, open: l, ref: t, customCSS: n }, a === "top" && /* @__PURE__ */ m.createElement(kl, { open: l }, s), /* @__PURE__ */ m.createElement(o0, { onClick: d }, i === "left" ? /* @__PURE__ */ m.createElement(m.Fragment, null, o, c) : /* @__PURE__ */ m.createElement(m.Fragment, null, c, o)), a === "bottom" && /* @__PURE__ */ m.createElement(kl, { open: l }, s));
}), a0 = v`
  padding: var(--sq-spacing-x-small) var(--sq-spacing-small);
  color: var(--sq-text);
  position: relative;
  left: -1px;
  cursor: pointer;

  &:hover {
    background: var(--sq-surface-subdued);
  }
`, s0 = v`
  display: flex;
  flex-direction: column;
  position: relative;
  width: max-content;
  margin: auto;
  border-left: 1px solid var(--sq-border);
  max-width: 180px;
`, Vu = E.div`
  ${a0}
  ${(e) => e.customCSS}
`, l0 = E.div`
  ${s0}

  ${Vu}:nth-child( ${(e) => e.current}) {
    border-left: 2px solid var(--sq-action-primary);
  }
  ${(e) => e.customCSS}
`, c0 = g.forwardRef((e, t) => {
  const { currentSection: n, customCSS: r = {}, children: o, ...i } = e;
  return /* @__PURE__ */ g.createElement(
    l0,
    {
      ...i,
      current: n,
      customCSS: r,
      ref: t
    },
    o
  );
}), u0 = g.forwardRef((e, t) => {
  const { children: n, customCSS: r = {}, onClick: o, ...i } = e;
  return /* @__PURE__ */ g.createElement(
    Vu,
    {
      ...i,
      onClick: o,
      customCSS: r,
      ref: t
    },
    n
  );
}), lq = Object.assign(c0, {
  ItemView: u0
}), cq = ({
  items: e,
  itemToString: t = Kt.ItemToString
}) => {
  const n = Tn({ items: e, itemToString: t });
  return { items: e, functional: n, itemToString: t };
}, uq = ({
  selectItems: e,
  ...t
}) => {
  const [n, r] = kn("");
  function o(w) {
    return function(F) {
      return w.indexOf(F) < 0;
    };
  }
  const i = (w) => {
    var T;
    return ((T = t == null ? void 0 : t.itemMap) == null ? void 0 : T[w]) ?? w;
  }, a = t.itemToString || i, {
    getSelectedItemProps: s,
    getDropdownProps: l,
    addSelectedItem: d,
    removeSelectedItem: p,
    selectedItems: c
  } = gf({
    initialSelectedItems: [e[0], e[1]]
  }), b = t.useCombobox ? vf(
    () => e == null ? void 0 : e.filter((w) => {
      var L, me, O;
      const T = c.includes(w), F = ((O = (me = (L = t.itemMap) == null ? void 0 : L[w]) == null ? void 0 : me.toLowerCase()) == null ? void 0 : O.includes(n == null ? void 0 : n.toLowerCase())) || w.toLowerCase().includes(n.toLowerCase());
      return !T && F;
    }),
    [n, c, e]
  ) : e, k = e.filter(o(c));
  let q;
  t.useCombobox ? q = Ar({
    itemToString: a,
    selectedItem: null,
    items: b,
    inputValue: n,
    onInputValueChange: ({ inputValue: w }) => {
      r(w || "");
    },
    defaultHighlightedIndex: 0,
    // after selection, highlight the first item.
    //@ts-ignore
    stateReducer: (w, T) => {
      const { changes: F, type: L } = T;
      switch (L) {
        case Ar.stateChangeTypes.InputKeyDownEnter:
        case Ar.stateChangeTypes.ItemClick:
          return {
            ...F,
            isOpen: !0
            // keep the menu open after selection.
          };
      }
      return F;
    },
    onStateChange: ({ type: w, selectedItem: T }) => {
      switch (w) {
        case Ar.stateChangeTypes.InputKeyDownEnter:
        case Ar.stateChangeTypes.ItemClick:
          T && (d(T), r(""));
          break;
      }
    }
  }) : q = Tn({
    selectedItem: null,
    defaultHighlightedIndex: 0,
    // after selection, highlight the first item.
    items: k,
    stateReducer: (w, T) => {
      const { changes: F, type: L } = T;
      switch (L) {
        case Tn.stateChangeTypes.ToggleButtonKeyDownEnter:
        case Tn.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case Tn.stateChangeTypes.ItemClick:
          return {
            ...F,
            isOpen: !0
            // keep the menu open after selection.
          };
      }
      return F;
    },
    onStateChange: ({ type: w, selectedItem: T }) => {
      switch (w) {
        case Tn.stateChangeTypes.ToggleButtonKeyDownEnter:
        case Tn.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case Tn.stateChangeTypes.ItemClick:
          T && d(T);
          break;
      }
    }
  });
  const C = /* @__PURE__ */ g.createElement(g.Fragment, null, c.map(function(T, F) {
    return /* @__PURE__ */ g.createElement(
      Oc,
      {
        key: `selected-item-${F}`,
        ...s({
          selectedItem: T,
          index: F
        }),
        onClickClose: (L) => {
          L.stopPropagation(), p(T);
        }
      },
      T
    );
  }));
  return {
    getSelectedItemProps: s,
    getDropdownProps: l,
    addSelectedItem: d,
    removeSelectedItem: p,
    functional: q,
    items: t.useCombobox ? b : k,
    tagsSlot: C,
    empty: !k.length
  };
}, dq = ({
  items: e,
  itemToString: t = Kt.ItemToString
}) => {
  const [n, r] = kn(e), o = Ar({
    items: n,
    onInputValueChange: ({ inputValue: i = "" }) => {
      r(
        () => e.filter((a) => t(a).toLowerCase().startsWith(i == null ? void 0 : i.toLowerCase()))
      );
    },
    itemToString: t
  });
  return { items: n, functional: o, itemToString: t };
}, d0 = E(qn("uicl-form-section"))`
  display: block;
`, p0 = E.div`
  grid-column: 1 / span 2;
  color: var(--coal-black);
  text-align: center;
  cursor: pointer;
  padding-bottom: var(--form-gutter);
`, pq = (e) => {
  const {
    isAdvanced: t,
    isSubformSection: n,
    isAdvancedShown: r,
    isVisible: o = !0,
    isDisplayColumn: i,
    toggleAdvanced: a,
    isOptional: s,
    optionalLabel: l,
    heading: d,
    description: p,
    noGutter: c = !1,
    advancedSettingsLabel: b,
    // labelTooltip,
    children: k,
    className: q = ""
  } = e, C = `${d ? "" : "no-heading"} ${t ? "advanced" : ""} ${n ? "subFormSection" : ""} ${c ? "no-gutter" : ""} ${i ? "display-column" : ""} ${!i && d ? "side-heading" : ""} ${q || ""}`;
  return /* @__PURE__ */ g.createElement(
    d0,
    {
      isAdvanced: Be(!1),
      isAdvancedShown: Be(r),
      isSubformSection: Be(n),
      isVisible: Be(o),
      isDisplayColumn: Be(i),
      isOptional: Be(s),
      optionalLabel: l,
      heading: d,
      description: p,
      advancedSettingsLabel: b,
      className: C,
      style: { width: "100%" }
    },
    t && /* @__PURE__ */ g.createElement(p0, { onClick: () => a && a() }, /* @__PURE__ */ g.createElement(
      Le,
      {
        size: "badge",
        icon: r ? "arrow-up" : "arrow-down",
        iconSet: "impact"
      }
    ), " ", b),
    (!t || r) && k
  );
}, f0 = E(qn("uicl-field-label-pair"))`
  display: block;
  ${(e) => e.customContainerCSS}
`, fq = (e) => {
  const {
    mainLabel: t,
    isVisible: n = !0,
    isDisabled: r,
    isReadOnly: o,
    topFieldLabel: i,
    leftFieldLabel: a,
    rightFieldLabel: s,
    // labelTooltip,
    // fieldTooltip,
    isRequired: l,
    isParent: d,
    isChild: p,
    isChildDisplayBelow: c,
    customContainerCSS: b = {},
    errors: k = null,
    instructions: q,
    children: C,
    className: w = ""
  } = e, T = `${p ? "child " : ""}${d || c ? "parent " : ""}${k && k.length ? "error " : ""}${r ? "disabled" : ""} ${w || ""}`, F = t ? typeof t == "string" ? t : "enable-slot" : void 0, L = i ? typeof i == "string" ? i : "enable-slot" : void 0;
  return /* @__PURE__ */ g.createElement(
    f0,
    {
      errors: k,
      isVisible: Be(n),
      isDisabled: Be(r),
      isReadOnly: Be(o),
      isRequired: Be(l),
      isParent: Be(d),
      isChild: Be(p),
      isChildDisplayBelow: Be(c),
      leftFieldLabel: a,
      rightFieldLabel: s,
      topFieldLabel: L,
      mainLabel: F,
      className: T,
      customContainerCSS: b
    },
    i && /* @__PURE__ */ g.createElement("div", { slot: "topFieldLabel" }, i),
    q && /* @__PURE__ */ g.createElement("div", { slot: "instructions" }, q),
    t && /* @__PURE__ */ g.createElement("span", { slot: "mainLabel" }, t),
    C
  );
};
function Wr(e, t) {
  const n = /* @__PURE__ */ Object.create(null), r = e.split(",");
  for (let o = 0; o < r.length; o++)
    n[r[o]] = !0;
  return t ? (o) => !!n[o.toLowerCase()] : (o) => !!n[o];
}
const nt = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, Pr = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], Tt = () => {
}, zu = () => !1, h0 = /^on[^a-z]/, bo = (e) => h0.test(e), Ko = (e) => e.startsWith("onUpdate:"), pt = Object.assign, Na = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, m0 = Object.prototype.hasOwnProperty, Fe = (e, t) => m0.call(e, t), he = Array.isArray, ur = (e) => yo(e) === "[object Map]", Hr = (e) => yo(e) === "[object Set]", Sl = (e) => yo(e) === "[object Date]", Oe = (e) => typeof e == "function", gt = (e) => typeof e == "string", lo = (e) => typeof e == "symbol", Je = (e) => e !== null && typeof e == "object", Va = (e) => Je(e) && Oe(e.then) && Oe(e.catch), Pu = Object.prototype.toString, yo = (e) => Pu.call(e), za = (e) => yo(e).slice(8, -1), Fu = (e) => yo(e) === "[object Object]", Pa = (e) => gt(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Uo = /* @__PURE__ */ Wr(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), v0 = /* @__PURE__ */ Wr(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), ci = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, g0 = /-(\w)/g, en = ci((e) => e.replace(g0, (t, n) => n ? n.toUpperCase() : "")), b0 = /\B([A-Z])/g, Zt = ci(
  (e) => e.replace(b0, "-$1").toLowerCase()
), gr = ci(
  (e) => e.charAt(0).toUpperCase() + e.slice(1)
), ir = ci(
  (e) => e ? `on${gr(e)}` : ""
), co = (e, t) => !Object.is(e, t), $r = (e, t) => {
  for (let n = 0; n < e.length; n++)
    e[n](t);
}, Go = (e, t, n) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    value: n
  });
}, Zo = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, Cl = (e) => {
  const t = gt(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let ql;
const Qo = () => ql || (ql = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function En(e) {
  if (he(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const r = e[n], o = gt(r) ? E0(r) : En(r);
      if (o)
        for (const i in o)
          t[i] = o[i];
    }
    return t;
  } else if (gt(e) || Je(e))
    return e;
}
const y0 = /;(?![^(]*\))/g, x0 = /:([^]+)/, w0 = /\/\*[^]*?\*\//g;
function E0(e) {
  const t = {};
  return e.replace(w0, "").split(y0).forEach((n) => {
    if (n) {
      const r = n.split(x0);
      r.length > 1 && (t[r[0].trim()] = r[1].trim());
    }
  }), t;
}
function qt(e) {
  let t = "";
  if (gt(e))
    t = e;
  else if (he(e))
    for (let n = 0; n < e.length; n++) {
      const r = qt(e[n]);
      r && (t += r + " ");
    }
  else if (Je(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
function k0(e) {
  if (!e)
    return null;
  let { class: t, style: n } = e;
  return t && !gt(t) && (e.class = qt(t)), n && (e.style = En(n)), e;
}
const S0 = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", C0 = /* @__PURE__ */ Wr(S0);
function Lu(e) {
  return !!e || e === "";
}
function q0(e, t) {
  if (e.length !== t.length)
    return !1;
  let n = !0;
  for (let r = 0; n && r < e.length; r++)
    n = br(e[r], t[r]);
  return n;
}
function br(e, t) {
  if (e === t)
    return !0;
  let n = Sl(e), r = Sl(t);
  if (n || r)
    return n && r ? e.getTime() === t.getTime() : !1;
  if (n = lo(e), r = lo(t), n || r)
    return e === t;
  if (n = he(e), r = he(t), n || r)
    return n && r ? q0(e, t) : !1;
  if (n = Je(e), r = Je(t), n || r) {
    if (!n || !r)
      return !1;
    const o = Object.keys(e).length, i = Object.keys(t).length;
    if (o !== i)
      return !1;
    for (const a in e) {
      const s = e.hasOwnProperty(a), l = t.hasOwnProperty(a);
      if (s && !l || !s && l || !br(e[a], t[a]))
        return !1;
    }
  }
  return String(e) === String(t);
}
function Fa(e, t) {
  return e.findIndex((n) => br(n, t));
}
const tt = (e) => gt(e) ? e : e == null ? "" : he(e) || Je(e) && (e.toString === Pu || !Oe(e.toString)) ? JSON.stringify(e, Mu, 2) : String(e), Mu = (e, t) => t && t.__v_isRef ? Mu(e, t.value) : ur(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce((n, [r, o]) => (n[`${r} =>`] = o, n), {})
} : Hr(t) ? {
  [`Set(${t.size})`]: [...t.values()]
} : Je(t) && !he(t) && !Fu(t) ? String(t) : t;
function ia(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let cn;
class _0 {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this.parent = cn, !t && cn && (this.index = (cn.scopes || (cn.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  run(t) {
    if (this._active) {
      const n = cn;
      try {
        return cn = this, t();
      } finally {
        cn = n;
      }
    } else
      process.env.NODE_ENV !== "production" && ia("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    cn = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    cn = this.parent;
  }
  stop(t) {
    if (this._active) {
      let n, r;
      for (n = 0, r = this.effects.length; n < r; n++)
        this.effects[n].stop();
      for (n = 0, r = this.cleanups.length; n < r; n++)
        this.cleanups[n]();
      if (this.scopes)
        for (n = 0, r = this.scopes.length; n < r; n++)
          this.scopes[n].stop(!0);
      if (!this.detached && this.parent && !t) {
        const o = this.parent.scopes.pop();
        o && o !== this && (this.parent.scopes[this.index] = o, o.index = this.index);
      }
      this.parent = void 0, this._active = !1;
    }
  }
}
function D0(e, t = cn) {
  t && t.active && t.effects.push(e);
}
function O0() {
  return cn;
}
const uo = (e) => {
  const t = new Set(e);
  return t.w = 0, t.n = 0, t;
}, Uu = (e) => (e.w & Kn) > 0, ju = (e) => (e.n & Kn) > 0, R0 = ({ deps: e }) => {
  if (e.length)
    for (let t = 0; t < e.length; t++)
      e[t].w |= Kn;
}, T0 = (e) => {
  const { deps: t } = e;
  if (t.length) {
    let n = 0;
    for (let r = 0; r < t.length; r++) {
      const o = t[r];
      Uu(o) && !ju(o) ? o.delete(e) : t[n++] = o, o.w &= ~Kn, o.n &= ~Kn;
    }
    t.length = n;
  }
}, aa = /* @__PURE__ */ new WeakMap();
let Qr = 0, Kn = 1;
const sa = 30;
let Mt;
const dr = Symbol(process.env.NODE_ENV !== "production" ? "iterate" : ""), la = Symbol(process.env.NODE_ENV !== "production" ? "Map key iterate" : "");
class La {
  constructor(t, n = null, r) {
    this.fn = t, this.scheduler = n, this.active = !0, this.deps = [], this.parent = void 0, D0(this, r);
  }
  run() {
    if (!this.active)
      return this.fn();
    let t = Mt, n = Xn;
    for (; t; ) {
      if (t === this)
        return;
      t = t.parent;
    }
    try {
      return this.parent = Mt, Mt = this, Xn = !0, Kn = 1 << ++Qr, Qr <= sa ? R0(this) : _l(this), this.fn();
    } finally {
      Qr <= sa && T0(this), Kn = 1 << --Qr, Mt = this.parent, Xn = n, this.parent = void 0, this.deferStop && this.stop();
    }
  }
  stop() {
    Mt === this ? this.deferStop = !0 : this.active && (_l(this), this.onStop && this.onStop(), this.active = !1);
  }
}
function _l(e) {
  const { deps: t } = e;
  if (t.length) {
    for (let n = 0; n < t.length; n++)
      t[n].delete(e);
    t.length = 0;
  }
}
let Xn = !0;
const Bu = [];
function wr() {
  Bu.push(Xn), Xn = !1;
}
function Er() {
  const e = Bu.pop();
  Xn = e === void 0 ? !0 : e;
}
function At(e, t, n) {
  if (Xn && Mt) {
    let r = aa.get(e);
    r || aa.set(e, r = /* @__PURE__ */ new Map());
    let o = r.get(n);
    o || r.set(n, o = uo());
    const i = process.env.NODE_ENV !== "production" ? { effect: Mt, target: e, type: t, key: n } : void 0;
    ca(o, i);
  }
}
function ca(e, t) {
  let n = !1;
  Qr <= sa ? ju(e) || (e.n |= Kn, n = !Uu(e)) : n = !e.has(Mt), n && (e.add(Mt), Mt.deps.push(e), process.env.NODE_ENV !== "production" && Mt.onTrack && Mt.onTrack(
    pt(
      {
        effect: Mt
      },
      t
    )
  ));
}
function Sn(e, t, n, r, o, i) {
  const a = aa.get(e);
  if (!a)
    return;
  let s = [];
  if (t === "clear")
    s = [...a.values()];
  else if (n === "length" && he(e)) {
    const d = Number(r);
    a.forEach((p, c) => {
      (c === "length" || c >= d) && s.push(p);
    });
  } else
    switch (n !== void 0 && s.push(a.get(n)), t) {
      case "add":
        he(e) ? Pa(n) && s.push(a.get("length")) : (s.push(a.get(dr)), ur(e) && s.push(a.get(la)));
        break;
      case "delete":
        he(e) || (s.push(a.get(dr)), ur(e) && s.push(a.get(la)));
        break;
      case "set":
        ur(e) && s.push(a.get(dr));
        break;
    }
  const l = process.env.NODE_ENV !== "production" ? { target: e, type: t, key: n, newValue: r, oldValue: o, oldTarget: i } : void 0;
  if (s.length === 1)
    s[0] && (process.env.NODE_ENV !== "production" ? Vr(s[0], l) : Vr(s[0]));
  else {
    const d = [];
    for (const p of s)
      p && d.push(...p);
    process.env.NODE_ENV !== "production" ? Vr(uo(d), l) : Vr(uo(d));
  }
}
function Vr(e, t) {
  const n = he(e) ? e : [...e];
  for (const r of n)
    r.computed && Dl(r, t);
  for (const r of n)
    r.computed || Dl(r, t);
}
function Dl(e, t) {
  (e !== Mt || e.allowRecurse) && (process.env.NODE_ENV !== "production" && e.onTrigger && e.onTrigger(pt({ effect: e }, t)), e.scheduler ? e.scheduler() : e.run());
}
const A0 = /* @__PURE__ */ Wr("__proto__,__v_isRef,__isVue"), Wu = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(lo)
), $0 = /* @__PURE__ */ ui(), I0 = /* @__PURE__ */ ui(!1, !0), N0 = /* @__PURE__ */ ui(!0), V0 = /* @__PURE__ */ ui(!0, !0), Ol = /* @__PURE__ */ z0();
function z0() {
  const e = {};
  return ["includes", "indexOf", "lastIndexOf"].forEach((t) => {
    e[t] = function(...n) {
      const r = Ie(this);
      for (let i = 0, a = this.length; i < a; i++)
        At(r, "get", i + "");
      const o = r[t](...n);
      return o === -1 || o === !1 ? r[t](...n.map(Ie)) : o;
    };
  }), ["push", "pop", "shift", "unshift", "splice"].forEach((t) => {
    e[t] = function(...n) {
      wr();
      const r = Ie(this)[t].apply(this, n);
      return Er(), r;
    };
  }), e;
}
function P0(e) {
  const t = Ie(this);
  return At(t, "has", e), t.hasOwnProperty(e);
}
function ui(e = !1, t = !1) {
  return function(n, r, o) {
    if (r === "__v_isReactive")
      return !e;
    if (r === "__v_isReadonly")
      return e;
    if (r === "__v_isShallow")
      return t;
    if (r === "__v_raw" && o === (e ? t ? Qu : Zu : t ? Gu : Ku).get(n))
      return n;
    const i = he(n);
    if (!e) {
      if (i && Fe(Ol, r))
        return Reflect.get(Ol, r, o);
      if (r === "hasOwnProperty")
        return P0;
    }
    const a = Reflect.get(n, r, o);
    return (lo(r) ? Wu.has(r) : A0(r)) || (e || At(n, "get", r), t) ? a : Et(a) ? i && Pa(r) ? a : a.value : Je(a) ? e ? ed(a) : Ua(a) : a;
  };
}
const F0 = /* @__PURE__ */ Hu(), L0 = /* @__PURE__ */ Hu(!0);
function Hu(e = !1) {
  return function(t, n, r, o) {
    let i = t[n];
    if (Gn(i) && Et(i) && !Et(r))
      return !1;
    if (!e && (!ei(r) && !Gn(r) && (i = Ie(i), r = Ie(r)), !he(t) && Et(i) && !Et(r)))
      return i.value = r, !0;
    const a = he(t) && Pa(n) ? Number(n) < t.length : Fe(t, n), s = Reflect.set(t, n, r, o);
    return t === Ie(o) && (a ? co(r, i) && Sn(t, "set", n, r, i) : Sn(t, "add", n, r)), s;
  };
}
function M0(e, t) {
  const n = Fe(e, t), r = e[t], o = Reflect.deleteProperty(e, t);
  return o && n && Sn(e, "delete", t, void 0, r), o;
}
function U0(e, t) {
  const n = Reflect.has(e, t);
  return (!lo(t) || !Wu.has(t)) && At(e, "has", t), n;
}
function j0(e) {
  return At(e, "iterate", he(e) ? "length" : dr), Reflect.ownKeys(e);
}
const Yu = {
  get: $0,
  set: F0,
  deleteProperty: M0,
  has: U0,
  ownKeys: j0
}, Xu = {
  get: N0,
  set(e, t) {
    return process.env.NODE_ENV !== "production" && ia(
      `Set operation on key "${String(t)}" failed: target is readonly.`,
      e
    ), !0;
  },
  deleteProperty(e, t) {
    return process.env.NODE_ENV !== "production" && ia(
      `Delete operation on key "${String(t)}" failed: target is readonly.`,
      e
    ), !0;
  }
}, B0 = /* @__PURE__ */ pt(
  {},
  Yu,
  {
    get: I0,
    set: L0
  }
), W0 = /* @__PURE__ */ pt(
  {},
  Xu,
  {
    get: V0
  }
), Ma = (e) => e, di = (e) => Reflect.getPrototypeOf(e);
function $o(e, t, n = !1, r = !1) {
  e = e.__v_raw;
  const o = Ie(e), i = Ie(t);
  n || (t !== i && At(o, "get", t), At(o, "get", i));
  const { has: a } = di(o), s = r ? Ma : n ? ja : po;
  if (a.call(o, t))
    return s(e.get(t));
  if (a.call(o, i))
    return s(e.get(i));
  e !== o && e.get(t);
}
function Io(e, t = !1) {
  const n = this.__v_raw, r = Ie(n), o = Ie(e);
  return t || (e !== o && At(r, "has", e), At(r, "has", o)), e === o ? n.has(e) : n.has(e) || n.has(o);
}
function No(e, t = !1) {
  return e = e.__v_raw, !t && At(Ie(e), "iterate", dr), Reflect.get(e, "size", e);
}
function Rl(e) {
  e = Ie(e);
  const t = Ie(this);
  return di(t).has.call(t, e) || (t.add(e), Sn(t, "add", e, e)), this;
}
function Tl(e, t) {
  t = Ie(t);
  const n = Ie(this), { has: r, get: o } = di(n);
  let i = r.call(n, e);
  i ? process.env.NODE_ENV !== "production" && Ju(n, r, e) : (e = Ie(e), i = r.call(n, e));
  const a = o.call(n, e);
  return n.set(e, t), i ? co(t, a) && Sn(n, "set", e, t, a) : Sn(n, "add", e, t), this;
}
function Al(e) {
  const t = Ie(this), { has: n, get: r } = di(t);
  let o = n.call(t, e);
  o ? process.env.NODE_ENV !== "production" && Ju(t, n, e) : (e = Ie(e), o = n.call(t, e));
  const i = r ? r.call(t, e) : void 0, a = t.delete(e);
  return o && Sn(t, "delete", e, void 0, i), a;
}
function $l() {
  const e = Ie(this), t = e.size !== 0, n = process.env.NODE_ENV !== "production" ? ur(e) ? new Map(e) : new Set(e) : void 0, r = e.clear();
  return t && Sn(e, "clear", void 0, void 0, n), r;
}
function Vo(e, t) {
  return function(n, r) {
    const o = this, i = o.__v_raw, a = Ie(i), s = t ? Ma : e ? ja : po;
    return !e && At(a, "iterate", dr), i.forEach((l, d) => n.call(r, s(l), s(d), o));
  };
}
function zo(e, t, n) {
  return function(...r) {
    const o = this.__v_raw, i = Ie(o), a = ur(i), s = e === "entries" || e === Symbol.iterator && a, l = e === "keys" && a, d = o[e](...r), p = n ? Ma : t ? ja : po;
    return !t && At(
      i,
      "iterate",
      l ? la : dr
    ), {
      // iterator protocol
      next() {
        const { value: c, done: b } = d.next();
        return b ? { value: c, done: b } : {
          value: s ? [p(c[0]), p(c[1])] : p(c),
          done: b
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function jn(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const n = t[0] ? `on key "${t[0]}" ` : "";
      console.warn(
        `${gr(e)} operation ${n}failed: target is readonly.`,
        Ie(this)
      );
    }
    return e === "delete" ? !1 : this;
  };
}
function H0() {
  const e = {
    get(o) {
      return $o(this, o);
    },
    get size() {
      return No(this);
    },
    has: Io,
    add: Rl,
    set: Tl,
    delete: Al,
    clear: $l,
    forEach: Vo(!1, !1)
  }, t = {
    get(o) {
      return $o(this, o, !1, !0);
    },
    get size() {
      return No(this);
    },
    has: Io,
    add: Rl,
    set: Tl,
    delete: Al,
    clear: $l,
    forEach: Vo(!1, !0)
  }, n = {
    get(o) {
      return $o(this, o, !0);
    },
    get size() {
      return No(this, !0);
    },
    has(o) {
      return Io.call(this, o, !0);
    },
    add: jn("add"),
    set: jn("set"),
    delete: jn("delete"),
    clear: jn("clear"),
    forEach: Vo(!0, !1)
  }, r = {
    get(o) {
      return $o(this, o, !0, !0);
    },
    get size() {
      return No(this, !0);
    },
    has(o) {
      return Io.call(this, o, !0);
    },
    add: jn("add"),
    set: jn("set"),
    delete: jn("delete"),
    clear: jn("clear"),
    forEach: Vo(!0, !0)
  };
  return ["keys", "values", "entries", Symbol.iterator].forEach((o) => {
    e[o] = zo(
      o,
      !1,
      !1
    ), n[o] = zo(
      o,
      !0,
      !1
    ), t[o] = zo(
      o,
      !1,
      !0
    ), r[o] = zo(
      o,
      !0,
      !0
    );
  }), [
    e,
    n,
    t,
    r
  ];
}
const [
  Y0,
  X0,
  J0,
  K0
] = /* @__PURE__ */ H0();
function pi(e, t) {
  const n = t ? e ? K0 : J0 : e ? X0 : Y0;
  return (r, o, i) => o === "__v_isReactive" ? !e : o === "__v_isReadonly" ? e : o === "__v_raw" ? r : Reflect.get(
    Fe(n, o) && o in r ? n : r,
    o,
    i
  );
}
const G0 = {
  get: /* @__PURE__ */ pi(!1, !1)
}, Z0 = {
  get: /* @__PURE__ */ pi(!1, !0)
}, Q0 = {
  get: /* @__PURE__ */ pi(!0, !1)
}, ew = {
  get: /* @__PURE__ */ pi(!0, !0)
};
function Ju(e, t, n) {
  const r = Ie(n);
  if (r !== n && t.call(e, r)) {
    const o = za(e);
    console.warn(
      `Reactive ${o} contains both the raw and reactive versions of the same object${o === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const Ku = /* @__PURE__ */ new WeakMap(), Gu = /* @__PURE__ */ new WeakMap(), Zu = /* @__PURE__ */ new WeakMap(), Qu = /* @__PURE__ */ new WeakMap();
function tw(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function nw(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : tw(za(e));
}
function Ua(e) {
  return Gn(e) ? e : fi(
    e,
    !1,
    Yu,
    G0,
    Ku
  );
}
function rw(e) {
  return fi(
    e,
    !1,
    B0,
    Z0,
    Gu
  );
}
function ed(e) {
  return fi(
    e,
    !0,
    Xu,
    Q0,
    Zu
  );
}
function eo(e) {
  return fi(
    e,
    !0,
    W0,
    ew,
    Qu
  );
}
function fi(e, t, n, r, o) {
  if (!Je(e))
    return process.env.NODE_ENV !== "production" && console.warn(`value cannot be made reactive: ${String(e)}`), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const i = o.get(e);
  if (i)
    return i;
  const a = nw(e);
  if (a === 0)
    return e;
  const s = new Proxy(
    e,
    a === 2 ? r : n
  );
  return o.set(e, s), s;
}
function pr(e) {
  return Gn(e) ? pr(e.__v_raw) : !!(e && e.__v_isReactive);
}
function Gn(e) {
  return !!(e && e.__v_isReadonly);
}
function ei(e) {
  return !!(e && e.__v_isShallow);
}
function ua(e) {
  return pr(e) || Gn(e);
}
function Ie(e) {
  const t = e && e.__v_raw;
  return t ? Ie(t) : e;
}
function td(e) {
  return Go(e, "__v_skip", !0), e;
}
const po = (e) => Je(e) ? Ua(e) : e, ja = (e) => Je(e) ? ed(e) : e;
function nd(e) {
  Xn && Mt && (e = Ie(e), process.env.NODE_ENV !== "production" ? ca(e.dep || (e.dep = uo()), {
    target: e,
    type: "get",
    key: "value"
  }) : ca(e.dep || (e.dep = uo())));
}
function rd(e, t) {
  e = Ie(e);
  const n = e.dep;
  n && (process.env.NODE_ENV !== "production" ? Vr(n, {
    target: e,
    type: "set",
    key: "value",
    newValue: t
  }) : Vr(n));
}
function Et(e) {
  return !!(e && e.__v_isRef === !0);
}
function Xe(e) {
  return ow(e, !1);
}
function ow(e, t) {
  return Et(e) ? e : new iw(e, t);
}
class iw {
  constructor(t, n) {
    this.__v_isShallow = n, this.dep = void 0, this.__v_isRef = !0, this._rawValue = n ? t : Ie(t), this._value = n ? t : po(t);
  }
  get value() {
    return nd(this), this._value;
  }
  set value(t) {
    const n = this.__v_isShallow || ei(t) || Gn(t);
    t = n ? t : Ie(t), co(t, this._rawValue) && (this._rawValue = t, this._value = n ? t : po(t), rd(this, t));
  }
}
function fo(e) {
  return Et(e) ? e.value : e;
}
const aw = {
  get: (e, t, n) => fo(Reflect.get(e, t, n)),
  set: (e, t, n, r) => {
    const o = e[t];
    return Et(o) && !Et(n) ? (o.value = n, !0) : Reflect.set(e, t, n, r);
  }
};
function od(e) {
  return pr(e) ? e : new Proxy(e, aw);
}
class sw {
  constructor(t, n, r, o) {
    this._setter = n, this.dep = void 0, this.__v_isRef = !0, this.__v_isReadonly = !1, this._dirty = !0, this.effect = new La(t, () => {
      this._dirty || (this._dirty = !0, rd(this));
    }), this.effect.computed = this, this.effect.active = this._cacheable = !o, this.__v_isReadonly = r;
  }
  get value() {
    const t = Ie(this);
    return nd(t), (t._dirty || !t._cacheable) && (t._dirty = !1, t._value = t.effect.run()), t._value;
  }
  set value(t) {
    this._setter(t);
  }
}
function lw(e, t, n = !1) {
  let r, o;
  const i = Oe(e);
  i ? (r = e, o = process.env.NODE_ENV !== "production" ? () => {
    console.warn("Write operation failed: computed value is readonly");
  } : Tt) : (r = e.get, o = e.set);
  const a = new sw(r, o, i || !o, n);
  return process.env.NODE_ENV !== "production" && t && !n && (a.effect.onTrack = t.onTrack, a.effect.onTrigger = t.onTrigger), a;
}
const fr = [];
function jo(e) {
  fr.push(e);
}
function Bo() {
  fr.pop();
}
function H(e, ...t) {
  if (process.env.NODE_ENV === "production")
    return;
  wr();
  const n = fr.length ? fr[fr.length - 1].component : null, r = n && n.appContext.config.warnHandler, o = cw();
  if (r)
    $n(
      r,
      n,
      11,
      [
        e + t.join(""),
        n && n.proxy,
        o.map(
          ({ vnode: i }) => `at <${xi(n, i.type)}>`
        ).join(`
`),
        o
      ]
    );
  else {
    const i = [`[Vue warn]: ${e}`, ...t];
    o.length && i.push(`
`, ...uw(o)), console.warn(...i);
  }
  Er();
}
function cw() {
  let e = fr[fr.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const r = e.component && e.component.parent;
    e = r && r.vnode;
  }
  return t;
}
function uw(e) {
  const t = [];
  return e.forEach((n, r) => {
    t.push(...r === 0 ? [] : [`
`], ...dw(n));
  }), t;
}
function dw({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, o = ` at <${xi(
    e.component,
    e.type,
    r
  )}`, i = ">" + n;
  return e.props ? [o, ...pw(e.props), i] : [o + i];
}
function pw(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((r) => {
    t.push(...id(r, e[r]));
  }), n.length > 3 && t.push(" ..."), t;
}
function id(e, t, n) {
  return gt(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : Et(t) ? (t = id(e, Ie(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : Oe(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = Ie(t), n ? t : [`${e}=`, t]);
}
const Ba = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $n(e, t, n, r) {
  let o;
  try {
    o = r ? e(...r) : e();
  } catch (i) {
    hi(i, t, n);
  }
  return o;
}
function hn(e, t, n, r) {
  if (Oe(e)) {
    const i = $n(e, t, n, r);
    return i && Va(i) && i.catch((a) => {
      hi(a, t, n);
    }), i;
  }
  const o = [];
  for (let i = 0; i < e.length; i++)
    o.push(hn(e[i], t, n, r));
  return o;
}
function hi(e, t, n, r = !0) {
  const o = t ? t.vnode : null;
  if (t) {
    let i = t.parent;
    const a = t.proxy, s = process.env.NODE_ENV !== "production" ? Ba[n] : n;
    for (; i; ) {
      const d = i.ec;
      if (d) {
        for (let p = 0; p < d.length; p++)
          if (d[p](e, a, s) === !1)
            return;
      }
      i = i.parent;
    }
    const l = t.appContext.config.errorHandler;
    if (l) {
      $n(
        l,
        null,
        10,
        [e, a, s]
      );
      return;
    }
  }
  fw(e, n, o, r);
}
function fw(e, t, n, r = !0) {
  if (process.env.NODE_ENV !== "production") {
    const o = Ba[t];
    if (n && jo(n), H(`Unhandled error${o ? ` during execution of ${o}` : ""}`), n && Bo(), r)
      throw e;
    console.error(e);
  } else
    console.error(e);
}
let ho = !1, da = !1;
const $t = [];
let xn = 0;
const Fr = [];
let yn = null, Wn = 0;
const ad = /* @__PURE__ */ Promise.resolve();
let Wa = null;
const hw = 100;
function Ha(e) {
  const t = Wa || ad;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function mw(e) {
  let t = xn + 1, n = $t.length;
  for (; t < n; ) {
    const r = t + n >>> 1;
    mo($t[r]) < e ? t = r + 1 : n = r;
  }
  return t;
}
function mi(e) {
  (!$t.length || !$t.includes(
    e,
    ho && e.allowRecurse ? xn + 1 : xn
  )) && (e.id == null ? $t.push(e) : $t.splice(mw(e.id), 0, e), sd());
}
function sd() {
  !ho && !da && (da = !0, Wa = ad.then(ud));
}
function vw(e) {
  const t = $t.indexOf(e);
  t > xn && $t.splice(t, 1);
}
function ld(e) {
  he(e) ? Fr.push(...e) : (!yn || !yn.includes(
    e,
    e.allowRecurse ? Wn + 1 : Wn
  )) && Fr.push(e), sd();
}
function Il(e, t = ho ? xn + 1 : 0) {
  for (process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()); t < $t.length; t++) {
    const n = $t[t];
    if (n && n.pre) {
      if (process.env.NODE_ENV !== "production" && Ya(e, n))
        continue;
      $t.splice(t, 1), t--, n();
    }
  }
}
function cd(e) {
  if (Fr.length) {
    const t = [...new Set(Fr)];
    if (Fr.length = 0, yn) {
      yn.push(...t);
      return;
    }
    for (yn = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), yn.sort((n, r) => mo(n) - mo(r)), Wn = 0; Wn < yn.length; Wn++)
      process.env.NODE_ENV !== "production" && Ya(e, yn[Wn]) || yn[Wn]();
    yn = null, Wn = 0;
  }
}
const mo = (e) => e.id == null ? 1 / 0 : e.id, gw = (e, t) => {
  const n = mo(e) - mo(t);
  if (n === 0) {
    if (e.pre && !t.pre)
      return -1;
    if (t.pre && !e.pre)
      return 1;
  }
  return n;
};
function ud(e) {
  da = !1, ho = !0, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), $t.sort(gw);
  const t = process.env.NODE_ENV !== "production" ? (n) => Ya(e, n) : Tt;
  try {
    for (xn = 0; xn < $t.length; xn++) {
      const n = $t[xn];
      if (n && n.active !== !1) {
        if (process.env.NODE_ENV !== "production" && t(n))
          continue;
        $n(n, null, 14);
      }
    }
  } finally {
    xn = 0, $t.length = 0, cd(e), ho = !1, Wa = null, ($t.length || Fr.length) && ud(e);
  }
}
function Ya(e, t) {
  if (!e.has(t))
    e.set(t, 1);
  else {
    const n = e.get(t);
    if (n > hw) {
      const r = t.ownerInstance, o = r && os(r.type);
      return H(
        `Maximum recursive updates exceeded${o ? ` in component <${o}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`
      ), !0;
    } else
      e.set(t, n + 1);
  }
}
let hr = !1;
const Ir = /* @__PURE__ */ new Set();
process.env.NODE_ENV !== "production" && (Qo().__VUE_HMR_RUNTIME__ = {
  createRecord: Bi(dd),
  rerender: Bi(xw),
  reload: Bi(ww)
});
const yr = /* @__PURE__ */ new Map();
function bw(e) {
  const t = e.type.__hmrId;
  let n = yr.get(t);
  n || (dd(t, e.type), n = yr.get(t)), n.instances.add(e);
}
function yw(e) {
  yr.get(e.type.__hmrId).instances.delete(e);
}
function dd(e, t) {
  return yr.has(e) ? !1 : (yr.set(e, {
    initialDef: oo(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function oo(e) {
  return Fd(e) ? e.__vccOpts : e;
}
function xw(e, t) {
  const n = yr.get(e);
  n && (n.initialDef.render = t, [...n.instances].forEach((r) => {
    t && (r.render = t, oo(r.type).render = t), r.renderCache = [], hr = !0, r.update(), hr = !1;
  }));
}
function ww(e, t) {
  const n = yr.get(e);
  if (!n)
    return;
  t = oo(t), Nl(n.initialDef, t);
  const r = [...n.instances];
  for (const o of r) {
    const i = oo(o.type);
    Ir.has(i) || (i !== n.initialDef && Nl(i, t), Ir.add(i)), o.appContext.propsCache.delete(o.type), o.appContext.emitsCache.delete(o.type), o.appContext.optionsCache.delete(o.type), o.ceReload ? (Ir.add(i), o.ceReload(t.styles), Ir.delete(i)) : o.parent ? mi(o.parent.update) : o.appContext.reload ? o.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    );
  }
  ld(() => {
    for (const o of r)
      Ir.delete(
        oo(o.type)
      );
  });
}
function Nl(e, t) {
  pt(e, t);
  for (const n in e)
    n !== "__file" && !(n in t) && delete e[n];
}
function Bi(e) {
  return (t, n) => {
    try {
      return e(t, n);
    } catch (r) {
      console.error(r), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let wn, to = [], pa = !1;
function xo(e, ...t) {
  wn ? wn.emit(e, ...t) : pa || to.push({ event: e, args: t });
}
function pd(e, t) {
  var n, r;
  wn = e, wn ? (wn.enabled = !0, to.forEach(({ event: o, args: i }) => wn.emit(o, ...i)), to = []) : (
    /* handle late devtools injection - only do this if we are in an actual */
    /* browser environment to avoid the timer handle stalling test runner exit */
    /* (#4815) */
    typeof window < "u" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((r = (n = window.navigator) == null ? void 0 : n.userAgent) != null && r.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((o) => {
      pd(o, t);
    }), setTimeout(() => {
      wn || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, pa = !0, to = []);
    }, 3e3)) : (pa = !0, to = [])
  );
}
function Ew(e, t) {
  xo("app:init", e, t, {
    Fragment: Gt,
    Text: wo,
    Comment: Xt,
    Static: Ho
  });
}
function kw(e) {
  xo("app:unmount", e);
}
const Sw = /* @__PURE__ */ Xa(
  "component:added"
  /* COMPONENT_ADDED */
), fd = /* @__PURE__ */ Xa(
  "component:updated"
  /* COMPONENT_UPDATED */
), Cw = /* @__PURE__ */ Xa(
  "component:removed"
  /* COMPONENT_REMOVED */
), qw = (e) => {
  wn && typeof wn.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !wn.cleanupBuffer(e) && Cw(e);
};
function Xa(e) {
  return (t) => {
    xo(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const _w = /* @__PURE__ */ hd(
  "perf:start"
  /* PERFORMANCE_START */
), Dw = /* @__PURE__ */ hd(
  "perf:end"
  /* PERFORMANCE_END */
);
function hd(e) {
  return (t, n, r) => {
    xo(e, t.appContext.app, t.uid, t, n, r);
  };
}
function Ow(e, t, n) {
  xo(
    "component:emit",
    e.appContext.app,
    e,
    t,
    n
  );
}
function Rw(e, t, ...n) {
  if (e.isUnmounted)
    return;
  const r = e.vnode.props || nt;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: p,
      propsOptions: [c]
    } = e;
    if (p)
      if (!(t in p))
        (!c || !(ir(t) in c)) && H(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${ir(t)}" prop.`
        );
      else {
        const b = p[t];
        Oe(b) && (b(...n) || H(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let o = n;
  const i = t.startsWith("update:"), a = i && t.slice(7);
  if (a && a in r) {
    const p = `${a === "modelValue" ? "model" : a}Modifiers`, { number: c, trim: b } = r[p] || nt;
    b && (o = n.map((k) => gt(k) ? k.trim() : k)), c && (o = n.map(Zo));
  }
  if (process.env.NODE_ENV !== "production" && Ow(e, t, o), process.env.NODE_ENV !== "production") {
    const p = t.toLowerCase();
    p !== t && r[ir(p)] && H(
      `Event "${p}" is emitted in component ${xi(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${Zt(t)}" instead of "${t}".`
    );
  }
  let s, l = r[s = ir(t)] || // also try camelCase event handler (#2249)
  r[s = ir(en(t))];
  !l && i && (l = r[s = ir(Zt(t))]), l && hn(
    l,
    e,
    6,
    o
  );
  const d = r[s + "Once"];
  if (d) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[s])
      return;
    e.emitted[s] = !0, hn(
      d,
      e,
      6,
      o
    );
  }
}
function md(e, t, n = !1) {
  const r = t.emitsCache, o = r.get(e);
  if (o !== void 0)
    return o;
  const i = e.emits;
  let a = {}, s = !1;
  if (!Oe(e)) {
    const l = (d) => {
      const p = md(d, t, !0);
      p && (s = !0, pt(a, p));
    };
    !n && t.mixins.length && t.mixins.forEach(l), e.extends && l(e.extends), e.mixins && e.mixins.forEach(l);
  }
  return !i && !s ? (Je(e) && r.set(e, null), null) : (he(i) ? i.forEach((l) => a[l] = null) : pt(a, i), Je(e) && r.set(e, a), a);
}
function vi(e, t) {
  return !e || !bo(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), Fe(e, t[0].toLowerCase() + t.slice(1)) || Fe(e, Zt(t)) || Fe(e, t));
}
let Ct = null, vd = null;
function ti(e) {
  const t = Ct;
  return Ct = e, vd = e && e.type.__scopeId || null, t;
}
function Qt(e, t = Ct, n) {
  if (!t || e._n)
    return e;
  const r = (...o) => {
    r._d && Xl(-1);
    const i = ti(t);
    let a;
    try {
      a = e(...o);
    } finally {
      ti(i), r._d && Xl(1);
    }
    return process.env.NODE_ENV !== "production" && fd(t), a;
  };
  return r._n = !0, r._c = !0, r._d = !0, r;
}
let fa = !1;
function ni() {
  fa = !0;
}
function Wi(e) {
  const {
    type: t,
    vnode: n,
    proxy: r,
    withProxy: o,
    props: i,
    propsOptions: [a],
    slots: s,
    attrs: l,
    emit: d,
    render: p,
    renderCache: c,
    data: b,
    setupState: k,
    ctx: q,
    inheritAttrs: C
  } = e;
  let w, T;
  const F = ti(e);
  process.env.NODE_ENV !== "production" && (fa = !1);
  try {
    if (n.shapeFlag & 4) {
      const O = o || r;
      w = dn(
        p.call(
          O,
          O,
          c,
          i,
          k,
          b,
          q
        )
      ), T = l;
    } else {
      const O = t;
      process.env.NODE_ENV !== "production" && l === i && ni(), w = dn(
        O.length > 1 ? O(
          i,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return ni(), l;
            },
            slots: s,
            emit: d
          } : { attrs: l, slots: s, emit: d }
        ) : O(
          i,
          null
          /* we know it doesn't need it */
        )
      ), T = t.props ? l : Aw(l);
    }
  } catch (O) {
    ao.length = 0, hi(O, e, 1), w = vt(Xt);
  }
  let L = w, me;
  if (process.env.NODE_ENV !== "production" && w.patchFlag > 0 && w.patchFlag & 2048 && ([L, me] = Tw(w)), T && C !== !1) {
    const O = Object.keys(T), { shapeFlag: Pe } = L;
    if (O.length) {
      if (Pe & 7)
        a && O.some(Ko) && (T = $w(
          T,
          a
        )), L = Qn(L, T);
      else if (process.env.NODE_ENV !== "production" && !fa && L.type !== Xt) {
        const qe = Object.keys(l), it = [], Ne = [];
        for (let Ke = 0, at = qe.length; Ke < at; Ke++) {
          const rt = qe[Ke];
          bo(rt) ? Ko(rt) || it.push(rt[2].toLowerCase() + rt.slice(3)) : Ne.push(rt);
        }
        Ne.length && H(
          `Extraneous non-props attributes (${Ne.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`
        ), it.length && H(
          `Extraneous non-emits event listeners (${it.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return n.dirs && (process.env.NODE_ENV !== "production" && !Vl(L) && H(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), L = Qn(L), L.dirs = L.dirs ? L.dirs.concat(n.dirs) : n.dirs), n.transition && (process.env.NODE_ENV !== "production" && !Vl(L) && H(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), L.transition = n.transition), process.env.NODE_ENV !== "production" && me ? me(L) : w = L, ti(F), w;
}
const Tw = (e) => {
  const t = e.children, n = e.dynamicChildren, r = gd(t);
  if (!r)
    return [e, void 0];
  const o = t.indexOf(r), i = n ? n.indexOf(r) : -1, a = (s) => {
    t[o] = s, n && (i > -1 ? n[i] = s : s.patchFlag > 0 && (e.dynamicChildren = [...n, s]));
  };
  return [dn(r), a];
};
function gd(e) {
  let t;
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    if (Ur(r)) {
      if (r.type !== Xt || r.children === "v-if") {
        if (t)
          return;
        t = r;
      }
    } else
      return;
  }
  return t;
}
const Aw = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || bo(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, $w = (e, t) => {
  const n = {};
  for (const r in e)
    (!Ko(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
  return n;
}, Vl = (e) => e.shapeFlag & 7 || e.type === Xt;
function Iw(e, t, n) {
  const { props: r, children: o, component: i } = e, { props: a, children: s, patchFlag: l } = t, d = i.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (o || s) && hr || t.dirs || t.transition)
    return !0;
  if (n && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return r ? zl(r, a, d) : !!a;
    if (l & 8) {
      const p = t.dynamicProps;
      for (let c = 0; c < p.length; c++) {
        const b = p[c];
        if (a[b] !== r[b] && !vi(d, b))
          return !0;
      }
    }
  } else
    return (o || s) && (!s || !s.$stable) ? !0 : r === a ? !1 : r ? a ? zl(r, a, d) : !0 : !!a;
  return !1;
}
function zl(e, t, n) {
  const r = Object.keys(t);
  if (r.length !== Object.keys(e).length)
    return !0;
  for (let o = 0; o < r.length; o++) {
    const i = r[o];
    if (t[i] !== e[i] && !vi(n, i))
      return !0;
  }
  return !1;
}
function Nw({ vnode: e, parent: t }, n) {
  for (; t && t.subTree === e; )
    (e = t.vnode).el = n, t = t.parent;
}
const Vw = (e) => e.__isSuspense;
function zw(e, t) {
  t && t.pendingBranch ? he(e) ? t.effects.push(...e) : t.effects.push(e) : ld(e);
}
const Po = {};
function ht(e, t, n) {
  return process.env.NODE_ENV !== "production" && !Oe(t) && H(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), bd(e, t, n);
}
function bd(e, t, { immediate: n, deep: r, flush: o, onTrack: i, onTrigger: a } = nt) {
  var s;
  process.env.NODE_ENV !== "production" && !t && (n !== void 0 && H(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), r !== void 0 && H(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const l = (O) => {
    H(
      "Invalid watch source: ",
      O,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, d = O0() === ((s = St) == null ? void 0 : s.scope) ? St : null;
  let p, c = !1, b = !1;
  if (Et(e) ? (p = () => e.value, c = ei(e)) : pr(e) ? (p = () => e, r = !0) : he(e) ? (b = !0, c = e.some((O) => pr(O) || ei(O)), p = () => e.map((O) => {
    if (Et(O))
      return O.value;
    if (pr(O))
      return cr(O);
    if (Oe(O))
      return $n(O, d, 2);
    process.env.NODE_ENV !== "production" && l(O);
  })) : Oe(e) ? t ? p = () => $n(e, d, 2) : p = () => {
    if (!(d && d.isUnmounted))
      return k && k(), hn(
        e,
        d,
        3,
        [q]
      );
  } : (p = Tt, process.env.NODE_ENV !== "production" && l(e)), t && r) {
    const O = p;
    p = () => cr(O());
  }
  let k, q = (O) => {
    k = L.onStop = () => {
      $n(O, d, 4);
    };
  }, C;
  if (go)
    if (q = Tt, t ? n && hn(t, d, 3, [
      p(),
      b ? [] : void 0,
      q
    ]) : p(), o === "sync") {
      const O = BE();
      C = O.__watcherHandles || (O.__watcherHandles = []);
    } else
      return Tt;
  let w = b ? new Array(e.length).fill(Po) : Po;
  const T = () => {
    if (L.active)
      if (t) {
        const O = L.run();
        (r || c || (b ? O.some(
          (Pe, qe) => co(Pe, w[qe])
        ) : co(O, w))) && (k && k(), hn(t, d, 3, [
          O,
          // pass undefined as the old value when it's changed for the first time
          w === Po ? void 0 : b && w[0] === Po ? [] : w,
          q
        ]), w = O);
      } else
        L.run();
  };
  T.allowRecurse = !!t;
  let F;
  o === "sync" ? F = T : o === "post" ? F = () => Yt(T, d && d.suspense) : (T.pre = !0, d && (T.id = d.uid), F = () => mi(T));
  const L = new La(p, F);
  process.env.NODE_ENV !== "production" && (L.onTrack = i, L.onTrigger = a), t ? n ? T() : w = L.run() : o === "post" ? Yt(
    L.run.bind(L),
    d && d.suspense
  ) : L.run();
  const me = () => {
    L.stop(), d && d.scope && Na(d.scope.effects, L);
  };
  return C && C.push(me), me;
}
function Pw(e, t, n) {
  const r = this.proxy, o = gt(e) ? e.includes(".") ? yd(r, e) : () => r[e] : e.bind(r, r);
  let i;
  Oe(t) ? i = t : (i = t.handler, n = t);
  const a = St;
  jr(this);
  const s = bd(o, i.bind(r), n);
  return a ? jr(a) : vr(), s;
}
function yd(e, t) {
  const n = t.split(".");
  return () => {
    let r = e;
    for (let o = 0; o < n.length && r; o++)
      r = r[n[o]];
    return r;
  };
}
function cr(e, t) {
  if (!Je(e) || e.__v_skip || (t = t || /* @__PURE__ */ new Set(), t.has(e)))
    return e;
  if (t.add(e), Et(e))
    cr(e.value, t);
  else if (he(e))
    for (let n = 0; n < e.length; n++)
      cr(e[n], t);
  else if (Hr(e) || ur(e))
    e.forEach((n) => {
      cr(n, t);
    });
  else if (Fu(e))
    for (const n in e)
      cr(e[n], t);
  return e;
}
function xd(e) {
  v0(e) && H("Do not use built-in directive ids as custom directive id: " + e);
}
function Zn(e, t) {
  const n = Ct;
  if (n === null)
    return process.env.NODE_ENV !== "production" && H("withDirectives can only be used inside render functions."), e;
  const r = yi(n) || n.proxy, o = e.dirs || (e.dirs = []);
  for (let i = 0; i < t.length; i++) {
    let [a, s, l, d = nt] = t[i];
    a && (Oe(a) && (a = {
      mounted: a,
      updated: a
    }), a.deep && cr(s), o.push({
      dir: a,
      instance: r,
      value: s,
      oldValue: void 0,
      arg: l,
      modifiers: d
    }));
  }
  return e;
}
function rr(e, t, n, r) {
  const o = e.dirs, i = t && t.dirs;
  for (let a = 0; a < o.length; a++) {
    const s = o[a];
    i && (s.oldValue = i[a].value);
    let l = s.dir[r];
    l && (wr(), hn(l, n, 8, [
      e.el,
      s,
      e,
      t
    ]), Er());
  }
}
function Ut(e, t) {
  return Oe(e) ? (
    // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (() => pt({ name: e.name }, t, { setup: e }))()
  ) : e;
}
const io = (e) => !!e.type.__asyncLoader, Ja = (e) => e.type.__isKeepAlive;
function Fw(e, t) {
  wd(e, "a", t);
}
function Lw(e, t) {
  wd(e, "da", t);
}
function wd(e, t, n = St) {
  const r = e.__wdc || (e.__wdc = () => {
    let o = n;
    for (; o; ) {
      if (o.isDeactivated)
        return;
      o = o.parent;
    }
    return e();
  });
  if (gi(t, r, n), n) {
    let o = n.parent;
    for (; o && o.parent; )
      Ja(o.parent.vnode) && Mw(r, t, n, o), o = o.parent;
  }
}
function Mw(e, t, n, r) {
  const o = gi(
    t,
    e,
    r,
    !0
    /* prepend */
  );
  Ga(() => {
    Na(r[t], o);
  }, n);
}
function gi(e, t, n = St, r = !1) {
  if (n) {
    const o = n[e] || (n[e] = []), i = t.__weh || (t.__weh = (...a) => {
      if (n.isUnmounted)
        return;
      wr(), jr(n);
      const s = hn(t, n, e, a);
      return vr(), Er(), s;
    });
    return r ? o.unshift(i) : o.push(i), i;
  } else if (process.env.NODE_ENV !== "production") {
    const o = ir(Ba[e].replace(/ hook$/, ""));
    H(
      `${o} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const Nn = (e) => (t, n = St) => (
  // post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
  (!go || e === "sp") && gi(e, (...r) => t(...r), n)
), Uw = Nn("bm"), Ka = Nn("m"), jw = Nn("bu"), Bw = Nn("u"), Ww = Nn("bum"), Ga = Nn("um"), Hw = Nn("sp"), Yw = Nn(
  "rtg"
), Xw = Nn(
  "rtc"
);
function Jw(e, t = St) {
  gi("ec", e, t);
}
const ha = "components";
function ri(e, t) {
  return Gw(ha, e, !0, t) || e;
}
const Kw = Symbol.for("v-ndc");
function Gw(e, t, n = !0, r = !1) {
  const o = Ct || St;
  if (o) {
    const i = o.type;
    if (e === ha) {
      const s = os(
        i,
        !1
        /* do not include inferred name to avoid breaking existing code */
      );
      if (s && (s === t || s === en(t) || s === gr(en(t))))
        return i;
    }
    const a = (
      // local registration
      // check instance[type] first which is resolved for options API
      Pl(o[e] || i[e], t) || // global registration
      Pl(o.appContext[e], t)
    );
    if (!a && r)
      return i;
    if (process.env.NODE_ENV !== "production" && n && !a) {
      const s = e === ha ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : "";
      H(`Failed to resolve ${e.slice(0, -1)}: ${t}${s}`);
    }
    return a;
  } else
    process.env.NODE_ENV !== "production" && H(
      `resolve${gr(e.slice(0, -1))} can only be used in render() or setup().`
    );
}
function Pl(e, t) {
  return e && (e[t] || e[en(t)] || e[gr(en(t))]);
}
function Zw(e, t, n, r) {
  let o;
  const i = n && n[r];
  if (he(e) || gt(e)) {
    o = new Array(e.length);
    for (let a = 0, s = e.length; a < s; a++)
      o[a] = t(e[a], a, void 0, i && i[a]);
  } else if (typeof e == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(e) && H(`The v-for range expect an integer value but got ${e}.`), o = new Array(e);
    for (let a = 0; a < e; a++)
      o[a] = t(a + 1, a, void 0, i && i[a]);
  } else if (Je(e))
    if (e[Symbol.iterator])
      o = Array.from(
        e,
        (a, s) => t(a, s, void 0, i && i[s])
      );
    else {
      const a = Object.keys(e);
      o = new Array(a.length);
      for (let s = 0, l = a.length; s < l; s++) {
        const d = a[s];
        o[s] = t(e[d], d, s, i && i[s]);
      }
    }
  else
    o = [];
  return n && (n[r] = o), o;
}
function It(e, t, n = {}, r, o) {
  if (Ct.isCE || Ct.parent && io(Ct.parent) && Ct.parent.isCE)
    return t !== "default" && (n.name = t), vt("slot", n, r && r());
  let i = e[t];
  process.env.NODE_ENV !== "production" && i && i.length > 1 && (H(
    "SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."
  ), i = () => []), i && i._c && (i._d = !1), ue();
  const a = i && Ed(i(n)), s = bt(
    Gt,
    {
      key: n.key || // slot content array of a dynamic conditional slot may have a branch
      // key attached in the `createSlots` helper, respect that
      a && a.key || `_${t}`
    },
    a || (r ? r() : []),
    a && e._ === 1 ? 64 : -2
  );
  return !o && s.scopeId && (s.slotScopeIds = [s.scopeId + "-s"]), i && i._c && (i._d = !0), s;
}
function Ed(e) {
  return e.some((t) => Ur(t) ? !(t.type === Xt || t.type === Gt && !Ed(t.children)) : !0) ? e : null;
}
const ma = (e) => e ? Vd(e) ? yi(e) || e.proxy : ma(e.parent) : null, mr = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ pt(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? eo(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? eo(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? eo(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? eo(e.refs) : e.refs,
    $parent: (e) => ma(e.parent),
    $root: (e) => ma(e.root),
    $emit: (e) => e.emit,
    $options: (e) => Qa(e),
    $forceUpdate: (e) => e.f || (e.f = () => mi(e.update)),
    $nextTick: (e) => e.n || (e.n = Ha.bind(e.proxy)),
    $watch: (e) => Pw.bind(e)
  })
), Za = (e) => e === "_" || e === "$", Hi = (e, t) => e !== nt && !e.__isScriptSetup && Fe(e, t), kd = {
  get({ _: e }, t) {
    const { ctx: n, setupState: r, data: o, props: i, accessCache: a, type: s, appContext: l } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let d;
    if (t[0] !== "$") {
      const k = a[t];
      if (k !== void 0)
        switch (k) {
          case 1:
            return r[t];
          case 2:
            return o[t];
          case 4:
            return n[t];
          case 3:
            return i[t];
        }
      else {
        if (Hi(r, t))
          return a[t] = 1, r[t];
        if (o !== nt && Fe(o, t))
          return a[t] = 2, o[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (d = e.propsOptions[0]) && Fe(d, t)
        )
          return a[t] = 3, i[t];
        if (n !== nt && Fe(n, t))
          return a[t] = 4, n[t];
        va && (a[t] = 0);
      }
    }
    const p = mr[t];
    let c, b;
    if (p)
      return t === "$attrs" ? (At(e, "get", t), process.env.NODE_ENV !== "production" && ni()) : process.env.NODE_ENV !== "production" && t === "$slots" && At(e, "get", t), p(e);
    if (
      // css module (injected by vue-loader)
      (c = s.__cssModules) && (c = c[t])
    )
      return c;
    if (n !== nt && Fe(n, t))
      return a[t] = 4, n[t];
    if (
      // global properties
      b = l.config.globalProperties, Fe(b, t)
    )
      return b[t];
    process.env.NODE_ENV !== "production" && Ct && (!gt(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (o !== nt && Za(t[0]) && Fe(o, t) ? H(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === Ct && H(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, n) {
    const { data: r, setupState: o, ctx: i } = e;
    return Hi(o, t) ? (o[t] = n, !0) : process.env.NODE_ENV !== "production" && o.__isScriptSetup && Fe(o, t) ? (H(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : r !== nt && Fe(r, t) ? (r[t] = n, !0) : Fe(e.props, t) ? (process.env.NODE_ENV !== "production" && H(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && H(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(i, t, {
      enumerable: !0,
      configurable: !0,
      value: n
    }) : i[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: o, propsOptions: i }
  }, a) {
    let s;
    return !!n[a] || e !== nt && Fe(e, a) || Hi(t, a) || (s = i[0]) && Fe(s, a) || Fe(r, a) || Fe(mr, a) || Fe(o.config.globalProperties, a);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : Fe(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
process.env.NODE_ENV !== "production" && (kd.ownKeys = (e) => (H(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function Qw(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(mr).forEach((n) => {
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      get: () => mr[n](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: Tt
    });
  }), t;
}
function eE(e) {
  const {
    ctx: t,
    propsOptions: [n]
  } = e;
  n && Object.keys(n).forEach((r) => {
    Object.defineProperty(t, r, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[r],
      set: Tt
    });
  });
}
function tE(e) {
  const { ctx: t, setupState: n } = e;
  Object.keys(Ie(n)).forEach((r) => {
    if (!n.__isScriptSetup) {
      if (Za(r[0])) {
        H(
          `setup() return property ${JSON.stringify(
            r
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, r, {
        enumerable: !0,
        configurable: !0,
        get: () => n[r],
        set: Tt
      });
    }
  });
}
function nE() {
  return rE().slots;
}
function rE() {
  const e = wa();
  return process.env.NODE_ENV !== "production" && !e && H("useContext() called without active instance."), e.setupContext || (e.setupContext = Pd(e));
}
function Fl(e) {
  return he(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
function oE() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, n) => {
    e[n] ? H(`${t} property "${n}" is already defined in ${e[n]}.`) : e[n] = t;
  };
}
let va = !0;
function iE(e) {
  const t = Qa(e), n = e.proxy, r = e.ctx;
  va = !1, t.beforeCreate && Ll(t.beforeCreate, e, "bc");
  const {
    // state
    data: o,
    computed: i,
    methods: a,
    watch: s,
    provide: l,
    inject: d,
    // lifecycle
    created: p,
    beforeMount: c,
    mounted: b,
    beforeUpdate: k,
    updated: q,
    activated: C,
    deactivated: w,
    beforeDestroy: T,
    beforeUnmount: F,
    destroyed: L,
    unmounted: me,
    render: O,
    renderTracked: Pe,
    renderTriggered: qe,
    errorCaptured: it,
    serverPrefetch: Ne,
    // public API
    expose: Ke,
    inheritAttrs: at,
    // assets
    components: rt,
    directives: _t,
    filters: Me
  } = t, He = process.env.NODE_ENV !== "production" ? oE() : null;
  if (process.env.NODE_ENV !== "production") {
    const [Ee] = e.propsOptions;
    if (Ee)
      for (const le in Ee)
        He("Props", le);
  }
  if (d && aE(d, r, He), a)
    for (const Ee in a) {
      const le = a[Ee];
      Oe(le) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(r, Ee, {
        value: le.bind(n),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : r[Ee] = le.bind(n), process.env.NODE_ENV !== "production" && He("Methods", Ee)) : process.env.NODE_ENV !== "production" && H(
        `Method "${Ee}" has type "${typeof le}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (o) {
    process.env.NODE_ENV !== "production" && !Oe(o) && H(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const Ee = o.call(n, n);
    if (process.env.NODE_ENV !== "production" && Va(Ee) && H(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !Je(Ee))
      process.env.NODE_ENV !== "production" && H("data() should return an object.");
    else if (e.data = Ua(Ee), process.env.NODE_ENV !== "production")
      for (const le in Ee)
        He("Data", le), Za(le[0]) || Object.defineProperty(r, le, {
          configurable: !0,
          enumerable: !0,
          get: () => Ee[le],
          set: Tt
        });
  }
  if (va = !0, i)
    for (const Ee in i) {
      const le = i[Ee], Ve = Oe(le) ? le.bind(n, n) : Oe(le.get) ? le.get.bind(n, n) : Tt;
      process.env.NODE_ENV !== "production" && Ve === Tt && H(`Computed property "${Ee}" has no getter.`);
      const M = !Oe(le) && Oe(le.set) ? le.set.bind(n) : process.env.NODE_ENV !== "production" ? () => {
        H(
          `Write operation failed: computed property "${Ee}" is readonly.`
        );
      } : Tt, Z = Ld({
        get: Ve,
        set: M
      });
      Object.defineProperty(r, Ee, {
        enumerable: !0,
        configurable: !0,
        get: () => Z.value,
        set: (xe) => Z.value = xe
      }), process.env.NODE_ENV !== "production" && He("Computed", Ee);
    }
  if (s)
    for (const Ee in s)
      Sd(s[Ee], r, n, Ee);
  if (l) {
    const Ee = Oe(l) ? l.call(n) : l;
    Reflect.ownKeys(Ee).forEach((le) => {
      pE(le, Ee[le]);
    });
  }
  p && Ll(p, e, "c");
  function fe(Ee, le) {
    he(le) ? le.forEach((Ve) => Ee(Ve.bind(n))) : le && Ee(le.bind(n));
  }
  if (fe(Uw, c), fe(Ka, b), fe(jw, k), fe(Bw, q), fe(Fw, C), fe(Lw, w), fe(Jw, it), fe(Xw, Pe), fe(Yw, qe), fe(Ww, F), fe(Ga, me), fe(Hw, Ne), he(Ke))
    if (Ke.length) {
      const Ee = e.exposed || (e.exposed = {});
      Ke.forEach((le) => {
        Object.defineProperty(Ee, le, {
          get: () => n[le],
          set: (Ve) => n[le] = Ve
        });
      });
    } else
      e.exposed || (e.exposed = {});
  O && e.render === Tt && (e.render = O), at != null && (e.inheritAttrs = at), rt && (e.components = rt), _t && (e.directives = _t);
}
function aE(e, t, n = Tt) {
  he(e) && (e = ga(e));
  for (const r in e) {
    const o = e[r];
    let i;
    Je(o) ? "default" in o ? i = Lr(
      o.from || r,
      o.default,
      !0
      /* treat default function as factory */
    ) : i = Lr(o.from || r) : i = Lr(o), Et(i) ? Object.defineProperty(t, r, {
      enumerable: !0,
      configurable: !0,
      get: () => i.value,
      set: (a) => i.value = a
    }) : t[r] = i, process.env.NODE_ENV !== "production" && n("Inject", r);
  }
}
function Ll(e, t, n) {
  hn(
    he(e) ? e.map((r) => r.bind(t.proxy)) : e.bind(t.proxy),
    t,
    n
  );
}
function Sd(e, t, n, r) {
  const o = r.includes(".") ? yd(n, r) : () => n[r];
  if (gt(e)) {
    const i = t[e];
    Oe(i) ? ht(o, i) : process.env.NODE_ENV !== "production" && H(`Invalid watch handler specified by key "${e}"`, i);
  } else if (Oe(e))
    ht(o, e.bind(n));
  else if (Je(e))
    if (he(e))
      e.forEach((i) => Sd(i, t, n, r));
    else {
      const i = Oe(e.handler) ? e.handler.bind(n) : t[e.handler];
      Oe(i) ? ht(o, i, e) : process.env.NODE_ENV !== "production" && H(`Invalid watch handler specified by key "${e.handler}"`, i);
    }
  else
    process.env.NODE_ENV !== "production" && H(`Invalid watch option: "${r}"`, e);
}
function Qa(e) {
  const t = e.type, { mixins: n, extends: r } = t, {
    mixins: o,
    optionsCache: i,
    config: { optionMergeStrategies: a }
  } = e.appContext, s = i.get(t);
  let l;
  return s ? l = s : !o.length && !n && !r ? l = t : (l = {}, o.length && o.forEach(
    (d) => oi(l, d, a, !0)
  ), oi(l, t, a)), Je(t) && i.set(t, l), l;
}
function oi(e, t, n, r = !1) {
  const { mixins: o, extends: i } = t;
  i && oi(e, i, n, !0), o && o.forEach(
    (a) => oi(e, a, n, !0)
  );
  for (const a in t)
    if (r && a === "expose")
      process.env.NODE_ENV !== "production" && H(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const s = sE[a] || n && n[a];
      e[a] = s ? s(e[a], t[a]) : t[a];
    }
  return e;
}
const sE = {
  data: Ml,
  props: Ul,
  emits: Ul,
  // objects
  methods: no,
  computed: no,
  // lifecycle
  beforeCreate: Ft,
  created: Ft,
  beforeMount: Ft,
  mounted: Ft,
  beforeUpdate: Ft,
  updated: Ft,
  beforeDestroy: Ft,
  beforeUnmount: Ft,
  destroyed: Ft,
  unmounted: Ft,
  activated: Ft,
  deactivated: Ft,
  errorCaptured: Ft,
  serverPrefetch: Ft,
  // assets
  components: no,
  directives: no,
  // watch
  watch: cE,
  // provide / inject
  provide: Ml,
  inject: lE
};
function Ml(e, t) {
  return t ? e ? function() {
    return pt(
      Oe(e) ? e.call(this, this) : e,
      Oe(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function lE(e, t) {
  return no(ga(e), ga(t));
}
function ga(e) {
  if (he(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function Ft(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function no(e, t) {
  return e ? pt(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Ul(e, t) {
  return e ? he(e) && he(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : pt(
    /* @__PURE__ */ Object.create(null),
    Fl(e),
    Fl(t ?? {})
  ) : t;
}
function cE(e, t) {
  if (!e)
    return t;
  if (!t)
    return e;
  const n = pt(/* @__PURE__ */ Object.create(null), e);
  for (const r in t)
    n[r] = Ft(e[r], t[r]);
  return n;
}
function Cd() {
  return {
    app: null,
    config: {
      isNativeTag: zu,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let uE = 0;
function dE(e, t) {
  return function(n, r = null) {
    Oe(n) || (n = pt({}, n)), r != null && !Je(r) && (process.env.NODE_ENV !== "production" && H("root props passed to app.mount() must be an object."), r = null);
    const o = Cd();
    process.env.NODE_ENV !== "production" && Object.defineProperty(o.config, "unwrapInjectedRef", {
      get() {
        return !0;
      },
      set() {
        H(
          "app.config.unwrapInjectedRef has been deprecated. 3.3 now alawys unwraps injected refs in Options API."
        );
      }
    });
    const i = /* @__PURE__ */ new Set();
    let a = !1;
    const s = o.app = {
      _uid: uE++,
      _component: n,
      _props: r,
      _container: null,
      _context: o,
      _instance: null,
      version: Zl,
      get config() {
        return o.config;
      },
      set config(l) {
        process.env.NODE_ENV !== "production" && H(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(l, ...d) {
        return i.has(l) ? process.env.NODE_ENV !== "production" && H("Plugin has already been applied to target app.") : l && Oe(l.install) ? (i.add(l), l.install(s, ...d)) : Oe(l) ? (i.add(l), l(s, ...d)) : process.env.NODE_ENV !== "production" && H(
          'A plugin must either be a function or an object with an "install" function.'
        ), s;
      },
      mixin(l) {
        return o.mixins.includes(l) ? process.env.NODE_ENV !== "production" && H(
          "Mixin has already been applied to target app" + (l.name ? `: ${l.name}` : "")
        ) : o.mixins.push(l), s;
      },
      component(l, d) {
        return process.env.NODE_ENV !== "production" && Ea(l, o.config), d ? (process.env.NODE_ENV !== "production" && o.components[l] && H(`Component "${l}" has already been registered in target app.`), o.components[l] = d, s) : o.components[l];
      },
      directive(l, d) {
        return process.env.NODE_ENV !== "production" && xd(l), d ? (process.env.NODE_ENV !== "production" && o.directives[l] && H(`Directive "${l}" has already been registered in target app.`), o.directives[l] = d, s) : o.directives[l];
      },
      mount(l, d, p) {
        if (a)
          process.env.NODE_ENV !== "production" && H(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && l.__vue_app__ && H(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const c = vt(
            n,
            r
          );
          return c.appContext = o, process.env.NODE_ENV !== "production" && (o.reload = () => {
            e(Qn(c), l, p);
          }), d && t ? t(c, l) : e(c, l, p), a = !0, s._container = l, l.__vue_app__ = s, process.env.NODE_ENV !== "production" && (s._instance = c.component, Ew(s, Zl)), yi(c.component) || c.component.proxy;
        }
      },
      unmount() {
        a ? (e(null, s._container), process.env.NODE_ENV !== "production" && (s._instance = null, kw(s)), delete s._container.__vue_app__) : process.env.NODE_ENV !== "production" && H("Cannot unmount an app that is not mounted.");
      },
      provide(l, d) {
        return process.env.NODE_ENV !== "production" && l in o.provides && H(
          `App already provides property with key "${String(l)}". It will be overwritten with the new value.`
        ), o.provides[l] = d, s;
      },
      runWithContext(l) {
        ii = s;
        try {
          return l();
        } finally {
          ii = null;
        }
      }
    };
    return s;
  };
}
let ii = null;
function pE(e, t) {
  if (!St)
    process.env.NODE_ENV !== "production" && H("provide() can only be used inside setup().");
  else {
    let n = St.provides;
    const r = St.parent && St.parent.provides;
    r === n && (n = St.provides = Object.create(r)), n[e] = t;
  }
}
function Lr(e, t, n = !1) {
  const r = St || Ct;
  if (r || ii) {
    const o = r ? r.parent == null ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : ii._context.provides;
    if (o && e in o)
      return o[e];
    if (arguments.length > 1)
      return n && Oe(t) ? t.call(r && r.proxy) : t;
    process.env.NODE_ENV !== "production" && H(`injection "${String(e)}" not found.`);
  } else
    process.env.NODE_ENV !== "production" && H("inject() can only be used inside setup() or functional components.");
}
function fE(e, t, n, r = !1) {
  const o = {}, i = {};
  Go(i, bi, 1), e.propsDefaults = /* @__PURE__ */ Object.create(null), qd(e, t, o, i);
  for (const a in e.propsOptions[0])
    a in o || (o[a] = void 0);
  process.env.NODE_ENV !== "production" && Dd(t || {}, o, e), n ? e.props = r ? o : rw(o) : e.type.props ? e.props = o : e.props = i, e.attrs = i;
}
function hE(e) {
  for (; e; ) {
    if (e.type.__hmrId)
      return !0;
    e = e.parent;
  }
}
function mE(e, t, n, r) {
  const {
    props: o,
    attrs: i,
    vnode: { patchFlag: a }
  } = e, s = Ie(o), [l] = e.propsOptions;
  let d = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && hE(e)) && (r || a > 0) && !(a & 16)
  ) {
    if (a & 8) {
      const p = e.vnode.dynamicProps;
      for (let c = 0; c < p.length; c++) {
        let b = p[c];
        if (vi(e.emitsOptions, b))
          continue;
        const k = t[b];
        if (l)
          if (Fe(i, b))
            k !== i[b] && (i[b] = k, d = !0);
          else {
            const q = en(b);
            o[q] = ba(
              l,
              s,
              q,
              k,
              e,
              !1
              /* isAbsent */
            );
          }
        else
          k !== i[b] && (i[b] = k, d = !0);
      }
    }
  } else {
    qd(e, t, o, i) && (d = !0);
    let p;
    for (const c in s)
      (!t || // for camelCase
      !Fe(t, c) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((p = Zt(c)) === c || !Fe(t, p))) && (l ? n && // for camelCase
      (n[c] !== void 0 || // for kebab-case
      n[p] !== void 0) && (o[c] = ba(
        l,
        s,
        c,
        void 0,
        e,
        !0
        /* isAbsent */
      )) : delete o[c]);
    if (i !== s)
      for (const c in i)
        (!t || !Fe(t, c)) && (delete i[c], d = !0);
  }
  d && Sn(e, "set", "$attrs"), process.env.NODE_ENV !== "production" && Dd(t || {}, o, e);
}
function qd(e, t, n, r) {
  const [o, i] = e.propsOptions;
  let a = !1, s;
  if (t)
    for (let l in t) {
      if (Uo(l))
        continue;
      const d = t[l];
      let p;
      o && Fe(o, p = en(l)) ? !i || !i.includes(p) ? n[p] = d : (s || (s = {}))[p] = d : vi(e.emitsOptions, l) || (!(l in r) || d !== r[l]) && (r[l] = d, a = !0);
    }
  if (i) {
    const l = Ie(n), d = s || nt;
    for (let p = 0; p < i.length; p++) {
      const c = i[p];
      n[c] = ba(
        o,
        l,
        c,
        d[c],
        e,
        !Fe(d, c)
      );
    }
  }
  return a;
}
function ba(e, t, n, r, o, i) {
  const a = e[n];
  if (a != null) {
    const s = Fe(a, "default");
    if (s && r === void 0) {
      const l = a.default;
      if (a.type !== Function && !a.skipFactory && Oe(l)) {
        const { propsDefaults: d } = o;
        n in d ? r = d[n] : (jr(o), r = d[n] = l.call(
          null,
          t
        ), vr());
      } else
        r = l;
    }
    a[
      0
      /* shouldCast */
    ] && (i && !s ? r = !1 : a[
      1
      /* shouldCastTrue */
    ] && (r === "" || r === Zt(n)) && (r = !0));
  }
  return r;
}
function _d(e, t, n = !1) {
  const r = t.propsCache, o = r.get(e);
  if (o)
    return o;
  const i = e.props, a = {}, s = [];
  let l = !1;
  if (!Oe(e)) {
    const p = (c) => {
      l = !0;
      const [b, k] = _d(c, t, !0);
      pt(a, b), k && s.push(...k);
    };
    !n && t.mixins.length && t.mixins.forEach(p), e.extends && p(e.extends), e.mixins && e.mixins.forEach(p);
  }
  if (!i && !l)
    return Je(e) && r.set(e, Pr), Pr;
  if (he(i))
    for (let p = 0; p < i.length; p++) {
      process.env.NODE_ENV !== "production" && !gt(i[p]) && H("props must be strings when using array syntax.", i[p]);
      const c = en(i[p]);
      jl(c) && (a[c] = nt);
    }
  else if (i) {
    process.env.NODE_ENV !== "production" && !Je(i) && H("invalid props options", i);
    for (const p in i) {
      const c = en(p);
      if (jl(c)) {
        const b = i[p], k = a[c] = he(b) || Oe(b) ? { type: b } : pt({}, b);
        if (k) {
          const q = Wl(Boolean, k.type), C = Wl(String, k.type);
          k[
            0
            /* shouldCast */
          ] = q > -1, k[
            1
            /* shouldCastTrue */
          ] = C < 0 || q < C, (q > -1 || Fe(k, "default")) && s.push(c);
        }
      }
    }
  }
  const d = [a, s];
  return Je(e) && r.set(e, d), d;
}
function jl(e) {
  return e[0] !== "$" ? !0 : (process.env.NODE_ENV !== "production" && H(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function ya(e) {
  const t = e && e.toString().match(/^\s*(function|class) (\w+)/);
  return t ? t[2] : e === null ? "null" : "";
}
function Bl(e, t) {
  return ya(e) === ya(t);
}
function Wl(e, t) {
  return he(t) ? t.findIndex((n) => Bl(n, e)) : Oe(t) && Bl(t, e) ? 0 : -1;
}
function Dd(e, t, n) {
  const r = Ie(t), o = n.propsOptions[0];
  for (const i in o) {
    let a = o[i];
    a != null && vE(
      i,
      r[i],
      a,
      !Fe(e, i) && !Fe(e, Zt(i))
    );
  }
}
function vE(e, t, n, r) {
  const { type: o, required: i, validator: a, skipCheck: s } = n;
  if (i && r) {
    H('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !i)) {
    if (o != null && o !== !0 && !s) {
      let l = !1;
      const d = he(o) ? o : [o], p = [];
      for (let c = 0; c < d.length && !l; c++) {
        const { valid: b, expectedType: k } = bE(t, d[c]);
        p.push(k || ""), l = b;
      }
      if (!l) {
        H(yE(e, t, p));
        return;
      }
    }
    a && !a(t) && H('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const gE = /* @__PURE__ */ Wr(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function bE(e, t) {
  let n;
  const r = ya(t);
  if (gE(r)) {
    const o = typeof e;
    n = o === r.toLowerCase(), !n && o === "object" && (n = e instanceof t);
  } else
    r === "Object" ? n = Je(e) : r === "Array" ? n = he(e) : r === "null" ? n = e === null : n = e instanceof t;
  return {
    valid: n,
    expectedType: r
  };
}
function yE(e, t, n) {
  let r = `Invalid prop: type check failed for prop "${e}". Expected ${n.map(gr).join(" | ")}`;
  const o = n[0], i = za(t), a = Hl(t, o), s = Hl(t, i);
  return n.length === 1 && Yl(o) && !xE(o, i) && (r += ` with value ${a}`), r += `, got ${i} `, Yl(i) && (r += `with value ${s}.`), r;
}
function Hl(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function Yl(e) {
  return ["string", "number", "boolean"].some((t) => e.toLowerCase() === t);
}
function xE(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const Od = (e) => e[0] === "_" || e === "$stable", es = (e) => he(e) ? e.map(dn) : [dn(e)], wE = (e, t, n) => {
  if (t._n)
    return t;
  const r = Qt((...o) => (process.env.NODE_ENV !== "production" && St && H(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), es(t(...o))), n);
  return r._c = !1, r;
}, Rd = (e, t, n) => {
  const r = e._ctx;
  for (const o in e) {
    if (Od(o))
      continue;
    const i = e[o];
    if (Oe(i))
      t[o] = wE(o, i, r);
    else if (i != null) {
      process.env.NODE_ENV !== "production" && H(
        `Non-function value encountered for slot "${o}". Prefer function slots for better performance.`
      );
      const a = es(i);
      t[o] = () => a;
    }
  }
}, Td = (e, t) => {
  process.env.NODE_ENV !== "production" && !Ja(e.vnode) && H(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const n = es(t);
  e.slots.default = () => n;
}, EE = (e, t) => {
  if (e.vnode.shapeFlag & 32) {
    const n = t._;
    n ? (e.slots = Ie(t), Go(t, "_", n)) : Rd(
      t,
      e.slots = {}
    );
  } else
    e.slots = {}, t && Td(e, t);
  Go(e.slots, bi, 1);
}, kE = (e, t, n) => {
  const { vnode: r, slots: o } = e;
  let i = !0, a = nt;
  if (r.shapeFlag & 32) {
    const s = t._;
    s ? process.env.NODE_ENV !== "production" && hr ? (pt(o, t), Sn(e, "set", "$slots")) : n && s === 1 ? i = !1 : (pt(o, t), !n && s === 1 && delete o._) : (i = !t.$stable, Rd(t, o)), a = t;
  } else
    t && (Td(e, t), a = { default: 1 });
  if (i)
    for (const s in o)
      !Od(s) && !(s in a) && delete o[s];
};
function xa(e, t, n, r, o = !1) {
  if (he(e)) {
    e.forEach(
      (b, k) => xa(
        b,
        t && (he(t) ? t[k] : t),
        n,
        r,
        o
      )
    );
    return;
  }
  if (io(r) && !o)
    return;
  const i = r.shapeFlag & 4 ? yi(r.component) || r.component.proxy : r.el, a = o ? null : i, { i: s, r: l } = e;
  if (process.env.NODE_ENV !== "production" && !s) {
    H(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const d = t && t.r, p = s.refs === nt ? s.refs = {} : s.refs, c = s.setupState;
  if (d != null && d !== l && (gt(d) ? (p[d] = null, Fe(c, d) && (c[d] = null)) : Et(d) && (d.value = null)), Oe(l))
    $n(l, s, 12, [a, p]);
  else {
    const b = gt(l), k = Et(l);
    if (b || k) {
      const q = () => {
        if (e.f) {
          const C = b ? Fe(c, l) ? c[l] : p[l] : l.value;
          o ? he(C) && Na(C, i) : he(C) ? C.includes(i) || C.push(i) : b ? (p[l] = [i], Fe(c, l) && (c[l] = p[l])) : (l.value = [i], e.k && (p[e.k] = l.value));
        } else
          b ? (p[l] = a, Fe(c, l) && (c[l] = a)) : k ? (l.value = a, e.k && (p[e.k] = a)) : process.env.NODE_ENV !== "production" && H("Invalid template ref type:", l, `(${typeof l})`);
      };
      a ? (q.id = -1, Yt(q, n)) : q();
    } else
      process.env.NODE_ENV !== "production" && H("Invalid template ref type:", l, `(${typeof l})`);
  }
}
let Fo, Yn;
function On(e, t) {
  e.appContext.config.performance && ai() && Yn.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && _w(e, t, ai() ? Yn.now() : Date.now());
}
function Rn(e, t) {
  if (e.appContext.config.performance && ai()) {
    const n = `vue-${t}-${e.uid}`, r = n + ":end";
    Yn.mark(r), Yn.measure(
      `<${xi(e, e.type)}> ${t}`,
      n,
      r
    ), Yn.clearMarks(n), Yn.clearMarks(r);
  }
  process.env.NODE_ENV !== "production" && Dw(e, t, ai() ? Yn.now() : Date.now());
}
function ai() {
  return Fo !== void 0 || (typeof window < "u" && window.performance ? (Fo = !0, Yn = window.performance) : Fo = !1), Fo;
}
function SE() {
  const e = [];
  if (process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const Yt = zw;
function CE(e) {
  return qE(e);
}
function qE(e, t) {
  SE();
  const n = Qo();
  n.__VUE__ = !0, process.env.NODE_ENV !== "production" && pd(n.__VUE_DEVTOOLS_GLOBAL_HOOK__, n);
  const {
    insert: r,
    remove: o,
    patchProp: i,
    createElement: a,
    createText: s,
    createComment: l,
    setText: d,
    setElementText: p,
    parentNode: c,
    nextSibling: b,
    setScopeId: k = Tt,
    insertStaticContent: q
  } = e, C = (h, x, R, N = null, V = null, j = null, J = !1, U = null, B = process.env.NODE_ENV !== "production" && hr ? !1 : !!x.dynamicChildren) => {
    if (h === x)
      return;
    h && !Jr(h, x) && (N = ge(h), ve(h, V, j, !0), h = null), x.patchFlag === -2 && (B = !1, x.dynamicChildren = null);
    const { type: P, ref: oe, shapeFlag: ae } = x;
    switch (P) {
      case wo:
        w(h, x, R, N);
        break;
      case Xt:
        T(h, x, R, N);
        break;
      case Ho:
        h == null ? F(x, R, N, J) : process.env.NODE_ENV !== "production" && L(h, x, R, J);
        break;
      case Gt:
        _t(
          h,
          x,
          R,
          N,
          V,
          j,
          J,
          U,
          B
        );
        break;
      default:
        ae & 1 ? Pe(
          h,
          x,
          R,
          N,
          V,
          j,
          J,
          U,
          B
        ) : ae & 6 ? Me(
          h,
          x,
          R,
          N,
          V,
          j,
          J,
          U,
          B
        ) : ae & 64 || ae & 128 ? P.process(
          h,
          x,
          R,
          N,
          V,
          j,
          J,
          U,
          B,
          Se
        ) : process.env.NODE_ENV !== "production" && H("Invalid VNode type:", P, `(${typeof P})`);
    }
    oe != null && V && xa(oe, h && h.ref, j, x || h, !x);
  }, w = (h, x, R, N) => {
    if (h == null)
      r(
        x.el = s(x.children),
        R,
        N
      );
    else {
      const V = x.el = h.el;
      x.children !== h.children && d(V, x.children);
    }
  }, T = (h, x, R, N) => {
    h == null ? r(
      x.el = l(x.children || ""),
      R,
      N
    ) : x.el = h.el;
  }, F = (h, x, R, N) => {
    [h.el, h.anchor] = q(
      h.children,
      x,
      R,
      N,
      h.el,
      h.anchor
    );
  }, L = (h, x, R, N) => {
    if (x.children !== h.children) {
      const V = b(h.anchor);
      O(h), [x.el, x.anchor] = q(
        x.children,
        R,
        V,
        N
      );
    } else
      x.el = h.el, x.anchor = h.anchor;
  }, me = ({ el: h, anchor: x }, R, N) => {
    let V;
    for (; h && h !== x; )
      V = b(h), r(h, R, N), h = V;
    r(x, R, N);
  }, O = ({ el: h, anchor: x }) => {
    let R;
    for (; h && h !== x; )
      R = b(h), o(h), h = R;
    o(x);
  }, Pe = (h, x, R, N, V, j, J, U, B) => {
    J = J || x.type === "svg", h == null ? qe(
      x,
      R,
      N,
      V,
      j,
      J,
      U,
      B
    ) : Ke(
      h,
      x,
      V,
      j,
      J,
      U,
      B
    );
  }, qe = (h, x, R, N, V, j, J, U) => {
    let B, P;
    const { type: oe, props: ae, shapeFlag: pe, transition: ye, dirs: Re } = h;
    if (B = h.el = a(
      h.type,
      j,
      ae && ae.is,
      ae
    ), pe & 8 ? p(B, h.children) : pe & 16 && Ne(
      h.children,
      B,
      null,
      N,
      V,
      j && oe !== "foreignObject",
      J,
      U
    ), Re && rr(h, null, N, "created"), it(B, h, h.scopeId, J, N), ae) {
      for (const Ue in ae)
        Ue !== "value" && !Uo(Ue) && i(
          B,
          Ue,
          null,
          ae[Ue],
          j,
          h.children,
          N,
          V,
          de
        );
      "value" in ae && i(B, "value", null, ae.value), (P = ae.onVnodeBeforeMount) && bn(P, N, h);
    }
    process.env.NODE_ENV !== "production" && (Object.defineProperty(B, "__vnode", {
      value: h,
      enumerable: !1
    }), Object.defineProperty(B, "__vueParentComponent", {
      value: N,
      enumerable: !1
    })), Re && rr(h, null, N, "beforeMount");
    const je = (!V || V && !V.pendingBranch) && ye && !ye.persisted;
    je && ye.beforeEnter(B), r(B, x, R), ((P = ae && ae.onVnodeMounted) || je || Re) && Yt(() => {
      P && bn(P, N, h), je && ye.enter(B), Re && rr(h, null, N, "mounted");
    }, V);
  }, it = (h, x, R, N, V) => {
    if (R && k(h, R), N)
      for (let j = 0; j < N.length; j++)
        k(h, N[j]);
    if (V) {
      let j = V.subTree;
      if (process.env.NODE_ENV !== "production" && j.patchFlag > 0 && j.patchFlag & 2048 && (j = gd(j.children) || j), x === j) {
        const J = V.vnode;
        it(
          h,
          J,
          J.scopeId,
          J.slotScopeIds,
          V.parent
        );
      }
    }
  }, Ne = (h, x, R, N, V, j, J, U, B = 0) => {
    for (let P = B; P < h.length; P++) {
      const oe = h[P] = U ? Hn(h[P]) : dn(h[P]);
      C(
        null,
        oe,
        x,
        R,
        N,
        V,
        j,
        J,
        U
      );
    }
  }, Ke = (h, x, R, N, V, j, J) => {
    const U = x.el = h.el;
    let { patchFlag: B, dynamicChildren: P, dirs: oe } = x;
    B |= h.patchFlag & 16;
    const ae = h.props || nt, pe = x.props || nt;
    let ye;
    R && or(R, !1), (ye = pe.onVnodeBeforeUpdate) && bn(ye, R, x, h), oe && rr(x, h, R, "beforeUpdate"), R && or(R, !0), process.env.NODE_ENV !== "production" && hr && (B = 0, J = !1, P = null);
    const Re = V && x.type !== "foreignObject";
    if (P ? (at(
      h.dynamicChildren,
      P,
      U,
      R,
      N,
      Re,
      j
    ), process.env.NODE_ENV !== "production" && Wo(h, x)) : J || Ve(
      h,
      x,
      U,
      null,
      R,
      N,
      Re,
      j,
      !1
    ), B > 0) {
      if (B & 16)
        rt(
          U,
          x,
          ae,
          pe,
          R,
          N,
          V
        );
      else if (B & 2 && ae.class !== pe.class && i(U, "class", null, pe.class, V), B & 4 && i(U, "style", ae.style, pe.style, V), B & 8) {
        const je = x.dynamicProps;
        for (let Ue = 0; Ue < je.length; Ue++) {
          const lt = je[Ue], _ = ae[lt], z = pe[lt];
          (z !== _ || lt === "value") && i(
            U,
            lt,
            _,
            z,
            V,
            h.children,
            R,
            N,
            de
          );
        }
      }
      B & 1 && h.children !== x.children && p(U, x.children);
    } else
      !J && P == null && rt(
        U,
        x,
        ae,
        pe,
        R,
        N,
        V
      );
    ((ye = pe.onVnodeUpdated) || oe) && Yt(() => {
      ye && bn(ye, R, x, h), oe && rr(x, h, R, "updated");
    }, N);
  }, at = (h, x, R, N, V, j, J) => {
    for (let U = 0; U < x.length; U++) {
      const B = h[U], P = x[U], oe = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        B.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (B.type === Gt || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Jr(B, P) || // - In the case of a component, it could contain anything.
        B.shapeFlag & 70) ? c(B.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          R
        )
      );
      C(
        B,
        P,
        oe,
        null,
        N,
        V,
        j,
        J,
        !0
      );
    }
  }, rt = (h, x, R, N, V, j, J) => {
    if (R !== N) {
      if (R !== nt)
        for (const U in R)
          !Uo(U) && !(U in N) && i(
            h,
            U,
            R[U],
            null,
            J,
            x.children,
            V,
            j,
            de
          );
      for (const U in N) {
        if (Uo(U))
          continue;
        const B = N[U], P = R[U];
        B !== P && U !== "value" && i(
          h,
          U,
          P,
          B,
          J,
          x.children,
          V,
          j,
          de
        );
      }
      "value" in N && i(h, "value", R.value, N.value);
    }
  }, _t = (h, x, R, N, V, j, J, U, B) => {
    const P = x.el = h ? h.el : s(""), oe = x.anchor = h ? h.anchor : s("");
    let { patchFlag: ae, dynamicChildren: pe, slotScopeIds: ye } = x;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (hr || ae & 2048) && (ae = 0, B = !1, pe = null), ye && (U = U ? U.concat(ye) : ye), h == null ? (r(P, R, N), r(oe, R, N), Ne(
      x.children,
      R,
      oe,
      V,
      j,
      J,
      U,
      B
    )) : ae > 0 && ae & 64 && pe && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    h.dynamicChildren ? (at(
      h.dynamicChildren,
      pe,
      R,
      V,
      j,
      J,
      U
    ), process.env.NODE_ENV !== "production" ? Wo(h, x) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (x.key != null || V && x === V.subTree) && Wo(
        h,
        x,
        !0
        /* shallow */
      )
    )) : Ve(
      h,
      x,
      R,
      oe,
      V,
      j,
      J,
      U,
      B
    );
  }, Me = (h, x, R, N, V, j, J, U, B) => {
    x.slotScopeIds = U, h == null ? x.shapeFlag & 512 ? V.ctx.activate(
      x,
      R,
      N,
      J,
      B
    ) : He(
      x,
      R,
      N,
      V,
      j,
      J,
      B
    ) : fe(h, x, B);
  }, He = (h, x, R, N, V, j, J) => {
    const U = h.component = IE(
      h,
      N,
      V
    );
    if (process.env.NODE_ENV !== "production" && U.type.__hmrId && bw(U), process.env.NODE_ENV !== "production" && (jo(h), On(U, "mount")), Ja(h) && (U.ctx.renderer = Se), process.env.NODE_ENV !== "production" && On(U, "init"), VE(U), process.env.NODE_ENV !== "production" && Rn(U, "init"), U.asyncDep) {
      if (V && V.registerDep(U, Ee), !h.el) {
        const B = U.subTree = vt(Xt);
        T(null, B, x, R);
      }
      return;
    }
    Ee(
      U,
      h,
      x,
      R,
      V,
      j,
      J
    ), process.env.NODE_ENV !== "production" && (Bo(), Rn(U, "mount"));
  }, fe = (h, x, R) => {
    const N = x.component = h.component;
    if (Iw(h, x, R))
      if (N.asyncDep && !N.asyncResolved) {
        process.env.NODE_ENV !== "production" && jo(x), le(N, x, R), process.env.NODE_ENV !== "production" && Bo();
        return;
      } else
        N.next = x, vw(N.update), N.update();
    else
      x.el = h.el, N.vnode = x;
  }, Ee = (h, x, R, N, V, j, J) => {
    const U = () => {
      if (h.isMounted) {
        let { next: oe, bu: ae, u: pe, parent: ye, vnode: Re } = h, je = oe, Ue;
        process.env.NODE_ENV !== "production" && jo(oe || h.vnode), or(h, !1), oe ? (oe.el = Re.el, le(h, oe, J)) : oe = Re, ae && $r(ae), (Ue = oe.props && oe.props.onVnodeBeforeUpdate) && bn(Ue, ye, oe, Re), or(h, !0), process.env.NODE_ENV !== "production" && On(h, "render");
        const lt = Wi(h);
        process.env.NODE_ENV !== "production" && Rn(h, "render");
        const _ = h.subTree;
        h.subTree = lt, process.env.NODE_ENV !== "production" && On(h, "patch"), C(
          _,
          lt,
          // parent may have changed if it's in a teleport
          c(_.el),
          // anchor may have changed if it's in a fragment
          ge(_),
          h,
          V,
          j
        ), process.env.NODE_ENV !== "production" && Rn(h, "patch"), oe.el = lt.el, je === null && Nw(h, lt.el), pe && Yt(pe, V), (Ue = oe.props && oe.props.onVnodeUpdated) && Yt(
          () => bn(Ue, ye, oe, Re),
          V
        ), process.env.NODE_ENV !== "production" && fd(h), process.env.NODE_ENV !== "production" && Bo();
      } else {
        let oe;
        const { el: ae, props: pe } = x, { bm: ye, m: Re, parent: je } = h, Ue = io(x);
        if (or(h, !1), ye && $r(ye), !Ue && (oe = pe && pe.onVnodeBeforeMount) && bn(oe, je, x), or(h, !0), ae && Y) {
          const lt = () => {
            process.env.NODE_ENV !== "production" && On(h, "render"), h.subTree = Wi(h), process.env.NODE_ENV !== "production" && Rn(h, "render"), process.env.NODE_ENV !== "production" && On(h, "hydrate"), Y(
              ae,
              h.subTree,
              h,
              V,
              null
            ), process.env.NODE_ENV !== "production" && Rn(h, "hydrate");
          };
          Ue ? x.type.__asyncLoader().then(
            // note: we are moving the render call into an async callback,
            // which means it won't track dependencies - but it's ok because
            // a server-rendered async wrapper is already in resolved state
            // and it will never need to change.
            () => !h.isUnmounted && lt()
          ) : lt();
        } else {
          process.env.NODE_ENV !== "production" && On(h, "render");
          const lt = h.subTree = Wi(h);
          if (h && h.parent && !(h.parent.type.__asyncLoader && h.parent.isCE)) {
            const _ = h.isCEChild && h.type.styles || null;
            h.addCEChildStyle && _ && h.addCEChildStyle(_, h);
          }
          process.env.NODE_ENV !== "production" && Rn(h, "render"), process.env.NODE_ENV !== "production" && On(h, "patch"), C(
            null,
            lt,
            R,
            N,
            h,
            V,
            j
          ), process.env.NODE_ENV !== "production" && Rn(h, "patch"), x.el = lt.el;
        }
        if (Re && Yt(Re, V), !Ue && (oe = pe && pe.onVnodeMounted)) {
          const lt = x;
          Yt(
            () => bn(oe, je, lt),
            V
          );
        }
        (x.shapeFlag & 256 || je && io(je.vnode) && je.vnode.shapeFlag & 256) && h.a && Yt(h.a, V), h.isMounted = !0, process.env.NODE_ENV !== "production" && Sw(h), x = R = N = null;
      }
    }, B = h.effect = new La(
      U,
      () => mi(P),
      h.scope
      // track it in component's effect scope
    ), P = h.update = () => B.run();
    P.id = h.uid, or(h, !0), process.env.NODE_ENV !== "production" && (B.onTrack = h.rtc ? (oe) => $r(h.rtc, oe) : void 0, B.onTrigger = h.rtg ? (oe) => $r(h.rtg, oe) : void 0, P.ownerInstance = h), P();
  }, le = (h, x, R) => {
    x.component = h;
    const N = h.vnode.props;
    h.vnode = x, h.next = null, mE(h, x.props, N, R), kE(h, x.children, R), wr(), Il(), Er();
  }, Ve = (h, x, R, N, V, j, J, U, B = !1) => {
    const P = h && h.children, oe = h ? h.shapeFlag : 0, ae = x.children, { patchFlag: pe, shapeFlag: ye } = x;
    if (pe > 0) {
      if (pe & 128) {
        Z(
          P,
          ae,
          R,
          N,
          V,
          j,
          J,
          U,
          B
        );
        return;
      } else if (pe & 256) {
        M(
          P,
          ae,
          R,
          N,
          V,
          j,
          J,
          U,
          B
        );
        return;
      }
    }
    ye & 8 ? (oe & 16 && de(P, V, j), ae !== P && p(R, ae)) : oe & 16 ? ye & 16 ? Z(
      P,
      ae,
      R,
      N,
      V,
      j,
      J,
      U,
      B
    ) : de(P, V, j, !0) : (oe & 8 && p(R, ""), ye & 16 && Ne(
      ae,
      R,
      N,
      V,
      j,
      J,
      U,
      B
    ));
  }, M = (h, x, R, N, V, j, J, U, B) => {
    h = h || Pr, x = x || Pr;
    const P = h.length, oe = x.length, ae = Math.min(P, oe);
    let pe;
    for (pe = 0; pe < ae; pe++) {
      const ye = x[pe] = B ? Hn(x[pe]) : dn(x[pe]);
      C(
        h[pe],
        ye,
        R,
        null,
        V,
        j,
        J,
        U,
        B
      );
    }
    P > oe ? de(
      h,
      V,
      j,
      !0,
      !1,
      ae
    ) : Ne(
      x,
      R,
      N,
      V,
      j,
      J,
      U,
      B,
      ae
    );
  }, Z = (h, x, R, N, V, j, J, U, B) => {
    let P = 0;
    const oe = x.length;
    let ae = h.length - 1, pe = oe - 1;
    for (; P <= ae && P <= pe; ) {
      const ye = h[P], Re = x[P] = B ? Hn(x[P]) : dn(x[P]);
      if (Jr(ye, Re))
        C(
          ye,
          Re,
          R,
          null,
          V,
          j,
          J,
          U,
          B
        );
      else
        break;
      P++;
    }
    for (; P <= ae && P <= pe; ) {
      const ye = h[ae], Re = x[pe] = B ? Hn(x[pe]) : dn(x[pe]);
      if (Jr(ye, Re))
        C(
          ye,
          Re,
          R,
          null,
          V,
          j,
          J,
          U,
          B
        );
      else
        break;
      ae--, pe--;
    }
    if (P > ae) {
      if (P <= pe) {
        const ye = pe + 1, Re = ye < oe ? x[ye].el : N;
        for (; P <= pe; )
          C(
            null,
            x[P] = B ? Hn(x[P]) : dn(x[P]),
            R,
            Re,
            V,
            j,
            J,
            U,
            B
          ), P++;
      }
    } else if (P > pe)
      for (; P <= ae; )
        ve(h[P], V, j, !0), P++;
    else {
      const ye = P, Re = P, je = /* @__PURE__ */ new Map();
      for (P = Re; P <= pe; P++) {
        const Ce = x[P] = B ? Hn(x[P]) : dn(x[P]);
        Ce.key != null && (process.env.NODE_ENV !== "production" && je.has(Ce.key) && H(
          "Duplicate keys found during update:",
          JSON.stringify(Ce.key),
          "Make sure keys are unique."
        ), je.set(Ce.key, P));
      }
      let Ue, lt = 0;
      const _ = pe - Re + 1;
      let z = !1, W = 0;
      const De = new Array(_);
      for (P = 0; P < _; P++)
        De[P] = 0;
      for (P = ye; P <= ae; P++) {
        const Ce = h[P];
        if (lt >= _) {
          ve(Ce, V, j, !0);
          continue;
        }
        let _e;
        if (Ce.key != null)
          _e = je.get(Ce.key);
        else
          for (Ue = Re; Ue <= pe; Ue++)
            if (De[Ue - Re] === 0 && Jr(Ce, x[Ue])) {
              _e = Ue;
              break;
            }
        _e === void 0 ? ve(Ce, V, j, !0) : (De[_e - Re] = P + 1, _e >= W ? W = _e : z = !0, C(
          Ce,
          x[_e],
          R,
          null,
          V,
          j,
          J,
          U,
          B
        ), lt++);
      }
      const We = z ? _E(De) : Pr;
      for (Ue = We.length - 1, P = _ - 1; P >= 0; P--) {
        const Ce = Re + P, _e = x[Ce], Ae = Ce + 1 < oe ? x[Ce + 1].el : N;
        De[P] === 0 ? C(
          null,
          _e,
          R,
          Ae,
          V,
          j,
          J,
          U,
          B
        ) : z && (Ue < 0 || P !== We[Ue] ? xe(_e, R, Ae, 2) : Ue--);
      }
    }
  }, xe = (h, x, R, N, V = null) => {
    const { el: j, type: J, transition: U, children: B, shapeFlag: P } = h;
    if (P & 6) {
      xe(h.component.subTree, x, R, N);
      return;
    }
    if (P & 128) {
      h.suspense.move(x, R, N);
      return;
    }
    if (P & 64) {
      J.move(h, x, R, Se);
      return;
    }
    if (J === Gt) {
      r(j, x, R);
      for (let oe = 0; oe < B.length; oe++)
        xe(B[oe], x, R, N);
      r(h.anchor, x, R);
      return;
    }
    if (J === Ho) {
      me(h, x, R);
      return;
    }
    if (N !== 2 && P & 1 && U)
      if (N === 0)
        U.beforeEnter(j), r(j, x, R), Yt(() => U.enter(j), V);
      else {
        const { leave: oe, delayLeave: ae, afterLeave: pe } = U, ye = () => r(j, x, R), Re = () => {
          oe(j, () => {
            ye(), pe && pe();
          });
        };
        ae ? ae(j, ye, Re) : Re();
      }
    else
      r(j, x, R);
  }, ve = (h, x, R, N = !1, V = !1) => {
    const {
      type: j,
      props: J,
      ref: U,
      children: B,
      dynamicChildren: P,
      shapeFlag: oe,
      patchFlag: ae,
      dirs: pe
    } = h;
    if (U != null && xa(U, null, R, h, !0), oe & 256) {
      x.ctx.deactivate(h);
      return;
    }
    const ye = oe & 1 && pe, Re = !io(h);
    let je;
    if (Re && (je = J && J.onVnodeBeforeUnmount) && bn(je, x, h), oe & 6)
      h.component.isCEChild && h.component.removeCEChildStyle && h.component.removeCEChildStyle(
        h.component.type.styles,
        h.component.uid
      ), ke(h.component, R, N);
    else {
      if (oe & 128) {
        h.suspense.unmount(R, N);
        return;
      }
      ye && rr(h, null, x, "beforeUnmount"), oe & 64 ? h.type.remove(
        h,
        x,
        R,
        V,
        Se,
        N
      ) : P && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (j !== Gt || ae > 0 && ae & 64) ? de(
        P,
        x,
        R,
        !1,
        !0
      ) : (j === Gt && ae & 384 || !V && oe & 16) && de(B, x, R), N && we(h);
    }
    (Re && (je = J && J.onVnodeUnmounted) || ye) && Yt(() => {
      je && bn(je, x, h), ye && rr(h, null, x, "unmounted");
    }, R);
  }, we = (h) => {
    const { type: x, el: R, anchor: N, transition: V } = h;
    if (x === Gt) {
      process.env.NODE_ENV !== "production" && h.patchFlag > 0 && h.patchFlag & 2048 && V && !V.persisted ? h.children.forEach((J) => {
        J.type === Xt ? o(J.el) : we(J);
      }) : Te(R, N);
      return;
    }
    if (x === Ho) {
      O(h);
      return;
    }
    const j = () => {
      o(R), V && !V.persisted && V.afterLeave && V.afterLeave();
    };
    if (h.shapeFlag & 1 && V && !V.persisted) {
      const { leave: J, delayLeave: U } = V, B = () => J(R, j);
      U ? U(h.el, j, B) : B();
    } else
      j();
  }, Te = (h, x) => {
    let R;
    for (; h !== x; )
      R = b(h), o(h), h = R;
    o(x);
  }, ke = (h, x, R) => {
    process.env.NODE_ENV !== "production" && h.type.__hmrId && yw(h);
    const { bum: N, scope: V, update: j, subTree: J, um: U } = h;
    N && $r(N), V.stop(), j && (j.active = !1, ve(J, h, x, R)), U && Yt(U, x), Yt(() => {
      h.isUnmounted = !0;
    }, x), x && x.pendingBranch && !x.isUnmounted && h.asyncDep && !h.asyncResolved && h.suspenseId === x.pendingId && (x.deps--, x.deps === 0 && x.resolve()), process.env.NODE_ENV !== "production" && qw(h);
  }, de = (h, x, R, N = !1, V = !1, j = 0) => {
    for (let J = j; J < h.length; J++)
      ve(h[J], x, R, N, V);
  }, ge = (h) => h.shapeFlag & 6 ? ge(h.component.subTree) : h.shapeFlag & 128 ? h.suspense.next() : b(h.anchor || h.el), ie = (h, x, R) => {
    h == null ? x._vnode && ve(x._vnode, null, null, !0) : C(x._vnode || null, h, x, null, null, null, R), Il(), cd(), x._vnode = h;
  }, Se = {
    p: C,
    um: ve,
    m: xe,
    r: we,
    mt: He,
    mc: Ne,
    pc: Ve,
    pbc: at,
    n: ge,
    o: e
  };
  let st, Y;
  return t && ([st, Y] = t(
    Se
  )), {
    render: ie,
    hydrate: st,
    createApp: dE(ie, st)
  };
}
function or({ effect: e, update: t }, n) {
  e.allowRecurse = t.allowRecurse = n;
}
function Wo(e, t, n = !1) {
  const r = e.children, o = t.children;
  if (he(r) && he(o))
    for (let i = 0; i < r.length; i++) {
      const a = r[i];
      let s = o[i];
      s.shapeFlag & 1 && !s.dynamicChildren && ((s.patchFlag <= 0 || s.patchFlag === 32) && (s = o[i] = Hn(o[i]), s.el = a.el), n || Wo(a, s)), s.type === wo && (s.el = a.el), process.env.NODE_ENV !== "production" && s.type === Xt && !s.el && (s.el = a.el);
    }
}
function _E(e) {
  const t = e.slice(), n = [0];
  let r, o, i, a, s;
  const l = e.length;
  for (r = 0; r < l; r++) {
    const d = e[r];
    if (d !== 0) {
      if (o = n[n.length - 1], e[o] < d) {
        t[r] = o, n.push(r);
        continue;
      }
      for (i = 0, a = n.length - 1; i < a; )
        s = i + a >> 1, e[n[s]] < d ? i = s + 1 : a = s;
      d < e[n[i]] && (i > 0 && (t[r] = n[i - 1]), n[i] = r);
    }
  }
  for (i = n.length, a = n[i - 1]; i-- > 0; )
    n[i] = a, a = t[a];
  return n;
}
const DE = (e) => e.__isTeleport, Gt = Symbol.for("v-fgt"), wo = Symbol.for("v-txt"), Xt = Symbol.for("v-cmt"), Ho = Symbol.for("v-stc"), ao = [];
let pn = null;
function ue(e = !1) {
  ao.push(pn = e ? null : []);
}
function OE() {
  ao.pop(), pn = ao[ao.length - 1] || null;
}
let vo = 1;
function Xl(e) {
  vo += e;
}
function Ad(e) {
  return e.dynamicChildren = vo > 0 ? pn || Pr : null, OE(), vo > 0 && pn && pn.push(e), e;
}
function $e(e, t, n, r, o, i) {
  return Ad(
    et(
      e,
      t,
      n,
      r,
      o,
      i,
      !0
      /* isBlock */
    )
  );
}
function bt(e, t, n, r, o) {
  return Ad(
    vt(
      e,
      t,
      n,
      r,
      o,
      !0
      /* isBlock: prevent a block from tracking itself */
    )
  );
}
function Ur(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Jr(e, t) {
  return process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && Ir.has(t.type) ? (e.shapeFlag &= -257, t.shapeFlag &= -513, !1) : e.type === t.type && e.key === t.key;
}
const RE = (...e) => Id(
  ...e
), bi = "__vInternal", $d = ({ key: e }) => e ?? null, Yo = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? gt(e) || Et(e) || Oe(e) ? { i: Ct, r: e, k: t, f: !!n } : e : null);
function et(e, t = null, n = null, r = 0, o = null, i = e === Gt ? 0 : 1, a = !1, s = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && $d(t),
    ref: t && Yo(t),
    scopeId: vd,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: r,
    dynamicProps: o,
    dynamicChildren: null,
    appContext: null,
    ctx: Ct
  };
  return s ? (ts(l, n), i & 128 && e.normalize(l)) : n && (l.shapeFlag |= gt(n) ? 8 : 16), process.env.NODE_ENV !== "production" && l.key !== l.key && H("VNode created with invalid key (NaN). VNode type:", l.type), vo > 0 && // avoid a block node from tracking itself
  !a && // has current parent block
  pn && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || i & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && pn.push(l), l;
}
const vt = process.env.NODE_ENV !== "production" ? RE : Id;
function Id(e, t = null, n = null, r = 0, o = null, i = !1) {
  if ((!e || e === Kw) && (process.env.NODE_ENV !== "production" && !e && H(`Invalid vnode type when creating vnode: ${e}.`), e = Xt), Ur(e)) {
    const s = Qn(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && ts(s, n), vo > 0 && !i && pn && (s.shapeFlag & 6 ? pn[pn.indexOf(e)] = s : pn.push(s)), s.patchFlag |= -2, s;
  }
  if (Fd(e) && (e = e.__vccOpts), t) {
    t = TE(t);
    let { class: s, style: l } = t;
    s && !gt(s) && (t.class = qt(s)), Je(l) && (ua(l) && !he(l) && (l = pt({}, l)), t.style = En(l));
  }
  const a = gt(e) ? 1 : Vw(e) ? 128 : DE(e) ? 64 : Je(e) ? 4 : Oe(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && a & 4 && ua(e) && (e = Ie(e), H(
    "Vue received a Component which was made a reactive object. This can lead to unnecessary performance overhead, and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), et(
    e,
    t,
    n,
    r,
    o,
    a,
    i,
    !0
  );
}
function TE(e) {
  return e ? ua(e) || bi in e ? pt({}, e) : e : null;
}
function Qn(e, t, n = !1) {
  const { props: r, ref: o, patchFlag: i, children: a } = e, s = t ? ns(r || {}, t) : r;
  return {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: s,
    key: s && $d(s),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && o ? he(o) ? o.concat(Yo(t)) : [o, Yo(t)] : Yo(t)
    ) : o,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && i === -1 && he(a) ? a.map(Nd) : a,
    target: e.target,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== Gt ? i === -1 ? 16 : i | 16 : i,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: e.transition,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Qn(e.ssContent),
    ssFallback: e.ssFallback && Qn(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
}
function Nd(e) {
  const t = Qn(e);
  return he(e.children) && (t.children = e.children.map(Nd)), t;
}
function mt(e = " ", t = 0) {
  return vt(wo, null, e, t);
}
function ze(e = "", t = !1) {
  return t ? (ue(), bt(Xt, null, e)) : vt(Xt, null, e);
}
function dn(e) {
  return e == null || typeof e == "boolean" ? vt(Xt) : he(e) ? vt(
    Gt,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : typeof e == "object" ? Hn(e) : vt(wo, null, String(e));
}
function Hn(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : Qn(e);
}
function ts(e, t) {
  let n = 0;
  const { shapeFlag: r } = e;
  if (t == null)
    t = null;
  else if (he(t))
    n = 16;
  else if (typeof t == "object")
    if (r & 65) {
      const o = t.default;
      o && (o._c && (o._d = !1), ts(e, o()), o._c && (o._d = !0));
      return;
    } else {
      n = 32;
      const o = t._;
      !o && !(bi in t) ? t._ctx = Ct : o === 3 && Ct && (Ct.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else
    Oe(t) ? (t = { default: t, _ctx: Ct }, n = 32) : (t = String(t), r & 64 ? (n = 16, t = [mt(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function ns(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    for (const o in r)
      if (o === "class")
        t.class !== r.class && (t.class = qt([t.class, r.class]));
      else if (o === "style")
        t.style = En([t.style, r.style]);
      else if (bo(o)) {
        const i = t[o], a = r[o];
        a && i !== a && !(he(i) && i.includes(a)) && (t[o] = i ? [].concat(i, a) : a);
      } else
        o !== "" && (t[o] = r[o]);
  }
  return t;
}
function bn(e, t, n, r = null) {
  hn(e, t, 7, [
    n,
    r
  ]);
}
const AE = Cd();
let $E = 0;
function IE(e, t, n) {
  const r = e.type, o = (t ? t.appContext : e.appContext) || AE, i = {
    isCEChild: t && (t.isCE || t.isCEChild),
    addCEChildStyle: t && t.addCEChildStyle ? t.addCEChildStyle : null,
    removeCEChildStyle: t && t.removeCEChildStyle ? t.removeCEChildStyle : null,
    cecStyleIds: null,
    uid: $E++,
    vnode: e,
    type: r,
    parent: t,
    appContext: o,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    scope: new _0(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(o.provides),
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: _d(r, o),
    emitsOptions: md(r, o),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: nt,
    // inheritAttrs
    inheritAttrs: r.inheritAttrs,
    // state
    ctx: nt,
    data: nt,
    props: nt,
    attrs: nt,
    slots: nt,
    refs: nt,
    setupState: nt,
    setupContext: null,
    attrsProxy: null,
    slotsProxy: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? i.ctx = Qw(i) : i.ctx = { _: i }, i.root = t ? t.root : i, i.emit = Rw.bind(null, i), e.ce && e.ce(i), i;
}
let St = null;
const wa = () => St || Ct;
let rs, Tr, Jl = "__VUE_INSTANCE_SETTERS__";
(Tr = Qo()[Jl]) || (Tr = Qo()[Jl] = []), Tr.push((e) => St = e), rs = (e) => {
  Tr.length > 1 ? Tr.forEach((t) => t(e)) : Tr[0](e);
};
const jr = (e) => {
  rs(e), e.scope.on();
}, vr = () => {
  St && St.scope.off(), rs(null);
}, NE = /* @__PURE__ */ Wr("slot,component");
function Ea(e, t) {
  const n = t.isNativeTag || zu;
  (NE(e) || n(e)) && H(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function Vd(e) {
  return e.vnode.shapeFlag & 4;
}
let go = !1;
function VE(e, t = !1) {
  go = t;
  const { props: n, children: r } = e.vnode, o = Vd(e);
  fE(e, n, o, t), EE(e, r);
  const i = o ? zE(e, t) : void 0;
  return go = !1, i;
}
function zE(e, t) {
  var n;
  const r = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (r.name && Ea(r.name, e.appContext.config), r.components) {
      const i = Object.keys(r.components);
      for (let a = 0; a < i.length; a++)
        Ea(i[a], e.appContext.config);
    }
    if (r.directives) {
      const i = Object.keys(r.directives);
      for (let a = 0; a < i.length; a++)
        xd(i[a]);
    }
    r.compilerOptions && PE() && H(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = td(new Proxy(e.ctx, kd)), process.env.NODE_ENV !== "production" && eE(e);
  const { setup: o } = r;
  if (o) {
    const i = e.setupContext = o.length > 1 ? Pd(e) : null;
    jr(e), wr();
    const a = $n(
      o,
      e,
      0,
      [process.env.NODE_ENV !== "production" ? eo(e.props) : e.props, i]
    );
    if (Er(), vr(), Va(a)) {
      if (a.then(vr, vr), t)
        return a.then((s) => {
          Kl(e, s, t);
        }).catch((s) => {
          hi(s, e, 0);
        });
      if (e.asyncDep = a, process.env.NODE_ENV !== "production" && !e.suspense) {
        const s = (n = r.name) != null ? n : "Anonymous";
        H(
          `Component <${s}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      Kl(e, a, t);
  } else
    zd(e, t);
}
function Kl(e, t, n) {
  Oe(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : Je(t) ? (process.env.NODE_ENV !== "production" && Ur(t) && H(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = od(t), process.env.NODE_ENV !== "production" && tE(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && H(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), zd(e, n);
}
let ka;
const PE = () => !ka;
function zd(e, t, n) {
  const r = e.type;
  if (!e.render) {
    if (!t && ka && !r.render) {
      const o = r.template || Qa(e).template;
      if (o) {
        process.env.NODE_ENV !== "production" && On(e, "compile");
        const { isCustomElement: i, compilerOptions: a } = e.appContext.config, { delimiters: s, compilerOptions: l } = r, d = pt(
          pt(
            {
              isCustomElement: i,
              delimiters: s
            },
            a
          ),
          l
        );
        r.render = ka(o, d), process.env.NODE_ENV !== "production" && Rn(e, "compile");
      }
    }
    e.render = r.render || Tt;
  }
  jr(e), wr(), iE(e), Er(), vr(), process.env.NODE_ENV !== "production" && !r.render && e.render === Tt && !t && (r.template ? H(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
    /* should not happen */
  ) : H("Component is missing template or render function."));
}
function Gl(e) {
  return e.attrsProxy || (e.attrsProxy = new Proxy(
    e.attrs,
    process.env.NODE_ENV !== "production" ? {
      get(t, n) {
        return ni(), At(e, "get", "$attrs"), t[n];
      },
      set() {
        return H("setupContext.attrs is readonly."), !1;
      },
      deleteProperty() {
        return H("setupContext.attrs is readonly."), !1;
      }
    } : {
      get(t, n) {
        return At(e, "get", "$attrs"), t[n];
      }
    }
  ));
}
function FE(e) {
  return e.slotsProxy || (e.slotsProxy = new Proxy(e.slots, {
    get(t, n) {
      return At(e, "get", "$slots"), t[n];
    }
  }));
}
function Pd(e) {
  const t = (n) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && H("expose() should be called only once per setup()."), n != null)) {
      let r = typeof n;
      r === "object" && (he(n) ? r = "array" : Et(n) && (r = "ref")), r !== "object" && H(
        `expose() should be passed a plain object, received ${r}.`
      );
    }
    e.exposed = n || {};
  };
  return process.env.NODE_ENV !== "production" ? Object.freeze({
    get attrs() {
      return Gl(e);
    },
    get slots() {
      return FE(e);
    },
    get emit() {
      return (n, ...r) => e.emit(n, ...r);
    },
    expose: t
  }) : {
    get attrs() {
      return Gl(e);
    },
    slots: e.slots,
    emit: e.emit,
    expose: t
  };
}
function yi(e) {
  if (e.exposed)
    return e.exposeProxy || (e.exposeProxy = new Proxy(od(td(e.exposed)), {
      get(t, n) {
        if (n in t)
          return t[n];
        if (n in mr)
          return mr[n](e);
      },
      has(t, n) {
        return n in t || n in mr;
      }
    }));
}
const LE = /(?:^|[-_])(\w)/g, ME = (e) => e.replace(LE, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function os(e, t = !0) {
  return Oe(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function xi(e, t, n = !1) {
  let r = os(t);
  if (!r && t.__file) {
    const o = t.__file.match(/([^/\\]+)\.\w+$/);
    o && (r = o[1]);
  }
  if (!r && e && e.parent) {
    const o = (i) => {
      for (const a in i)
        if (i[a] === t)
          return a;
    };
    r = o(
      e.components || e.parent.type.components
    ) || o(e.appContext.components);
  }
  return r ? ME(r) : n ? "App" : "Anonymous";
}
function Fd(e) {
  return Oe(e) && "__vccOpts" in e;
}
const Ld = (e, t) => lw(e, t, go);
function UE(e, t, n) {
  const r = arguments.length;
  return r === 2 ? Je(t) && !he(t) ? Ur(t) ? vt(e, null, [t]) : vt(e, t) : vt(e, null, t) : (r > 3 ? n = Array.prototype.slice.call(arguments, 2) : r === 3 && Ur(n) && (n = [n]), vt(e, t, n));
}
const jE = Symbol.for("v-scx"), BE = () => {
  {
    const e = Lr(jE);
    return e || process.env.NODE_ENV !== "production" && H(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function Yi(e) {
  return !!(e && e.__v_isShallow);
}
function WE() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#0b1bc9" }, n = { style: "color:#b62e24" }, r = { style: "color:#9d288c" }, o = {
    header(c) {
      return Je(c) ? c.__isVue ? ["div", e, "VueInstance"] : Et(c) ? [
        "div",
        {},
        ["span", e, p(c)],
        "<",
        s(c.value),
        ">"
      ] : pr(c) ? [
        "div",
        {},
        ["span", e, Yi(c) ? "ShallowReactive" : "Reactive"],
        "<",
        s(c),
        `>${Gn(c) ? " (readonly)" : ""}`
      ] : Gn(c) ? [
        "div",
        {},
        ["span", e, Yi(c) ? "ShallowReadonly" : "Readonly"],
        "<",
        s(c),
        ">"
      ] : null : null;
    },
    hasBody(c) {
      return c && c.__isVue;
    },
    body(c) {
      if (c && c.__isVue)
        return [
          "div",
          {},
          ...i(c.$)
        ];
    }
  };
  function i(c) {
    const b = [];
    c.type.props && c.props && b.push(a("props", Ie(c.props))), c.setupState !== nt && b.push(a("setup", c.setupState)), c.data !== nt && b.push(a("data", Ie(c.data)));
    const k = l(c, "computed");
    k && b.push(a("computed", k));
    const q = l(c, "inject");
    return q && b.push(a("injected", q)), b.push([
      "div",
      {},
      [
        "span",
        {
          style: r.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: c }]
    ]), b;
  }
  function a(c, b) {
    return b = pt({}, b), Object.keys(b).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        c
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(b).map((k) => [
          "div",
          {},
          ["span", r, k + ": "],
          s(b[k], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function s(c, b = !0) {
    return typeof c == "number" ? ["span", t, c] : typeof c == "string" ? ["span", n, JSON.stringify(c)] : typeof c == "boolean" ? ["span", r, c] : Je(c) ? ["object", { object: b ? Ie(c) : c }] : ["span", n, String(c)];
  }
  function l(c, b) {
    const k = c.type;
    if (Oe(k))
      return;
    const q = {};
    for (const C in c.ctx)
      d(k, C, b) && (q[C] = c.ctx[C]);
    return q;
  }
  function d(c, b, k) {
    const q = c[k];
    if (he(q) && q.includes(b) || Je(q) && b in q || c.extends && d(c.extends, b, k) || c.mixins && c.mixins.some((C) => d(C, b, k)))
      return !0;
  }
  function p(c) {
    return Yi(c) ? "ShallowRef" : c.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(o) : window.devtoolsFormatters = [o];
}
const Zl = "3.3.4", Bn = /* @__PURE__ */ new Map(), HE = "http://www.w3.org/2000/svg", sr = typeof document < "u" ? document : null, Ql = sr && /* @__PURE__ */ sr.createElement("template"), YE = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, r) => {
    const o = t ? sr.createElementNS(HE, e) : sr.createElement(e, n ? { is: n } : void 0);
    return e === "select" && r && r.multiple != null && o.setAttribute("multiple", r.multiple), o;
  },
  createText: (e) => sr.createTextNode(e),
  createComment: (e) => sr.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => sr.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, r, o, i) {
    const a = n ? n.previousSibling : t.lastChild;
    if (o && (o === i || o.nextSibling))
      for (; t.insertBefore(o.cloneNode(!0), n), !(o === i || !(o = o.nextSibling)); )
        ;
    else {
      Ql.innerHTML = r ? `<svg>${e}</svg>` : e;
      const s = Ql.content;
      if (r) {
        const l = s.firstChild;
        for (; l.firstChild; )
          s.appendChild(l.firstChild);
        s.removeChild(l);
      }
      t.insertBefore(s, n);
    }
    return [
      // first
      a ? a.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
};
function XE(e, t, n) {
  const r = e._vtc;
  r && (t = (t ? [t, ...r] : [...r]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
function JE(e, t, n) {
  const r = e.style, o = gt(n);
  if (n && !o) {
    if (t && !gt(t))
      for (const i in t)
        n[i] == null && Sa(r, i, "");
    for (const i in n)
      Sa(r, i, n[i]);
  } else {
    const i = r.display;
    o ? t !== n && (r.cssText = n) : t && e.removeAttribute("style"), "_vod" in e && (r.display = i);
  }
}
const KE = /[^\\];\s*$/, ec = /\s*!important$/;
function Sa(e, t, n) {
  if (he(n))
    n.forEach((r) => Sa(e, t, r));
  else if (n == null && (n = ""), process.env.NODE_ENV !== "production" && KE.test(n) && H(
    `Unexpected semicolon at the end of '${t}' style value: '${n}'`
  ), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const r = GE(e, t);
    ec.test(n) ? e.setProperty(
      Zt(r),
      n.replace(ec, ""),
      "important"
    ) : e[r] = n;
  }
}
const tc = ["Webkit", "Moz", "ms"], Xi = {};
function GE(e, t) {
  const n = Xi[t];
  if (n)
    return n;
  let r = en(t);
  if (r !== "filter" && r in e)
    return Xi[t] = r;
  r = gr(r);
  for (let o = 0; o < tc.length; o++) {
    const i = tc[o] + r;
    if (i in e)
      return Xi[t] = i;
  }
  return t;
}
const nc = "http://www.w3.org/1999/xlink";
function ZE(e, t, n, r, o) {
  if (r && t.startsWith("xlink:"))
    n == null ? e.removeAttributeNS(nc, t.slice(6, t.length)) : e.setAttributeNS(nc, t, n);
  else {
    const i = C0(t);
    n == null || i && !Lu(n) ? e.removeAttribute(t) : e.setAttribute(t, i ? "" : n);
  }
}
function QE(e, t, n, r, o, i, a) {
  if (t === "innerHTML" || t === "textContent") {
    r && a(r, o, i), e[t] = n ?? "";
    return;
  }
  const s = e.tagName;
  if (t === "value" && s !== "PROGRESS" && // custom elements may use _value internally
  !s.includes("-")) {
    e._value = n;
    const d = s === "OPTION" ? e.getAttribute("value") : e.value, p = n ?? "";
    d !== p && (e.value = p), n == null && e.removeAttribute(t);
    return;
  }
  let l = !1;
  if (n === "" || n == null) {
    const d = typeof e[t];
    d === "boolean" ? n = Lu(n) : n == null && d === "string" ? (n = "", l = !0) : d === "number" && (n = 0, l = !0);
  }
  try {
    e[t] = n;
  } catch (d) {
    process.env.NODE_ENV !== "production" && !l && H(
      `Failed setting prop "${t}" on <${s.toLowerCase()}>: value ${n} is invalid.`,
      d
    );
  }
  l && e.removeAttribute(t);
}
function An(e, t, n, r) {
  e.addEventListener(t, n, r);
}
function ek(e, t, n, r) {
  e.removeEventListener(t, n, r);
}
function tk(e, t, n, r, o = null) {
  const i = e._vei || (e._vei = {}), a = i[t];
  if (r && a)
    a.value = r;
  else {
    const [s, l] = nk(t);
    if (r) {
      const d = i[t] = ik(r, o);
      An(e, s, d, l);
    } else
      a && (ek(e, s, a, l), i[t] = void 0);
  }
}
const rc = /(?:Once|Passive|Capture)$/;
function nk(e) {
  let t;
  if (rc.test(e)) {
    t = {};
    let n;
    for (; n = e.match(rc); )
      e = e.slice(0, e.length - n[0].length), t[n[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : Zt(e.slice(2)), t];
}
let Ji = 0;
const rk = /* @__PURE__ */ Promise.resolve(), ok = () => Ji || (rk.then(() => Ji = 0), Ji = Date.now());
function ik(e, t) {
  const n = (r) => {
    if (!r._vts)
      r._vts = Date.now();
    else if (r._vts <= n.attached)
      return;
    hn(
      ak(r, n.value),
      t,
      5,
      [r]
    );
  };
  return n.value = e, n.attached = ok(), n;
}
function ak(e, t) {
  if (he(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map((r) => (o) => !o._stopped && r && r(o));
  } else
    return t;
}
const oc = /^on[a-z]/, sk = (e, t, n, r, o = !1, i, a, s, l) => {
  t === "class" ? XE(e, r, o) : t === "style" ? JE(e, n, r) : bo(t) ? Ko(t) || tk(e, t, n, r, a) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : lk(e, t, r, o)) ? QE(
    e,
    t,
    r,
    i,
    a,
    s,
    l
  ) : (t === "true-value" ? e._trueValue = r : t === "false-value" && (e._falseValue = r), ZE(e, t, r, o));
};
function lk(e, t, n, r) {
  return r ? !!(t === "innerHTML" || t === "textContent" || t in e && oc.test(t) && Oe(n)) : t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA" || oc.test(t) && gt(n) ? !1 : t in e;
}
function mn(e, t) {
  const n = Ut(e);
  class r extends is {
    constructor(i) {
      super(n, i, t);
    }
  }
  return r.def = n, r;
}
const ck = typeof HTMLElement < "u" ? HTMLElement : class {
};
class is extends ck {
  constructor(t, n = {}, r) {
    super(), this._childStylesAnchor = null, this._def = t, this._props = n, this._instance = null, this._connected = !1, this._resolved = !1, this._numberProps = null, this.shadowRoot && r ? r(this._createVNode(), this.shadowRoot) : (process.env.NODE_ENV !== "production" && this.shadowRoot && H(
      "Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use `defineSSRCustomElement`."
    ), this.attachShadow({ mode: "open" }), this._def.__asyncLoader || this._resolveProps(this._def));
  }
  connectedCallback() {
    this._connected = !0, this._instance || (this._resolved ? this._update() : this._resolveDef());
  }
  disconnectedCallback() {
    this._connected = !1, Ha(() => {
      this._connected || (cc(null, this.shadowRoot), this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    this._resolved = !0;
    for (let r = 0; r < this.attributes.length; r++)
      this._setAttr(this.attributes[r].name);
    new MutationObserver((r) => {
      for (const o of r)
        this._setAttr(o.attributeName);
    }).observe(this, { attributes: !0 });
    const t = (r, o = !1) => {
      const { props: i, styles: a } = r;
      let s;
      if (i && !he(i))
        for (const l in i) {
          const d = i[l];
          (d === Number || d && d.type === Number) && (l in this._props && (this._props[l] = Cl(this._props[l])), (s || (s = /* @__PURE__ */ Object.create(null)))[en(l)] = !0);
        }
      this._numberProps = s, o && this._resolveProps(r), this._applyStyles(a), this._update();
    }, n = this._def.__asyncLoader;
    n ? n().then((r) => t(r, !0)) : t(this._def);
  }
  _resolveProps(t) {
    const { props: n } = t, r = he(n) ? n : Object.keys(n || {});
    for (const o of Object.keys(this))
      o[0] !== "_" && r.includes(o) && this._setProp(o, this[o], !0, !1);
    for (const o of r.map(en))
      Object.defineProperty(this, o, {
        get() {
          return this._getProp(o);
        },
        set(i) {
          this._setProp(o, i);
        }
      });
  }
  _setAttr(t) {
    let n = this.getAttribute(t);
    const r = en(t);
    this._numberProps && this._numberProps[r] && (n = Cl(n)), this._setProp(r, n, !1);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, n, r = !0, o = !0) {
    n !== this._props[t] && (this._props[t] = n, o && this._instance && this._update(), r && (n === !0 ? this.setAttribute(Zt(t), "") : typeof n == "string" || typeof n == "number" ? this.setAttribute(Zt(t), n + "") : n || this.removeAttribute(Zt(t))));
  }
  _update() {
    cc(this._createVNode(), this.shadowRoot);
  }
  _createVNode() {
    const t = vt(this._def, pt({}, this._props));
    return this._instance || (t.ce = (n) => {
      this._instance = n, n.addCEChildStyle = this._addChildStyles.bind(this), n.removeCEChildStyle = this._removeChildStyles.bind(this), n.isCE = !0, process.env.NODE_ENV !== "production" && (n.ceReload = (i) => {
        this._styles && (this._styles.forEach((a) => this.shadowRoot.removeChild(a)), this._styles.length = 0), this._applyStyles(i), this._instance = null, this._update();
      });
      const r = (i, a) => {
        this.dispatchEvent(
          new CustomEvent(i, {
            detail: a
          })
        );
      };
      n.emit = (i, ...a) => {
        r(i, a), Zt(i) !== i && r(Zt(i), a);
      };
      let o = this;
      for (; o = o && (o.parentNode || o.host); )
        if (o instanceof is) {
          n.parent = o._instance, n.provides = o._instance.provides;
          break;
        }
    }), t;
  }
  _applyStyles(t) {
    t && t.forEach((n) => {
      const r = document.createElement("style");
      r.textContent = n, this.shadowRoot.appendChild(r), this._childStylesAnchor = r, process.env.NODE_ENV !== "production" && (this._styles || (this._styles = [])).push(r);
    });
  }
  _addChildStyles(t, n) {
    if (t) {
      const r = t.join(), o = `__${this._instance.uid}`;
      let i = /* @__PURE__ */ new Set();
      if (Bn.has(r) && (i = Bn.get(r), i.has(o))) {
        i.add(o), Bn.set(r, i);
        return;
      }
      i.add(o), Bn.set(r, i);
      const a = `data-v-ce-${n.uid}`;
      t.forEach((s, l) => {
        const d = document.createElement("style");
        d.textContent = s, d.setAttribute(a, ""), this._childStylesAnchor ? this.shadowRoot.insertBefore(
          d,
          this._childStylesAnchor.nextSibling
        ) : this.shadowRoot.appendChild(d), this._childStylesAnchor = d, (this._styles || (this._styles = [])).push(d);
      });
    }
  }
  _removeChildStyles(t, n) {
    if (t) {
      const r = t.join();
      let o = /* @__PURE__ */ new Set();
      if (Bn.has(r)) {
        const i = `__${this._instance.uid}`;
        if (o = Bn.get(r), o.delete(i), o.size === 0) {
          const a = this.shadowRoot.querySelectorAll(`[data-v-ce-${n}]`);
          a.length > 0 && a.forEach((l) => this.shadowRoot.removeChild(l));
          const s = this.shadowRoot.querySelectorAll("style");
          this._childStylesAnchor = s.length > 0 ? s[s.length - 1] : void 0, Bn.delete(r);
        } else
          Bn.set(r, o);
      }
    }
  }
}
const er = (e) => {
  const t = e.props["onUpdate:modelValue"] || !1;
  return he(t) ? (n) => $r(t, n) : t;
};
function uk(e) {
  e.target.composing = !0;
}
function ic(e) {
  const t = e.target;
  t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
const Ca = {
  created(e, { modifiers: { lazy: t, trim: n, number: r } }, o) {
    e._assign = er(o);
    const i = r || o.props && o.props.type === "number";
    An(e, t ? "change" : "input", (a) => {
      if (a.target.composing)
        return;
      let s = e.value;
      n && (s = s.trim()), i && (s = Zo(s)), e._assign(s);
    }), n && An(e, "change", () => {
      e.value = e.value.trim();
    }), t || (An(e, "compositionstart", uk), An(e, "compositionend", ic), An(e, "change", ic));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(e, { value: t }) {
    e.value = t ?? "";
  },
  beforeUpdate(e, { value: t, modifiers: { lazy: n, trim: r, number: o } }, i) {
    if (e._assign = er(i), e.composing || document.activeElement === e && e.type !== "range" && (n || r && e.value.trim() === t || (o || e.type === "number") && Zo(e.value) === t))
      return;
    const a = t ?? "";
    e.value !== a && (e.value = a);
  }
}, Md = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(e, t, n) {
    e._assign = er(n), An(e, "change", () => {
      const r = e._modelValue, o = Br(e), i = e.checked, a = e._assign;
      if (he(r)) {
        const s = Fa(r, o), l = s !== -1;
        if (i && !l)
          a(r.concat(o));
        else if (!i && l) {
          const d = [...r];
          d.splice(s, 1), a(d);
        }
      } else if (Hr(r)) {
        const s = new Set(r);
        i ? s.add(o) : s.delete(o), a(s);
      } else
        a(jd(e, i));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: ac,
  beforeUpdate(e, t, n) {
    e._assign = er(n), ac(e, t, n);
  }
};
function ac(e, { value: t, oldValue: n }, r) {
  e._modelValue = t, he(t) ? e.checked = Fa(t, r.props.value) > -1 : Hr(t) ? e.checked = t.has(r.props.value) : t !== n && (e.checked = br(t, jd(e, !0)));
}
const Ud = {
  created(e, { value: t }, n) {
    e.checked = br(t, n.props.value), e._assign = er(n), An(e, "change", () => {
      e._assign(Br(e));
    });
  },
  beforeUpdate(e, { value: t, oldValue: n }, r) {
    e._assign = er(r), t !== n && (e.checked = br(t, r.props.value));
  }
}, dk = {
  // <select multiple> value need to be deep traversed
  deep: !0,
  created(e, { value: t, modifiers: { number: n } }, r) {
    const o = Hr(t);
    An(e, "change", () => {
      const i = Array.prototype.filter.call(e.options, (a) => a.selected).map(
        (a) => n ? Zo(Br(a)) : Br(a)
      );
      e._assign(
        e.multiple ? o ? new Set(i) : i : i[0]
      );
    }), e._assign = er(r);
  },
  // set value in mounted & updated because <select> relies on its children
  // <option>s.
  mounted(e, { value: t }) {
    sc(e, t);
  },
  beforeUpdate(e, t, n) {
    e._assign = er(n);
  },
  updated(e, { value: t }) {
    sc(e, t);
  }
};
function sc(e, t) {
  const n = e.multiple;
  if (n && !he(t) && !Hr(t)) {
    process.env.NODE_ENV !== "production" && H(
      `<select multiple v-model> expects an Array or Set value for its binding, but got ${Object.prototype.toString.call(t).slice(8, -1)}.`
    );
    return;
  }
  for (let r = 0, o = e.options.length; r < o; r++) {
    const i = e.options[r], a = Br(i);
    if (n)
      he(t) ? i.selected = Fa(t, a) > -1 : i.selected = t.has(a);
    else if (br(Br(i), t)) {
      e.selectedIndex !== r && (e.selectedIndex = r);
      return;
    }
  }
  !n && e.selectedIndex !== -1 && (e.selectedIndex = -1);
}
function Br(e) {
  return "_value" in e ? e._value : e.value;
}
function jd(e, t) {
  const n = t ? "_trueValue" : "_falseValue";
  return n in e ? e[n] : t;
}
const pk = {
  created(e, t, n) {
    Lo(e, t, n, null, "created");
  },
  mounted(e, t, n) {
    Lo(e, t, n, null, "mounted");
  },
  beforeUpdate(e, t, n, r) {
    Lo(e, t, n, r, "beforeUpdate");
  },
  updated(e, t, n, r) {
    Lo(e, t, n, r, "updated");
  }
};
function fk(e, t) {
  switch (e) {
    case "SELECT":
      return dk;
    case "TEXTAREA":
      return Ca;
    default:
      switch (t) {
        case "checkbox":
          return Md;
        case "radio":
          return Ud;
        default:
          return Ca;
      }
  }
}
function Lo(e, t, n, r, o) {
  const i = fk(
    e.tagName,
    n.props && n.props.type
  )[o];
  i && i(e, t, n, r);
}
const si = {
  beforeMount(e, { value: t }, { transition: n }) {
    e._vod = e.style.display === "none" ? "" : e.style.display, n && t ? n.beforeEnter(e) : Kr(e, t);
  },
  mounted(e, { value: t }, { transition: n }) {
    n && t && n.enter(e);
  },
  updated(e, { value: t, oldValue: n }, { transition: r }) {
    !t != !n && (r ? t ? (r.beforeEnter(e), Kr(e, !0), r.enter(e)) : r.leave(e, () => {
      Kr(e, !1);
    }) : Kr(e, t));
  },
  beforeUnmount(e, { value: t }) {
    Kr(e, t);
  }
};
function Kr(e, t) {
  e.style.display = t ? e._vod : "none";
}
const hk = /* @__PURE__ */ pt({ patchProp: sk }, YE);
let lc;
function mk() {
  return lc || (lc = CE(hk));
}
const cc = (...e) => {
  mk().render(...e);
};
function vk() {
  WE();
}
process.env.NODE_ENV !== "production" && vk();
const gk = ["type", "disabled"], bk = /* @__PURE__ */ Ut({
  name: "Btn",
  __name: "Btn",
  props: {
    isDisabled: { type: Boolean },
    isMultiClickable: { type: Boolean, default: !1 },
    type: { default: "button" }
  },
  emits: ["click", "focus", "blur"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = Xe(null), i = Xe(0), a = () => {
      var p;
      (p = o.value) == null || p.focus();
    }, s = (p) => {
      var c;
      !r.isMultiClickable && i.value > 0 || (n("click", p), p.target instanceof HTMLElement && ((c = p == null ? void 0 : p.target) == null || c.blur()), i.value++);
    }, l = (p) => {
      n("focus", p);
    }, d = (p) => {
      n("blur", p);
    };
    return t({ doFocus: a }), (p, c) => (ue(), $e("button", {
      part: "base",
      ref_key: "el",
      ref: o,
      class: "iui-component iui-btn",
      type: p.type,
      disabled: p.isDisabled || !p.isMultiClickable && i.value > 0,
      onClick: s,
      onFocus: l,
      onBlur: d
    }, [
      It(p.$slots, "default", {}, () => [
        mt("Submit")
      ], !0)
    ], 40, gk));
  }
}), yk = `button[data-v-8122ae3a]{white-space:nowrap}.primary[data-v-8122ae3a]{min-width:var(--col-1-12);margin-right:var(--iui-horizontal-margin)}button[data-v-8122ae3a]{font-size:var(--iui-font-size-default);font-weight:var(--iui-font-weight-semi-bold);border:var(--iui-border-default);border-radius:var(--iui-border-radius-default);line-height:calc(var(--iui-line-height-large) - (var(--iui-border-width-default) * 2));padding:0 var(--iui-horizontal-padding);cursor:pointer;-webkit-user-select:none;user-select:none;text-align:center;background-color:#fff}button[data-v-8122ae3a]:focus{outline:none;border-color:var(--bleakest-gray)}button[data-v-8122ae3a]:active,button[data-v-8122ae3a]:hover{border-color:var(--coal-black)}button[data-v-8122ae3a]:disabled{color:var(--bleakest-gray);background-color:var(--flash-gray);border-color:var(--flash-gray);cursor:default}button.primary[data-v-8122ae3a]{background-color:var(--strata-blue);border:1px solid var(--strata-blue);color:#fff}button.primary[data-v-8122ae3a]:disabled{color:var(--bleakest-gray);background-color:var(--flash-gray);border-color:var(--flash-gray);box-shadow:none!important;cursor:default}button.secondary[data-v-8122ae3a],button.tertiary[data-v-8122ae3a]:hover,button.tertiary[data-v-8122ae3a]:focus{background-color:var(--flash-gray);color:var(--coal-black);border:1px solid var(--flash-gray)}button.secondary[data-v-8122ae3a]:disabled{color:var(--bleakest-gray);cursor:default;box-shadow:none!important}button.primary[data-v-8122ae3a]:hover,button.primary[data-v-8122ae3a]:focus,button.secondary[data-v-8122ae3a]:hover,button.secondary[data-v-8122ae3a]:focus{box-shadow:var(--iui-box-shadow-default)}button.tertiary[data-v-8122ae3a]{background-color:transparent;color:var(--coal-black);border:1px solid transparent}button.tertiary[data-v-8122ae3a]:disabled{color:var(--bleakest-gray);cursor:default;background-color:transparent;text-decoration:none;box-shadow:none;border-color:transparent}button.textlink[data-v-8122ae3a]{border:none;color:var(--strata-blue);display:inline-block;font-weight:500}button.textlink[data-v-8122ae3a]:hover{text-decoration:underline}button.textlink[data-v-8122ae3a]:disabled{color:var(--bleakest-gray);cursor:default}
`, Nt = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, Xo = /* @__PURE__ */ Nt(bk, [["styles", [yk]], ["__scopeId", "data-v-8122ae3a"]]), xk = ["name", "value", "disabled", "min", "max"], wk = {
  name: "HiddenInput"
}, Bd = /* @__PURE__ */ Ut({
  ...wk,
  props: {
    modelValue: {},
    fieldName: {},
    isReadOnly: { type: Boolean },
    isDisabled: { type: Boolean },
    min: {},
    max: {},
    ariaLabel: {},
    autocomplete: {}
  },
  setup(e) {
    return (t, n) => (ue(), $e("input", {
      type: "hidden",
      name: t.fieldName,
      value: t.modelValue,
      disabled: t.isDisabled,
      min: t.min,
      max: t.max
    }, null, 8, xk));
  }
});
let Wd = "";
function hq(e) {
  Wd = e;
}
function Ek(e = "") {
  return Wd.replace(/\/$/, "") + (e ? `/${e.replace(/^\//, "")}` : "");
}
const Gr = {};
function kk(e) {
  return Object.keys(e).reduce((t, n) => (e[n] !== !1 && e[n] !== null && e[n] !== void 0 && (t[n] = e[n]), t), {});
}
const Sk = {
  name: "InlineSvg",
  inheritAttrs: !1,
  render() {
    return this.svgElSource ? UE(
      "svg",
      Object.assign(
        {},
        // source attrs
        this.getSvgAttrs(this.svgElSource),
        // component attrs and listeners
        kk(this.$attrs),
        // content
        { innerHTML: this.getSvgContent(this.svgElSource) }
      )
    ) : null;
  },
  props: {
    src: {
      type: String,
      required: !0
    },
    title: {
      type: String
    },
    transformSource: {
      type: Function,
      default: (e) => e
    },
    keepDuringLoading: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["loaded", "unloaded", "error"],
  data() {
    return {
      /** @type SVGElement */
      svgElSource: null
    };
  },
  watch: {
    src(e) {
      this.getSource(e);
    }
  },
  mounted() {
    this.getSource(this.src);
  },
  methods: {
    getSvgAttrs(e) {
      let t = {};
      const n = e.attributes;
      if (!n)
        return t;
      for (let r = n.length - 1; r >= 0; r--)
        t[n[r].name] = n[r].value;
      return t;
    },
    getSvgContent(e) {
      return e = e.cloneNode(!0), e = this.transformSource(e), this.title && Ck(e, this.title), e.innerHTML;
    },
    /**
     * Get svgElSource
     * @param {string} src
     */
    getSource(e) {
      Gr[e] || (Gr[e] = this.download(e)), this.svgElSource && Gr[e].getIsPending() && !this.keepDuringLoading && (this.svgElSource = null, this.$emit("unloaded")), Gr[e].then((t) => {
        this.svgElSource = t, this.$nextTick(() => {
          this.$emit("loaded", this.$el);
        });
      }).catch((t) => {
        this.svgElSource && (this.svgElSource = null, this.$emit("unloaded")), delete Gr[e], this.$emit("error", t);
      });
    },
    /**
     * Get the contents of the SVG
     * @param {string} url
     * @returns {PromiseWithState<Element>}
     */
    download(e) {
      return qk(new Promise((t, n) => {
        const r = new XMLHttpRequest();
        r.open("GET", e, !0), r.onload = () => {
          if (r.status >= 200 && r.status < 400)
            try {
              let o = new DOMParser().parseFromString(r.responseText, "text/xml").getElementsByTagName("svg")[0];
              o ? t(o) : n(new Error('Loaded file is not valid SVG"'));
            } catch (o) {
              n(o);
            }
          else
            n(new Error("Error loading SVG"));
        }, r.onerror = n, r.send();
      }));
    }
  }
};
function Ck(e, t) {
  const n = e.getElementsByTagName("title");
  if (n.length)
    n[0].textContent = t;
  else {
    const r = document.createElementNS("http://www.w3.org/2000/svg", "title");
    r.textContent = t, e.insertBefore(r, e.firstChild);
  }
}
function qk(e) {
  if (e.getIsPending)
    return e;
  let t = !0, n = e.then(
    (r) => (t = !1, r),
    (r) => {
      throw t = !1, r;
    }
  );
  return n.getIsPending = function() {
    return t;
  }, n;
}
const _k = /* @__PURE__ */ Ut({
  name: "Icon",
  __name: "Icon",
  props: {
    title: { default: "" },
    name: { default: "" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = (o) => {
      t("click", o);
    }, r = (o) => Ek(o);
    return (o, i) => (ue(), bt(fo(Sk), {
      class: qt(["iui-icon", o.name]),
      src: r("/icons/" + o.name + ".svg"),
      title: o.title || "",
      part: "icon-base",
      onClick: n
    }, null, 8, ["class", "src", "title"]));
  }
}), Dk = `svg.iui-icon[data-v-abdecaa2]{display:inline-block;vertical-align:middle;width:var(--iui-icon-default);height:var(--iui-icon-default)}
`, Cn = /* @__PURE__ */ Nt(_k, [["styles", [Dk]], ["__scopeId", "data-v-abdecaa2"]]), Ok = ["role", "aria-checked", "aria-label"], Rk = ["tabindex"], Tk = ["name", "disabled", "readonly", "value", "true-value", "false-value"], Ak = { role: "presentation" }, $k = /* @__PURE__ */ Ut({
  name: "Checkbox",
  __name: "Checkbox",
  props: {
    isToggleDisplay: { type: Boolean, default: !1 },
    isSubmitUnchecked: { type: Boolean, default: !1 },
    valueAttribute: { type: [String, Number, Boolean], default: !0 },
    falseValue: { type: [String, Number, Boolean], default: !1 },
    fieldName: {},
    isReadOnly: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 },
    min: {},
    max: {},
    ariaLabel: {},
    autocomplete: {},
    modelValue: {}
  },
  emits: ["input", "focus", "update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = Xe(r.modelValue || r.falseValue), i = Xe(), a = Xe(), s = () => {
      var c;
      !r.isDisabled && !r.isReadOnly && ((c = i.value) == null || c.click());
    }, l = () => {
      n("update:modelValue", o.value);
    }, d = (c) => {
      var b;
      !r.isDisabled && !r.isReadOnly && (s(), (b = a.value) == null || b.focus(), n("focus", c));
    }, p = (c) => {
      c.keyCode === 32 && s();
    };
    return ht(() => r.isDisabled, (c) => {
      c && o.value && n("update:modelValue", !1);
    }), ht(() => r.modelValue, (c) => {
      !r.isDisabled && c !== void 0 && (o.value = c);
    }), t({ doFocus: d }), (c, b) => (ue(), $e("span", {
      class: "iui-component iui-checkbox",
      role: c.isToggleDisplay ? "switch" : "checkbox",
      "aria-checked": c.modelValue ? "true" : "false",
      "aria-label": c.ariaLabel
    }, [
      et("span", {
        ref: "toggler",
        class: qt([{ switch: c.isToggleDisplay, check: !c.isToggleDisplay, disabled: c.isDisabled, readOnly: c.isReadOnly, checked: c.modelValue }, "toggler"]),
        tabindex: c.isDisabled || c.isReadOnly ? -1 : 0,
        role: "presentation",
        onClick: s,
        onKeydown: p
      }, [
        Zn(et("input", {
          ref_key: "checkboxEl",
          ref: i,
          "onUpdate:modelValue": b[0] || (b[0] = (k) => o.value = k),
          onChange: l,
          name: c.isSubmitUnchecked ? void 0 : c.fieldName,
          type: "checkbox",
          disabled: c.isDisabled,
          readonly: c.isReadOnly,
          value: c.isSubmitUnchecked ? null : c.valueAttribute,
          "true-value": c.valueAttribute,
          "false-value": c.falseValue
        }, null, 40, Tk), [
          [Md, o.value]
        ]),
        et("span", Ak, [
          c.isToggleDisplay ? ze("", !0) : (ue(), bt(Cn, {
            key: 0,
            name: "check"
          }))
        ])
      ], 42, Rk),
      c.isSubmitUnchecked && !c.modelValue && c.fieldName ? (ue(), bt(Bd, {
        key: 0,
        "is-disabled": c.isDisabled,
        "field-name": c.fieldName,
        value: c.modelValue
      }, null, 8, ["is-disabled", "field-name", "value"])) : ze("", !0)
    ], 8, Ok));
  }
}), Ik = `span.iui-checkbox{-webkit-user-select:none;user-select:none}span.iui-checkbox :focus{outline:none}span.iui-checkbox .toggler{display:inline-block;position:relative}span.iui-checkbox input{display:none}span.iui-checkbox .switch{width:46px;height:22px;border-radius:100px;border:1px solid var(--bleakest-gray);vertical-align:middle}span.iui-checkbox .switch.checked,span.iui-checkbox .switch:hover{border-color:var(--coal-black)}span.iui-checkbox .switch span{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#fff;transition:.1s;transition-timing-function:ease;border-radius:100px}span.iui-checkbox .switch span:before{position:absolute;content:"";height:12px;width:12px;background-color:var(--coal-black);transition:.2s;transition-timing-function:ease;border-radius:100px;left:4px;top:5px}span.iui-checkbox .switch input{background-color:#fff}span.iui-checkbox .switch input:checked+span{background-color:var(--coal-black)}span.iui-checkbox .switch input:checked+span:before{background-color:#fff;transform:translate(26px)}span.iui-checkbox .switch input:checked+span:hover{box-shadow:var(--iui-box-shadow-default)}span.iui-checkbox .switch:focus{border-color:var(--coal-black)}span.iui-checkbox .switch:focus input:checked+span{box-shadow:var(--iui-box-shadow-default)}span.iui-checkbox .switch.disabled,span.iui-checkbox .switch.readOnly,span.iui-checkbox .switch.disabled:hover,span.iui-checkbox .switch.readOnly:hover{border-color:var(--serenity-gray)}span.iui-checkbox .switch.disabled span,span.iui-checkbox .switch.readOnly span{cursor:default}span.iui-checkbox .switch.disabled span:before,span.iui-checkbox .switch.readOnly span:before{background-color:var(--serenity-gray)}span.iui-checkbox .switch.disabled input:checked+span,span.iui-checkbox .switch.readOnly input:checked+span{background-color:var(--serenity-gray)}span.iui-checkbox .switch.disabled input:checked+span:hover,span.iui-checkbox .switch.readOnly input:checked+span:hover{box-shadow:none}span.iui-checkbox .switch.disabled:focus,span.iui-checkbox .switch.readOnly:focus{border-color:var(--serenity-gray)}span.iui-checkbox .switch.disabled:focus input:checked+span,span.iui-checkbox .switch.readOnly:focus input:checked+span{box-shadow:none}span.iui-checkbox .check:focus span{border-color:var(--coal-black)}span.iui-checkbox .check span{width:14px;height:14px;border:var(--iui-border-default);cursor:pointer;display:inline-block;vertical-align:middle;position:relative;border-radius:var(--iui-border-radius-small)}span.iui-checkbox .check span:hover{border-color:var(--coal-black)}span.iui-checkbox .check span svg{display:none;position:absolute;top:2px;left:2px}span.iui-checkbox .check input:checked+span{background:var(--coal-black);border-color:var(--coal-black);color:#fff}span.iui-checkbox .check input:checked+span svg{display:inline}span.iui-checkbox .check input:checked+span:hover{box-shadow:var(--iui-box-shadow-default)}span.iui-checkbox .check.disabled span,span.iui-checkbox .check.readOnly span{cursor:default;background:var(--pale-gray);border-color:var(--serenity-gray)}span.iui-checkbox .check.disabled span:hover,span.iui-checkbox .check.readOnly span:hover{border-color:var(--serenity-gray)}span.iui-checkbox .check.disabled input:checked+span,span.iui-checkbox .check.readOnly input:checked+span{background:var(--pale-gray);border-color:var(--serenity-gray);color:var(--bleakest-gray)}span.iui-checkbox .check.disabled input:checked+span:hover,span.iui-checkbox .check.readOnly input:checked+span:hover{box-shadow:none}span.iui-checkbox .check.disabled:focus span,span.iui-checkbox .check.readOnly:focus span{border-color:var(--serenity-gray)}span.iui-checkbox .check.disabled:focus input:checked+span,span.iui-checkbox .check.readOnly:focus input:checked+span{box-shadow:none}
`, Nk = /* @__PURE__ */ Nt($k, [["styles", [Ik]]]), uc = (e, t) => {
  if (!e || !t)
    return !1;
  for (var n = t.parentNode; n != null; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}, Vk = function(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}, zk = {
  props: {
    refs: Object,
    isOpen: Boolean,
    anchor: {
      validator(e) {
        return typeof e == "string" || e instanceof HTMLElement || e && e.$el;
      },
      required: !0
    },
    // which corner of the anchor the popper is attached to
    position: {
      type: String,
      default: "bottomLeft",
      validator(e) {
        return ["bottomLeft", "bottomRight", "topLeft", "topRight", "middleLeft", "middleRight", "topCenter", "bottomCenter"].indexOf(e) > -1;
      }
    },
    // which direction to expand the popper, e.g. leftDown would make it appear on the left side of the anchor going downwards
    direction: {
      type: String,
      default: "rightDown",
      validator(e) {
        return ["rightDown", "leftDown", "centerDown", "rightUp", "leftUp", "centerUp"].indexOf(e) > -1;
      }
    },
    width: Number,
    height: Number,
    zIndexOverride: Number,
    // a manual extra x-axis offset specified by developer
    offsetX: {
      type: Number,
      default: 0
    },
    // a manual extra y-axis offset specified by developer
    offsetY: {
      type: Number,
      default: 0
    },
    // the parent may want to dictate what's focused (see AutoCompleteInput.vue)
    ignoreFocus: Boolean,
    // prevent refocusing the component if anchor clicked
    stopRefocus: Boolean,
    // handle focusing manually
    doRefocus: Function,
    // optional param that defines a scroll container
    scrollElementSelector: String,
    atLeastAnchorWidth: Boolean,
    clickableWhitelist: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      anchorEl: null,
      show: !1,
      top: 0,
      left: 0,
      outOfBounds: { top: 0, right: 0, bottom: 0, left: 0 },
      internalWidth: 0,
      internalHeight: 0,
      internalPosition: this.position,
      internalDirection: this.direction,
      lastCoords: null,
      hasPositioned: !1,
      positionMap: null,
      zIndex: 1
    };
  },
  computed: {
    transform() {
      var e = "";
      switch (this.internalDirection) {
        case "leftDown":
          e = "translate(-100%, 0)";
          break;
        case "rightDown":
          break;
        case "centerDown":
          e = "translate(-50%, 0)";
          break;
        case "leftUp":
          e = "translate(-100%, -100%)";
          break;
        case "rightUp":
          e = "translate(0, -100%)";
          break;
        case "centerUp":
          e = "translate(-50%, -100%)";
          break;
      }
      return e;
    },
    parentData() {
      let e;
      if (this.scrollElementSelector && (e = document.querySelector(this.scrollElementSelector)), !this.anchorEl)
        return {
          zIndex: this.zIndexOverride || 1
        };
      let t = this.anchorEl.parentNode, n = 1, r = "", o = "scroll";
      for (; t.style && t.style.overflow !== o && t.style.overflowY !== o && t.style.overflowX !== o; )
        r = parseInt(window.getComputedStyle(t).getPropertyValue("z-index")) || -1, n = r > n ? r : n, t = t.parentNode;
      return e = t, {
        scrollContainer: e,
        zIndex: this.zIndexOverride || n + 1
      };
    },
    isOutOfBounds() {
      return Object.entries(this.outOfBounds).filter((e) => e[1] < 0).length > 0;
    }
  },
  beforeMount() {
    let e = this.refs || this.$parent.$refs, t = this.anchor, n = typeof t == "string" ? e[t] : t;
    this.anchorEl = (n == null ? void 0 : n.$el) || n, this.anchorEl = Array.isArray(this.anchorEl) ? this.anchorEl[0] : this.anchorEl, (!this.anchorEl || !(this.anchorEl instanceof HTMLElement)) && console.warn("Invalid anchor for poppable element.", this.$options.propsData.anchor);
  },
  methods: {
    close() {
      this.show = !1;
    },
    initialize() {
      this.prepPopper(), this.createPositionMap(), this.showPopper();
    },
    blur(e) {
      this.ignoreFocus || (e.relatedTarget !== this.anchorEl && e.relatedTarget !== this.$el && !uc(this.$el, e.relatedTarget) && !uc(this.anchorEl, e.relatedTarget) && !this.clickableWhitelist.includes(e.relatedTarget) ? this.close() : (!this.stopRefocus && !this.doRefocus && this.$el.focus(), typeof this.doRefocus == "function" && this.doRefocus(e, this.$el)));
    },
    prepPopper() {
      this.$el.style && (this.$el.style.display = "block", this.$el.style.left = "-9000px", this.$el.style.top = "-9000px", this.$el.style.position = "fixed", this.maxWidth ? this.$el.style.maxWidth = this.maxWidth + "px" : this.$el.style.whiteSpace = "nowrap", this.width ? this.$el.style.width = this.width + "px" : this.atLeastAnchorWidth && (this.$el.style.minWidth = this.anchorEl.offsetWidth + "px"), this.setSize(), this.$el.style.whiteSpace = "unset");
    },
    setSize() {
      this.internalHeight = this.$el.scrollHeight, this.internalWidth = this.$el.scrollWidth;
    },
    testOutOfBounds() {
      const e = this.$el.getBoundingClientRect(), t = this.direction.includes("Up") ? Math.min(e.top, 0) : 0, n = this.direction.includes("right") || this.direction.includes("center") ? Math.min((window.innerWidth || document.documentElement.clientWidth) - e.right, 0) : 0, r = this.direction.includes("Down") ? Math.min((window.innerHeight || document.documentElement.clientHeight) - e.bottom, 0) : 0, o = this.direction.includes("left") || this.direction.includes("center") ? Math.min(e.left, 0) : 0;
      this.$el.style.display = "unset", this.outOfBounds = {
        top: t,
        right: n,
        bottom: r,
        left: o
      };
    },
    showPopper() {
      this.setCoords(), this.hasPositioned || this.$nextTick(() => {
        this.testOutOfBounds(), this.hasPositioned = !0;
      });
    },
    setCoords() {
      const e = this.positionMap[this.internalPosition];
      this.top = e.y, this.left = e.x, this.$el.style && (this.$el.style.left = e.x + "px", this.$el.style.top = e.y + "px");
    },
    setDirection(e) {
      const t = "right", n = "left", r = "center", o = "Up", i = "Down", a = "Middle";
      let s;
      e.left < 0 ? s = t : e.right < 0 ? s = n : s = this.direction.includes(r) ? r : this.direction.includes(n) ? n : t, e.top < 0 ? s += i : e.bottom < 0 ? s += o : s += this.direction.includes(a) ? a : this.direction.includes(o) ? o : i, this.internalDirection = s;
    },
    setPosition(e) {
      let t;
      if (e.top < 0 ? t = "bottom" : e.bottom < 0 ? t = "top" : t = this.position.includes("top") > 0 ? "top" : "bottom", e.left < 0)
        t = t + "Right";
      else if (e.right < 0)
        t = t + "Left";
      else {
        let n = this.position.includes("Right") ? "Right" : this.position.includes("Left") ? "Left" : "Center";
        t = t + n;
      }
      this.internalPosition = t;
    },
    createPositionMap() {
      if (this.hasPositioned)
        return;
      let e = this.anchorEl.getBoundingClientRect(), t = e.top + this.offsetY, n = e.bottom + this.offsetY, r = t + e.height / 2 + this.offsetY, o = e.left + this.offsetX, i = e.right + this.offsetX, a = o + e.width / 2 + this.offsetX, s = {
        topLeft: {
          x: o,
          y: t
        },
        topCenter: {
          x: a,
          y: t
        },
        topRight: {
          x: i,
          y: t
        },
        middleRight: {
          x: i,
          y: r
        },
        bottomRight: {
          x: i,
          y: n
        },
        bottomCenter: {
          x: a,
          y: n
        },
        bottomLeft: {
          x: o,
          y: n
        },
        middleLeft: {
          x: o,
          y: r
        }
      };
      this.positionMap = s;
    }
  },
  mounted() {
    window.document.body.appendChild(this.$el), this.prepPopper(), this.parentData.scrollContainer.addEventListener("scroll", this.close.bind(this));
  },
  beforeDestroy() {
    this.parentData.scrollContainer.removeEventListener("scroll", this.close.bind(this)), this.$el.remove();
  },
  updated() {
    this.setSize();
  },
  watch: {
    parentData(e) {
      this.zIndex = this.parentData.zIndex;
    },
    isOpen(e) {
      this.show = e, e && (this.ignoreFocus || this.$nextTick(() => {
        this.$el.focus();
      }));
    },
    show(e) {
      e ? (this.createPositionMap(), this.showPopper()) : (this.$el.style.left = "-9000px", this.$el.style.top = "-9000px", this.hasPositioned = !1), this.$emit(e ? "open" : "close");
    },
    outOfBounds: {
      deep: !0,
      handler(e) {
        if (!this.isOutOfBounds) {
          this.internalPosition = this.position;
          return;
        }
        this.setDirection(e), this.setPosition(e), this.setCoords();
      }
    },
    positionMap: {
      deep: !0,
      handler() {
        this.lastCoords = this.positionMap[this.internalPosition];
      }
    }
  }
}, Pk = `div.iui-tooltip{position:absolute;font-size:13px;z-index:var(--iui-z-index-modal);max-width:350px;padding-bottom:7px}div.iui-tooltip:focus{outline:none}div.iui-tooltip .text-container{font-size:13px;background-color:var(--coal-black);color:#fff;text-align:left;padding:var(--iui-vertical-padding) 15px;border-radius:var(--iui-border-radius-default)}div.iui-tooltip .text-container:after{content:"";position:absolute;border:7px solid;margin-left:-3px;margin-top:-7px}div.iui-tooltip .text-container.centerUp:after{top:100%;left:50%;border-color:var(--coal-black) transparent transparent transparent}div.iui-tooltip .text-container.centerDown:after{top:-7px;left:50%;border-color:transparent transparent var(--coal-black) transparent}div.iui-tooltip .text-container.rightDown:after{top:-7px;left:15px;border-color:transparent transparent var(--coal-black) transparent}div.iui-tooltip .text-container.leftDown:after{top:-7px;right:15px;border-color:transparent transparent var(--coal-black) transparent}div.iui-tooltip .text-container.rightUp:after{top:100%;left:15px;border-color:var(--coal-black) transparent transparent transparent}div.iui-tooltip .text-container.leftUp:after{top:100%;right:15px;border-color:var(--coal-black) transparent transparent transparent}
`, Fk = {
  name: "Tooltip",
  mixins: [zk],
  props: {
    // overriding Poppable's prop with different default and limiting options (arrow breaks on other options currently)
    position: {
      type: String,
      default: "topCenter",
      validator(e) {
        return ["topCenter"].indexOf(e) > -1;
      }
    },
    maxWidth: {
      type: String,
      default: "300px"
    },
    direction: {
      type: String,
      default: "centerUp",
      validator(e) {
        return ["centerUp"].indexOf(e) > -1;
      }
    }
  }
};
function Lk(e, t, n, r, o, i) {
  return Zn((ue(), $e("div", {
    class: "iui-component iui-tooltip",
    tabindex: "0",
    style: En({ left: e.left + "px", top: e.top + "px", transform: e.transform, zIndex: e.zIndex }),
    onBlur: t[0] || (t[0] = (...a) => e.blur && e.blur(...a)),
    onMouseleave: t[1] || (t[1] = (...a) => e.close && e.close(...a))
  }, [
    et("div", {
      class: qt(["text-container", e.internalDirection])
    }, [
      It(e.$slots, "default")
    ], 2)
  ], 36)), [
    [si, e.show]
  ]);
}
const Mk = /* @__PURE__ */ Nt(Fk, [["render", Lk], ["styles", [Pk]]]), Uk = `span.iui-tooltip-icon{height:16px;line-height:16px;vertical-align:text-top}span.iui-tooltip-icon .tooltip-container{cursor:help;color:var(--coal-black)}span.iui-tooltip-icon svg.iui-icon{border:var(--iui-border-default);border-radius:100%;padding:2px}
`, jk = {
  name: "TooltipIcon",
  components: { Tooltip: Mk, Icon: Cn },
  props: {
    direction: String,
    position: String,
    iconName: {
      type: String,
      default: "question"
    },
    tooltipCls: String,
    tooltipOffsetX: {
      type: Number,
      default: -4
    },
    tooltipOffsetY: {
      type: Number,
      default: -4
    },
    maxWidth: {
      type: String,
      default: "300px"
    }
  },
  data() {
    return {
      showTooltip: !1
    };
  },
  methods: {
    close() {
      this.showTooltip = !1;
    }
  }
};
function Bk(e, t, n, r, o, i) {
  const a = ri("icon"), s = ri("tooltip");
  return ue(), $e("span", {
    class: "iui-component iui-tooltip-icon",
    part: "base",
    onMouseleave: t[1] || (t[1] = (l) => o.showTooltip = !1)
  }, [
    et("span", {
      ref: "tooltipIcon",
      class: "tooltip-container",
      onMouseenter: t[0] || (t[0] = (l) => o.showTooltip = !0)
    }, [
      vt(a, { name: n.iconName }, null, 8, ["name"])
    ], 544),
    vt(s, {
      anchor: "tooltipIcon",
      class: qt(n.tooltipCls),
      "is-open": o.showTooltip,
      "offset-y": n.tooltipOffsetY,
      "offset-x": n.tooltipOffsetX,
      direction: n.direction,
      position: n.position,
      "max-width": n.maxWidth,
      onClose: i.close
    }, {
      default: Qt(() => [
        It(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "is-open", "offset-y", "offset-x", "direction", "position", "max-width", "onClose"])
  ], 32);
}
const lr = /* @__PURE__ */ Nt(jk, [["render", Bk], ["styles", [Uk]]]), Wk = {
  key: 1,
  part: "heading",
  class: "form-section-header"
}, Hk = {
  key: 2,
  class: "form-section-header"
}, Yk = {
  key: 1,
  class: "optional-field"
}, Xk = {
  key: 3,
  class: "form-section-description"
}, Jk = /* @__PURE__ */ Ut({
  name: "FormSection",
  __name: "FormSection",
  props: {
    labelTooltip: { default: "" },
    isAdvanced: { type: Boolean, default: !1 },
    isSubformSection: { type: Boolean },
    isAdvancedShown: { type: Boolean, default: !1 },
    isVisible: { type: Boolean, default: !0 },
    advancedSettingsLabel: { default: "Advanced Settings" },
    heading: { default: "" },
    description: { default: "" },
    isDisplayColumn: { type: Boolean },
    isOptional: { type: Boolean },
    optionalLabel: { default: "" }
  },
  setup(e) {
    const t = e, n = Xe(t.isAdvanced && t.isAdvancedShown);
    ht([() => t.isAdvanced, () => t.isAdvancedShown], ([o, i]) => {
      n.value = o && i;
    });
    const r = () => {
      n.value = !n.value;
    };
    return (o, i) => Zn((ue(), $e("section", {
      part: "base subFormSection",
      class: qt(["iui-component iui-form-section", { "no-heading": !o.heading, advanced: o.isAdvanced, subFormSection: o.isSubformSection, "display-column": o.isDisplayColumn }])
    }, [
      o.isAdvanced ? (ue(), $e("div", {
        key: 0,
        class: "advancedLink",
        part: "advancedLink",
        onClick: r
      }, [
        mt(tt(o.advancedSettingsLabel) + " ", 1),
        vt(Cn, {
          name: n.value ? "arrow-up" : "arrow-down"
        }, null, 8, ["name"])
      ])) : ze("", !0),
      o.isSubformSection ? o.heading ? (ue(), $e("h3", Hk, [
        mt(tt(o.heading) + " ", 1),
        o.labelTooltip ? (ue(), bt(lr, { key: 0 }, {
          default: Qt(() => [
            mt(tt(o.labelTooltip), 1)
          ]),
          _: 1
        })) : ze("", !0),
        o.isOptional ? (ue(), $e("span", Yk, tt(o.optionalLabel), 1)) : ze("", !0)
      ])) : ze("", !0) : Zn((ue(), $e("h3", Wk, [
        mt(tt(o.heading) + " ", 1),
        o.labelTooltip ? (ue(), bt(lr, { key: 0 }, {
          default: Qt(() => [
            mt(tt(o.labelTooltip), 1)
          ]),
          _: 1
        })) : ze("", !0)
      ], 512)), [
        [si, o.heading && (!o.isAdvanced || n.value)]
      ]),
      o.description ? (ue(), $e("div", Xk, [
        It(o.$slots, "description", {}, () => [
          mt(tt(o.description), 1)
        ])
      ])) : ze("", !0),
      o.isAdvanced ? n.value ? It(o.$slots, "default", { key: 5 }) : ze("", !0) : It(o.$slots, "default", { key: 4 })
    ], 2)), [
      [si, o.isVisible]
    ]);
  }
}), Kk = `.iui-form-section:not(.subFormSection).no-heading .iui-conditional-actions{grid-column:1}.iui-form-section:not(.subFormSection):not(.no-heading) .iui-conditional-actions{grid-column:2}.iui-form-section:not(.subFormSection):not(.no-heading) .subFormSection.display-column>.iui-component:nth-child(odd){margin-right:var(--col-2-12)}.iui-form-section:not(.subFormSection):not(.no-heading) .subFormSection.display-column.no-heading>.iui-component:nth-child(even){margin-right:var(--col-2-12)}.iui-form-section:not(.subFormSection):not(.no-heading) .subFormSection.display-column.no-heading>.iui-component:nth-child(odd){margin-right:var(--form-gutter)}.iui-form-section.subFormSection.display-column{display:flex!important;flex-flow:row wrap;align-items:flex-start}.iui-form-section.subFormSection.display-column .form-section-header,.iui-form-section.subFormSection.display-column h3{flex:0 0 100%}.iui-form-section.subFormSection.display-column .form-section-description{flex:0 0 100%;font-weight:400}.iui-form-section.subFormSection.display-column>.iui-component:nth-child(odd){margin-right:var(--col-4-12)}.iui-form-section.subFormSection.display-column.no-heading>.iui-component:nth-child(odd){margin-right:var(--form-gutter)}.iui-form-section.subFormSection.display-column.no-heading>.iui-component:nth-child(even){margin-right:var(--col-4-12)}.iui-form-section.subFormSection.display-column .iui-field-group{margin-right:var(--form-gutter);margin-bottom:var(--iui-vertical-margin);margin-top:var(--iui-vertical-margin);flex-basis:var(--col-3-12);display:flex;flex-wrap:wrap}.iui-form-section.subFormSection.display-column .iui-field-group h3{font-size:var(--iui-font-size-default);font-weight:var(--iui-font-weight-semi-bold);margin-bottom:0;margin-top:var(--iui-vertical-margin)}.iui-form-section.subFormSection.display-column .iui-field-group .iui-text-input,.iui-form-section.subFormSection.display-column .iui-field-group .iui-multiselect-input .iui-btn,.iui-form-section.subFormSection.display-column .iui-field-group .iui-select-input .iui-btn{box-sizing:border-box;min-width:var(--col-3-12)}.iui-form-section.subFormSection.display-column .iui-field-group .country-code-phone-number-input .iui-multiselect-input .iui-btn,.iui-form-section.subFormSection.display-column .iui-field-group .country-code-phone-number-input .iui-select-input .iui-btn{box-sizing:border-box;min-width:unset}.iui-form-section.subFormSection.display-column>.iui-conditional-actions>.iui-field-group{margin-right:0}.iui-form-section .advancedLink{color:var(--coal-black);text-align:center;cursor:pointer;padding-bottom:var(--form-gutter)}
`, Gk = /* @__PURE__ */ Nt(Jk, [["styles", [Kk]]]), Zk = ["role"], Qk = ["role"], eS = /* @__PURE__ */ Ut({
  name: "List",
  __name: "List",
  props: {
    items: {},
    isListBox: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Ld(() => (t.items || []).map((r, o) => (typeof r == "object" && !r.__listIndex && (r.__listIndex = o), r)));
    return (r, o) => (ue(), $e("ul", {
      class: "iui-component iui-list",
      role: r.isListBox ? "listbox" : "list"
    }, [
      (ue(!0), $e(Gt, null, Zw(n.value, (i, a) => (ue(), $e("li", {
        key: a,
        role: r.isListBox ? "option" : "listitem"
      }, [
        typeof i == "object" ? It(r.$slots, "default", k0(ns({ key: 0 }, i)), void 0, !0) : It(r.$slots, "default", {
          key: 1,
          value: i
        }, () => [
          mt(tt(i), 1)
        ], !0)
      ], 8, Qk))), 128))
    ], 8, Zk));
  }
}), tS = `ul.iui-list[data-v-a2bbdb74]{list-style:none;padding-inline-start:0;margin-block-start:0;margin-block-end:0}
`, nS = /* @__PURE__ */ Nt(eS, [["styles", [tS]], ["__scopeId", "data-v-a2bbdb74"]]), rS = `div.iui-field-errors li{color:var(--error-red);line-height:var(--iui-line-height-medium)}div.iui-field-errors li .exclamation-circle{margin-right:var(--iui-horizontal-margin)}
`, oS = {
  name: "FieldErrors",
  components: { Icon: Cn, List: nS },
  props: {
    errors: [Array, String]
  }
}, iS = {
  key: 0,
  class: "iui-component iui-field-errors"
};
function aS(e, t, n, r, o, i) {
  const a = ri("icon"), s = ri("list");
  return n.errors && n.errors.length ? (ue(), $e("div", iS, [
    vt(s, { items: n.errors }, {
      default: Qt((l) => [
        vt(a, { name: "exclamation-circle" }),
        mt(tt(l.value), 1)
      ]),
      _: 1
    }, 8, ["items"])
  ])) : ze("", !0);
}
const sS = /* @__PURE__ */ Nt(oS, [["render", aS], ["styles", [rS]]]), lS = {
  key: 0,
  class: "required"
}, cS = { class: "fields" }, uS = ["innerHTML"], dS = /* @__PURE__ */ Ut({
  name: "FieldLabelPair",
  __name: "FieldLabelPair",
  props: {
    isVisible: { type: Boolean, default: !0 },
    isDisabled: { type: Boolean },
    isReadOnly: { type: Boolean },
    mainLabel: { default: "" },
    topFieldLabel: { default: "" },
    leftFieldLabel: { default: "" },
    rightFieldLabel: { default: "" },
    labelTooltip: { default: "" },
    fieldTooltip: { default: "" },
    isRequired: { type: Boolean },
    isParent: { type: Boolean },
    isChildDisplayBelow: { type: Boolean },
    isChild: { type: Boolean },
    errors: {},
    instructions: { default: "" }
  },
  setup(e, { expose: t }) {
    const n = e, r = nE(), o = Xe(n.isDisabled), i = Xe(n.isReadOnly), a = Xe(!1), s = Xe(!1), l = () => {
      s.value = !0, setTimeout(() => {
        s.value = !1;
      }, 500);
    };
    Ka(() => {
      var c, b, k, q;
      a.value = ((b = (c = wa()) == null ? void 0 : c.parent) == null ? void 0 : b.type.name) === "FieldGroup" || ((q = (k = wa()) == null ? void 0 : k.parent) == null ? void 0 : q.type.name) === "RadioButtonGroup";
    });
    const d = (c) => {
      o.value = !c;
    }, p = () => r.default ? r.default().filter((c) => {
      var b;
      return (b = c == null ? void 0 : c.props) == null ? void 0 : b.fieldName;
    })[0] : null;
    return ht(() => n.isDisabled, (c) => {
      o.value = c;
    }), ht(() => n.isReadOnly, (c) => {
      i.value = c;
    }), t({ setDisabled: d, getField: p, focusField: l }), (c, b) => Zn((ue(), $e("div", {
      class: qt(["iui-component iui-field-label-pair", { child: c.isChild, parent: c.isParent || c.isChildDisplayBelow, error: c.errors, disabled: o.value }]),
      part: "base"
    }, [
      c.mainLabel ? (ue(), $e("div", {
        key: 0,
        class: "main-label",
        part: "mainLabel",
        onClick: l
      }, [
        et("label", null, [
          It(c.$slots, "mainLabel", {}, () => [
            mt(tt(c.mainLabel), 1)
          ]),
          c.isRequired ? (ue(), $e("span", lS, "*")) : ze("", !0),
          c.labelTooltip ? (ue(), bt(lr, { key: 1 }, {
            default: Qt(() => [
              mt(tt(c.labelTooltip), 1)
            ]),
            _: 1
          })) : ze("", !0)
        ])
      ])) : ze("", !0),
      et("div", cS, [
        c.topFieldLabel ? (ue(), $e("label", {
          key: 0,
          class: "top-label",
          onClick: l
        }, [
          It(c.$slots, "topFieldLabel", {}, () => [
            mt(tt(c.topFieldLabel), 1)
          ]),
          !c.mainLabel && c.labelTooltip ? (ue(), bt(lr, { key: 0 }, {
            default: Qt(() => [
              mt(tt(c.labelTooltip), 1)
            ]),
            _: 1
          })) : ze("", !0)
        ])) : ze("", !0),
        c.leftFieldLabel ? (ue(), $e("label", {
          key: 1,
          class: "left-label",
          part: "leftLabel",
          onClick: l
        }, [
          mt(tt(c.leftFieldLabel) + " ", 1),
          !c.mainLabel && !c.topFieldLabel && c.labelTooltip ? (ue(), bt(lr, { key: 0 }, {
            default: Qt(() => [
              mt(tt(c.labelTooltip), 1)
            ]),
            _: 1
          })) : ze("", !0)
        ])) : ze("", !0),
        It(c.$slots, "default", {
          focused: s.value,
          disabled: o.value,
          readOnly: i.value
        }),
        c.rightFieldLabel ? (ue(), $e("label", {
          key: 2,
          class: "right-label",
          part: "rightLabel",
          onClick: l
        }, [
          mt(tt(c.rightFieldLabel) + " ", 1),
          !c.mainLabel && !c.topFieldLabel && !c.leftFieldLabel && c.labelTooltip ? (ue(), bt(lr, { key: 0 }, {
            default: Qt(() => [
              mt(tt(c.labelTooltip), 1)
            ]),
            _: 1
          })) : ze("", !0)
        ])) : ze("", !0),
        c.fieldTooltip ? (ue(), bt(lr, { key: 3 }, {
          default: Qt(() => [
            mt(tt(c.fieldTooltip), 1)
          ]),
          _: 1
        })) : ze("", !0),
        It(c.$slots, "instructions", { class: "instructions" }, () => [
          c.instructions ? (ue(), $e("p", {
            key: 0,
            class: "instructions",
            innerHTML: c.instructions
          }, null, 8, uS)) : ze("", !0)
        ])
      ]),
      a.value ? ze("", !0) : (ue(), bt(sS, {
        key: 1,
        errors: c.errors
      }, null, 8, ["errors"]))
    ], 2)), [
      [si, c.isVisible]
    ]);
  }
}), pS = `div.iui-field-label-pair .error{display:table-row}div.iui-field-label-pair .required{color:#ff613a}div.iui-field-label-pair .left-label,div.iui-field-label-pair .right-label{vertical-align:middle}div.iui-field-label-pair .main-label{font-size:14px;font-weight:var(--iui-font-weight-semi-bold);line-height:var(--iui-line-height-small);margin-bottom:var(--iui-vertical-margin)}div.iui-field-label-pair .top-label{display:block;color:var(--storm-gray);line-height:var(--iui-line-height-small);margin-bottom:var(--iui-vertical-margin)}div.iui-field-label-pair .instructions{color:var(--storm-gray)}div.iui-field-label-pair .instructions a{color:var(--strata-blue);text-decoration:none}div.iui-field-label-pair .instructions a:hover{text-decoration:underline}div.iui-field-label-pair.error .input-wrap,div.iui-field-label-pair.error .iui-checkbox,div.iui-field-label-pair.error .iui-radio-button,div.iui-field-label-pair.error .iui-select-input .iui-btn,div.iui-field-label-pair.error .iui-multiselect-input .iui-btn,div.iui-field-label-pair.error .iui-text-area-input{border-color:var(--rose-pink)}div.iui-field-label-pair.error .input-wrap .inner-text,div.iui-field-label-pair.error .iui-checkbox .inner-text,div.iui-field-label-pair.error .iui-radio-button .inner-text,div.iui-field-label-pair.error .iui-select-input .iui-btn .inner-text,div.iui-field-label-pair.error .iui-multiselect-input .iui-btn .inner-text,div.iui-field-label-pair.error .iui-text-area-input .inner-text,div.iui-field-label-pair.error .input-wrap .value,div.iui-field-label-pair.error .iui-checkbox .value,div.iui-field-label-pair.error .iui-radio-button .value,div.iui-field-label-pair.error .iui-select-input .iui-btn .value,div.iui-field-label-pair.error .iui-multiselect-input .iui-btn .value,div.iui-field-label-pair.error .iui-text-area-input .value,div.iui-field-label-pair.error .input-wrap .iui-icon,div.iui-field-label-pair.error .iui-checkbox .iui-icon,div.iui-field-label-pair.error .iui-radio-button .iui-icon,div.iui-field-label-pair.error .iui-select-input .iui-btn .iui-icon,div.iui-field-label-pair.error .iui-multiselect-input .iui-btn .iui-icon,div.iui-field-label-pair.error .iui-text-area-input .iui-icon,div.iui-field-label-pair.error .input-wrap input,div.iui-field-label-pair.error .iui-checkbox input,div.iui-field-label-pair.error .iui-radio-button input,div.iui-field-label-pair.error .iui-select-input .iui-btn input,div.iui-field-label-pair.error .iui-multiselect-input .iui-btn input,div.iui-field-label-pair.error .iui-text-area-input input,div.iui-field-label-pair.error .input-wrap textarea,div.iui-field-label-pair.error .iui-checkbox textarea,div.iui-field-label-pair.error .iui-radio-button textarea,div.iui-field-label-pair.error .iui-select-input .iui-btn textarea,div.iui-field-label-pair.error .iui-multiselect-input .iui-btn textarea,div.iui-field-label-pair.error .iui-text-area-input textarea,div.iui-field-label-pair.error .input-wrap .please-select,div.iui-field-label-pair.error .iui-checkbox .please-select,div.iui-field-label-pair.error .iui-radio-button .please-select,div.iui-field-label-pair.error .iui-select-input .iui-btn .please-select,div.iui-field-label-pair.error .iui-multiselect-input .iui-btn .please-select,div.iui-field-label-pair.error .iui-text-area-input .please-select{color:var(--dark-red)}
`, fS = /* @__PURE__ */ Nt(dS, [["styles", [pS]]]), hS = /* @__PURE__ */ et("div", {
  class: "dot-container",
  part: "animation"
}, [
  /* @__PURE__ */ et("div", { class: "dot-wrap red" }, [
    /* @__PURE__ */ et("div", { class: "dot" }, [
      /* @__PURE__ */ et("div", { style: { margin: "-1px", visibility: "hidden" } }, ".")
    ])
  ]),
  /* @__PURE__ */ et("div", { class: "dot-wrap grey" }, [
    /* @__PURE__ */ et("div", { class: "dot" })
  ]),
  /* @__PURE__ */ et("div", { class: "dot-wrap black" }, [
    /* @__PURE__ */ et("div", { class: "dot" })
  ])
], -1), mS = [
  hS
], vS = {
  name: "LoadingDots"
}, gS = /* @__PURE__ */ Ut({
  ...vS,
  props: {
    offsetX: { default: "50%" },
    offsetY: { default: "50%" },
    position: { default: "fixed" }
  },
  setup(e) {
    const t = e, n = { left: t.offsetX, top: t.offsetY, position: t.position };
    return (r, o) => (ue(), $e("div", {
      class: "iui-component iui-loading-dots",
      part: "base",
      style: n
    }, mS));
  }
}), bS = `@keyframes loadingDotsExpand{0%,to{transform:translateY(-5px)}50%{transform:translateY(-15px)}}@keyframes loadingDotsRotate{0%{transform:rotate(0)}to{transform:rotate(360deg)}}div.iui-loading-dots{pointer-events:none;overflow:hidden;margin-left:-250px;margin-top:-250px}div.iui-loading-dots .dot-container{width:500px;height:500px;animation:loadingDotsRotate 1.5s infinite ease-in-out}div.iui-loading-dots .dot-wrap{height:100%;width:100%;position:absolute}div.iui-loading-dots .dot{width:10px;height:10px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;border-radius:10px;animation:loadingDotsExpand 1.5s infinite ease-in-out}div.iui-loading-dots .dot-wrap.red{transform:rotate(-120deg)}div.iui-loading-dots .dot-wrap.red .dot{background-color:#e40046}div.iui-loading-dots .dot-wrap.grey .dot{background-color:#a9b4bd}div.iui-loading-dots .dot-wrap.black{transform:rotate(120deg)}div.iui-loading-dots .dot-wrap.black .dot{background-color:#4b5e6a}
`, Hd = /* @__PURE__ */ Nt(gS, [["styles", [bS]]]), yS = ["contenteditable", "maxLength", "placeholder", "title", "min", "max"], xS = /* @__PURE__ */ Ut({
  name: "AutoWidthInput",
  __name: "AutoWidthInput",
  props: {
    modelValue: { type: [String, Number, Boolean] },
    minWidth: {},
    maxLength: {},
    placeholder: {},
    fieldName: {},
    isReadOnly: { type: Boolean },
    isDisabled: { type: Boolean },
    min: {},
    max: {},
    ariaLabel: {},
    autocomplete: {}
  },
  emits: ["blur", "keyup", "keydown", "focus", "update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = Xe(!1), i = Xe(r.modelValue || r.placeholder), a = Xe(null);
    ht(
      () => r.isDisabled,
      (q) => {
        q && (p(r.placeholder), n("update:modelValue", ""));
      }
    ), ht(
      () => r.modelValue,
      (q) => {
        if (a.value && q !== a.value.textContent) {
          const C = o ? q : q || r.placeholder;
          p(`${C}`);
        }
      }
    );
    function s(q) {
      const C = q.key;
      ["Backspace", "Tab", "ArrowLeft", "ArrowRight"].includes(C) || (C === "Enter" || r.modelValue && `${r.modelValue}`.trim().length >= r.maxLength) && q.preventDefault(), n("keydown", q);
    }
    function l(q) {
      var C;
      (q.key.length === 1 || q.key === "Backspace" || q.key === "Space") && n("update:modelValue", ((C = a.value) == null ? void 0 : C.textContent) || ""), n("keyup", q);
    }
    function d(q) {
      var C, w;
      !r.isDisabled && !o.value && (o.value = !0, ((w = (C = a.value) == null ? void 0 : C.textContent) == null ? void 0 : w.trim()) === r.placeholder && c(), Ha(() => {
        var T;
        (T = a.value) == null || T.focus(), n("focus", q);
      }));
    }
    function p(q) {
      var C;
      i.value = q, (C = a.value) != null && C.textContent && (a.value.textContent = q);
    }
    function c() {
      p("");
    }
    function b(q) {
      const C = window.clipboardData ? (
        // @ts-ignore
        window.clipboardData.getData("Text")
      ) : (
        // @ts-ignore
        (q.originalEvent || q).clipboardData.getData("text/plain")
      );
      /\r|\n/.exec(C) && q.preventDefault();
    }
    function k(q) {
      o.value = !1, r.modelValue || p(r.placeholder), n("blur", q);
    }
    return t({ doFocus: d }), (q, C) => (ue(), $e("span", {
      class: qt(["iui-component iui-autowidth-input", {
        disabled: q.isDisabled,
        readOnly: q.isReadOnly,
        placeholder: q.placeholder && i.value === q.placeholder
      }]),
      tabindex: "0",
      onClick: d,
      onFocus: d
    }, [
      et("span", {
        ref_key: "input",
        ref: a,
        role: "textbox",
        class: "input-wrap",
        part: "inputWrap",
        contenteditable: !q.isDisabled && !q.isReadOnly && o.value,
        maxLength: q.maxLength,
        placeholder: q.placeholder,
        title: `${q.placeholder || q.modelValue || ""}`,
        min: q.min,
        max: q.max,
        style: En({ "min-width": q.minWidth + "px" }),
        onPaste: b,
        onBlur: k,
        onKeydown: s,
        onKeyup: l
      }, tt(i.value), 45, yS),
      vt(Bd, {
        value: q.modelValue,
        "field-name": q.fieldName
      }, null, 8, ["value", "field-name"])
    ], 34));
  }
}), wS = `.input-wrap{padding:0 var(--iui-horizontal-padding);border:var(--iui-border-default);border-radius:var(--iui-border-radius-default);display:inline-block;white-space:nowrap;background-color:#fff;font-size:var(--iui-font-size-default);vertical-align:middle;line-height:var(--iui-line-height-large)}.input-wrap:hover{border-color:var(--coal-black)}.input-wrap input{background:transparent;border:0;line-height:inherit}.input-wrap input:focus{outline:0}.input-wrap input:focus::placeholder{color:transparent}.input-wrap input::placeholder{color:var(--bleakest-gray)}.input-wrap.disabled{background-color:var(--pale-gray)}.input-wrap.disabled:hover{border-color:var(--serenity-gray)}.input-wrap.disabled input::placeholder{color:var(--bleakest-gray)}.text-ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block;vertical-align:middle}span.iui-autowidth-input{outline:none;cursor:text}span.iui-autowidth-input.placeholder{color:var(--bleakest-gray);-webkit-user-select:none;user-select:none}span.iui-autowidth-input .input-wrap{min-height:var(--iui-line-height-medium);outline:none;min-width:20px;display:inline-block}span.iui-autowidth-input.disabled{cursor:default}span.iui-autowidth-input.disabled .input-wrap{background-color:var(--pale-gray);border-color:var(--serenity-gray)}
`, ES = /* @__PURE__ */ Nt(xS, [["styles", [wS]]]);
function Yd(e, t) {
  const n = Lr(
    "updateSharedChild",
    () => {
    }
  ), r = Lr(
    "deleteSharedChild",
    () => {
    }
  );
  let o = !0, i = e.validationFunction, a = e.validationPattern;
  const s = Xe(!1), l = Xe(""), d = e.fieldName || window.crypto.randomUUID();
  ht(
    () => e.validationFunction,
    (C) => {
      i = C;
    }
  ), ht(
    () => e.validationPattern,
    (C) => {
      a = C;
    }
  );
  const p = (C) => {
    t("validity", C, o);
  }, c = (C) => {
    s.value = C, (e.isRequired || e.validationPattern || e.validationFunction) && n(d, C), p(C);
  }, b = (C, w) => (c(C), (w || !w && !o) && (l.value = s.value ? "" : "uicl-invalid"), o = !1, C), k = (C) => b(!!(a != null && a.test(C)), C), q = (C) => !C || Array.isArray(C) && C.length < 1 || Vk(C) && Object.keys(C).length < 1 ? b(!1, C) : !0;
  return Ga(() => {
    r(d), p(!0);
  }), ht(
    () => e.modelValue,
    (C) => {
      const w = (Et(C) ? C.value : C) || "";
      if (e.validationOverride)
        return b(!0, w);
      if (!(e.isRequired && !q(w))) {
        if (C) {
          if (a)
            return k(w);
          if (i)
            return i(w).then(function(T) {
              b(T, w);
            });
        }
        b(!0, w);
      }
    },
    { immediate: !0, deep: !0 }
  ), { validityCls: l, isValid: s };
}
const kS = { key: 1 }, SS = ["autocomplete", "type", "size", "maxLength", "placeholder", "title", "readonly", "disabled", "aria-label", "name", "min", "max"], CS = { key: 1 }, qS = /* @__PURE__ */ Ut({
  name: "TextInput",
  __name: "TextInput",
  props: {
    size: {},
    maxLength: {},
    isAutoWidth: { type: Boolean, default: !1 },
    innerTextLeft: { default: void 0 },
    innerTextRight: { default: void 0 },
    innerIconLeft: { default: void 0 },
    innerIconRight: { default: void 0 },
    type: { default: "text" },
    placeholder: {},
    validationFail: { type: Boolean, default: void 0 },
    fieldName: {},
    isReadOnly: { type: Boolean },
    isDisabled: { type: Boolean },
    min: { default: void 0 },
    max: { default: void 0 },
    ariaLabel: {},
    autocomplete: {},
    modelValue: {},
    isRequired: { type: Boolean },
    validationOverride: { type: Boolean },
    validationFunction: {},
    validationPattern: {}
  },
  emits: ["innerLeftClick", "innerRightClick", "blur", "keyup", "keydown", "focus", "update:modelValue", "validity"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = Xe(r.modelValue || ""), i = Xe(), a = Xe(null);
    ht(() => r.modelValue, (w) => {
      w !== void 0 && (o.value = w);
    }), ht(() => r.validationFail, (w) => {
      p.value = w ? "uicl-invalid" : "";
    }), ht(o, (w) => {
      n("update:modelValue", w);
    });
    const s = (w) => w === "email" ? new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ) : r.type === "tel" || r.type === "number" ? new RegExp(/^[0-9]*$/) : void 0, l = Xe(), d = Xe();
    let p = r.validationFail ? Xe("uicl-invalid") : Xe("");
    Ka(() => {
      r.validationFail === void 0 && (l.value = r.validationPattern || s(r.type), d.value = r.validationFunction || r.type === "url" ? function(w) {
        const T = ["http:", "https:", "ftp:"];
        return new Promise(function(F) {
          let L;
          try {
            if (!w) {
              F(!0);
              return;
            }
            L = new URL(w), F(
              !!(w.indexOf(".") !== -1 && w.split(".")[1].length > 1 && L.protocol && T.includes(L.protocol))
            );
          } catch {
            F(!1);
          }
        });
      } : void 0, p = Yd(
        {
          ...r,
          validationFunction: d.value,
          validationPattern: l.value,
          modelValue: o
        },
        n
      ).validityCls);
    });
    function c(w) {
      i.value = !0, n("focus", w);
    }
    function b(w) {
      i.value = !1, n("blur", w);
    }
    function k(w) {
      w instanceof KeyboardEvent && n("keydown", w);
    }
    function q(w) {
      n("keyup", w);
    }
    function C(w) {
      var T, F;
      r.isAutoWidth ? (F = a.value) == null || F.doFocus() : (T = a.value) == null || T.focus(), n("focus", w);
    }
    return t({ doFocus: C }), (w, T) => (ue(), $e("label", {
      class: qt(["iui-component iui-text-input input-wrap", [
        {
          disabled: w.isDisabled,
          focused: i.value,
          "has-value": !!w.modelValue,
          "auto-width": w.isAutoWidth
        },
        fo(p)
      ]]),
      part: "base",
      onClick: C
    }, [
      w.innerTextLeft || w.innerIconLeft ? (ue(), $e("span", {
        key: 0,
        class: "inner-text left",
        onClick: T[0] || (T[0] = (F) => w.$emit("innerLeftClick"))
      }, [
        w.innerIconLeft ? (ue(), bt(Cn, {
          key: 0,
          name: w.innerIconLeft
        }, null, 8, ["name"])) : (ue(), $e("span", kS, tt(w.innerTextLeft), 1))
      ])) : ze("", !0),
      w.isAutoWidth ? ze("", !0) : Zn((ue(), $e("input", {
        key: 1,
        part: "input",
        ref_key: "input",
        ref: a,
        "onUpdate:modelValue": T[1] || (T[1] = (F) => o.value = F),
        role: "textbox",
        autocomplete: w.autocomplete,
        type: w.type,
        size: w.size,
        maxLength: w.maxLength,
        placeholder: w.placeholder,
        title: w.placeholder,
        readonly: w.isReadOnly,
        disabled: w.isDisabled,
        "aria-label": w.ariaLabel,
        name: w.fieldName,
        min: w.min,
        max: w.max,
        onBlur: b,
        onKeydown: k,
        onKeyup: q,
        onFocus: c
      }, null, 40, SS)), [
        [pk, o.value]
      ]),
      w.isAutoWidth ? (ue(), bt(ES, {
        key: 2,
        ref_key: "input",
        ref: a,
        modelValue: o.value,
        "onUpdate:modelValue": T[2] || (T[2] = (F) => o.value = F),
        "max-length": w.maxLength,
        placeholder: w.placeholder,
        title: w.placeholder,
        "is-read-only": w.isReadOnly,
        "is-disabled": w.isDisabled,
        "field-name": w.fieldName,
        min: w.min,
        max: w.max,
        "aria-label": w.ariaLabel,
        "min-width": 30,
        onBlur: b,
        onKeydown: k,
        onKeyup: q,
        onFocus: c
      }, null, 8, ["modelValue", "max-length", "placeholder", "title", "is-read-only", "is-disabled", "field-name", "min", "max", "aria-label"])) : ze("", !0),
      w.innerTextRight || w.innerIconRight ? (ue(), $e("span", {
        key: 3,
        class: "inner-text right",
        onClick: T[3] || (T[3] = (F) => w.$emit("innerRightClick"))
      }, [
        w.innerIconRight ? (ue(), bt(Cn, {
          key: 0,
          name: w.innerIconRight
        }, null, 8, ["name"])) : (ue(), $e("span", CS, tt(w.innerTextRight), 1))
      ])) : ze("", !0)
    ], 2));
  }
}), _S = `.input-wrap{padding:0 var(--iui-horizontal-padding);border:var(--iui-border-default);border-radius:var(--iui-border-radius-default);display:inline-block;white-space:nowrap;background-color:#fff;font-size:var(--iui-font-size-default);vertical-align:middle;line-height:var(--iui-line-height-large)}.input-wrap:hover{border-color:var(--coal-black)}.input-wrap input{background:transparent;border:0;line-height:inherit}.input-wrap input:focus{outline:0}.input-wrap input:focus::placeholder{color:transparent}.input-wrap input::placeholder{color:var(--bleakest-gray)}.input-wrap.disabled{background-color:var(--pale-gray)}.input-wrap.disabled:hover{border-color:var(--serenity-gray)}.input-wrap.disabled input::placeholder{color:var(--bleakest-gray)}.text-ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block;vertical-align:middle}label.iui-text-input{overflow:hidden;cursor:text;display:inline-flex}label.iui-text-input.uicl-invalid{border-color:var(--rose-pink)}label.iui-text-input.uicl-invalid input{color:var(--dark-red)}label.iui-text-input.full-width{display:flex}label.iui-text-input.full-width input{flex:1 1 auto}label.iui-text-input span{-webkit-user-select:none;user-select:none}label.iui-text-input input{flex-grow:1;font-family:var(--iui-font-family-default);font-size:var(--iui-font-size-default)}label.iui-text-input .inner-text{color:var(--bleakest-gray);pointer-events:none}label.iui-text-input .inner-text.left{margin-right:var(--iui-horizontal-margin)}label.iui-text-input .inner-text.right{margin-left:var(--iui-horizontal-margin);float:right}label.iui-text-input.disabled .inner-text{color:var(--bleakest-gray)}label.iui-text-input.focused{border-color:var(--coal-black)}label.iui-text-input.focused .inner-text,label.iui-text-input.has-value .inner-text{color:var(--coal-black)}label.iui-text-input.auto-width .input-wrap{border-width:0;padding:0;vertical-align:top}
`, DS = /* @__PURE__ */ Nt(qS, [["styles", [_S]]]), OS = (e) => {
  var t = 0, n, r;
  if (e == null || typeof e != "string" || e.length === 0)
    return t;
  for (n = 0; n < e.length; n++)
    r = e.charCodeAt(n), t = (t << 5) - t + r, t |= 0;
  return t;
}, RS = (e) => ({
  "data-testid": ((t) => {
    const n = OS(t);
    return n === 0 ? "" : `uicl-field-${n}`;
  })(e),
  name: e
}), TS = ["placeholder", "readonly", "disabled", "maxlength", "aria-label", "autocomplete"], AS = /* @__PURE__ */ Ut({
  name: "TextAreaInput",
  title: "asdf",
  __name: "TextAreaInput",
  props: {
    placeholder: { default: void 0 },
    width: {},
    height: {},
    maxCharacters: { default: void 0 },
    validationFail: { type: Boolean, default: void 0 },
    fieldName: {},
    isReadOnly: { type: Boolean },
    isDisabled: { type: Boolean },
    min: {},
    max: {},
    ariaLabel: {},
    autocomplete: {},
    modelValue: {},
    isRequired: { type: Boolean },
    validationOverride: { type: Boolean },
    validationFunction: {},
    validationPattern: {}
  },
  emits: ["blur", "keydown", "keyup", "input", "focus", "validity", "update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = r.validationFail === void 0 ? Yd(r, n).validityCls : r.validationFail ? Xe("uicl-invalid") : Xe(""), i = "uniq-" + window.crypto.randomUUID(), a = Xe(r.modelValue);
    ht(() => r.validationFail, (l) => {
      o.value = l ? "uicl-invalid" : "";
    }), ht(
      () => r.modelValue,
      (l) => {
        a.value = l;
      }
    ), ht(a, (l) => {
      n("update:modelValue", l);
    });
    const s = Xe();
    return t({
      doFocus: (l) => {
        var d;
        (d = s.value) == null || d.focus(), n("focus", l);
      }
    }), (l, d) => (ue(), $e("div", {
      class: "iui-component iui-text-area-input",
      part: "base",
      role: "presentation",
      style: En({ width: l.width + "px", height: l.height + "px" })
    }, [
      Zn(et("textarea", ns(fo(RS)(l.fieldName), {
        id: i,
        ref_key: "textarea",
        ref: s,
        "onUpdate:modelValue": d[0] || (d[0] = (p) => a.value = p),
        class: [
          {
            "input-wrap": !0,
            placeholder: l.placeholder && !a.value,
            responsive: !0,
            "has-max-char": l.maxCharacters
          },
          fo(o)
        ],
        part: "input",
        placeholder: l.placeholder,
        readonly: l.isReadOnly,
        disabled: l.isDisabled,
        maxlength: l.maxCharacters,
        "aria-label": l.ariaLabel,
        autocomplete: l.autocomplete || "off",
        onBlur: d[1] || (d[1] = (p) => l.$emit("blur", p)),
        onKeydown: d[2] || (d[2] = (p) => l.$emit("keydown", p)),
        onKeyup: d[3] || (d[3] = (p) => l.$emit("keyup", p)),
        onInput: d[4] || (d[4] = (p) => l.$emit("input", p, a.value))
      }), `
    `, 16, TS), [
        [Ca, a.value]
      ]),
      l.maxCharacters ? (ue(), $e("label", {
        key: 0,
        class: "max-char",
        for: i
      }, [
        et("span", null, tt(a.value ? l.maxCharacters - a.value.length : l.maxCharacters), 1)
      ])) : ze("", !0)
    ], 4));
  }
}), $S = `div.iui-text-area-input{position:relative}div.iui-text-area-input .max-char{position:absolute;bottom:0;right:0;font-size:var(--small-text);color:var(--bleakest-gray);line-height:28px;background-color:#fff}div.iui-text-area-input textarea{box-sizing:border-box;resize:none;color:var(--coal-black);border:var(--iui-border-default);border-radius:var(--iui-border-radius-default);padding:var(--iui-vertical-padding) var(--iui-horizontal-padding);line-height:var(--iui-line-height-small);font-family:var(--iui-font-family-default);white-space:normal;width:100%;height:100%}div.iui-text-area-input textarea.placeholder{color:var(--bleakest-gray)}div.iui-text-area-input textarea:focus,div.iui-text-area-input textarea:hover{border-color:var(--coal-black);outline:none}div.iui-text-area-input textarea.uicl-invalid{border-color:var(--rose-pink)}div.iui-text-area-input textarea:disabled{color:var(--bleakest-gray);border-color:var(--bleakest-gray);background-color:var(--pale-gray)}div.iui-text-area-input.full-width textarea,div.iui-text-area-input.full-width label{display:block;width:100%!important;box-sizing:border-box}
`, IS = /* @__PURE__ */ Nt(AS, [["styles", [$S]]]), NS = ["aria-checked", "aria-label"], VS = ["checked", "name", "value", "readonly", "disabled"], zS = ["tabindex"], PS = /* @__PURE__ */ Ut({
  name: "RadioButton",
  __name: "RadioButton",
  props: {
    modelValue: {},
    submitValue: {},
    checked: { type: Boolean, default: !1 },
    fieldName: {},
    isReadOnly: { type: Boolean },
    isDisabled: { type: Boolean },
    min: {},
    max: {},
    ariaLabel: {},
    autocomplete: {}
  },
  emits: ["input", "focus", "update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = Xe(null), i = Xe(null), a = Xe(r.modelValue);
    function s() {
      !r.isReadOnly && !r.isDisabled && n("update:modelValue", r.submitValue);
    }
    function l(p) {
      var c;
      !r.isReadOnly && !r.isDisabled && (s(), (c = o.value) == null || c.focus(), n("focus", p));
    }
    function d(p) {
      p.key === " " && s();
    }
    return ht(
      () => r.modelValue,
      async (p) => {
        p && (a.value = p);
      },
      { immediate: !0 }
    ), ht(
      () => r.isDisabled,
      async (p) => {
        p && (n("input", null, null), n("update:modelValue", ""));
      },
      { immediate: !0 }
    ), t({ doFocus: l, inputRef: i }), (p, c) => (ue(), $e("span", {
      class: qt(["iui-component iui-radio-button", { disabled: p.isDisabled, readOnly: p.isReadOnly }]),
      role: "radio",
      "aria-checked": p.modelValue === p.submitValue,
      "aria-label": p.ariaLabel,
      onClick: s
    }, [
      Zn(et("input", {
        "onUpdate:modelValue": c[0] || (c[0] = (b) => a.value = b),
        type: "radio",
        ref_key: "inputRef",
        ref: i,
        checked: p.checked,
        name: p.fieldName,
        value: p.submitValue,
        readonly: p.isReadOnly,
        disabled: p.isDisabled || p.isReadOnly,
        onInput: c[1] || (c[1] = (b) => n("input", p.submitValue, b))
      }, null, 40, VS), [
        [Ud, a.value]
      ]),
      et("span", {
        ref_key: "focusEl",
        ref: o,
        role: "presentation",
        tabindex: p.isDisabled || p.isReadOnly ? -1 : 0,
        class: "radio-icon",
        onKeydown: d
      }, null, 40, zS)
    ], 10, NS));
  }
}), FS = `span.iui-radio-button input{display:none}span.iui-radio-button .radio-icon{display:inline-block;border:var(--iui-border-default);border-radius:100%;width:14px;height:14px;-webkit-user-select:none;user-select:none;position:relative;cursor:pointer;vertical-align:middle}span.iui-radio-button .radio-icon:hover,span.iui-radio-button .radio-icon:focus{border-color:var(--coal-black);outline:none}span.iui-radio-button input:checked+.radio-icon{border-color:var(--coal-black)}span.iui-radio-button input:checked+.radio-icon:hover,span.iui-radio-button input:checked+.radio-icon:focus{box-shadow:var(--iui-box-shadow-default)}span.iui-radio-button input:checked+.radio-icon:after{content:"";position:absolute;width:8px;height:8px;border-radius:var(--iui-border-radius-default);top:3px;left:3px;background:var(--coal-black)}span.iui-radio-button.disabled .radio-icon,span.iui-radio-button.readOnly .radio-icon{border-color:var(--serenity-gray);cursor:default;background-color:var(--pale-gray)}span.iui-radio-button.disabled .radio-icon:hover,span.iui-radio-button.readOnly .radio-icon:hover,span.iui-radio-button.disabled .radio-icon:focus,span.iui-radio-button.readOnly .radio-icon:focus{border-color:var(--serenity-gray)}span.iui-radio-button.disabled input:checked+.radio-icon,span.iui-radio-button.readOnly input:checked+.radio-icon{border-color:var(--serenity-gray)}span.iui-radio-button.disabled input:checked+.radio-icon:hover,span.iui-radio-button.readOnly input:checked+.radio-icon:hover,span.iui-radio-button.disabled input:checked+.radio-icon:focus,span.iui-radio-button.readOnly input:checked+.radio-icon:focus{box-shadow:none}span.iui-radio-button.disabled input:checked+.radio-icon:after,span.iui-radio-button.readOnly input:checked+.radio-icon:after{background:var(--serenity-gray)}
`, Xd = /* @__PURE__ */ Nt(PS, [["styles", [FS]]]), LS = { class: "card-header" }, MS = {
  key: 1,
  class: "empty-check",
  style: { "margin-left": "auto" }
}, US = { class: "option-description" }, jS = /* @__PURE__ */ Ut({
  name: "CardRadioButton",
  __name: "CardRadioButton",
  props: {
    submitValue: {},
    optionName: {},
    optionDescription: {},
    iconName: {},
    modelValue: { default: "" },
    errors: { default: !1 },
    checked: { type: Boolean, default: !1 },
    fieldName: {},
    isReadOnly: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 },
    min: {},
    max: {},
    ariaLabel: {},
    autocomplete: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = Xe(n.modelValue), o = Xe();
    ht(() => n.checked, (a) => {
      a && i();
    }), ht(r, (a) => {
      a === n.submitValue && i();
    }), ht(() => n.modelValue, (a) => {
      r.value = a;
    });
    const i = () => {
      var a, s;
      !n.isReadOnly && !n.isDisabled && (t("update:modelValue", n.submitValue), (s = (a = o == null ? void 0 : o.value) == null ? void 0 : a.inputRef) == null || s.click());
    };
    return (a, s) => (ue(), $e("div", {
      class: qt([
        { "read-only": a.isReadOnly, disabled: a.isDisabled, "with-errors": a.errors },
        "iui-custom-component iui-radio-button-card card-container"
      ]),
      part: "base",
      onClick: s[1] || (s[1] = (l) => i())
    }, [
      vt(Xd, {
        modelValue: r.value,
        "onUpdate:modelValue": s[0] || (s[0] = (l) => r.value = l),
        checked: a.checked,
        class: qt(["card-btn", [{ "read-only": a.isReadOnly, disabled: a.isDisabled }]]),
        ref_key: "radioButtonRef",
        ref: o,
        id: a.submitValue,
        "field-name": a.fieldName,
        "submit-value": a.submitValue,
        "aria-label": a.optionName,
        "is-read-only": a.isReadOnly,
        "is-disabled": a.isDisabled
      }, null, 8, ["modelValue", "checked", "id", "class", "field-name", "submit-value", "aria-label", "is-read-only", "is-disabled"]),
      et("div", LS, [
        It(a.$slots, "icon", {}, () => [
          a.iconName ? (ue(), bt(Cn, {
            key: 0,
            name: a.iconName,
            alt: a.optionName,
            class: "card-icon"
          }, null, 8, ["name", "alt"])) : ze("", !0)
        ], !0),
        et("p", {
          class: qt(["option-name", [{ "no-icon": !a.iconName }]])
        }, tt(a.optionName), 3),
        a.checked || a.submitValue === a.modelValue ? (ue(), bt(Cn, {
          key: 0,
          name: "check-circle",
          class: "checked"
        })) : (ue(), $e("div", MS))
      ]),
      et("p", US, [
        It(a.$slots, "default", {}, () => [
          mt(tt(a.optionDescription), 1)
        ], !0)
      ])
    ], 2));
  }
}), BS = `.card-container[data-v-abccf01f]{background:#ffffff;border-radius:var(--iui-border-radius-default);border:var(--iui-border-default);cursor:pointer;display:block;height:100%;min-height:130px;min-width:253px;padding:20px;box-sizing:border-box}.card-container[data-v-abccf01f]:hover{border-color:var(--coal-black)}.card-container.with-errors[data-v-abccf01f]{border-color:var(--rose-pink)}.card-container.disabled[data-v-abccf01f],.card-container.read-only[data-v-abccf01f]{cursor:default;position:relative;background-color:var(--serenity-gray);opacity:.66}.card-container .card-btn[data-v-abccf01f]{display:none}.card-container .card-header[data-v-abccf01f]{display:flex}.card-container .card-header .option-name[data-v-abccf01f]{color:var(--coal-black);font-family:var(--iui-font-family-default);font-size:18px;font-style:normal;font-weight:600;padding-left:14px;margin:0}.card-container .card-header .option-name.no-icon[data-v-abccf01f]{padding-left:0}.card-container .empty-check[data-v-abccf01f]{height:20px;min-width:20px;border:var(--iui-border-default);border-radius:20px}.card-container .checked[data-v-abccf01f]{height:20px;min-width:20px;margin-left:auto}.card-container .card-icon[data-v-abccf01f]{min-width:30px;height:25px}.card-container .option-description[data-v-abccf01f]{color:var(--storm-gray);font-family:var(--iui-font-family-default);font-size:14px;font-style:normal;font-weight:400;line-height:18px;padding:10px 0 20px;margin:0}
`, WS = /* @__PURE__ */ Nt(jS, [["styles", [BS]], ["__scopeId", "data-v-abccf01f"]]), HS = {
  key: 0,
  class: "iui-component iui-modal"
}, YS = {
  key: 0,
  class: "modal-subtitle"
}, XS = {
  ref: "contentOverflow",
  class: "modal-overflow-cnt"
}, JS = ["name", "src"], KS = ["innerHTML"], GS = /* @__PURE__ */ Ut({
  name: "ModalView",
  __name: "ModalView",
  props: {
    show: { type: Boolean },
    modalStyle: {},
    title: {},
    subTitle: {},
    preventClose: { type: Boolean },
    isHideClose: { type: Boolean },
    isConfirmation: { type: Boolean },
    contentHeight: {},
    contentShadow: {},
    contentPadding: {},
    hasIframe: { type: Boolean },
    name: {},
    contentUrl: {},
    iframeName: {},
    iframeStyle: {},
    externalContentHtml: {},
    hasContentSlot: { type: Boolean },
    iframeLoaded: { type: Boolean },
    primaryButton: {},
    secondaryButton: {},
    hasFooterSlot: { type: Boolean }
  },
  emits: ["primaryClick", "secondaryClick", "iframeLoaded", "screenClick", "close"],
  setup(e, { emit: t }) {
    const n = () => {
      t("primaryClick");
    }, r = () => {
      t("secondaryClick");
    }, o = (s) => {
      t("screenClick", s);
    }, i = () => {
      t("iframeLoaded");
    }, a = () => {
      t("close");
    };
    return (s, l) => {
      var d, p, c, b;
      return s.show ? (ue(), $e("div", HS, [
        et("div", {
          class: "modal-screen",
          onClick: o
        }),
        et("div", {
          class: "modal-container",
          part: "modal-base",
          style: En(s.modalStyle)
        }, [
          s.title ? (ue(), $e("div", {
            key: 0,
            part: "title",
            ref: "modalTitle",
            class: qt(["modal-title", [{ "is-confirmation": s.isConfirmation }]])
          }, [
            mt(tt(s.title) + " ", 1),
            s.subTitle ? (ue(), $e("div", YS, tt(s.subTitle), 1)) : ze("", !0)
          ], 2)) : ze("", !0),
          !s.preventClose && !s.isHideClose && !s.isConfirmation ? (ue(), bt(Xo, {
            key: 1,
            class: qt([{ "has-subtitle": s.subTitle }, "modal-close"]),
            "is-disabled": !1,
            onClick: a
          }, {
            default: Qt(() => [
              vt(Cn, { name: "times" })
            ]),
            _: 1
          }, 8, ["class"])) : ze("", !0),
          et("div", {
            class: "modal-content",
            style: En({
              height: s.contentHeight,
              boxShadow: s.contentShadow,
              padding: s.contentPadding + "px"
            })
          }, [
            et("div", XS, [
              It(s.$slots, "default"),
              s.hasIframe ? (ue(), $e("iframe", {
                key: 0,
                name: s.iframeName,
                src: s.contentUrl,
                style: En(s.iframeStyle),
                onLoad: i
              }, null, 44, JS)) : ze("", !0),
              s.hasIframe && !s.iframeLoaded ? (ue(), bt(Hd, { key: 1 })) : ze("", !0),
              s.externalContentHtml && !s.hasContentSlot ? (ue(), $e("div", {
                key: 2,
                innerHTML: s.externalContentHtml
              }, null, 8, KS)) : ze("", !0)
            ], 512)
          ], 4),
          (d = s.primaryButton) != null && d.label || (p = s.secondaryButton) != null && p.label || s.hasFooterSlot ? (ue(), $e("div", {
            key: 2,
            part: "footer",
            class: qt([[{ "is-confirmation": s.isConfirmation }], "modal-footer"]),
            ref: "modalFooter"
          }, [
            s.hasFooterSlot ? It(s.$slots, "footer", { key: 0 }) : ze("", !0),
            !s.hasFooterSlot && (c = s.primaryButton) != null && c.label ? (ue(), bt(Xo, {
              key: 1,
              class: "primary",
              "is-disabled": !1,
              onClick: n
            }, {
              default: Qt(() => [
                mt(tt(s.primaryButton.label), 1)
              ]),
              _: 1
            })) : ze("", !0),
            !s.hasFooterSlot && (b = s.secondaryButton) != null && b.label ? (ue(), bt(Xo, {
              key: 2,
              class: "tertiary",
              "is-disabled": !1,
              onClick: r
            }, {
              default: Qt(() => [
                mt(tt(s.secondaryButton.label), 1)
              ]),
              _: 1
            })) : ze("", !0)
          ], 2)) : ze("", !0)
        ], 4)
      ])) : ze("", !0);
    };
  }
}), ZS = `div.iui-modal iframe{display:block;width:100%;height:100%;border:0}div.iui-modal .modal-overflow-cnt{height:100%}div.iui-modal .modal-screen{position:fixed;top:0;left:0;background-color:var(--coal-black);opacity:.2;width:100%;height:100%;z-index:var(--iui-z-index-overlay)}div.iui-modal .modal-container{color:var(--coal-black);border-radius:var(--iui-border-radius-default);background-color:#fff;box-shadow:var(--iui-box-shadow-light);position:fixed;z-index:var(--iui-z-index-modal);top:50%;left:50%;transform:translate(-50%,-50%);max-width:100%;max-height:100%}@media only screen and (max-width: 767px){div.iui-modal .modal-container{max-width:calc(100% - 40px)}}div.iui-modal .modal-container .modal-title{border-bottom:1px solid var(--flash-gray);line-height:45px;font-size:26px;font-weight:700;padding:10px 25px}div.iui-modal .modal-container .modal-title.is-confirmation{border-bottom:none;text-align:center;font-size:18px}div.iui-modal .modal-container .modal-subtitle{font-size:14px;line-height:14px;color:var(--bleakest-gray);font-weight:100;padding-right:10px}div.iui-modal .modal-container .modal-title.is-confirmation .modal-subtitle{color:var(--coal-black)}div.iui-modal .modal-container .modal-close{position:absolute;right:20px;top:16px;cursor:pointer;border-radius:100%;width:30px;height:30px;line-height:28px;padding:0}div.iui-modal .modal-container .modal-close.has-subtitle{top:24px}div.iui-modal .modal-container .modal-close .times{width:10px;height:10px;margin-top:-1px}div.iui-modal .modal-container .modal-content{overflow:auto}div.iui-modal .modal-container .modal-footer{height:60px;line-height:60px;padding-left:20px}div.iui-modal .modal-container .modal-footer .iui-btn{margin-right:10px;min-width:60px}div.iui-modal .modal-container .modal-footer .iui-link{margin-left:20px}div.iui-modal .modal-container .modal-footer .iui-link button{color:var(--coal-black)}div.iui-modal .modal-container .modal-footer.is-confirmation{display:flex;align-items:center;justify-content:center;padding-left:10px}div.iui-modal .modal-container .modal-footer.is-confirmation>*{flex:1}
`, QS = /* @__PURE__ */ Nt(GS, [["styles", [ZS]]]), e1 = mn(Xo), t1 = mn(Nk), n1 = mn(Gk), r1 = mn(fS), o1 = mn(DS), i1 = mn(IS), a1 = mn(Hd), s1 = mn(Xd), l1 = mn(Cn), c1 = mn(WS), u1 = mn(QS);
function mq() {
  customElements.define("uicl-btn", e1), customElements.define("uicl-checkbox", t1), customElements.define("uicl-form-section", n1), customElements.define("uicl-field-label-pair", r1), customElements.define("uicl-text-input", o1), customElements.define("uicl-text-area", i1), customElements.define("uicl-loading-dots", a1), customElements.define("uicl-radio-button", s1), customElements.define("uicl-icon", l1), customElements.define("uicl-card-radio-button", c1), customElements.define("uicl-modal-view", u1);
}
const d1 = v`
  position: relative;
  display: inline-block;
`, p1 = v`
  position: absolute;
  width: max-content;
  min-width: inherit;
  z-index: 100;
  background: var(--sq-surface);
  box-shadow: 0px 1px 4px var(--iui-serenity-gray);
  border-radius: var(--sq-border-radius-normal);
  box-sizing: border-box;
  padding: var(--sq-spacing-xx-small);
  &:empty {
    border: none;
  }
`, f1 = v`
  padding: var(--sq-spacing-x-small) var(--sq-spacing-small);
  cursor: pointer;
  color: var(--sq-text);
  font-family: "Helvetica Neue", Helvetica, sans-serif;
  font-weight: var(--sq-font-weight-regular);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
  border-radius: var(--sq-border-radius-normal);
  &:hover {
    background: var(--iui-pale-gray);
  }
`, h1 = v`
  display: flex;
  align-items: center;
  & > *:not(last-child) {
    margin-right: var(--sq-spacing-xx-small);
  }
`, m1 = v`
  font-size: var(--sq-font-size-regular);
  color: var(--sq-placeholder-text-on-secondary);
  margin-left: auto;
  padding-left: var(--sq-spacing-x-small);
`, v1 = v`
  margin: 0;
  font-size: var(--sq-font-size-small);
  line-height: var(--sq-line-height-regular);
  color: var(--sq-text-subdued);
`, g1 = v`
  color: var(--sq-text-subdued);
  font-size: var(--sq-font-size-regular);
  font-style: italic;
`, b1 = v`
  border-radius: inherit;
`, y1 = v`
  text-indent: var(--sq-spacing-small);
  border-radius: inherit;
`, x1 = v`
  padding: var(--sq-spacing-x-small) var(--sq-spacing-small);
  border-radius: inherit;
  user-select: none;
  color: var(--sq-text);
  font-family: var(--sq-font-family-sans);
  font-weight: var(--sq-font-weight-bold);
  font-size: var(--sq-font-size-regular);
  line-height: var(--sq-line-height-regular);
`, w1 = {
  left: v`
    right: 0;
  `,
  center: v`
    transform: translateX(50%);
    right: 50%;
  `,
  right: v``
}, E1 = E.div`
  ${d1}
  ${(e) => e.customCSS}
`, Jd = E("div")`
  ${p1}

  ${(e) => e.popUpwards && v`
      top: 0;
      transform: translateY(-100%);
    `}

  ${(e) => w1[e.menuPosition ?? "right"]}
`, k1 = E("span")`
  ${g1}
`, S1 = m.forwardRef((e, t) => {
  const {
    showMenu: n = !1,
    popUpwards: r = !1,
    menuPosition: o = "right",
    children: i,
    placeholder: a,
    emptyText: s,
    customCSS: l = {},
    handleSlot: d = /* @__PURE__ */ m.createElement("div", null),
    ...p
  } = e;
  return /* @__PURE__ */ m.createElement(E1, { ...p, ref: t, customCSS: l }, d, n && /* @__PURE__ */ m.createElement(Jd, { popUpwards: r, menuPosition: o }, i || s && /* @__PURE__ */ m.createElement(Kd, null, /* @__PURE__ */ m.createElement(k1, null, s))));
}), C1 = m.forwardRef(
  (e, t) => {
    const {
      placeholder: n,
      icon: r,
      buttonType: o = "primary",
      size: i = "medium",
      disabled: a = !1,
      customCSS: s = {},
      onClickDropdown: l,
      children: d,
      ...p
    } = e;
    return /* @__PURE__ */ m.createElement(
      Vc,
      {
        disabled: a,
        size: i,
        buttonType: o,
        ref: t,
        onClick: l,
        customCSS: s,
        ...p
      },
      r && /* @__PURE__ */ m.createElement(
        Le,
        {
          color: "inherit",
          size: "16px",
          icon: r,
          customCSS: {
            marginRight: "var(--sq-spacing-x-small)"
          }
        }
      ),
      d || n,
      /* @__PURE__ */ m.createElement(
        Le,
        {
          size: "14px",
          icon: "chevron_down",
          customCSS: {
            marginTop: "var(--sq-spacing-xxx-small)",
            marginLeft: "var(--sq-spacing-x-small)"
          }
        }
      )
    );
  }
), q1 = E("div")`
  ${f1}
  ${(e) => e.customCSS}
`, _1 = E("div")`
  ${h1}
`, D1 = E("span")`
  ${m1}
`, O1 = E("p")`
  ${v1}
`, Kd = m.forwardRef(
  (e, t) => {
    const {
      onClick: n,
      children: r,
      checked: o,
      description: i,
      sideDescription: a,
      customCSS: s = {},
      ...l
    } = e;
    return /* @__PURE__ */ m.createElement(
      q1,
      {
        onClick: n,
        ...l,
        ref: t,
        customCSS: s
      },
      /* @__PURE__ */ m.createElement(_1, null, o && /* @__PURE__ */ m.createElement(Le, { icon: "checkmark", size: "18px" }), r, a && /* @__PURE__ */ m.createElement(D1, null, a)),
      i && /* @__PURE__ */ m.createElement(O1, null, i)
    );
  }
), R1 = E("div")`
  ${b1}
  ${(e) => e.customCSS}
`, T1 = E("div")`
  ${y1}
`, A1 = E("div")`
  ${x1}
`, $1 = m.forwardRef((e, t) => {
  const { name: n, children: r, customCSS: o = {}, ...i } = e;
  return /* @__PURE__ */ m.createElement(R1, { ...i, ref: t, customCSS: o }, /* @__PURE__ */ m.createElement(A1, null, n), /* @__PURE__ */ m.createElement(T1, null, r));
}), vq = Object.assign(S1, {
  SublistView: $1,
  ItemView: Kd,
  HandleView: C1,
  FrameView: Jd
}), I1 = v`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: var(--sq-spacing-xxx-small);
  flex-direction: column;
`, N1 = v`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--sq-spacing-x-small);
`, V1 = v`
  margin: 0;
  font-size: var(--sq-font-size-small);
  font-weight: var(--sq-font-weight-regular);
  color: var(--sq-text);
`, z1 = v`
  margin: 0;
  font-size: var(--sq-font-size-small);
  font-weight: var(--sq-font-weight-regular);
  color: var(--iui-bleakest-gray);
`, P1 = E.div`
  ${I1}

  ${(e) => e.customCSS}
`, F1 = E.div`
  ${N1}
`, L1 = E.p`
  ${V1}
`, M1 = E.p`
  ${z1}
`, gq = m.forwardRef((e, t) => {
  const {
    status: n,
    customCSS: r = {},
    iconSlot: o,
    icon: i,
    customIconColor: a,
    descriptionText: s,
    statusText: l,
    ...d
  } = e, p = (w) => {
    switch (w) {
      case "approved":
        return {
          text: "Approved",
          icon: "checkmark_circle_filled",
          iconColor: a || "var(--sq-surface-success)"
        };
      case "pending":
        return {
          text: "Pending",
          icon: "pending",
          iconColor: a || "var(--iui-serenity-gray)"
        };
      case "declined":
        return {
          text: "Declined",
          icon: "declined",
          iconColor: a || "var(--sq-surface-critical)"
        };
      case "counter":
        return {
          text: "Counter",
          icon: "counter",
          iconColor: a || "var(--sq-icon-warning)"
        };
      case "redeemed":
        return {
          text: "Redeemed",
          icon: "redeemed",
          iconColor: a || "var(--sq-focused)"
        };
      case "invalid":
        return {
          text: "Invalid",
          icon: "alert_alt",
          iconColor: a || "var(--sq-decorative-orange)"
        };
      case "default":
        return {
          text: "Status",
          icon: "gift",
          iconColor: a || "var(--sq-text)"
        };
    }
  }, { text: c, icon: b, iconColor: k } = p(n), q = i || n === "default", C = {
    width: "8px",
    height: "8px",
    minWidth: "8px"
  };
  return /* @__PURE__ */ m.createElement(
    P1,
    {
      ...d,
      status: n,
      ref: t,
      customCSS: r
    },
    /* @__PURE__ */ m.createElement(F1, null, o || /* @__PURE__ */ m.createElement(
      Le,
      {
        customCSS: {
          background: q ? k : "",
          borderRadius: "var(--sq-border-radius-pill)",
          padding: q ? "10px" : "",
          boxSizing: "border-box"
        },
        size: q ? "14px" : "16px",
        customSVGCSS: q ? C : {},
        icon: i || b,
        color: q ? "#fff" : k
      }
    ), /* @__PURE__ */ m.createElement(L1, null, l || c)),
    s && /* @__PURE__ */ m.createElement(M1, null, s)
  );
}), U1 = v`
  width: 100%;
`, j1 = v`
  width: 100%;
  padding: var(--sq-spacing-x-small) var(--sq-spacing-small);
  height: auto;
  font-size: var(--sq-font-size-regular);
  font-weight: var(--sq-font-weight-bold);
  color: var(--sq-surface-critical);
  border-top-left-radius: var(--sq-border-radius-normal);
  border-top-right-radius: var(--sq-border-radius-normal);
  background: var(--iui-rose-pink);
`, B1 = v`
  width: 100%;
  padding: var(--sq-spacing-small);
  border-bottom-left-radius: var(--sq-border-radius-normal);
  border-bottom-right-radius: var(--sq-border-radius-normal);
  border: 1px solid var(--iui-rose-pink);
  border-top: none;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  color: var(--sq-surface-critical);
  background: var(--sq-surface);
  gap: var(--sq-spacing-x-small);
`, W1 = E.div`
  ${U1}
  ${(e) => e.customCSS}
`, H1 = E.div`
  ${j1}
`, Y1 = E.div`
  ${B1}
`, bq = (e) => {
  const { errors: t, title: n, customCSS: r = {} } = e, o = `make ${t.length} ${t.length > 1 ? "changes" : "change"}`;
  return /* @__PURE__ */ g.createElement(W1, { customCSS: r }, /* @__PURE__ */ g.createElement(H1, null, n, ", ", o), /* @__PURE__ */ g.createElement(Y1, null, t.map((i, a) => /* @__PURE__ */ g.createElement(
    _a,
    {
      key: `${i}-${a}`,
      type: "textCritical",
      customCSS: "color: var(--sq-surface-critical)"
    },
    i
  ))));
}, X1 = v`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100%;
  color: var(--sq-border);
  gap: var(--sq-spacing-small);
  align-self: stretch;
`, J1 = v`
  height: 100%;
  border-left: 1px solid var(--sq-border);
`, K1 = v`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--sq-border);
  gap: var(--sq-spacing-small);
`, G1 = v`
  // width: 47%;
  // border-bottom: 1px solid var(--sq-border);
  // position: absolute;
  // left: 0%;
  // margin-left: -1px;

  // &:nth-child(2) {
  //   border-bottom: 1px solid green;
  //   right: 47%;
  //   width: 47%;
  // }
  width: 100%;
  border-bottom: 1px solid var(--sq-border);
`, Z1 = E.div`
  ${(e) => e.lineDirection === "vertical" ? X1 : K1}
`, dc = E.div`
  ${(e) => e.lineDirection === "vertical" ? J1 : G1}
`, yq = g.forwardRef((e, t) => {
  const { separatorText: n = "Or", lineDirection: r = "vertical" } = e;
  return /* @__PURE__ */ g.createElement(Z1, { ref: t, lineDirection: r }, /* @__PURE__ */ g.createElement(dc, { lineDirection: r }), /* @__PURE__ */ g.createElement("div", null, n), /* @__PURE__ */ g.createElement(dc, { lineDirection: r }));
}), xq = {
  HandleView: Kt.HandleView,
  ListView: Kt.ListView,
  FrameView: Kt.FrameView,
  ContainerView: Kt.ContainerView,
  ItemView: Kt.ItemView,
  ItemToNode: Kt.ItemToNode,
  ItemToString: Kt.ItemToString
}, Q1 = v`
  display: flex;
  gap: var(--sq-spacing-medium);
  padding: var(--sq-spacing-small) var(--sq-spacing-xx-large);
  bottom: 0;
  position: fixed;
  width: 100%;
  box-shadow: var(--iui-box-shadow-default);
  background: var(--sq-surface);
  z-index: 9;
`, eC = v`
  padding-top: 60px;
`;
v`
  width: 300px;
  height: 30px;

  font: 400 14px Helvetica;
  text-indent: 6px;

  color: #575757;
  background: #ffffff;

  border: 1px solid var(--sq-border);
  border-radius: var(--sq-border-radius-normal);

  &::placeholder {
    color: #bdbdbd;
  }

  &:focus {
    outline: none;
    border-color: #448ee1;
  }

  &:disabled {
    user-select: none;
    cursor: not-allowed;
    pointer-events: none;
    color: #bdbdbd;
    background-color: #ebebeb;
  }
`;
v`
  user-select: none;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  cursor: pointer;
  margin-right: 10px;

  color: #575757;
  font-family: Helvetica;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
`;
v`
  display: none;

  &:checked + div {
    border-color: #f49c20;
  }

  &:checked + div::after {
    transform: scale(1);
  }
`;
v`
  //   Outer Circle
  margin-top: 2.5px;
  width: 14px;
  height: 14px;
  border: 1.5px solid #575757;
  border-radius: 50%;
  margin-right: 20px;
  box-sizing: border-box;
  padding: 1.5px;
  flex-shrink: 0;

  //   Inner Circle
  &::after {
    content: "";
    width: 8px;
    height: 8px;
    display: block;
    background: #f49c20;
    border-radius: 100%;
    transform: scale(0);
    transition: transform 0.15s;
  }
`;
v`
  user-select: none;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  cursor: pointer;
  margin-right: 10px;

  color: #575757;
  font-family: Helvetica;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;

  padding: 20px;
`;
v`
  display: none;

  &:checked + div {
    border-color: #f49c20;
  }

  &:checked + div::after {
    transform: scale(1);
  }
`;
v`
  //   Outer Circle
  margin-top: 2.5px;
  width: 14px;
  height: 14px;
  border: 1.5px solid #575757;
  border-radius: 50%;
  margin-right: 20px;
  box-sizing: border-box;
  padding: 1.5px;
  flex-shrink: 0;

  //   Inner Circle
  &::after {
    content: "";
    width: 8px;
    height: 8px;
    display: block;
    background: #f49c20;
    border-radius: 100%;
    transform: scale(0);
    transition: transform 0.15s;
  }
`;
const tC = E.div`
  ${Q1}
  ${(e) => e.customCSS}
`, nC = E.div`
  ${eC}
`, rC = (e) => {
  const { customCSS: t = {} } = e;
  return /* @__PURE__ */ g.createElement(nC, null, /* @__PURE__ */ g.createElement(tC, { customCSS: t }, e.children));
}, wq = {
  ButtonsView: rC
};
export {
  WC as Accordion,
  py as AccordionView,
  uC as Alert,
  _a as AlertView,
  IC as ArrayFieldTemplate,
  dC as Avatar,
  qh as AvatarView,
  pC as Badge,
  _c as BadgeView,
  Mr as Button,
  vq as ButtonDropdownView,
  Vc as ButtonView,
  Gh as CSSVariables,
  GC as Card,
  KC as CardContainer,
  QC as CardEdit,
  Qy as CardEditView,
  ZC as CardLong,
  Hy as CardLongView,
  My as CardView,
  yC as Checkbox,
  zc as CheckboxView,
  JC as CopyWrapper,
  by as CopyWrapperView,
  gl as DataGraphic,
  AC as DataTable,
  ji as DataTableView,
  sq as DetailsView,
  iq as DisplayDropdown,
  yq as DividerView,
  TC as Dropdown,
  Ao as DropdownView,
  bq as ErrorListBannerView,
  Ia as ErrorListTemplate,
  fq as FieldLabelPairView,
  xr as FieldTemplate,
  xq as FilterView,
  tm as FontFamilyRules,
  pq as FormSectionView,
  wq as FormView,
  bC as GlobalStyle,
  XC as HoverPopover,
  cC as Icon,
  fn as IconButton,
  Jn as IconButtonView,
  Le as IconView,
  SC as Input,
  In as InputView,
  Zh as LinkRules,
  BC as List,
  jC as ListView,
  Df as LoadingSpinner,
  nq as ModalView,
  $C as ObjectFieldTemplate,
  YC as Popover,
  HC as PopoverView,
  aq as ProgressBarView,
  RC as RJSFCancellableInput,
  xC as RJSFCheckbox,
  OC as RJSFClearableInput,
  CC as RJSFInput,
  DC as RJSFLockableInput,
  qC as RJSFNumericalInput,
  _C as RJSFPasswordInput,
  kC as RJSFRadio,
  UC as RJSFRadioActionWidget,
  VC as RJSFRadioCardWidget,
  FC as RJSFSelect,
  mC as RJSFSwitch,
  PC as RJSFTextarea,
  wC as Radio,
  LC as RadioAction,
  MC as RadioActionGroup,
  Su as RadioActionGroupView,
  ku as RadioActionView,
  NC as RadioCard,
  wl as RadioCardView,
  EC as RadioGroup,
  rv as RadioGroupView,
  Xc as RadioView,
  lq as ScrollNavView,
  Vg as Select,
  Kt as SelectView,
  rq as SliderView,
  gq as StatusView,
  hC as Switch,
  Dc as SwitchView,
  tq as Tabs,
  eq as TabsView,
  vC as Tag,
  oq as TagInputView,
  Oc as TagView,
  em as TextRules,
  zC as Textarea,
  Eu as TextareaView,
  gC as Tooltip,
  Kh as TooltipView,
  Qh as TypographyRules,
  im as UICLRules,
  $f as getBasePath,
  mq as registerUICL,
  lC as setBasePath,
  hq as setBasePathUICL,
  dq as useComboboxDemo,
  uq as useMultiSelectDemo,
  cq as useSelectDemo,
  Be as wcBoolean
};
//# sourceMappingURL=visual-dev.js.map
